var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/has-symbols/shams.js
var require_shams = __commonJS({
  "../../node_modules/has-symbols/shams.js"(exports, module) {
    "use strict";
    module.exports = function hasSymbols() {
      if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
        return false;
      }
      if (typeof Symbol.iterator === "symbol") {
        return true;
      }
      var obj = {};
      var sym = Symbol("test");
      var symObj = Object(sym);
      if (typeof sym === "string") {
        return false;
      }
      if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
        return false;
      }
      if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
        return false;
      }
      var symVal = 42;
      obj[sym] = symVal;
      for (sym in obj) {
        return false;
      }
      if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
        return false;
      }
      if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
        return false;
      }
      var syms = Object.getOwnPropertySymbols(obj);
      if (syms.length !== 1 || syms[0] !== sym) {
        return false;
      }
      if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
        return false;
      }
      if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor2 = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor2.value !== symVal || descriptor2.enumerable !== true) {
          return false;
        }
      }
      return true;
    };
  }
});

// ../../node_modules/has-symbols/index.js
var require_has_symbols = __commonJS({
  "../../node_modules/has-symbols/index.js"(exports, module) {
    "use strict";
    var origSymbol = typeof Symbol !== "undefined" && Symbol;
    var hasSymbolSham = require_shams();
    module.exports = function hasNativeSymbols() {
      if (typeof origSymbol !== "function") {
        return false;
      }
      if (typeof Symbol !== "function") {
        return false;
      }
      if (typeof origSymbol("foo") !== "symbol") {
        return false;
      }
      if (typeof Symbol("bar") !== "symbol") {
        return false;
      }
      return hasSymbolSham();
    };
  }
});

// ../../node_modules/function-bind/implementation.js
var require_implementation = __commonJS({
  "../../node_modules/function-bind/implementation.js"(exports, module) {
    "use strict";
    var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
    var slice2 = Array.prototype.slice;
    var toStr = Object.prototype.toString;
    var funcType = "[object Function]";
    module.exports = function bind(that) {
      var target = this;
      if (typeof target !== "function" || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
      }
      var args = slice2.call(arguments, 1);
      var bound;
      var binder = function() {
        if (this instanceof bound) {
          var result = target.apply(
            this,
            args.concat(slice2.call(arguments))
          );
          if (Object(result) === result) {
            return result;
          }
          return this;
        } else {
          return target.apply(
            that,
            args.concat(slice2.call(arguments))
          );
        }
      };
      var boundLength = Math.max(0, target.length - args.length);
      var boundArgs = [];
      for (var i = 0; i < boundLength; i++) {
        boundArgs.push("$" + i);
      }
      bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
      if (target.prototype) {
        var Empty = function Empty2() {
        };
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
      }
      return bound;
    };
  }
});

// ../../node_modules/function-bind/index.js
var require_function_bind = __commonJS({
  "../../node_modules/function-bind/index.js"(exports, module) {
    "use strict";
    var implementation = require_implementation();
    module.exports = Function.prototype.bind || implementation;
  }
});

// ../../node_modules/has/src/index.js
var require_src = __commonJS({
  "../../node_modules/has/src/index.js"(exports, module) {
    "use strict";
    var bind = require_function_bind();
    module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/get-intrinsic/index.js
var require_get_intrinsic = __commonJS({
  "../../node_modules/get-intrinsic/index.js"(exports, module) {
    "use strict";
    var undefined2;
    var $SyntaxError = SyntaxError;
    var $Function = Function;
    var $TypeError = TypeError;
    var getEvalledConstructor = function(expressionSyntax) {
      try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
      } catch (e) {
      }
    };
    var $gOPD = Object.getOwnPropertyDescriptor;
    if ($gOPD) {
      try {
        $gOPD({}, "");
      } catch (e) {
        $gOPD = null;
      }
    }
    var throwTypeError = function() {
      throw new $TypeError();
    };
    var ThrowTypeError = $gOPD ? function() {
      try {
        arguments.callee;
        return throwTypeError;
      } catch (calleeThrows) {
        try {
          return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
          return throwTypeError;
        }
      }
    }() : throwTypeError;
    var hasSymbols = require_has_symbols()();
    var getProto = Object.getPrototypeOf || function(x) {
      return x.__proto__;
    };
    var needsEval = {};
    var TypedArray = typeof Uint8Array === "undefined" ? undefined2 : getProto(Uint8Array);
    var INTRINSICS = {
      "%AggregateError%": typeof AggregateError === "undefined" ? undefined2 : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined2 : ArrayBuffer,
      "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined2,
      "%AsyncFromSyncIteratorPrototype%": undefined2,
      "%AsyncFunction%": needsEval,
      "%AsyncGenerator%": needsEval,
      "%AsyncGeneratorFunction%": needsEval,
      "%AsyncIteratorPrototype%": needsEval,
      "%Atomics%": typeof Atomics === "undefined" ? undefined2 : Atomics,
      "%BigInt%": typeof BigInt === "undefined" ? undefined2 : BigInt,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView === "undefined" ? undefined2 : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%eval%": eval,
      // eslint-disable-line no-eval
      "%EvalError%": EvalError,
      "%Float32Array%": typeof Float32Array === "undefined" ? undefined2 : Float32Array,
      "%Float64Array%": typeof Float64Array === "undefined" ? undefined2 : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined2 : FinalizationRegistry,
      "%Function%": $Function,
      "%GeneratorFunction%": needsEval,
      "%Int8Array%": typeof Int8Array === "undefined" ? undefined2 : Int8Array,
      "%Int16Array%": typeof Int16Array === "undefined" ? undefined2 : Int16Array,
      "%Int32Array%": typeof Int32Array === "undefined" ? undefined2 : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined2,
      "%JSON%": typeof JSON === "object" ? JSON : undefined2,
      "%Map%": typeof Map === "undefined" ? undefined2 : Map,
      "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise === "undefined" ? undefined2 : Promise,
      "%Proxy%": typeof Proxy === "undefined" ? undefined2 : Proxy,
      "%RangeError%": RangeError,
      "%ReferenceError%": ReferenceError,
      "%Reflect%": typeof Reflect === "undefined" ? undefined2 : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set === "undefined" ? undefined2 : Set,
      "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined2 : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined2,
      "%Symbol%": hasSymbols ? Symbol : undefined2,
      "%SyntaxError%": $SyntaxError,
      "%ThrowTypeError%": ThrowTypeError,
      "%TypedArray%": TypedArray,
      "%TypeError%": $TypeError,
      "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined2 : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined2 : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined2 : Uint16Array,
      "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined2 : Uint32Array,
      "%URIError%": URIError,
      "%WeakMap%": typeof WeakMap === "undefined" ? undefined2 : WeakMap,
      "%WeakRef%": typeof WeakRef === "undefined" ? undefined2 : WeakRef,
      "%WeakSet%": typeof WeakSet === "undefined" ? undefined2 : WeakSet
    };
    var doEval = function doEval2(name) {
      var value;
      if (name === "%AsyncFunction%") {
        value = getEvalledConstructor("async function () {}");
      } else if (name === "%GeneratorFunction%") {
        value = getEvalledConstructor("function* () {}");
      } else if (name === "%AsyncGeneratorFunction%") {
        value = getEvalledConstructor("async function* () {}");
      } else if (name === "%AsyncGenerator%") {
        var fn = doEval2("%AsyncGeneratorFunction%");
        if (fn) {
          value = fn.prototype;
        }
      } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval2("%AsyncGenerator%");
        if (gen) {
          value = getProto(gen.prototype);
        }
      }
      INTRINSICS[name] = value;
      return value;
    };
    var LEGACY_ALIASES = {
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    };
    var bind = require_function_bind();
    var hasOwn2 = require_src();
    var $concat = bind.call(Function.call, Array.prototype.concat);
    var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
    var $replace = bind.call(Function.call, String.prototype.replace);
    var $strSlice = bind.call(Function.call, String.prototype.slice);
    var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = function stringToPath2(string) {
      var first = $strSlice(string, 0, 1);
      var last = $strSlice(string, -1);
      if (first === "%" && last !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
      } else if (last === "%" && first !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
      }
      var result = [];
      $replace(string, rePropName, function(match2, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match2;
      });
      return result;
    };
    var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
      var intrinsicName = name;
      var alias;
      if (hasOwn2(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
      }
      if (hasOwn2(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) {
          value = doEval(intrinsicName);
        }
        if (typeof value === "undefined" && !allowMissing) {
          throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        }
        return {
          alias,
          name: intrinsicName,
          value
        };
      }
      throw new $SyntaxError("intrinsic " + name + " does not exist!");
    };
    module.exports = function GetIntrinsic(name, allowMissing) {
      if (typeof name !== "string" || name.length === 0) {
        throw new $TypeError("intrinsic name must be a non-empty string");
      }
      if (arguments.length > 1 && typeof allowMissing !== "boolean") {
        throw new $TypeError('"allowMissing" argument must be a boolean');
      }
      var parts = stringToPath(name);
      var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
      var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
      var intrinsicRealName = intrinsic.name;
      var value = intrinsic.value;
      var skipFurtherCaching = false;
      var alias = intrinsic.alias;
      if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([0, 1], alias));
      }
      for (var i = 1, isOwn = true; i < parts.length; i += 1) {
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
          throw new $SyntaxError("property names with quotes must have matching quotes");
        }
        if (part === "constructor" || !isOwn) {
          skipFurtherCaching = true;
        }
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn2(INTRINSICS, intrinsicRealName)) {
          value = INTRINSICS[intrinsicRealName];
        } else if (value != null) {
          if (!(part in value)) {
            if (!allowMissing) {
              throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
            }
            return void 0;
          }
          if ($gOPD && i + 1 >= parts.length) {
            var desc = $gOPD(value, part);
            isOwn = !!desc;
            if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
              value = desc.get;
            } else {
              value = value[part];
            }
          } else {
            isOwn = hasOwn2(value, part);
            value = value[part];
          }
          if (isOwn && !skipFurtherCaching) {
            INTRINSICS[intrinsicRealName] = value;
          }
        }
      }
      return value;
    };
  }
});

// ../../node_modules/call-bind/index.js
var require_call_bind = __commonJS({
  "../../node_modules/call-bind/index.js"(exports, module) {
    "use strict";
    var bind = require_function_bind();
    var GetIntrinsic = require_get_intrinsic();
    var $apply = GetIntrinsic("%Function.prototype.apply%");
    var $call = GetIntrinsic("%Function.prototype.call%");
    var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    var $defineProperty2 = GetIntrinsic("%Object.defineProperty%", true);
    var $max = GetIntrinsic("%Math.max%");
    if ($defineProperty2) {
      try {
        $defineProperty2({}, "a", { value: 1 });
      } catch (e) {
        $defineProperty2 = null;
      }
    }
    module.exports = function callBind(originalFunction) {
      var func = $reflectApply(bind, $call, arguments);
      if ($gOPD && $defineProperty2) {
        var desc = $gOPD(func, "length");
        if (desc.configurable) {
          $defineProperty2(
            func,
            "length",
            { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
          );
        }
      }
      return func;
    };
    var applyBind = function applyBind2() {
      return $reflectApply(bind, $apply, arguments);
    };
    if ($defineProperty2) {
      $defineProperty2(module.exports, "apply", { value: applyBind });
    } else {
      module.exports.apply = applyBind;
    }
  }
});

// ../../node_modules/call-bind/callBound.js
var require_callBound = __commonJS({
  "../../node_modules/call-bind/callBound.js"(exports, module) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var callBind = require_call_bind();
    var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
    module.exports = function callBoundIntrinsic(name, allowMissing) {
      var intrinsic = GetIntrinsic(name, !!allowMissing);
      if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
        return callBind(intrinsic);
      }
      return intrinsic;
    };
  }
});

// (disabled):../../node_modules/object-inspect/util.inspect
var require_util = __commonJS({
  "(disabled):../../node_modules/object-inspect/util.inspect"() {
  }
});

// ../../node_modules/object-inspect/index.js
var require_object_inspect = __commonJS({
  "../../node_modules/object-inspect/index.js"(exports, module) {
    var hasMap = typeof Map === "function" && Map.prototype;
    var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
    var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
    var mapForEach = hasMap && Map.prototype.forEach;
    var hasSet = typeof Set === "function" && Set.prototype;
    var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
    var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
    var setForEach = hasSet && Set.prototype.forEach;
    var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
    var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
    var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
    var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
    var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
    var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
    var booleanValueOf = Boolean.prototype.valueOf;
    var objectToString = Object.prototype.toString;
    var functionToString2 = Function.prototype.toString;
    var $match = String.prototype.match;
    var $slice = String.prototype.slice;
    var $replace = String.prototype.replace;
    var $toUpperCase = String.prototype.toUpperCase;
    var $toLowerCase = String.prototype.toLowerCase;
    var $test = RegExp.prototype.test;
    var $concat = Array.prototype.concat;
    var $join = Array.prototype.join;
    var $arrSlice = Array.prototype.slice;
    var $floor = Math.floor;
    var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
    var gOPS = Object.getOwnPropertySymbols;
    var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
    var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
    var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
      return O.__proto__;
    } : null);
    function addNumericSeparator(num, str) {
      if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) {
        return str;
      }
      var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
      if (typeof num === "number") {
        var int = num < 0 ? -$floor(-num) : $floor(num);
        if (int !== num) {
          var intStr = String(int);
          var dec = $slice.call(str, intStr.length + 1);
          return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
      }
      return $replace.call(str, sepRegex, "$&_");
    }
    var inspectCustom = require_util().custom;
    var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;
    module.exports = function inspect_(obj, options2, depth, seen) {
      var opts = options2 || {};
      if (has3(opts, "quoteStyle") && (opts.quoteStyle !== "single" && opts.quoteStyle !== "double")) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
      }
      if (has3(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
      }
      var customInspect = has3(opts, "customInspect") ? opts.customInspect : true;
      if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
        throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
      }
      if (has3(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
      }
      if (has3(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
      }
      var numericSeparator = opts.numericSeparator;
      if (typeof obj === "undefined") {
        return "undefined";
      }
      if (obj === null) {
        return "null";
      }
      if (typeof obj === "boolean") {
        return obj ? "true" : "false";
      }
      if (typeof obj === "string") {
        return inspectString(obj, opts);
      }
      if (typeof obj === "number") {
        if (obj === 0) {
          return Infinity / obj > 0 ? "0" : "-0";
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
      }
      if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
      }
      var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
      if (typeof depth === "undefined") {
        depth = 0;
      }
      if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
        return isArray3(obj) ? "[Array]" : "[Object]";
      }
      var indent = getIndent(opts, depth);
      if (typeof seen === "undefined") {
        seen = [];
      } else if (indexOf2(seen, obj) >= 0) {
        return "[Circular]";
      }
      function inspect(value, from, noIndent) {
        if (from) {
          seen = $arrSlice.call(seen);
          seen.push(from);
        }
        if (noIndent) {
          var newOpts = {
            depth: opts.depth
          };
          if (has3(opts, "quoteStyle")) {
            newOpts.quoteStyle = opts.quoteStyle;
          }
          return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
      }
      if (typeof obj === "function") {
        var name = nameOf(obj);
        var keys4 = arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys4.length > 0 ? " { " + $join.call(keys4, ", ") + " }" : "");
      }
      if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
        return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
      }
      if (isElement(obj)) {
        var s = "<" + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
          s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
        }
        s += ">";
        if (obj.childNodes && obj.childNodes.length) {
          s += "...";
        }
        s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
      }
      if (isArray3(obj)) {
        if (obj.length === 0) {
          return "[]";
        }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
          return "[" + indentedJoin(xs, indent) + "]";
        }
        return "[ " + $join.call(xs, ", ") + " ]";
      }
      if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if ("cause" in obj && !isEnumerable.call(obj, "cause")) {
          return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        }
        if (parts.length === 0) {
          return "[" + String(obj) + "]";
        }
        return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
      }
      if (typeof obj === "object" && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === "function") {
          return obj[inspectSymbol]();
        } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
          return obj.inspect();
        }
      }
      if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function(value, key) {
          mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return collectionOf("Map", mapSize.call(obj), mapParts, indent);
      }
      if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function(value) {
          setParts.push(inspect(value, obj));
        });
        return collectionOf("Set", setSize.call(obj), setParts, indent);
      }
      if (isWeakMap(obj)) {
        return weakCollectionOf("WeakMap");
      }
      if (isWeakSet(obj)) {
        return weakCollectionOf("WeakSet");
      }
      if (isWeakRef(obj)) {
        return weakCollectionOf("WeakRef");
      }
      if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
      }
      if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
      }
      if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
      }
      if (isString4(obj)) {
        return markBoxed(inspect(String(obj)));
      }
      if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) {
          return tag + "{}";
        }
        if (indent) {
          return tag + "{" + indentedJoin(ys, indent) + "}";
        }
        return tag + "{ " + $join.call(ys, ", ") + " }";
      }
      return String(obj);
    };
    function wrapQuotes(s, defaultStyle, opts) {
      var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
      return quoteChar + s + quoteChar;
    }
    function quote(s) {
      return $replace.call(String(s), /"/g, "&quot;");
    }
    function isArray3(obj) {
      return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isDate(obj) {
      return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isRegExp(obj) {
      return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isError(obj) {
      return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isString4(obj) {
      return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isNumber(obj) {
      return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isBoolean(obj) {
      return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isSymbol(obj) {
      if (hasShammedSymbols) {
        return obj && typeof obj === "object" && obj instanceof Symbol;
      }
      if (typeof obj === "symbol") {
        return true;
      }
      if (!obj || typeof obj !== "object" || !symToString) {
        return false;
      }
      try {
        symToString.call(obj);
        return true;
      } catch (e) {
      }
      return false;
    }
    function isBigInt(obj) {
      if (!obj || typeof obj !== "object" || !bigIntValueOf) {
        return false;
      }
      try {
        bigIntValueOf.call(obj);
        return true;
      } catch (e) {
      }
      return false;
    }
    var hasOwn2 = Object.prototype.hasOwnProperty || function(key) {
      return key in this;
    };
    function has3(obj, key) {
      return hasOwn2.call(obj, key);
    }
    function toStr(obj) {
      return objectToString.call(obj);
    }
    function nameOf(f2) {
      if (f2.name) {
        return f2.name;
      }
      var m = $match.call(functionToString2.call(f2), /^function\s*([\w$]+)/);
      if (m) {
        return m[1];
      }
      return null;
    }
    function indexOf2(xs, x) {
      if (xs.indexOf) {
        return xs.indexOf(x);
      }
      for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) {
          return i;
        }
      }
      return -1;
    }
    function isMap(x) {
      if (!mapSize || !x || typeof x !== "object") {
        return false;
      }
      try {
        mapSize.call(x);
        try {
          setSize.call(x);
        } catch (s) {
          return true;
        }
        return x instanceof Map;
      } catch (e) {
      }
      return false;
    }
    function isWeakMap(x) {
      if (!weakMapHas || !x || typeof x !== "object") {
        return false;
      }
      try {
        weakMapHas.call(x, weakMapHas);
        try {
          weakSetHas.call(x, weakSetHas);
        } catch (s) {
          return true;
        }
        return x instanceof WeakMap;
      } catch (e) {
      }
      return false;
    }
    function isWeakRef(x) {
      if (!weakRefDeref || !x || typeof x !== "object") {
        return false;
      }
      try {
        weakRefDeref.call(x);
        return true;
      } catch (e) {
      }
      return false;
    }
    function isSet(x) {
      if (!setSize || !x || typeof x !== "object") {
        return false;
      }
      try {
        setSize.call(x);
        try {
          mapSize.call(x);
        } catch (m) {
          return true;
        }
        return x instanceof Set;
      } catch (e) {
      }
      return false;
    }
    function isWeakSet(x) {
      if (!weakSetHas || !x || typeof x !== "object") {
        return false;
      }
      try {
        weakSetHas.call(x, weakSetHas);
        try {
          weakMapHas.call(x, weakMapHas);
        } catch (s) {
          return true;
        }
        return x instanceof WeakSet;
      } catch (e) {
      }
      return false;
    }
    function isElement(x) {
      if (!x || typeof x !== "object") {
        return false;
      }
      if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
        return true;
      }
      return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
    }
    function inspectString(str, opts) {
      if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
      }
      var s = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
      return wrapQuotes(s, "single", opts);
    }
    function lowbyte(c) {
      var n = c.charCodeAt(0);
      var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
      }[n];
      if (x) {
        return "\\" + x;
      }
      return "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
    }
    function markBoxed(str) {
      return "Object(" + str + ")";
    }
    function weakCollectionOf(type) {
      return type + " { ? }";
    }
    function collectionOf(type, size6, entries, indent) {
      var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
      return type + " (" + size6 + ") {" + joinedEntries + "}";
    }
    function singleLineValues(xs) {
      for (var i = 0; i < xs.length; i++) {
        if (indexOf2(xs[i], "\n") >= 0) {
          return false;
        }
      }
      return true;
    }
    function getIndent(opts, depth) {
      var baseIndent;
      if (opts.indent === "	") {
        baseIndent = "	";
      } else if (typeof opts.indent === "number" && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), " ");
      } else {
        return null;
      }
      return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
      };
    }
    function indentedJoin(xs, indent) {
      if (xs.length === 0) {
        return "";
      }
      var lineJoiner = "\n" + indent.prev + indent.base;
      return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
    }
    function arrObjKeys(obj, inspect) {
      var isArr = isArray3(obj);
      var xs = [];
      if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
          xs[i] = has3(obj, i) ? inspect(obj[i], obj) : "";
        }
      }
      var syms = typeof gOPS === "function" ? gOPS(obj) : [];
      var symMap;
      if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
          symMap["$" + syms[k]] = syms[k];
        }
      }
      for (var key in obj) {
        if (!has3(obj, key)) {
          continue;
        }
        if (isArr && String(Number(key)) === key && key < obj.length) {
          continue;
        }
        if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
          continue;
        } else if ($test.call(/[^\w$]/, key)) {
          xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        } else {
          xs.push(key + ": " + inspect(obj[key], obj));
        }
      }
      if (typeof gOPS === "function") {
        for (var j = 0; j < syms.length; j++) {
          if (isEnumerable.call(obj, syms[j])) {
            xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
          }
        }
      }
      return xs;
    }
  }
});

// ../../node_modules/side-channel/index.js
var require_side_channel = __commonJS({
  "../../node_modules/side-channel/index.js"(exports, module) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var callBound = require_callBound();
    var inspect = require_object_inspect();
    var $TypeError = GetIntrinsic("%TypeError%");
    var $WeakMap = GetIntrinsic("%WeakMap%", true);
    var $Map = GetIntrinsic("%Map%", true);
    var $weakMapGet = callBound("WeakMap.prototype.get", true);
    var $weakMapSet = callBound("WeakMap.prototype.set", true);
    var $weakMapHas = callBound("WeakMap.prototype.has", true);
    var $mapGet = callBound("Map.prototype.get", true);
    var $mapSet = callBound("Map.prototype.set", true);
    var $mapHas = callBound("Map.prototype.has", true);
    var listGetNode = function(list, key) {
      for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
        if (curr.key === key) {
          prev.next = curr.next;
          curr.next = list.next;
          list.next = curr;
          return curr;
        }
      }
    };
    var listGet = function(objects, key) {
      var node = listGetNode(objects, key);
      return node && node.value;
    };
    var listSet = function(objects, key, value) {
      var node = listGetNode(objects, key);
      if (node) {
        node.value = value;
      } else {
        objects.next = {
          // eslint-disable-line no-param-reassign
          key,
          next: objects.next,
          value
        };
      }
    };
    var listHas = function(objects, key) {
      return !!listGetNode(objects, key);
    };
    module.exports = function getSideChannel() {
      var $wm;
      var $m;
      var $o;
      var channel = {
        assert: function(key) {
          if (!channel.has(key)) {
            throw new $TypeError("Side channel does not contain " + inspect(key));
          }
        },
        get: function(key) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if ($wm) {
              return $weakMapGet($wm, key);
            }
          } else if ($Map) {
            if ($m) {
              return $mapGet($m, key);
            }
          } else {
            if ($o) {
              return listGet($o, key);
            }
          }
        },
        has: function(key) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if ($wm) {
              return $weakMapHas($wm, key);
            }
          } else if ($Map) {
            if ($m) {
              return $mapHas($m, key);
            }
          } else {
            if ($o) {
              return listHas($o, key);
            }
          }
          return false;
        },
        set: function(key, value) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if (!$wm) {
              $wm = new $WeakMap();
            }
            $weakMapSet($wm, key, value);
          } else if ($Map) {
            if (!$m) {
              $m = new $Map();
            }
            $mapSet($m, key, value);
          } else {
            if (!$o) {
              $o = { key: {}, next: null };
            }
            listSet($o, key, value);
          }
        }
      };
      return channel;
    };
  }
});

// ../../node_modules/qs/lib/formats.js
var require_formats = __commonJS({
  "../../node_modules/qs/lib/formats.js"(exports, module) {
    "use strict";
    var replace = String.prototype.replace;
    var percentTwenties = /%20/g;
    var Format = {
      RFC1738: "RFC1738",
      RFC3986: "RFC3986"
    };
    module.exports = {
      "default": Format.RFC3986,
      formatters: {
        RFC1738: function(value) {
          return replace.call(value, percentTwenties, "+");
        },
        RFC3986: function(value) {
          return String(value);
        }
      },
      RFC1738: Format.RFC1738,
      RFC3986: Format.RFC3986
    };
  }
});

// ../../node_modules/qs/lib/utils.js
var require_utils = __commonJS({
  "../../node_modules/qs/lib/utils.js"(exports, module) {
    "use strict";
    var formats = require_formats();
    var has3 = Object.prototype.hasOwnProperty;
    var isArray3 = Array.isArray;
    var hexTable = function() {
      var array = [];
      for (var i = 0; i < 256; ++i) {
        array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
      }
      return array;
    }();
    var compactQueue = function compactQueue2(queue2) {
      while (queue2.length > 1) {
        var item = queue2.pop();
        var obj = item.obj[item.prop];
        if (isArray3(obj)) {
          var compacted = [];
          for (var j = 0; j < obj.length; ++j) {
            if (typeof obj[j] !== "undefined") {
              compacted.push(obj[j]);
            }
          }
          item.obj[item.prop] = compacted;
        }
      }
    };
    var arrayToObject = function arrayToObject2(source, options2) {
      var obj = options2 && options2.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== "undefined") {
          obj[i] = source[i];
        }
      }
      return obj;
    };
    var merge = function merge2(target, source, options2) {
      if (!source) {
        return target;
      }
      if (typeof source !== "object") {
        if (isArray3(target)) {
          target.push(source);
        } else if (target && typeof target === "object") {
          if (options2 && (options2.plainObjects || options2.allowPrototypes) || !has3.call(Object.prototype, source)) {
            target[source] = true;
          }
        } else {
          return [target, source];
        }
        return target;
      }
      if (!target || typeof target !== "object") {
        return [target].concat(source);
      }
      var mergeTarget = target;
      if (isArray3(target) && !isArray3(source)) {
        mergeTarget = arrayToObject(target, options2);
      }
      if (isArray3(target) && isArray3(source)) {
        source.forEach(function(item, i) {
          if (has3.call(target, i)) {
            var targetItem = target[i];
            if (targetItem && typeof targetItem === "object" && item && typeof item === "object") {
              target[i] = merge2(targetItem, item, options2);
            } else {
              target.push(item);
            }
          } else {
            target[i] = item;
          }
        });
        return target;
      }
      return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if (has3.call(acc, key)) {
          acc[key] = merge2(acc[key], value, options2);
        } else {
          acc[key] = value;
        }
        return acc;
      }, mergeTarget);
    };
    var assign = function assignSingleSource(target, source) {
      return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
      }, target);
    };
    var decode = function(str, decoder, charset) {
      var strWithoutPlus = str.replace(/\+/g, " ");
      if (charset === "iso-8859-1") {
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
      }
      try {
        return decodeURIComponent(strWithoutPlus);
      } catch (e) {
        return strWithoutPlus;
      }
    };
    var encode = function encode2(str, defaultEncoder, charset, kind, format) {
      if (str.length === 0) {
        return str;
      }
      var string = str;
      if (typeof str === "symbol") {
        string = Symbol.prototype.toString.call(str);
      } else if (typeof str !== "string") {
        string = String(str);
      }
      if (charset === "iso-8859-1") {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
          return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
        });
      }
      var out = "";
      for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);
        if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === formats.RFC1738 && (c === 40 || c === 41)) {
          out += string.charAt(i);
          continue;
        }
        if (c < 128) {
          out = out + hexTable[c];
          continue;
        }
        if (c < 2048) {
          out = out + (hexTable[192 | c >> 6] + hexTable[128 | c & 63]);
          continue;
        }
        if (c < 55296 || c >= 57344) {
          out = out + (hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63]);
          continue;
        }
        i += 1;
        c = 65536 + ((c & 1023) << 10 | string.charCodeAt(i) & 1023);
        out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
      }
      return out;
    };
    var compact4 = function compact5(value) {
      var queue2 = [{ obj: { o: value }, prop: "o" }];
      var refs = [];
      for (var i = 0; i < queue2.length; ++i) {
        var item = queue2[i];
        var obj = item.obj[item.prop];
        var keys4 = Object.keys(obj);
        for (var j = 0; j < keys4.length; ++j) {
          var key = keys4[j];
          var val = obj[key];
          if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
            queue2.push({ obj, prop: key });
            refs.push(val);
          }
        }
      }
      compactQueue(queue2);
      return value;
    };
    var isRegExp = function isRegExp2(obj) {
      return Object.prototype.toString.call(obj) === "[object RegExp]";
    };
    var isBuffer = function isBuffer2(obj) {
      if (!obj || typeof obj !== "object") {
        return false;
      }
      return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
    };
    var combine = function combine2(a, b) {
      return [].concat(a, b);
    };
    var maybeMap = function maybeMap2(val, fn) {
      if (isArray3(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
          mapped.push(fn(val[i]));
        }
        return mapped;
      }
      return fn(val);
    };
    module.exports = {
      arrayToObject,
      assign,
      combine,
      compact: compact4,
      decode,
      encode,
      isBuffer,
      isRegExp,
      maybeMap,
      merge
    };
  }
});

// ../../node_modules/qs/lib/stringify.js
var require_stringify = __commonJS({
  "../../node_modules/qs/lib/stringify.js"(exports, module) {
    "use strict";
    var getSideChannel = require_side_channel();
    var utils = require_utils();
    var formats = require_formats();
    var has3 = Object.prototype.hasOwnProperty;
    var arrayPrefixGenerators = {
      brackets: function brackets(prefix2) {
        return prefix2 + "[]";
      },
      comma: "comma",
      indices: function indices(prefix2, key) {
        return prefix2 + "[" + key + "]";
      },
      repeat: function repeat(prefix2) {
        return prefix2;
      }
    };
    var isArray3 = Array.isArray;
    var push2 = Array.prototype.push;
    var pushToArray = function(arr, valueOrArray) {
      push2.apply(arr, isArray3(valueOrArray) ? valueOrArray : [valueOrArray]);
    };
    var toISO = Date.prototype.toISOString;
    var defaultFormat = formats["default"];
    var defaults = {
      addQueryPrefix: false,
      allowDots: false,
      charset: "utf-8",
      charsetSentinel: false,
      delimiter: "&",
      encode: true,
      encoder: utils.encode,
      encodeValuesOnly: false,
      format: defaultFormat,
      formatter: formats.formatters[defaultFormat],
      // deprecated
      indices: false,
      serializeDate: function serializeDate(date) {
        return toISO.call(date);
      },
      skipNulls: false,
      strictNullHandling: false
    };
    var isNonNullishPrimitive = function isNonNullishPrimitive2(v) {
      return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
    };
    var sentinel = {};
    var stringify = function stringify2(object, prefix2, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter12, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
      var obj = object;
      var tmpSc = sideChannel;
      var step = 0;
      var findFlag = false;
      while ((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag) {
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
          if (pos === step) {
            throw new RangeError("Cyclic object value");
          } else {
            findFlag = true;
          }
        }
        if (typeof tmpSc.get(sentinel) === "undefined") {
          step = 0;
        }
      }
      if (typeof filter12 === "function") {
        obj = filter12(prefix2, obj);
      } else if (obj instanceof Date) {
        obj = serializeDate(obj);
      } else if (generateArrayPrefix === "comma" && isArray3(obj)) {
        obj = utils.maybeMap(obj, function(value2) {
          if (value2 instanceof Date) {
            return serializeDate(value2);
          }
          return value2;
        });
      }
      if (obj === null) {
        if (strictNullHandling) {
          return encoder && !encodeValuesOnly ? encoder(prefix2, defaults.encoder, charset, "key", format) : prefix2;
        }
        obj = "";
      }
      if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
          var keyValue = encodeValuesOnly ? prefix2 : encoder(prefix2, defaults.encoder, charset, "key", format);
          return [formatter(keyValue) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value", format))];
        }
        return [formatter(prefix2) + "=" + formatter(String(obj))];
      }
      var values = [];
      if (typeof obj === "undefined") {
        return values;
      }
      var objKeys;
      if (generateArrayPrefix === "comma" && isArray3(obj)) {
        if (encodeValuesOnly && encoder) {
          obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
      } else if (isArray3(filter12)) {
        objKeys = filter12;
      } else {
        var keys4 = Object.keys(obj);
        objKeys = sort ? keys4.sort(sort) : keys4;
      }
      var adjustedPrefix = commaRoundTrip && isArray3(obj) && obj.length === 1 ? prefix2 + "[]" : prefix2;
      for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) {
          continue;
        }
        var keyPrefix = isArray3(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify2(
          value,
          keyPrefix,
          generateArrayPrefix,
          commaRoundTrip,
          strictNullHandling,
          skipNulls,
          generateArrayPrefix === "comma" && encodeValuesOnly && isArray3(obj) ? null : encoder,
          filter12,
          sort,
          allowDots,
          serializeDate,
          format,
          formatter,
          encodeValuesOnly,
          charset,
          valueSideChannel
        ));
      }
      return values;
    };
    var normalizeStringifyOptions = function normalizeStringifyOptions2(opts) {
      if (!opts) {
        return defaults;
      }
      if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") {
        throw new TypeError("Encoder has to be a function.");
      }
      var charset = opts.charset || defaults.charset;
      if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
        throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      }
      var format = formats["default"];
      if (typeof opts.format !== "undefined") {
        if (!has3.call(formats.formatters, opts.format)) {
          throw new TypeError("Unknown format option provided.");
        }
        format = opts.format;
      }
      var formatter = formats.formatters[format];
      var filter12 = defaults.filter;
      if (typeof opts.filter === "function" || isArray3(opts.filter)) {
        filter12 = opts.filter;
      }
      return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
        charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter12,
        format,
        formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
      };
    };
    module.exports = function(object, opts) {
      var obj = object;
      var options2 = normalizeStringifyOptions(opts);
      var objKeys;
      var filter12;
      if (typeof options2.filter === "function") {
        filter12 = options2.filter;
        obj = filter12("", obj);
      } else if (isArray3(options2.filter)) {
        filter12 = options2.filter;
        objKeys = filter12;
      }
      var keys4 = [];
      if (typeof obj !== "object" || obj === null) {
        return "";
      }
      var arrayFormat;
      if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
      } else if (opts && "indices" in opts) {
        arrayFormat = opts.indices ? "indices" : "repeat";
      } else {
        arrayFormat = "indices";
      }
      var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
      if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") {
        throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
      }
      var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
      if (!objKeys) {
        objKeys = Object.keys(obj);
      }
      if (options2.sort) {
        objKeys.sort(options2.sort);
      }
      var sideChannel = getSideChannel();
      for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        if (options2.skipNulls && obj[key] === null) {
          continue;
        }
        pushToArray(keys4, stringify(
          obj[key],
          key,
          generateArrayPrefix,
          commaRoundTrip,
          options2.strictNullHandling,
          options2.skipNulls,
          options2.encode ? options2.encoder : null,
          options2.filter,
          options2.sort,
          options2.allowDots,
          options2.serializeDate,
          options2.format,
          options2.formatter,
          options2.encodeValuesOnly,
          options2.charset,
          sideChannel
        ));
      }
      var joined = keys4.join(options2.delimiter);
      var prefix2 = options2.addQueryPrefix === true ? "?" : "";
      if (options2.charsetSentinel) {
        if (options2.charset === "iso-8859-1") {
          prefix2 += "utf8=%26%2310003%3B&";
        } else {
          prefix2 += "utf8=%E2%9C%93&";
        }
      }
      return joined.length > 0 ? prefix2 + joined : "";
    };
  }
});

// ../../node_modules/qs/lib/parse.js
var require_parse = __commonJS({
  "../../node_modules/qs/lib/parse.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var has3 = Object.prototype.hasOwnProperty;
    var isArray3 = Array.isArray;
    var defaults = {
      allowDots: false,
      allowPrototypes: false,
      allowSparse: false,
      arrayLimit: 20,
      charset: "utf-8",
      charsetSentinel: false,
      comma: false,
      decoder: utils.decode,
      delimiter: "&",
      depth: 5,
      ignoreQueryPrefix: false,
      interpretNumericEntities: false,
      parameterLimit: 1e3,
      parseArrays: true,
      plainObjects: false,
      strictNullHandling: false
    };
    var interpretNumericEntities = function(str) {
      return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
      });
    };
    var parseArrayValue = function(val, options2) {
      if (val && typeof val === "string" && options2.comma && val.indexOf(",") > -1) {
        return val.split(",");
      }
      return val;
    };
    var isoSentinel = "utf8=%26%2310003%3B";
    var charsetSentinel = "utf8=%E2%9C%93";
    var parseValues = function parseQueryStringValues(str, options2) {
      var obj = {};
      var cleanStr = options2.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
      var limit = options2.parameterLimit === Infinity ? void 0 : options2.parameterLimit;
      var parts = cleanStr.split(options2.delimiter, limit);
      var skipIndex = -1;
      var i;
      var charset = options2.charset;
      if (options2.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
          if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === charsetSentinel) {
              charset = "utf-8";
            } else if (parts[i] === isoSentinel) {
              charset = "iso-8859-1";
            }
            skipIndex = i;
            i = parts.length;
          }
        }
      }
      for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
          continue;
        }
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
          key = options2.decoder(part, defaults.decoder, charset, "key");
          val = options2.strictNullHandling ? null : "";
        } else {
          key = options2.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
          val = utils.maybeMap(
            parseArrayValue(part.slice(pos + 1), options2),
            function(encodedVal) {
              return options2.decoder(encodedVal, defaults.decoder, charset, "value");
            }
          );
        }
        if (val && options2.interpretNumericEntities && charset === "iso-8859-1") {
          val = interpretNumericEntities(val);
        }
        if (part.indexOf("[]=") > -1) {
          val = isArray3(val) ? [val] : val;
        }
        if (has3.call(obj, key)) {
          obj[key] = utils.combine(obj[key], val);
        } else {
          obj[key] = val;
        }
      }
      return obj;
    };
    var parseObject = function(chain, val, options2, valuesParsed) {
      var leaf = valuesParsed ? val : parseArrayValue(val, options2);
      for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root2 = chain[i];
        if (root2 === "[]" && options2.parseArrays) {
          obj = [].concat(leaf);
        } else {
          obj = options2.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
          var cleanRoot = root2.charAt(0) === "[" && root2.charAt(root2.length - 1) === "]" ? root2.slice(1, -1) : root2;
          var index = parseInt(cleanRoot, 10);
          if (!options2.parseArrays && cleanRoot === "") {
            obj = { 0: leaf };
          } else if (!isNaN(index) && root2 !== cleanRoot && String(index) === cleanRoot && index >= 0 && (options2.parseArrays && index <= options2.arrayLimit)) {
            obj = [];
            obj[index] = leaf;
          } else if (cleanRoot !== "__proto__") {
            obj[cleanRoot] = leaf;
          }
        }
        leaf = obj;
      }
      return leaf;
    };
    var parseKeys = function parseQueryStringKeys(givenKey, val, options2, valuesParsed) {
      if (!givenKey) {
        return;
      }
      var key = options2.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
      var brackets = /(\[[^[\]]*])/;
      var child = /(\[[^[\]]*])/g;
      var segment = options2.depth > 0 && brackets.exec(key);
      var parent = segment ? key.slice(0, segment.index) : key;
      var keys4 = [];
      if (parent) {
        if (!options2.plainObjects && has3.call(Object.prototype, parent)) {
          if (!options2.allowPrototypes) {
            return;
          }
        }
        keys4.push(parent);
      }
      var i = 0;
      while (options2.depth > 0 && (segment = child.exec(key)) !== null && i < options2.depth) {
        i += 1;
        if (!options2.plainObjects && has3.call(Object.prototype, segment[1].slice(1, -1))) {
          if (!options2.allowPrototypes) {
            return;
          }
        }
        keys4.push(segment[1]);
      }
      if (segment) {
        keys4.push("[" + key.slice(segment.index) + "]");
      }
      return parseObject(keys4, val, options2, valuesParsed);
    };
    var normalizeParseOptions = function normalizeParseOptions2(opts) {
      if (!opts) {
        return defaults;
      }
      if (opts.decoder !== null && opts.decoder !== void 0 && typeof opts.decoder !== "function") {
        throw new TypeError("Decoder has to be a function.");
      }
      if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
        throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      }
      var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
      return {
        allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
        charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
      };
    };
    module.exports = function(str, opts) {
      var options2 = normalizeParseOptions(opts);
      if (str === "" || str === null || typeof str === "undefined") {
        return options2.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      }
      var tempObj = typeof str === "string" ? parseValues(str, options2) : str;
      var obj = options2.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var keys4 = Object.keys(tempObj);
      for (var i = 0; i < keys4.length; ++i) {
        var key = keys4[i];
        var newObj = parseKeys(key, tempObj[key], options2, typeof str === "string");
        obj = utils.merge(obj, newObj, options2);
      }
      if (options2.allowSparse === true) {
        return obj;
      }
      return utils.compact(obj);
    };
  }
});

// ../../node_modules/qs/lib/index.js
var require_lib = __commonJS({
  "../../node_modules/qs/lib/index.js"(exports, module) {
    "use strict";
    var stringify = require_stringify();
    var parse = require_parse();
    var formats = require_formats();
    module.exports = {
      formats,
      parse,
      stringify
    };
  }
});

// ../../node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment56 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment56;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (false) {
      module.exports = null;
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty2 = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject2(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject2(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty2.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/prop-types/lib/has.js"(exports, module) {
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    var printWarning = function() {
    };
    if (true) {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has3 = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has3;
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (true) {
        for (var typeSpecName in typeSpecs) {
          if (has3(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (true) {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has3 = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (true) {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement2, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message, data2) {
        this.message = message;
        this.data = data2 && typeof data2 === "object" ? data2 : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (true) {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement2(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (true) {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has3(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          true ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has3(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has3(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement2(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/prop-types/index.js"(exports, module) {
    if (true) {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = null();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// ../../node_modules/timezones.json/timezones.json
var require_timezones = __commonJS({
  "../../node_modules/timezones.json/timezones.json"(exports, module) {
    module.exports = [
      {
        value: "Dateline Standard Time",
        abbr: "DST",
        offset: -12,
        isdst: false,
        text: "(UTC-12:00) International Date Line West",
        utc: [
          "Etc/GMT+12"
        ]
      },
      {
        value: "UTC-11",
        abbr: "U",
        offset: -11,
        isdst: false,
        text: "(UTC-11:00) Coordinated Universal Time-11",
        utc: [
          "Etc/GMT+11",
          "Pacific/Midway",
          "Pacific/Niue",
          "Pacific/Pago_Pago"
        ]
      },
      {
        value: "Hawaiian Standard Time",
        abbr: "HST",
        offset: -10,
        isdst: false,
        text: "(UTC-10:00) Hawaii",
        utc: [
          "Etc/GMT+10",
          "Pacific/Honolulu",
          "Pacific/Johnston",
          "Pacific/Rarotonga",
          "Pacific/Tahiti"
        ]
      },
      {
        value: "Alaskan Standard Time",
        abbr: "AKDT",
        offset: -8,
        isdst: true,
        text: "(UTC-09:00) Alaska",
        utc: [
          "America/Anchorage",
          "America/Juneau",
          "America/Nome",
          "America/Sitka",
          "America/Yakutat"
        ]
      },
      {
        value: "Pacific Standard Time (Mexico)",
        abbr: "PDT",
        offset: -7,
        isdst: true,
        text: "(UTC-08:00) Baja California",
        utc: [
          "America/Santa_Isabel"
        ]
      },
      {
        value: "Pacific Daylight Time",
        abbr: "PDT",
        offset: -7,
        isdst: true,
        text: "(UTC-07:00) Pacific Daylight Time (US & Canada)",
        utc: [
          "America/Los_Angeles",
          "America/Tijuana",
          "America/Vancouver"
        ]
      },
      {
        value: "Pacific Standard Time",
        abbr: "PST",
        offset: -8,
        isdst: false,
        text: "(UTC-08:00) Pacific Standard Time (US & Canada)",
        utc: [
          "America/Los_Angeles",
          "America/Tijuana",
          "America/Vancouver",
          "PST8PDT"
        ]
      },
      {
        value: "US Mountain Standard Time",
        abbr: "UMST",
        offset: -7,
        isdst: false,
        text: "(UTC-07:00) Arizona",
        utc: [
          "America/Creston",
          "America/Dawson",
          "America/Dawson_Creek",
          "America/Hermosillo",
          "America/Phoenix",
          "America/Whitehorse",
          "Etc/GMT+7"
        ]
      },
      {
        value: "Mountain Standard Time (Mexico)",
        abbr: "MDT",
        offset: -6,
        isdst: true,
        text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
        utc: [
          "America/Chihuahua",
          "America/Mazatlan"
        ]
      },
      {
        value: "Mountain Standard Time",
        abbr: "MDT",
        offset: -6,
        isdst: true,
        text: "(UTC-07:00) Mountain Time (US & Canada)",
        utc: [
          "America/Boise",
          "America/Cambridge_Bay",
          "America/Denver",
          "America/Edmonton",
          "America/Inuvik",
          "America/Ojinaga",
          "America/Yellowknife",
          "MST7MDT"
        ]
      },
      {
        value: "Central America Standard Time",
        abbr: "CAST",
        offset: -6,
        isdst: false,
        text: "(UTC-06:00) Central America",
        utc: [
          "America/Belize",
          "America/Costa_Rica",
          "America/El_Salvador",
          "America/Guatemala",
          "America/Managua",
          "America/Tegucigalpa",
          "Etc/GMT+6",
          "Pacific/Galapagos"
        ]
      },
      {
        value: "Central Standard Time",
        abbr: "CDT",
        offset: -5,
        isdst: true,
        text: "(UTC-06:00) Central Time (US & Canada)",
        utc: [
          "America/Chicago",
          "America/Indiana/Knox",
          "America/Indiana/Tell_City",
          "America/Matamoros",
          "America/Menominee",
          "America/North_Dakota/Beulah",
          "America/North_Dakota/Center",
          "America/North_Dakota/New_Salem",
          "America/Rainy_River",
          "America/Rankin_Inlet",
          "America/Resolute",
          "America/Winnipeg",
          "CST6CDT"
        ]
      },
      {
        value: "Central Standard Time (Mexico)",
        abbr: "CDT",
        offset: -5,
        isdst: true,
        text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
        utc: [
          "America/Bahia_Banderas",
          "America/Cancun",
          "America/Merida",
          "America/Mexico_City",
          "America/Monterrey"
        ]
      },
      {
        value: "Canada Central Standard Time",
        abbr: "CCST",
        offset: -6,
        isdst: false,
        text: "(UTC-06:00) Saskatchewan",
        utc: [
          "America/Regina",
          "America/Swift_Current"
        ]
      },
      {
        value: "SA Pacific Standard Time",
        abbr: "SPST",
        offset: -5,
        isdst: false,
        text: "(UTC-05:00) Bogota, Lima, Quito",
        utc: [
          "America/Bogota",
          "America/Cayman",
          "America/Coral_Harbour",
          "America/Eirunepe",
          "America/Guayaquil",
          "America/Jamaica",
          "America/Lima",
          "America/Panama",
          "America/Rio_Branco",
          "Etc/GMT+5"
        ]
      },
      {
        value: "Eastern Standard Time",
        abbr: "EST",
        offset: -5,
        isdst: false,
        text: "(UTC-05:00) Eastern Time (US & Canada)",
        utc: [
          "America/Detroit",
          "America/Havana",
          "America/Indiana/Petersburg",
          "America/Indiana/Vincennes",
          "America/Indiana/Winamac",
          "America/Iqaluit",
          "America/Kentucky/Monticello",
          "America/Louisville",
          "America/Montreal",
          "America/Nassau",
          "America/New_York",
          "America/Nipigon",
          "America/Pangnirtung",
          "America/Port-au-Prince",
          "America/Thunder_Bay",
          "America/Toronto"
        ]
      },
      {
        value: "Eastern Daylight Time",
        abbr: "EDT",
        offset: -4,
        isdst: true,
        text: "(UTC-04:00) Eastern Daylight Time (US & Canada)",
        utc: [
          "America/Detroit",
          "America/Havana",
          "America/Indiana/Petersburg",
          "America/Indiana/Vincennes",
          "America/Indiana/Winamac",
          "America/Iqaluit",
          "America/Kentucky/Monticello",
          "America/Louisville",
          "America/Montreal",
          "America/Nassau",
          "America/New_York",
          "America/Nipigon",
          "America/Pangnirtung",
          "America/Port-au-Prince",
          "America/Thunder_Bay",
          "America/Toronto"
        ]
      },
      {
        value: "US Eastern Standard Time",
        abbr: "UEDT",
        offset: -5,
        isdst: false,
        text: "(UTC-05:00) Indiana (East)",
        utc: [
          "America/Indiana/Marengo",
          "America/Indiana/Vevay",
          "America/Indianapolis"
        ]
      },
      {
        value: "Venezuela Standard Time",
        abbr: "VST",
        offset: -4.5,
        isdst: false,
        text: "(UTC-04:30) Caracas",
        utc: [
          "America/Caracas"
        ]
      },
      {
        value: "Paraguay Standard Time",
        abbr: "PYT",
        offset: -4,
        isdst: false,
        text: "(UTC-04:00) Asuncion",
        utc: [
          "America/Asuncion"
        ]
      },
      {
        value: "Atlantic Standard Time",
        abbr: "ADT",
        offset: -3,
        isdst: true,
        text: "(UTC-04:00) Atlantic Time (Canada)",
        utc: [
          "America/Glace_Bay",
          "America/Goose_Bay",
          "America/Halifax",
          "America/Moncton",
          "America/Thule",
          "Atlantic/Bermuda"
        ]
      },
      {
        value: "Central Brazilian Standard Time",
        abbr: "CBST",
        offset: -4,
        isdst: false,
        text: "(UTC-04:00) Cuiaba",
        utc: [
          "America/Campo_Grande",
          "America/Cuiaba"
        ]
      },
      {
        value: "SA Western Standard Time",
        abbr: "SWST",
        offset: -4,
        isdst: false,
        text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
        utc: [
          "America/Anguilla",
          "America/Antigua",
          "America/Aruba",
          "America/Barbados",
          "America/Blanc-Sablon",
          "America/Boa_Vista",
          "America/Curacao",
          "America/Dominica",
          "America/Grand_Turk",
          "America/Grenada",
          "America/Guadeloupe",
          "America/Guyana",
          "America/Kralendijk",
          "America/La_Paz",
          "America/Lower_Princes",
          "America/Manaus",
          "America/Marigot",
          "America/Martinique",
          "America/Montserrat",
          "America/Port_of_Spain",
          "America/Porto_Velho",
          "America/Puerto_Rico",
          "America/Santo_Domingo",
          "America/St_Barthelemy",
          "America/St_Kitts",
          "America/St_Lucia",
          "America/St_Thomas",
          "America/St_Vincent",
          "America/Tortola",
          "Etc/GMT+4"
        ]
      },
      {
        value: "Pacific SA Standard Time",
        abbr: "PSST",
        offset: -4,
        isdst: false,
        text: "(UTC-04:00) Santiago",
        utc: [
          "America/Santiago",
          "Antarctica/Palmer"
        ]
      },
      {
        value: "Newfoundland Standard Time",
        abbr: "NDT",
        offset: -2.5,
        isdst: true,
        text: "(UTC-03:30) Newfoundland",
        utc: [
          "America/St_Johns"
        ]
      },
      {
        value: "E. South America Standard Time",
        abbr: "ESAST",
        offset: -3,
        isdst: false,
        text: "(UTC-03:00) Brasilia",
        utc: [
          "America/Sao_Paulo"
        ]
      },
      {
        value: "Argentina Standard Time",
        abbr: "AST",
        offset: -3,
        isdst: false,
        text: "(UTC-03:00) Buenos Aires",
        utc: [
          "America/Argentina/La_Rioja",
          "America/Argentina/Rio_Gallegos",
          "America/Argentina/Salta",
          "America/Argentina/San_Juan",
          "America/Argentina/San_Luis",
          "America/Argentina/Tucuman",
          "America/Argentina/Ushuaia",
          "America/Buenos_Aires",
          "America/Catamarca",
          "America/Cordoba",
          "America/Jujuy",
          "America/Mendoza"
        ]
      },
      {
        value: "SA Eastern Standard Time",
        abbr: "SEST",
        offset: -3,
        isdst: false,
        text: "(UTC-03:00) Cayenne, Fortaleza",
        utc: [
          "America/Araguaina",
          "America/Belem",
          "America/Cayenne",
          "America/Fortaleza",
          "America/Maceio",
          "America/Paramaribo",
          "America/Recife",
          "America/Santarem",
          "Antarctica/Rothera",
          "Atlantic/Stanley",
          "Etc/GMT+3"
        ]
      },
      {
        value: "Greenland Standard Time",
        abbr: "GDT",
        offset: -3,
        isdst: true,
        text: "(UTC-03:00) Greenland",
        utc: [
          "America/Godthab"
        ]
      },
      {
        value: "Montevideo Standard Time",
        abbr: "MST",
        offset: -3,
        isdst: false,
        text: "(UTC-03:00) Montevideo",
        utc: [
          "America/Montevideo"
        ]
      },
      {
        value: "Bahia Standard Time",
        abbr: "BST",
        offset: -3,
        isdst: false,
        text: "(UTC-03:00) Salvador",
        utc: [
          "America/Bahia"
        ]
      },
      {
        value: "UTC-02",
        abbr: "U",
        offset: -2,
        isdst: false,
        text: "(UTC-02:00) Coordinated Universal Time-02",
        utc: [
          "America/Noronha",
          "Atlantic/South_Georgia",
          "Etc/GMT+2"
        ]
      },
      {
        value: "Mid-Atlantic Standard Time",
        abbr: "MDT",
        offset: -1,
        isdst: true,
        text: "(UTC-02:00) Mid-Atlantic - Old",
        utc: []
      },
      {
        value: "Azores Standard Time",
        abbr: "ADT",
        offset: 0,
        isdst: true,
        text: "(UTC-01:00) Azores",
        utc: [
          "America/Scoresbysund",
          "Atlantic/Azores"
        ]
      },
      {
        value: "Cape Verde Standard Time",
        abbr: "CVST",
        offset: -1,
        isdst: false,
        text: "(UTC-01:00) Cape Verde Is.",
        utc: [
          "Atlantic/Cape_Verde",
          "Etc/GMT+1"
        ]
      },
      {
        value: "Morocco Standard Time",
        abbr: "MDT",
        offset: 1,
        isdst: true,
        text: "(UTC) Casablanca",
        utc: [
          "Africa/Casablanca",
          "Africa/El_Aaiun"
        ]
      },
      {
        value: "UTC",
        abbr: "UTC",
        offset: 0,
        isdst: false,
        text: "(UTC) Coordinated Universal Time",
        utc: [
          "America/Danmarkshavn",
          "Etc/GMT"
        ]
      },
      {
        value: "GMT Standard Time",
        abbr: "GMT",
        offset: 0,
        isdst: false,
        text: "(UTC) Edinburgh, London",
        utc: [
          "Europe/Isle_of_Man",
          "Europe/Guernsey",
          "Europe/Jersey",
          "Europe/London"
        ]
      },
      {
        value: "British Summer Time",
        abbr: "BST",
        offset: 1,
        isdst: true,
        text: "(UTC+01:00) Edinburgh, London",
        utc: [
          "Europe/Isle_of_Man",
          "Europe/Guernsey",
          "Europe/Jersey",
          "Europe/London"
        ]
      },
      {
        value: "GMT Standard Time",
        abbr: "GDT",
        offset: 1,
        isdst: true,
        text: "(UTC) Dublin, Lisbon",
        utc: [
          "Atlantic/Canary",
          "Atlantic/Faeroe",
          "Atlantic/Madeira",
          "Europe/Dublin",
          "Europe/Lisbon"
        ]
      },
      {
        value: "Greenwich Standard Time",
        abbr: "GST",
        offset: 0,
        isdst: false,
        text: "(UTC) Monrovia, Reykjavik",
        utc: [
          "Africa/Abidjan",
          "Africa/Accra",
          "Africa/Bamako",
          "Africa/Banjul",
          "Africa/Bissau",
          "Africa/Conakry",
          "Africa/Dakar",
          "Africa/Freetown",
          "Africa/Lome",
          "Africa/Monrovia",
          "Africa/Nouakchott",
          "Africa/Ouagadougou",
          "Africa/Sao_Tome",
          "Atlantic/Reykjavik",
          "Atlantic/St_Helena"
        ]
      },
      {
        value: "W. Europe Standard Time",
        abbr: "WEDT",
        offset: 2,
        isdst: true,
        text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
        utc: [
          "Arctic/Longyearbyen",
          "Europe/Amsterdam",
          "Europe/Andorra",
          "Europe/Berlin",
          "Europe/Busingen",
          "Europe/Gibraltar",
          "Europe/Luxembourg",
          "Europe/Malta",
          "Europe/Monaco",
          "Europe/Oslo",
          "Europe/Rome",
          "Europe/San_Marino",
          "Europe/Stockholm",
          "Europe/Vaduz",
          "Europe/Vatican",
          "Europe/Vienna",
          "Europe/Zurich"
        ]
      },
      {
        value: "Central Europe Standard Time",
        abbr: "CEDT",
        offset: 2,
        isdst: true,
        text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
        utc: [
          "Europe/Belgrade",
          "Europe/Bratislava",
          "Europe/Budapest",
          "Europe/Ljubljana",
          "Europe/Podgorica",
          "Europe/Prague",
          "Europe/Tirane"
        ]
      },
      {
        value: "Romance Standard Time",
        abbr: "RDT",
        offset: 2,
        isdst: true,
        text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
        utc: [
          "Africa/Ceuta",
          "Europe/Brussels",
          "Europe/Copenhagen",
          "Europe/Madrid",
          "Europe/Paris"
        ]
      },
      {
        value: "Central European Standard Time",
        abbr: "CEDT",
        offset: 2,
        isdst: true,
        text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
        utc: [
          "Europe/Sarajevo",
          "Europe/Skopje",
          "Europe/Warsaw",
          "Europe/Zagreb"
        ]
      },
      {
        value: "W. Central Africa Standard Time",
        abbr: "WCAST",
        offset: 1,
        isdst: false,
        text: "(UTC+01:00) West Central Africa",
        utc: [
          "Africa/Algiers",
          "Africa/Bangui",
          "Africa/Brazzaville",
          "Africa/Douala",
          "Africa/Kinshasa",
          "Africa/Lagos",
          "Africa/Libreville",
          "Africa/Luanda",
          "Africa/Malabo",
          "Africa/Ndjamena",
          "Africa/Niamey",
          "Africa/Porto-Novo",
          "Africa/Tunis",
          "Etc/GMT-1"
        ]
      },
      {
        value: "Namibia Standard Time",
        abbr: "NST",
        offset: 1,
        isdst: false,
        text: "(UTC+01:00) Windhoek",
        utc: [
          "Africa/Windhoek"
        ]
      },
      {
        value: "GTB Standard Time",
        abbr: "GDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) Athens, Bucharest",
        utc: [
          "Asia/Nicosia",
          "Europe/Athens",
          "Europe/Bucharest",
          "Europe/Chisinau"
        ]
      },
      {
        value: "Middle East Standard Time",
        abbr: "MEDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) Beirut",
        utc: [
          "Asia/Beirut"
        ]
      },
      {
        value: "Egypt Standard Time",
        abbr: "EST",
        offset: 2,
        isdst: false,
        text: "(UTC+02:00) Cairo",
        utc: [
          "Africa/Cairo"
        ]
      },
      {
        value: "Syria Standard Time",
        abbr: "SDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) Damascus",
        utc: [
          "Asia/Damascus"
        ]
      },
      {
        value: "E. Europe Standard Time",
        abbr: "EEDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) E. Europe",
        utc: [
          "Asia/Nicosia",
          "Europe/Athens",
          "Europe/Bucharest",
          "Europe/Chisinau",
          "Europe/Helsinki",
          "Europe/Kiev",
          "Europe/Mariehamn",
          "Europe/Nicosia",
          "Europe/Riga",
          "Europe/Sofia",
          "Europe/Tallinn",
          "Europe/Uzhgorod",
          "Europe/Vilnius",
          "Europe/Zaporozhye"
        ]
      },
      {
        value: "South Africa Standard Time",
        abbr: "SAST",
        offset: 2,
        isdst: false,
        text: "(UTC+02:00) Harare, Pretoria",
        utc: [
          "Africa/Blantyre",
          "Africa/Bujumbura",
          "Africa/Gaborone",
          "Africa/Harare",
          "Africa/Johannesburg",
          "Africa/Kigali",
          "Africa/Lubumbashi",
          "Africa/Lusaka",
          "Africa/Maputo",
          "Africa/Maseru",
          "Africa/Mbabane",
          "Etc/GMT-2"
        ]
      },
      {
        value: "FLE Standard Time",
        abbr: "FDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
        utc: [
          "Europe/Helsinki",
          "Europe/Kiev",
          "Europe/Mariehamn",
          "Europe/Riga",
          "Europe/Sofia",
          "Europe/Tallinn",
          "Europe/Uzhgorod",
          "Europe/Vilnius",
          "Europe/Zaporozhye"
        ]
      },
      {
        value: "Turkey Standard Time",
        abbr: "TDT",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Istanbul",
        utc: [
          "Europe/Istanbul"
        ]
      },
      {
        value: "Israel Standard Time",
        abbr: "JDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) Jerusalem",
        utc: [
          "Asia/Jerusalem"
        ]
      },
      {
        value: "Libya Standard Time",
        abbr: "LST",
        offset: 2,
        isdst: false,
        text: "(UTC+02:00) Tripoli",
        utc: [
          "Africa/Tripoli"
        ]
      },
      {
        value: "Jordan Standard Time",
        abbr: "JST",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Amman",
        utc: [
          "Asia/Amman"
        ]
      },
      {
        value: "Arabic Standard Time",
        abbr: "AST",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Baghdad",
        utc: [
          "Asia/Baghdad"
        ]
      },
      {
        value: "Kaliningrad Standard Time",
        abbr: "KST",
        offset: 3,
        isdst: false,
        text: "(UTC+02:00) Kaliningrad",
        utc: [
          "Europe/Kaliningrad"
        ]
      },
      {
        value: "Arab Standard Time",
        abbr: "AST",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Kuwait, Riyadh",
        utc: [
          "Asia/Aden",
          "Asia/Bahrain",
          "Asia/Kuwait",
          "Asia/Qatar",
          "Asia/Riyadh"
        ]
      },
      {
        value: "E. Africa Standard Time",
        abbr: "EAST",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Nairobi",
        utc: [
          "Africa/Addis_Ababa",
          "Africa/Asmera",
          "Africa/Dar_es_Salaam",
          "Africa/Djibouti",
          "Africa/Juba",
          "Africa/Kampala",
          "Africa/Khartoum",
          "Africa/Mogadishu",
          "Africa/Nairobi",
          "Antarctica/Syowa",
          "Etc/GMT-3",
          "Indian/Antananarivo",
          "Indian/Comoro",
          "Indian/Mayotte"
        ]
      },
      {
        value: "Moscow Standard Time",
        abbr: "MSK",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
        utc: [
          "Europe/Kirov",
          "Europe/Moscow",
          "Europe/Simferopol",
          "Europe/Volgograd",
          "Europe/Minsk"
        ]
      },
      {
        value: "Samara Time",
        abbr: "SAMT",
        offset: 4,
        isdst: false,
        text: "(UTC+04:00) Samara, Ulyanovsk, Saratov",
        utc: [
          "Europe/Astrakhan",
          "Europe/Samara",
          "Europe/Ulyanovsk"
        ]
      },
      {
        value: "Iran Standard Time",
        abbr: "IDT",
        offset: 4.5,
        isdst: true,
        text: "(UTC+03:30) Tehran",
        utc: [
          "Asia/Tehran"
        ]
      },
      {
        value: "Arabian Standard Time",
        abbr: "AST",
        offset: 4,
        isdst: false,
        text: "(UTC+04:00) Abu Dhabi, Muscat",
        utc: [
          "Asia/Dubai",
          "Asia/Muscat",
          "Etc/GMT-4"
        ]
      },
      {
        value: "Azerbaijan Standard Time",
        abbr: "ADT",
        offset: 5,
        isdst: true,
        text: "(UTC+04:00) Baku",
        utc: [
          "Asia/Baku"
        ]
      },
      {
        value: "Mauritius Standard Time",
        abbr: "MST",
        offset: 4,
        isdst: false,
        text: "(UTC+04:00) Port Louis",
        utc: [
          "Indian/Mahe",
          "Indian/Mauritius",
          "Indian/Reunion"
        ]
      },
      {
        value: "Georgian Standard Time",
        abbr: "GET",
        offset: 4,
        isdst: false,
        text: "(UTC+04:00) Tbilisi",
        utc: [
          "Asia/Tbilisi"
        ]
      },
      {
        value: "Caucasus Standard Time",
        abbr: "CST",
        offset: 4,
        isdst: false,
        text: "(UTC+04:00) Yerevan",
        utc: [
          "Asia/Yerevan"
        ]
      },
      {
        value: "Afghanistan Standard Time",
        abbr: "AST",
        offset: 4.5,
        isdst: false,
        text: "(UTC+04:30) Kabul",
        utc: [
          "Asia/Kabul"
        ]
      },
      {
        value: "West Asia Standard Time",
        abbr: "WAST",
        offset: 5,
        isdst: false,
        text: "(UTC+05:00) Ashgabat, Tashkent",
        utc: [
          "Antarctica/Mawson",
          "Asia/Aqtau",
          "Asia/Aqtobe",
          "Asia/Ashgabat",
          "Asia/Dushanbe",
          "Asia/Oral",
          "Asia/Samarkand",
          "Asia/Tashkent",
          "Etc/GMT-5",
          "Indian/Kerguelen",
          "Indian/Maldives"
        ]
      },
      {
        value: "Yekaterinburg Time",
        abbr: "YEKT",
        offset: 5,
        isdst: false,
        text: "(UTC+05:00) Yekaterinburg",
        utc: [
          "Asia/Yekaterinburg"
        ]
      },
      {
        value: "Pakistan Standard Time",
        abbr: "PKT",
        offset: 5,
        isdst: false,
        text: "(UTC+05:00) Islamabad, Karachi",
        utc: [
          "Asia/Karachi"
        ]
      },
      {
        value: "India Standard Time",
        abbr: "IST",
        offset: 5.5,
        isdst: false,
        text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
        utc: [
          "Asia/Kolkata",
          "Asia/Calcutta"
        ]
      },
      {
        value: "Sri Lanka Standard Time",
        abbr: "SLST",
        offset: 5.5,
        isdst: false,
        text: "(UTC+05:30) Sri Jayawardenepura",
        utc: [
          "Asia/Colombo"
        ]
      },
      {
        value: "Nepal Standard Time",
        abbr: "NST",
        offset: 5.75,
        isdst: false,
        text: "(UTC+05:45) Kathmandu",
        utc: [
          "Asia/Kathmandu"
        ]
      },
      {
        value: "Central Asia Standard Time",
        abbr: "CAST",
        offset: 6,
        isdst: false,
        text: "(UTC+06:00) Nur-Sultan (Astana)",
        utc: [
          "Antarctica/Vostok",
          "Asia/Almaty",
          "Asia/Bishkek",
          "Asia/Qyzylorda",
          "Asia/Urumqi",
          "Etc/GMT-6",
          "Indian/Chagos"
        ]
      },
      {
        value: "Bangladesh Standard Time",
        abbr: "BST",
        offset: 6,
        isdst: false,
        text: "(UTC+06:00) Dhaka",
        utc: [
          "Asia/Dhaka",
          "Asia/Thimphu"
        ]
      },
      {
        value: "Myanmar Standard Time",
        abbr: "MST",
        offset: 6.5,
        isdst: false,
        text: "(UTC+06:30) Yangon (Rangoon)",
        utc: [
          "Asia/Rangoon",
          "Indian/Cocos"
        ]
      },
      {
        value: "SE Asia Standard Time",
        abbr: "SAST",
        offset: 7,
        isdst: false,
        text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
        utc: [
          "Antarctica/Davis",
          "Asia/Bangkok",
          "Asia/Hovd",
          "Asia/Jakarta",
          "Asia/Phnom_Penh",
          "Asia/Pontianak",
          "Asia/Saigon",
          "Asia/Vientiane",
          "Etc/GMT-7",
          "Indian/Christmas"
        ]
      },
      {
        value: "N. Central Asia Standard Time",
        abbr: "NCAST",
        offset: 7,
        isdst: false,
        text: "(UTC+07:00) Novosibirsk",
        utc: [
          "Asia/Novokuznetsk",
          "Asia/Novosibirsk",
          "Asia/Omsk"
        ]
      },
      {
        value: "China Standard Time",
        abbr: "CST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
        utc: [
          "Asia/Hong_Kong",
          "Asia/Macau",
          "Asia/Shanghai"
        ]
      },
      {
        value: "North Asia Standard Time",
        abbr: "NAST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Krasnoyarsk",
        utc: [
          "Asia/Krasnoyarsk"
        ]
      },
      {
        value: "Singapore Standard Time",
        abbr: "MPST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Kuala Lumpur, Singapore",
        utc: [
          "Asia/Brunei",
          "Asia/Kuala_Lumpur",
          "Asia/Kuching",
          "Asia/Makassar",
          "Asia/Manila",
          "Asia/Singapore",
          "Etc/GMT-8"
        ]
      },
      {
        value: "W. Australia Standard Time",
        abbr: "WAST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Perth",
        utc: [
          "Antarctica/Casey",
          "Australia/Perth"
        ]
      },
      {
        value: "Taipei Standard Time",
        abbr: "TST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Taipei",
        utc: [
          "Asia/Taipei"
        ]
      },
      {
        value: "Ulaanbaatar Standard Time",
        abbr: "UST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Ulaanbaatar",
        utc: [
          "Asia/Choibalsan",
          "Asia/Ulaanbaatar"
        ]
      },
      {
        value: "North Asia East Standard Time",
        abbr: "NAEST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Irkutsk",
        utc: [
          "Asia/Irkutsk"
        ]
      },
      {
        value: "Japan Standard Time",
        abbr: "JST",
        offset: 9,
        isdst: false,
        text: "(UTC+09:00) Osaka, Sapporo, Tokyo",
        utc: [
          "Asia/Dili",
          "Asia/Jayapura",
          "Asia/Tokyo",
          "Etc/GMT-9",
          "Pacific/Palau"
        ]
      },
      {
        value: "Korea Standard Time",
        abbr: "KST",
        offset: 9,
        isdst: false,
        text: "(UTC+09:00) Seoul",
        utc: [
          "Asia/Pyongyang",
          "Asia/Seoul"
        ]
      },
      {
        value: "Cen. Australia Standard Time",
        abbr: "CAST",
        offset: 9.5,
        isdst: false,
        text: "(UTC+09:30) Adelaide",
        utc: [
          "Australia/Adelaide",
          "Australia/Broken_Hill"
        ]
      },
      {
        value: "AUS Central Standard Time",
        abbr: "ACST",
        offset: 9.5,
        isdst: false,
        text: "(UTC+09:30) Darwin",
        utc: [
          "Australia/Darwin"
        ]
      },
      {
        value: "E. Australia Standard Time",
        abbr: "EAST",
        offset: 10,
        isdst: false,
        text: "(UTC+10:00) Brisbane",
        utc: [
          "Australia/Brisbane",
          "Australia/Lindeman"
        ]
      },
      {
        value: "AUS Eastern Standard Time",
        abbr: "AEST",
        offset: 10,
        isdst: false,
        text: "(UTC+10:00) Canberra, Melbourne, Sydney",
        utc: [
          "Australia/Melbourne",
          "Australia/Sydney"
        ]
      },
      {
        value: "West Pacific Standard Time",
        abbr: "WPST",
        offset: 10,
        isdst: false,
        text: "(UTC+10:00) Guam, Port Moresby",
        utc: [
          "Antarctica/DumontDUrville",
          "Etc/GMT-10",
          "Pacific/Guam",
          "Pacific/Port_Moresby",
          "Pacific/Saipan",
          "Pacific/Truk"
        ]
      },
      {
        value: "Tasmania Standard Time",
        abbr: "TST",
        offset: 10,
        isdst: false,
        text: "(UTC+10:00) Hobart",
        utc: [
          "Australia/Currie",
          "Australia/Hobart"
        ]
      },
      {
        value: "Yakutsk Standard Time",
        abbr: "YST",
        offset: 9,
        isdst: false,
        text: "(UTC+09:00) Yakutsk",
        utc: [
          "Asia/Chita",
          "Asia/Khandyga",
          "Asia/Yakutsk"
        ]
      },
      {
        value: "Central Pacific Standard Time",
        abbr: "CPST",
        offset: 11,
        isdst: false,
        text: "(UTC+11:00) Solomon Is., New Caledonia",
        utc: [
          "Antarctica/Macquarie",
          "Etc/GMT-11",
          "Pacific/Efate",
          "Pacific/Guadalcanal",
          "Pacific/Kosrae",
          "Pacific/Noumea",
          "Pacific/Ponape"
        ]
      },
      {
        value: "Vladivostok Standard Time",
        abbr: "VST",
        offset: 11,
        isdst: false,
        text: "(UTC+11:00) Vladivostok",
        utc: [
          "Asia/Sakhalin",
          "Asia/Ust-Nera",
          "Asia/Vladivostok"
        ]
      },
      {
        value: "New Zealand Standard Time",
        abbr: "NZST",
        offset: 12,
        isdst: false,
        text: "(UTC+12:00) Auckland, Wellington",
        utc: [
          "Antarctica/McMurdo",
          "Pacific/Auckland"
        ]
      },
      {
        value: "UTC+12",
        abbr: "U",
        offset: 12,
        isdst: false,
        text: "(UTC+12:00) Coordinated Universal Time+12",
        utc: [
          "Etc/GMT-12",
          "Pacific/Funafuti",
          "Pacific/Kwajalein",
          "Pacific/Majuro",
          "Pacific/Nauru",
          "Pacific/Tarawa",
          "Pacific/Wake",
          "Pacific/Wallis"
        ]
      },
      {
        value: "Fiji Standard Time",
        abbr: "FST",
        offset: 12,
        isdst: false,
        text: "(UTC+12:00) Fiji",
        utc: [
          "Pacific/Fiji"
        ]
      },
      {
        value: "Magadan Standard Time",
        abbr: "MST",
        offset: 12,
        isdst: false,
        text: "(UTC+12:00) Magadan",
        utc: [
          "Asia/Anadyr",
          "Asia/Kamchatka",
          "Asia/Magadan",
          "Asia/Srednekolymsk"
        ]
      },
      {
        value: "Kamchatka Standard Time",
        abbr: "KDT",
        offset: 13,
        isdst: true,
        text: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
        utc: [
          "Asia/Kamchatka"
        ]
      },
      {
        value: "Tonga Standard Time",
        abbr: "TST",
        offset: 13,
        isdst: false,
        text: "(UTC+13:00) Nuku'alofa",
        utc: [
          "Etc/GMT-13",
          "Pacific/Enderbury",
          "Pacific/Fakaofo",
          "Pacific/Tongatapu"
        ]
      },
      {
        value: "Samoa Standard Time",
        abbr: "SST",
        offset: 13,
        isdst: false,
        text: "(UTC+13:00) Samoa",
        utc: [
          "Pacific/Apia"
        ]
      }
    ];
  }
});

// ../../node_modules/timezones.json/index.js
var require_timezones2 = __commonJS({
  "../../node_modules/timezones.json/index.js"(exports, module) {
    module.exports = require_timezones();
  }
});

// ../../node_modules/entities/lib/generated/decode-data-html.js
var require_decode_data_html = __commonJS({
  "../../node_modules/entities/lib/generated/decode-data-html.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = new Uint16Array(
      // prettier-ignore
      '\u1D41<\xD5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7F\x84\x8B\x90\x95\x98\xA6\xB3\xB9\xC8\xCFlig\u803B\xC6\u40C6P\u803B&\u4026cute\u803B\xC1\u40C1reve;\u4102\u0100iyx}rc\u803B\xC2\u40C2;\u4410r;\uC000\u{1D504}rave\u803B\xC0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9D\xA1on;\u4104f;\uC000\u{1D538}plyFunction;\u6061ing\u803B\xC5\u40C5\u0100cs\xBE\xC3r;\uC000\u{1D49C}ign;\u6254ilde\u803B\xC3\u40C3ml\u803B\xC4\u40C4\u0400aceforsu\xE5\xFB\xFE\u0117\u011C\u0122\u0127\u012A\u0100cr\xEA\xF2kslash;\u6216\u0176\xF6\xF8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\u{1D505}pf;\uC000\u{1D539}eve;\u42D8c\xF2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xA9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xC7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xF2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\u{1D49E}p\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\u{1D507}\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\u{1D53B}\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xEC\u0239o\u0274\u0379\0\0\u037B\xBB\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xE5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\u{1D49F}rok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xD0\u40D0cute\u803B\xC9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xCA\u40CA;\u442Dot;\u4116r;\uC000\u{1D508}rave\u803B\xC8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\u{1D53C}silon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xCB\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\u{1D509}lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\u{1D53D}All;\u6200riertrf;\u6131c\xF2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\u{1D50A};\u62D9pf;\uC000\u{1D53E}eater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\u{1D4A2};\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xF2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xF0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xCD\u40CD\u0100iy\u0713\u0718rc\u803B\xCE\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xCC\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xF3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\u{1D540}a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xCF\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\u{1D50D}pf;\uC000\u{1D541}\u01E3\u07C7\0\u07CCr;\uC000\u{1D4A5}rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\u{1D50E}pf;\uC000\u{1D542}cr;\uC000\u{1D4A6}\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xE1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\u{1D50F}\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xE1\u03BFight\xE1\u03CAf;\uC000\u{1D543}er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xF2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\u{1D510}nusPlus;\u6213pf;\uC000\u{1D544}c\xF2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xEB\u0AD9eryThi\xEE\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xF2\u0673essLes\xF3\u0A48Line;\u400Ar;\uC000\u{1D511}\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\u{1D4A9}ilde\u803B\xD1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xD3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xD4\u40D4;\u441Eblac;\u4150r;\uC000\u{1D512}rave\u803B\xD2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\u{1D546}enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\u{1D4AA}ash\u803B\xD8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xD5\u40D5es;\u6A37ml\u803B\xD6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\u{1D513}i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xE5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\u{1D4AB};\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\u{1D514}pf;\u611Acr;\uC000\u{1D4AC}\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xAE\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xBB\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\u{1D516}ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xBB\u041EeftArrow\xBB\u089AightArrow\xBB\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\u{1D54A}\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\u{1D4AE}ar;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xE1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xBB\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xDE\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\u{1D517}\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\u{1D54B}ipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\u{1D4AF}rok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xDA\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xDB\u40DB;\u4423blac;\u4170r;\uC000\u{1D518}rave\u803B\xD9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\u{1D54C}\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xE1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\u{1D4B0}ilde;\u4168ml\u803B\xDC\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\u{1D519}pf;\uC000\u{1D54D}cr;\uC000\u{1D4B1}dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\u{1D51A}pf;\uC000\u{1D54E}cr;\uC000\u{1D4B2}\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\u{1D51B};\u439Epf;\uC000\u{1D54F}cr;\uC000\u{1D4B3}\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xDD\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\u{1D51C}pf;\uC000\u{1D550}cr;\uC000\u{1D4B4}ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xE8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\u{1D4B5}\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xE1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xE2\u40E2te\u80BB\xB4\u0306;\u4430lig\u803B\xE6\u40E6\u0100;r\xB2\u15BA;\uC000\u{1D51E}rave\u803B\xE0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xE8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xBB\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xBB\xB9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\u{1D552}\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xF1\u1683ing\u803B\xE5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\u{1D4B6};\u402Amp\u0100;e\u12C1\u16AF\xF1\u0288ilde\u803B\xE3\u40E3ml\u803B\xE4\u40E4\u0100ci\u16C2\u16C8onin\xF4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xBB\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xE9\u170Cno\xF5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\u{1D51F}g\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xF0\u0760rc;\u65EFp\xBB\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xE5\u1444\xE5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\u{1D553}\u0100;t\u13CB\u1863om\xBB\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xA6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\u{1D4B7}mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xBB\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xEE\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xE7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xB8\u01ADptyv;\u69B2t\u8100\xA2;e\u1A2D\u1A2E\u40A2r\xE4\u01B2r;\uC000\u{1D520}\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xBB\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xBB\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xBB\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xC7\xC6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xEE\u1160e\u0100mx\u1AF1\u1AF6ent\xBB\u1AE9e\xF3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xF4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\u{1D554}o\xE4\u0254\u8100\xA9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\u{1D4B8}\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xE3\u1B73u\xE3\u1B75ee;\u62CEedge;\u62CFen\u803B\xA4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xBB\u1B80ight\xBB\u1BBDe\xE4\u1BDD\u0100ci\u1C01\u1C07onin\xF4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xF2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xF2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xBB\u090A\u016B\u1C61\u1C67arow;\u690Fa\xE3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xB0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\u{1D521}ar\u0100lr\u1CB3\u1CB5\xBB\u08DC\xBB\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xF7;o\u1CE7\u1CF0ntimes;\u62C7n\xF8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\u{1D555}\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xE5\xFAn\u0180adh\u112E\u1D5D\u1D67ownarrow\xF3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xF4\u1CB4igh\xF4\u1CB6\u0162\u1D7F\u1D85karo\xF7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\u{1D4B9};\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xF2\u0429a\xF2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xF4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xE9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xEA\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\u{1D522}\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xE8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xBB\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\u{1D556}\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xBB\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xBB\u1E2E\u0269\u1EF9\0\0\u1EFB\xED\u0548ant\u0100gl\u1F02\u1F06tr\xBB\u1E5Dess\xBB\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xF4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xF0\u40F0\u0100mr\u1F53\u1F57l\u803B\xEB\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xF4\u056E\u0100eo\u1F6C\u1F74ctatio\xEE\u0559nential\xE5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xF1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\u{1D523}lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\u{1D557}\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xBD\u40BD;\u6153\u803B\xBC\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xBE\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\u{1D4BB}\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xF4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\u{1D524}\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xBB\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\u{1D558}\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xF8\u209Er;\u6978q\u0100lq\u063F\u2196les\xF3\u2088i\xED\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xC5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xF2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xF0\u1484f\xBB\u2024il\xF4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xBB\u220Alip;\u6026con;\u62B9r;\uC000\u{1D525}s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\u{1D559}bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\u{1D4BD}as\xE8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xBB\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xED\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xEE\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xA1\u40A1\u0100fr\u039F\u22C9;\uC000\u{1D526}rave\u803B\xEC\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xE5\u078Ear\xF4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xF4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xF3\u1563\xE3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\u{1D55A}a;\u43B9uest\u803B\xBF\u40BF\u0100ci\u238A\u238Fr;\uC000\u{1D4BE}n\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xEF\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\u{1D527}ath;\u4237pf;\uC000\u{1D55B}\u01E3\u23EC\0\u23F1r;\uC000\u{1D4BF}rcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\u{1D528}reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\u{1D55C}cr;\uC000\u{1D4C0}\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xF2\u09C6\xF2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xEE\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xE5\u088E;\u6A85uo\u803B\xAB\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xEB\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xEC\u08B0\xE2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xE9\u24F6arpoon\u0100du\u25AF\u25B4own\xBB\u045Ap\xBB\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xF3\u0F98quigarro\xF7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xF4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xF8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xF4\u0989gt\xF2\u248C\xF4\u099Bi\xED\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\u{1D529}\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xF2\u25C1orne\xF2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xBB\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xBB\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xEB\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xE1\u09F2apsto;\u67FCight\xE1\u09FDparrow\u0100lr\u2725\u2729ef\xF4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\u{1D55D}us;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xE1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xBB\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xF2\u08A8orne\xF2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\u{1D4C1}m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xE5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xC5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xAF\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xBB\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xEE\u048Cef\xF4\u090F\xF0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xBB\u1626r;\uC000\u{1D52A}o;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xB5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xF4\u16A7ir;\u6AF0ot\u80BB\xB7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xF2\u2212\xF0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\u{1D55E}\u0100ct\u28F8\u28FDr;\uC000\u{1D4C2}pos\xBB\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xBB\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xF8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xA0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xF6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xED\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\u{1D52B}\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xF4\u0BE2i\xED\u0BEA\u0100;r\u0BB6\u2A81\xBB\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xF2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xF2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xF7\u2AC1ightarro\xF7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xF4\u0C55\u0100;s\u0C55\u2AF4\xBB\u0C36i\xED\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xE4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\u{1D55F}\u8180\xAC;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xEC\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xE5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xF1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xF2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xBB\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xE5\u0D45;\uC000\u{1D4C3}ort\u026D\u2B05\0\0\u2BD6ar\xE1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xE5\u0CF8\xE5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xF1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xEC\u0BD7lde\u803B\xF1\u40F1\xE7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xF1\u0C26ight\u0100;e\u0CCB\u2C65\xF1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xF3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xF4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\u{1D52C}\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xF2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xF2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xE5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\u{1D560}\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xF2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xBB\u2DFF\u803B\xAA\u40AA\u803B\xBA\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xF2\u2E01ash\u803B\xF8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xF5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xF6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xB6;l\u2E6D\u2E6E\u40B6le\xEC\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\u{1D52D}\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xF4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xBB\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xF6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xB1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\u{1D561}nd\u803B\xA3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xE5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xF8\u2F43urlye\xF1\u0ED9\xF1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xED\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xF0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xEF\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\u{1D4C5};\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\u{1D52E}pf;\uC000\u{1D562}rime;\u6057cr;\uC000\u{1D4C6}\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xF3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xF1\u1F19\xF4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xF2\u10B3\xF2\u03DDail;\u691Car\xF2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xE3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xE5\u0FD1uo\u803B\xBB\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xEB\u225D\xF0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xF3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xF2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xEC\u0FF2\xE2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xE5\u10BBar\xF4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\u{1D52F}\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xBB\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xE9\u30C8arpoon\u0100du\u31BB\u31BFow\xEE\u317Ep\xBB\u1092eft\u0100ah\u31CA\u31D0rrow\xF3\u0FEAarpoon\xF3\u0551ightarrows;\u61C9quigarro\xF7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xF1\u1F32\u0180ahm\u320D\u3210\u3213r\xF2\u0FEAa\xF2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xBB\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xEB\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\u{1D563}us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xF2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\u{1D4C7}\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xE5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xEF\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xE5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xED\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xEB\u2228\u0100;o\u0A36\u0A34t\u803B\xA7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xF0nu\xF3\xF1t;\u6736r\u0100;o\u3376\u2055\uC000\u{1D530}\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xE4\u1464ara\xEC\u2E6F\u803B\xAD\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xF2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xE9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\u{1D564}a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xBB\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xF1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xF1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xBB\u117Car\xF2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\u{1D4C8}tm\xEE\xF1i\xEC\u3415ar\xE6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xEE\u1EE0h\xE9\u2EAFs\xBB\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xF8\u32FAurlye\xF1\u11FE\xF1\u11F3\u0180aes\u3582\u3588\u331Bppro\xF8\u331Aq\xF1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xB9\u40B9\u803B\xB2\u40B2\u803B\xB3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xEB\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xDF\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xEB\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\u{1D531}\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xF8\u12C1im\xBB\u12ACs\xF0\u129E\u0100as\u36BA\u36AE\xF0\u12C1rn\u803B\xFE\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xD7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xE1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\u{1D565}rk;\u6ADA\xE1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xE5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xBB\u1DBBeft\u0100;e\u2800\u373E\xF1\u092E;\u625Cight\u0100;e\u32AA\u374B\xF1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\u{1D4C9};\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xF4\u1777head\u0100lr\u3797\u37A0eftarro\xF7\u084Fightarrow\xBB\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xF2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xFA\u40FA\xF2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xFB\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xF2\u13ADlac;\u4171a\xF2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\u{1D532}rave\u803B\xF9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xBB\u0957\xBB\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xBB\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xA8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\u{1D566}\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xE1\u13B3arpoon\u0100lr\u3888\u388Cef\xF4\u382Digh\xF4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xBB\u13FAon\xBB\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xBB\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\u{1D4CA}\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xBB\u1813\u0100am\u38EF\u38F2r\xF2\u38A8l\u803B\xFC\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xF2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xE8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xE1\u2415othin\xE7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xF4\u2FB5\u0100;h\u13B7\u3962\xEF\u318D\u0100iu\u3969\u396Dgm\xE1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xE1\u369Ciangle\u0100lr\u39AA\u39AFeft\xBB\u0925ight\xBB\u1051y;\u4432ash\xBB\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xF2\u1469r;\uC000\u{1D533}tr\xE9\u39AEsu\u0100bp\u39EF\u39F1\xBB\u0D1C\xBB\u0D59pf;\uC000\u{1D567}ro\xF0\u0EFBtr\xE9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\u{1D4CB}\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xBB\u397En\u0100Ee\u3992\u3A1E\xBB\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\u{1D534}pf;\uC000\u{1D568}\u0100;e\u1479\u3A66at\xE8\u1479cr;\uC000\u{1D4CC}\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xE9\u17D1r;\uC000\u{1D535}\u0100Aa\u3A94\u3A97r\xF2\u03C3r\xF2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xF2\u03B8r\xF2\u09EBa\xF0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\u{1D569}im\xE5\u17B2\u0100Aa\u3AC7\u3ACAr\xF2\u03CEr\xF2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\u{1D4CD}\u0100pt\u17D6\u3ADCr\xE9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xFD\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xA5\u40A5r;\uC000\u{1D536}cy;\u4457pf;\uC000\u{1D56A}cr;\uC000\u{1D4CE}\u0100cm\u3B26\u3B29y;\u444El\u803B\xFF\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xE6\u155Fa;\u43B6r;\uC000\u{1D537}cy;\u4436grarr;\u61DDpf;\uC000\u{1D56B}cr;\uC000\u{1D4CF}\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map(function(c) {
        return c.charCodeAt(0);
      })
    );
  }
});

// ../../node_modules/entities/lib/generated/decode-data-xml.js
var require_decode_data_xml = __commonJS({
  "../../node_modules/entities/lib/generated/decode-data-xml.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = new Uint16Array(
      // prettier-ignore
      "\u0200aglq	\x1B\u026D\0\0p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map(function(c) {
        return c.charCodeAt(0);
      })
    );
  }
});

// ../../node_modules/entities/lib/decode_codepoint.js
var require_decode_codepoint = __commonJS({
  "../../node_modules/entities/lib/decode_codepoint.js"(exports) {
    "use strict";
    var _a;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.replaceCodePoint = exports.fromCodePoint = void 0;
    var decodeMap = /* @__PURE__ */ new Map([
      [0, 65533],
      [128, 8364],
      [130, 8218],
      [131, 402],
      [132, 8222],
      [133, 8230],
      [134, 8224],
      [135, 8225],
      [136, 710],
      [137, 8240],
      [138, 352],
      [139, 8249],
      [140, 338],
      [142, 381],
      [145, 8216],
      [146, 8217],
      [147, 8220],
      [148, 8221],
      [149, 8226],
      [150, 8211],
      [151, 8212],
      [152, 732],
      [153, 8482],
      [154, 353],
      [155, 8250],
      [156, 339],
      [158, 382],
      [159, 376]
    ]);
    exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
    (_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function(codePoint) {
      var output = "";
      if (codePoint > 65535) {
        codePoint -= 65536;
        output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
      }
      output += String.fromCharCode(codePoint);
      return output;
    };
    function replaceCodePoint(codePoint) {
      var _a2;
      if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
        return 65533;
      }
      return (_a2 = decodeMap.get(codePoint)) !== null && _a2 !== void 0 ? _a2 : codePoint;
    }
    exports.replaceCodePoint = replaceCodePoint;
    function decodeCodePoint(codePoint) {
      return (0, exports.fromCodePoint)(replaceCodePoint(codePoint));
    }
    exports.default = decodeCodePoint;
  }
});

// ../../node_modules/entities/lib/decode.js
var require_decode = __commonJS({
  "../../node_modules/entities/lib/decode.js"(exports) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.decodeXML = exports.decodeHTMLStrict = exports.decodeHTML = exports.determineBranch = exports.BinTrieFlags = exports.fromCodePoint = exports.replaceCodePoint = exports.decodeCodePoint = exports.xmlDecodeTree = exports.htmlDecodeTree = void 0;
    var decode_data_html_js_1 = __importDefault(require_decode_data_html());
    exports.htmlDecodeTree = decode_data_html_js_1.default;
    var decode_data_xml_js_1 = __importDefault(require_decode_data_xml());
    exports.xmlDecodeTree = decode_data_xml_js_1.default;
    var decode_codepoint_js_1 = __importDefault(require_decode_codepoint());
    exports.decodeCodePoint = decode_codepoint_js_1.default;
    var decode_codepoint_js_2 = require_decode_codepoint();
    Object.defineProperty(exports, "replaceCodePoint", { enumerable: true, get: function() {
      return decode_codepoint_js_2.replaceCodePoint;
    } });
    Object.defineProperty(exports, "fromCodePoint", { enumerable: true, get: function() {
      return decode_codepoint_js_2.fromCodePoint;
    } });
    var CharCodes;
    (function(CharCodes2) {
      CharCodes2[CharCodes2["NUM"] = 35] = "NUM";
      CharCodes2[CharCodes2["SEMI"] = 59] = "SEMI";
      CharCodes2[CharCodes2["ZERO"] = 48] = "ZERO";
      CharCodes2[CharCodes2["NINE"] = 57] = "NINE";
      CharCodes2[CharCodes2["LOWER_A"] = 97] = "LOWER_A";
      CharCodes2[CharCodes2["LOWER_F"] = 102] = "LOWER_F";
      CharCodes2[CharCodes2["LOWER_X"] = 120] = "LOWER_X";
      CharCodes2[CharCodes2["To_LOWER_BIT"] = 32] = "To_LOWER_BIT";
    })(CharCodes || (CharCodes = {}));
    var BinTrieFlags;
    (function(BinTrieFlags2) {
      BinTrieFlags2[BinTrieFlags2["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
      BinTrieFlags2[BinTrieFlags2["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
      BinTrieFlags2[BinTrieFlags2["JUMP_TABLE"] = 127] = "JUMP_TABLE";
    })(BinTrieFlags = exports.BinTrieFlags || (exports.BinTrieFlags = {}));
    function getDecoder(decodeTree) {
      return function decodeHTMLBinary(str, strict) {
        var ret = "";
        var lastIdx = 0;
        var strIdx = 0;
        while ((strIdx = str.indexOf("&", strIdx)) >= 0) {
          ret += str.slice(lastIdx, strIdx);
          lastIdx = strIdx;
          strIdx += 1;
          if (str.charCodeAt(strIdx) === CharCodes.NUM) {
            var start = strIdx + 1;
            var base = 10;
            var cp = str.charCodeAt(start);
            if ((cp | CharCodes.To_LOWER_BIT) === CharCodes.LOWER_X) {
              base = 16;
              strIdx += 1;
              start += 1;
            }
            do
              cp = str.charCodeAt(++strIdx);
            while (cp >= CharCodes.ZERO && cp <= CharCodes.NINE || base === 16 && (cp | CharCodes.To_LOWER_BIT) >= CharCodes.LOWER_A && (cp | CharCodes.To_LOWER_BIT) <= CharCodes.LOWER_F);
            if (start !== strIdx) {
              var entity = str.substring(start, strIdx);
              var parsed = parseInt(entity, base);
              if (str.charCodeAt(strIdx) === CharCodes.SEMI) {
                strIdx += 1;
              } else if (strict) {
                continue;
              }
              ret += (0, decode_codepoint_js_1.default)(parsed);
              lastIdx = strIdx;
            }
            continue;
          }
          var resultIdx = 0;
          var excess = 1;
          var treeIdx = 0;
          var current = decodeTree[treeIdx];
          for (; strIdx < str.length; strIdx++, excess++) {
            treeIdx = determineBranch(decodeTree, current, treeIdx + 1, str.charCodeAt(strIdx));
            if (treeIdx < 0)
              break;
            current = decodeTree[treeIdx];
            var masked = current & BinTrieFlags.VALUE_LENGTH;
            if (masked) {
              if (!strict || str.charCodeAt(strIdx) === CharCodes.SEMI) {
                resultIdx = treeIdx;
                excess = 0;
              }
              var valueLength = (masked >> 14) - 1;
              if (valueLength === 0)
                break;
              treeIdx += valueLength;
            }
          }
          if (resultIdx !== 0) {
            var valueLength = (decodeTree[resultIdx] & BinTrieFlags.VALUE_LENGTH) >> 14;
            ret += valueLength === 1 ? String.fromCharCode(decodeTree[resultIdx] & ~BinTrieFlags.VALUE_LENGTH) : valueLength === 2 ? String.fromCharCode(decodeTree[resultIdx + 1]) : String.fromCharCode(decodeTree[resultIdx + 1], decodeTree[resultIdx + 2]);
            lastIdx = strIdx - excess + 1;
          }
        }
        return ret + str.slice(lastIdx);
      };
    }
    function determineBranch(decodeTree, current, nodeIdx, char) {
      var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
      var jumpOffset = current & BinTrieFlags.JUMP_TABLE;
      if (branchCount === 0) {
        return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
      }
      if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
      }
      var lo = nodeIdx;
      var hi = lo + branchCount - 1;
      while (lo <= hi) {
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) {
          lo = mid + 1;
        } else if (midVal > char) {
          hi = mid - 1;
        } else {
          return decodeTree[mid + branchCount];
        }
      }
      return -1;
    }
    exports.determineBranch = determineBranch;
    var htmlDecoder = getDecoder(decode_data_html_js_1.default);
    var xmlDecoder = getDecoder(decode_data_xml_js_1.default);
    function decodeHTML(str) {
      return htmlDecoder(str, false);
    }
    exports.decodeHTML = decodeHTML;
    function decodeHTMLStrict(str) {
      return htmlDecoder(str, true);
    }
    exports.decodeHTMLStrict = decodeHTMLStrict;
    function decodeXML(str) {
      return xmlDecoder(str, true);
    }
    exports.decodeXML = decodeXML;
  }
});

// ../../node_modules/htmlparser2/lib/Tokenizer.js
var require_Tokenizer = __commonJS({
  "../../node_modules/htmlparser2/lib/Tokenizer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.QuoteType = void 0;
    var decode_js_1 = require_decode();
    var CharCodes;
    (function(CharCodes2) {
      CharCodes2[CharCodes2["Tab"] = 9] = "Tab";
      CharCodes2[CharCodes2["NewLine"] = 10] = "NewLine";
      CharCodes2[CharCodes2["FormFeed"] = 12] = "FormFeed";
      CharCodes2[CharCodes2["CarriageReturn"] = 13] = "CarriageReturn";
      CharCodes2[CharCodes2["Space"] = 32] = "Space";
      CharCodes2[CharCodes2["ExclamationMark"] = 33] = "ExclamationMark";
      CharCodes2[CharCodes2["Num"] = 35] = "Num";
      CharCodes2[CharCodes2["Amp"] = 38] = "Amp";
      CharCodes2[CharCodes2["SingleQuote"] = 39] = "SingleQuote";
      CharCodes2[CharCodes2["DoubleQuote"] = 34] = "DoubleQuote";
      CharCodes2[CharCodes2["Dash"] = 45] = "Dash";
      CharCodes2[CharCodes2["Slash"] = 47] = "Slash";
      CharCodes2[CharCodes2["Zero"] = 48] = "Zero";
      CharCodes2[CharCodes2["Nine"] = 57] = "Nine";
      CharCodes2[CharCodes2["Semi"] = 59] = "Semi";
      CharCodes2[CharCodes2["Lt"] = 60] = "Lt";
      CharCodes2[CharCodes2["Eq"] = 61] = "Eq";
      CharCodes2[CharCodes2["Gt"] = 62] = "Gt";
      CharCodes2[CharCodes2["Questionmark"] = 63] = "Questionmark";
      CharCodes2[CharCodes2["UpperA"] = 65] = "UpperA";
      CharCodes2[CharCodes2["LowerA"] = 97] = "LowerA";
      CharCodes2[CharCodes2["UpperF"] = 70] = "UpperF";
      CharCodes2[CharCodes2["LowerF"] = 102] = "LowerF";
      CharCodes2[CharCodes2["UpperZ"] = 90] = "UpperZ";
      CharCodes2[CharCodes2["LowerZ"] = 122] = "LowerZ";
      CharCodes2[CharCodes2["LowerX"] = 120] = "LowerX";
      CharCodes2[CharCodes2["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
    })(CharCodes || (CharCodes = {}));
    var State;
    (function(State2) {
      State2[State2["Text"] = 1] = "Text";
      State2[State2["BeforeTagName"] = 2] = "BeforeTagName";
      State2[State2["InTagName"] = 3] = "InTagName";
      State2[State2["InSelfClosingTag"] = 4] = "InSelfClosingTag";
      State2[State2["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
      State2[State2["InClosingTagName"] = 6] = "InClosingTagName";
      State2[State2["AfterClosingTagName"] = 7] = "AfterClosingTagName";
      State2[State2["BeforeAttributeName"] = 8] = "BeforeAttributeName";
      State2[State2["InAttributeName"] = 9] = "InAttributeName";
      State2[State2["AfterAttributeName"] = 10] = "AfterAttributeName";
      State2[State2["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
      State2[State2["InAttributeValueDq"] = 12] = "InAttributeValueDq";
      State2[State2["InAttributeValueSq"] = 13] = "InAttributeValueSq";
      State2[State2["InAttributeValueNq"] = 14] = "InAttributeValueNq";
      State2[State2["BeforeDeclaration"] = 15] = "BeforeDeclaration";
      State2[State2["InDeclaration"] = 16] = "InDeclaration";
      State2[State2["InProcessingInstruction"] = 17] = "InProcessingInstruction";
      State2[State2["BeforeComment"] = 18] = "BeforeComment";
      State2[State2["CDATASequence"] = 19] = "CDATASequence";
      State2[State2["InSpecialComment"] = 20] = "InSpecialComment";
      State2[State2["InCommentLike"] = 21] = "InCommentLike";
      State2[State2["BeforeSpecialS"] = 22] = "BeforeSpecialS";
      State2[State2["SpecialStartSequence"] = 23] = "SpecialStartSequence";
      State2[State2["InSpecialTag"] = 24] = "InSpecialTag";
      State2[State2["BeforeEntity"] = 25] = "BeforeEntity";
      State2[State2["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
      State2[State2["InNamedEntity"] = 27] = "InNamedEntity";
      State2[State2["InNumericEntity"] = 28] = "InNumericEntity";
      State2[State2["InHexEntity"] = 29] = "InHexEntity";
    })(State || (State = {}));
    function isWhitespace(c) {
      return c === CharCodes.Space || c === CharCodes.NewLine || c === CharCodes.Tab || c === CharCodes.FormFeed || c === CharCodes.CarriageReturn;
    }
    function isEndOfTagSection(c) {
      return c === CharCodes.Slash || c === CharCodes.Gt || isWhitespace(c);
    }
    function isNumber(c) {
      return c >= CharCodes.Zero && c <= CharCodes.Nine;
    }
    function isASCIIAlpha(c) {
      return c >= CharCodes.LowerA && c <= CharCodes.LowerZ || c >= CharCodes.UpperA && c <= CharCodes.UpperZ;
    }
    function isHexDigit(c) {
      return c >= CharCodes.UpperA && c <= CharCodes.UpperF || c >= CharCodes.LowerA && c <= CharCodes.LowerF;
    }
    var QuoteType;
    (function(QuoteType2) {
      QuoteType2[QuoteType2["NoValue"] = 0] = "NoValue";
      QuoteType2[QuoteType2["Unquoted"] = 1] = "Unquoted";
      QuoteType2[QuoteType2["Single"] = 2] = "Single";
      QuoteType2[QuoteType2["Double"] = 3] = "Double";
    })(QuoteType = exports.QuoteType || (exports.QuoteType = {}));
    var Sequences = {
      Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
      CdataEnd: new Uint8Array([93, 93, 62]),
      CommentEnd: new Uint8Array([45, 45, 62]),
      ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
      StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
      TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
      // `</title`
    };
    var Tokenizer = (
      /** @class */
      function() {
        function Tokenizer2(_a, cbs) {
          var _b = _a.xmlMode, xmlMode = _b === void 0 ? false : _b, _c = _a.decodeEntities, decodeEntities = _c === void 0 ? true : _c;
          this.cbs = cbs;
          this.state = State.Text;
          this.buffer = "";
          this.sectionStart = 0;
          this.index = 0;
          this.baseState = State.Text;
          this.isSpecial = false;
          this.running = true;
          this.offset = 0;
          this.sequenceIndex = 0;
          this.trieIndex = 0;
          this.trieCurrent = 0;
          this.entityResult = 0;
          this.entityExcess = 0;
          this.xmlMode = xmlMode;
          this.decodeEntities = decodeEntities;
          this.entityTrie = xmlMode ? decode_js_1.xmlDecodeTree : decode_js_1.htmlDecodeTree;
        }
        Tokenizer2.prototype.reset = function() {
          this.state = State.Text;
          this.buffer = "";
          this.sectionStart = 0;
          this.index = 0;
          this.baseState = State.Text;
          this.currentSequence = void 0;
          this.running = true;
          this.offset = 0;
        };
        Tokenizer2.prototype.write = function(chunk) {
          this.offset += this.buffer.length;
          this.buffer = chunk;
          this.parse();
        };
        Tokenizer2.prototype.end = function() {
          if (this.running)
            this.finish();
        };
        Tokenizer2.prototype.pause = function() {
          this.running = false;
        };
        Tokenizer2.prototype.resume = function() {
          this.running = true;
          if (this.index < this.buffer.length + this.offset) {
            this.parse();
          }
        };
        Tokenizer2.prototype.getIndex = function() {
          return this.index;
        };
        Tokenizer2.prototype.getSectionStart = function() {
          return this.sectionStart;
        };
        Tokenizer2.prototype.stateText = function(c) {
          if (c === CharCodes.Lt || !this.decodeEntities && this.fastForwardTo(CharCodes.Lt)) {
            if (this.index > this.sectionStart) {
              this.cbs.ontext(this.sectionStart, this.index);
            }
            this.state = State.BeforeTagName;
            this.sectionStart = this.index;
          } else if (this.decodeEntities && c === CharCodes.Amp) {
            this.state = State.BeforeEntity;
          }
        };
        Tokenizer2.prototype.stateSpecialStartSequence = function(c) {
          var isEnd = this.sequenceIndex === this.currentSequence.length;
          var isMatch = isEnd ? (
            // If we are at the end of the sequence, make sure the tag name has ended
            isEndOfTagSection(c)
          ) : (
            // Otherwise, do a case-insensitive comparison
            (c | 32) === this.currentSequence[this.sequenceIndex]
          );
          if (!isMatch) {
            this.isSpecial = false;
          } else if (!isEnd) {
            this.sequenceIndex++;
            return;
          }
          this.sequenceIndex = 0;
          this.state = State.InTagName;
          this.stateInTagName(c);
        };
        Tokenizer2.prototype.stateInSpecialTag = function(c) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (c === CharCodes.Gt || isWhitespace(c)) {
              var endOfText = this.index - this.currentSequence.length;
              if (this.sectionStart < endOfText) {
                var actualIndex = this.index;
                this.index = endOfText;
                this.cbs.ontext(this.sectionStart, endOfText);
                this.index = actualIndex;
              }
              this.isSpecial = false;
              this.sectionStart = endOfText + 2;
              this.stateInClosingTagName(c);
              return;
            }
            this.sequenceIndex = 0;
          }
          if ((c | 32) === this.currentSequence[this.sequenceIndex]) {
            this.sequenceIndex += 1;
          } else if (this.sequenceIndex === 0) {
            if (this.currentSequence === Sequences.TitleEnd) {
              if (this.decodeEntities && c === CharCodes.Amp) {
                this.state = State.BeforeEntity;
              }
            } else if (this.fastForwardTo(CharCodes.Lt)) {
              this.sequenceIndex = 1;
            }
          } else {
            this.sequenceIndex = Number(c === CharCodes.Lt);
          }
        };
        Tokenizer2.prototype.stateCDATASequence = function(c) {
          if (c === Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === Sequences.Cdata.length) {
              this.state = State.InCommentLike;
              this.currentSequence = Sequences.CdataEnd;
              this.sequenceIndex = 0;
              this.sectionStart = this.index + 1;
            }
          } else {
            this.sequenceIndex = 0;
            this.state = State.InDeclaration;
            this.stateInDeclaration(c);
          }
        };
        Tokenizer2.prototype.fastForwardTo = function(c) {
          while (++this.index < this.buffer.length + this.offset) {
            if (this.buffer.charCodeAt(this.index - this.offset) === c) {
              return true;
            }
          }
          this.index = this.buffer.length + this.offset - 1;
          return false;
        };
        Tokenizer2.prototype.stateInCommentLike = function(c) {
          if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
              if (this.currentSequence === Sequences.CdataEnd) {
                this.cbs.oncdata(this.sectionStart, this.index, 2);
              } else {
                this.cbs.oncomment(this.sectionStart, this.index, 2);
              }
              this.sequenceIndex = 0;
              this.sectionStart = this.index + 1;
              this.state = State.Text;
            }
          } else if (this.sequenceIndex === 0) {
            if (this.fastForwardTo(this.currentSequence[0])) {
              this.sequenceIndex = 1;
            }
          } else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
            this.sequenceIndex = 0;
          }
        };
        Tokenizer2.prototype.isTagStartChar = function(c) {
          return this.xmlMode ? !isEndOfTagSection(c) : isASCIIAlpha(c);
        };
        Tokenizer2.prototype.startSpecial = function(sequence, offset) {
          this.isSpecial = true;
          this.currentSequence = sequence;
          this.sequenceIndex = offset;
          this.state = State.SpecialStartSequence;
        };
        Tokenizer2.prototype.stateBeforeTagName = function(c) {
          if (c === CharCodes.ExclamationMark) {
            this.state = State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
          } else if (c === CharCodes.Questionmark) {
            this.state = State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
          } else if (this.isTagStartChar(c)) {
            var lower2 = c | 32;
            this.sectionStart = this.index;
            if (!this.xmlMode && lower2 === Sequences.TitleEnd[2]) {
              this.startSpecial(Sequences.TitleEnd, 3);
            } else {
              this.state = !this.xmlMode && lower2 === Sequences.ScriptEnd[2] ? State.BeforeSpecialS : State.InTagName;
            }
          } else if (c === CharCodes.Slash) {
            this.state = State.BeforeClosingTagName;
          } else {
            this.state = State.Text;
            this.stateText(c);
          }
        };
        Tokenizer2.prototype.stateInTagName = function(c) {
          if (isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
          }
        };
        Tokenizer2.prototype.stateBeforeClosingTagName = function(c) {
          if (isWhitespace(c)) {
          } else if (c === CharCodes.Gt) {
            this.state = State.Text;
          } else {
            this.state = this.isTagStartChar(c) ? State.InClosingTagName : State.InSpecialComment;
            this.sectionStart = this.index;
          }
        };
        Tokenizer2.prototype.stateInClosingTagName = function(c) {
          if (c === CharCodes.Gt || isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
          }
        };
        Tokenizer2.prototype.stateAfterClosingTagName = function(c) {
          if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
            this.state = State.Text;
            this.sectionStart = this.index + 1;
          }
        };
        Tokenizer2.prototype.stateBeforeAttributeName = function(c) {
          if (c === CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
              this.state = State.InSpecialTag;
              this.sequenceIndex = 0;
            } else {
              this.state = State.Text;
            }
            this.baseState = this.state;
            this.sectionStart = this.index + 1;
          } else if (c === CharCodes.Slash) {
            this.state = State.InSelfClosingTag;
          } else if (!isWhitespace(c)) {
            this.state = State.InAttributeName;
            this.sectionStart = this.index;
          }
        };
        Tokenizer2.prototype.stateInSelfClosingTag = function(c) {
          if (c === CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = State.Text;
            this.baseState = State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false;
          } else if (!isWhitespace(c)) {
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
          }
        };
        Tokenizer2.prototype.stateInAttributeName = function(c) {
          if (c === CharCodes.Eq || isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = State.AfterAttributeName;
            this.stateAfterAttributeName(c);
          }
        };
        Tokenizer2.prototype.stateAfterAttributeName = function(c) {
          if (c === CharCodes.Eq) {
            this.state = State.BeforeAttributeValue;
          } else if (c === CharCodes.Slash || c === CharCodes.Gt) {
            this.cbs.onattribend(QuoteType.NoValue, this.index);
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
          } else if (!isWhitespace(c)) {
            this.cbs.onattribend(QuoteType.NoValue, this.index);
            this.state = State.InAttributeName;
            this.sectionStart = this.index;
          }
        };
        Tokenizer2.prototype.stateBeforeAttributeValue = function(c) {
          if (c === CharCodes.DoubleQuote) {
            this.state = State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
          } else if (c === CharCodes.SingleQuote) {
            this.state = State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
          } else if (!isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c);
          }
        };
        Tokenizer2.prototype.handleInAttributeValue = function(c, quote) {
          if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === CharCodes.DoubleQuote ? QuoteType.Double : QuoteType.Single, this.index);
            this.state = State.BeforeAttributeName;
          } else if (this.decodeEntities && c === CharCodes.Amp) {
            this.baseState = this.state;
            this.state = State.BeforeEntity;
          }
        };
        Tokenizer2.prototype.stateInAttributeValueDoubleQuotes = function(c) {
          this.handleInAttributeValue(c, CharCodes.DoubleQuote);
        };
        Tokenizer2.prototype.stateInAttributeValueSingleQuotes = function(c) {
          this.handleInAttributeValue(c, CharCodes.SingleQuote);
        };
        Tokenizer2.prototype.stateInAttributeValueNoQuotes = function(c) {
          if (isWhitespace(c) || c === CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(QuoteType.Unquoted, this.index);
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
          } else if (this.decodeEntities && c === CharCodes.Amp) {
            this.baseState = this.state;
            this.state = State.BeforeEntity;
          }
        };
        Tokenizer2.prototype.stateBeforeDeclaration = function(c) {
          if (c === CharCodes.OpeningSquareBracket) {
            this.state = State.CDATASequence;
            this.sequenceIndex = 0;
          } else {
            this.state = c === CharCodes.Dash ? State.BeforeComment : State.InDeclaration;
          }
        };
        Tokenizer2.prototype.stateInDeclaration = function(c) {
          if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = State.Text;
            this.sectionStart = this.index + 1;
          }
        };
        Tokenizer2.prototype.stateInProcessingInstruction = function(c) {
          if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = State.Text;
            this.sectionStart = this.index + 1;
          }
        };
        Tokenizer2.prototype.stateBeforeComment = function(c) {
          if (c === CharCodes.Dash) {
            this.state = State.InCommentLike;
            this.currentSequence = Sequences.CommentEnd;
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
          } else {
            this.state = State.InDeclaration;
          }
        };
        Tokenizer2.prototype.stateInSpecialComment = function(c) {
          if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = State.Text;
            this.sectionStart = this.index + 1;
          }
        };
        Tokenizer2.prototype.stateBeforeSpecialS = function(c) {
          var lower2 = c | 32;
          if (lower2 === Sequences.ScriptEnd[3]) {
            this.startSpecial(Sequences.ScriptEnd, 4);
          } else if (lower2 === Sequences.StyleEnd[3]) {
            this.startSpecial(Sequences.StyleEnd, 4);
          } else {
            this.state = State.InTagName;
            this.stateInTagName(c);
          }
        };
        Tokenizer2.prototype.stateBeforeEntity = function(c) {
          this.entityExcess = 1;
          this.entityResult = 0;
          if (c === CharCodes.Num) {
            this.state = State.BeforeNumericEntity;
          } else if (c === CharCodes.Amp) {
          } else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.state = State.InNamedEntity;
            this.stateInNamedEntity(c);
          }
        };
        Tokenizer2.prototype.stateInNamedEntity = function(c) {
          this.entityExcess += 1;
          this.trieIndex = (0, decode_js_1.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
          if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this.index--;
            return;
          }
          this.trieCurrent = this.entityTrie[this.trieIndex];
          var masked = this.trieCurrent & decode_js_1.BinTrieFlags.VALUE_LENGTH;
          if (masked) {
            var valueLength = (masked >> 14) - 1;
            if (!this.allowLegacyEntity() && c !== CharCodes.Semi) {
              this.trieIndex += valueLength;
            } else {
              var entityStart = this.index - this.entityExcess + 1;
              if (entityStart > this.sectionStart) {
                this.emitPartial(this.sectionStart, entityStart);
              }
              this.entityResult = this.trieIndex;
              this.trieIndex += valueLength;
              this.entityExcess = 0;
              this.sectionStart = this.index + 1;
              if (valueLength === 0) {
                this.emitNamedEntity();
              }
            }
          }
        };
        Tokenizer2.prototype.emitNamedEntity = function() {
          this.state = this.baseState;
          if (this.entityResult === 0) {
            return;
          }
          var valueLength = (this.entityTrie[this.entityResult] & decode_js_1.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (valueLength) {
            case 1:
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~decode_js_1.BinTrieFlags.VALUE_LENGTH);
              break;
            case 2:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            case 3: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
            }
          }
        };
        Tokenizer2.prototype.stateBeforeNumericEntity = function(c) {
          if ((c | 32) === CharCodes.LowerX) {
            this.entityExcess++;
            this.state = State.InHexEntity;
          } else {
            this.state = State.InNumericEntity;
            this.stateInNumericEntity(c);
          }
        };
        Tokenizer2.prototype.emitNumericEntity = function(strict) {
          var entityStart = this.index - this.entityExcess - 1;
          var numberStart = entityStart + 2 + Number(this.state === State.InHexEntity);
          if (numberStart !== this.index) {
            if (entityStart > this.sectionStart) {
              this.emitPartial(this.sectionStart, entityStart);
            }
            this.sectionStart = this.index + Number(strict);
            this.emitCodePoint((0, decode_js_1.replaceCodePoint)(this.entityResult));
          }
          this.state = this.baseState;
        };
        Tokenizer2.prototype.stateInNumericEntity = function(c) {
          if (c === CharCodes.Semi) {
            this.emitNumericEntity(true);
          } else if (isNumber(c)) {
            this.entityResult = this.entityResult * 10 + (c - CharCodes.Zero);
            this.entityExcess++;
          } else {
            if (this.allowLegacyEntity()) {
              this.emitNumericEntity(false);
            } else {
              this.state = this.baseState;
            }
            this.index--;
          }
        };
        Tokenizer2.prototype.stateInHexEntity = function(c) {
          if (c === CharCodes.Semi) {
            this.emitNumericEntity(true);
          } else if (isNumber(c)) {
            this.entityResult = this.entityResult * 16 + (c - CharCodes.Zero);
            this.entityExcess++;
          } else if (isHexDigit(c)) {
            this.entityResult = this.entityResult * 16 + ((c | 32) - CharCodes.LowerA + 10);
            this.entityExcess++;
          } else {
            if (this.allowLegacyEntity()) {
              this.emitNumericEntity(false);
            } else {
              this.state = this.baseState;
            }
            this.index--;
          }
        };
        Tokenizer2.prototype.allowLegacyEntity = function() {
          return !this.xmlMode && (this.baseState === State.Text || this.baseState === State.InSpecialTag);
        };
        Tokenizer2.prototype.cleanup = function() {
          if (this.running && this.sectionStart !== this.index) {
            if (this.state === State.Text || this.state === State.InSpecialTag && this.sequenceIndex === 0) {
              this.cbs.ontext(this.sectionStart, this.index);
              this.sectionStart = this.index;
            } else if (this.state === State.InAttributeValueDq || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueNq) {
              this.cbs.onattribdata(this.sectionStart, this.index);
              this.sectionStart = this.index;
            }
          }
        };
        Tokenizer2.prototype.shouldContinue = function() {
          return this.index < this.buffer.length + this.offset && this.running;
        };
        Tokenizer2.prototype.parse = function() {
          while (this.shouldContinue()) {
            var c = this.buffer.charCodeAt(this.index - this.offset);
            if (this.state === State.Text) {
              this.stateText(c);
            } else if (this.state === State.SpecialStartSequence) {
              this.stateSpecialStartSequence(c);
            } else if (this.state === State.InSpecialTag) {
              this.stateInSpecialTag(c);
            } else if (this.state === State.CDATASequence) {
              this.stateCDATASequence(c);
            } else if (this.state === State.InAttributeValueDq) {
              this.stateInAttributeValueDoubleQuotes(c);
            } else if (this.state === State.InAttributeName) {
              this.stateInAttributeName(c);
            } else if (this.state === State.InCommentLike) {
              this.stateInCommentLike(c);
            } else if (this.state === State.InSpecialComment) {
              this.stateInSpecialComment(c);
            } else if (this.state === State.BeforeAttributeName) {
              this.stateBeforeAttributeName(c);
            } else if (this.state === State.InTagName) {
              this.stateInTagName(c);
            } else if (this.state === State.InClosingTagName) {
              this.stateInClosingTagName(c);
            } else if (this.state === State.BeforeTagName) {
              this.stateBeforeTagName(c);
            } else if (this.state === State.AfterAttributeName) {
              this.stateAfterAttributeName(c);
            } else if (this.state === State.InAttributeValueSq) {
              this.stateInAttributeValueSingleQuotes(c);
            } else if (this.state === State.BeforeAttributeValue) {
              this.stateBeforeAttributeValue(c);
            } else if (this.state === State.BeforeClosingTagName) {
              this.stateBeforeClosingTagName(c);
            } else if (this.state === State.AfterClosingTagName) {
              this.stateAfterClosingTagName(c);
            } else if (this.state === State.BeforeSpecialS) {
              this.stateBeforeSpecialS(c);
            } else if (this.state === State.InAttributeValueNq) {
              this.stateInAttributeValueNoQuotes(c);
            } else if (this.state === State.InSelfClosingTag) {
              this.stateInSelfClosingTag(c);
            } else if (this.state === State.InDeclaration) {
              this.stateInDeclaration(c);
            } else if (this.state === State.BeforeDeclaration) {
              this.stateBeforeDeclaration(c);
            } else if (this.state === State.BeforeComment) {
              this.stateBeforeComment(c);
            } else if (this.state === State.InProcessingInstruction) {
              this.stateInProcessingInstruction(c);
            } else if (this.state === State.InNamedEntity) {
              this.stateInNamedEntity(c);
            } else if (this.state === State.BeforeEntity) {
              this.stateBeforeEntity(c);
            } else if (this.state === State.InHexEntity) {
              this.stateInHexEntity(c);
            } else if (this.state === State.InNumericEntity) {
              this.stateInNumericEntity(c);
            } else {
              this.stateBeforeNumericEntity(c);
            }
            this.index++;
          }
          this.cleanup();
        };
        Tokenizer2.prototype.finish = function() {
          if (this.state === State.InNamedEntity) {
            this.emitNamedEntity();
          }
          if (this.sectionStart < this.index) {
            this.handleTrailingData();
          }
          this.cbs.onend();
        };
        Tokenizer2.prototype.handleTrailingData = function() {
          var endIndex = this.buffer.length + this.offset;
          if (this.state === State.InCommentLike) {
            if (this.currentSequence === Sequences.CdataEnd) {
              this.cbs.oncdata(this.sectionStart, endIndex, 0);
            } else {
              this.cbs.oncomment(this.sectionStart, endIndex, 0);
            }
          } else if (this.state === State.InNumericEntity && this.allowLegacyEntity()) {
            this.emitNumericEntity(false);
          } else if (this.state === State.InHexEntity && this.allowLegacyEntity()) {
            this.emitNumericEntity(false);
          } else if (this.state === State.InTagName || this.state === State.BeforeAttributeName || this.state === State.BeforeAttributeValue || this.state === State.AfterAttributeName || this.state === State.InAttributeName || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueDq || this.state === State.InAttributeValueNq || this.state === State.InClosingTagName) {
          } else {
            this.cbs.ontext(this.sectionStart, endIndex);
          }
        };
        Tokenizer2.prototype.emitPartial = function(start, endIndex) {
          if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
            this.cbs.onattribdata(start, endIndex);
          } else {
            this.cbs.ontext(start, endIndex);
          }
        };
        Tokenizer2.prototype.emitCodePoint = function(cp) {
          if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
            this.cbs.onattribentity(cp);
          } else {
            this.cbs.ontextentity(cp);
          }
        };
        return Tokenizer2;
      }()
    );
    exports.default = Tokenizer;
  }
});

// ../../node_modules/htmlparser2/lib/Parser.js
var require_Parser = __commonJS({
  "../../node_modules/htmlparser2/lib/Parser.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Parser = void 0;
    var Tokenizer_js_1 = __importStar(require_Tokenizer());
    var decode_js_1 = require_decode();
    var formTags = /* @__PURE__ */ new Set([
      "input",
      "option",
      "optgroup",
      "select",
      "button",
      "datalist",
      "textarea"
    ]);
    var pTag = /* @__PURE__ */ new Set(["p"]);
    var tableSectionTags = /* @__PURE__ */ new Set(["thead", "tbody"]);
    var ddtTags = /* @__PURE__ */ new Set(["dd", "dt"]);
    var rtpTags = /* @__PURE__ */ new Set(["rt", "rp"]);
    var openImpliesClose = /* @__PURE__ */ new Map([
      ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
      ["th", /* @__PURE__ */ new Set(["th"])],
      ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
      ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
      ["li", /* @__PURE__ */ new Set(["li"])],
      ["p", pTag],
      ["h1", pTag],
      ["h2", pTag],
      ["h3", pTag],
      ["h4", pTag],
      ["h5", pTag],
      ["h6", pTag],
      ["select", formTags],
      ["input", formTags],
      ["output", formTags],
      ["button", formTags],
      ["datalist", formTags],
      ["textarea", formTags],
      ["option", /* @__PURE__ */ new Set(["option"])],
      ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
      ["dd", ddtTags],
      ["dt", ddtTags],
      ["address", pTag],
      ["article", pTag],
      ["aside", pTag],
      ["blockquote", pTag],
      ["details", pTag],
      ["div", pTag],
      ["dl", pTag],
      ["fieldset", pTag],
      ["figcaption", pTag],
      ["figure", pTag],
      ["footer", pTag],
      ["form", pTag],
      ["header", pTag],
      ["hr", pTag],
      ["main", pTag],
      ["nav", pTag],
      ["ol", pTag],
      ["pre", pTag],
      ["section", pTag],
      ["table", pTag],
      ["ul", pTag],
      ["rt", rtpTags],
      ["rp", rtpTags],
      ["tbody", tableSectionTags],
      ["tfoot", tableSectionTags]
    ]);
    var voidElements = /* @__PURE__ */ new Set([
      "area",
      "base",
      "basefont",
      "br",
      "col",
      "command",
      "embed",
      "frame",
      "hr",
      "img",
      "input",
      "isindex",
      "keygen",
      "link",
      "meta",
      "param",
      "source",
      "track",
      "wbr"
    ]);
    var foreignContextElements = /* @__PURE__ */ new Set(["math", "svg"]);
    var htmlIntegrationElements = /* @__PURE__ */ new Set([
      "mi",
      "mo",
      "mn",
      "ms",
      "mtext",
      "annotation-xml",
      "foreignobject",
      "desc",
      "title"
    ]);
    var reNameEnd = /\s|\//;
    var Parser = (
      /** @class */
      function() {
        function Parser2(cbs, options2) {
          if (options2 === void 0) {
            options2 = {};
          }
          var _a, _b, _c, _d, _e;
          this.options = options2;
          this.startIndex = 0;
          this.endIndex = 0;
          this.openTagStart = 0;
          this.tagname = "";
          this.attribname = "";
          this.attribvalue = "";
          this.attribs = null;
          this.stack = [];
          this.foreignContext = [];
          this.buffers = [];
          this.bufferOffset = 0;
          this.writeIndex = 0;
          this.ended = false;
          this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
          this.lowerCaseTagNames = (_a = options2.lowerCaseTags) !== null && _a !== void 0 ? _a : !options2.xmlMode;
          this.lowerCaseAttributeNames = (_b = options2.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options2.xmlMode;
          this.tokenizer = new ((_c = options2.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_js_1.default)(this.options, this);
          (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
        }
        Parser2.prototype.ontext = function(start, endIndex) {
          var _a, _b;
          var data2 = this.getSlice(start, endIndex);
          this.endIndex = endIndex - 1;
          (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data2);
          this.startIndex = endIndex;
        };
        Parser2.prototype.ontextentity = function(cp) {
          var _a, _b;
          var idx = this.tokenizer.getSectionStart();
          this.endIndex = idx - 1;
          (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, (0, decode_js_1.fromCodePoint)(cp));
          this.startIndex = idx;
        };
        Parser2.prototype.isVoidElement = function(name) {
          return !this.options.xmlMode && voidElements.has(name);
        };
        Parser2.prototype.onopentagname = function(start, endIndex) {
          this.endIndex = endIndex;
          var name = this.getSlice(start, endIndex);
          if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
          }
          this.emitOpenTag(name);
        };
        Parser2.prototype.emitOpenTag = function(name) {
          var _a, _b, _c, _d;
          this.openTagStart = this.startIndex;
          this.tagname = name;
          var impliesClose = !this.options.xmlMode && openImpliesClose.get(name);
          if (impliesClose) {
            while (this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])) {
              var el = this.stack.pop();
              (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, el, true);
            }
          }
          if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if (foreignContextElements.has(name)) {
              this.foreignContext.push(true);
            } else if (htmlIntegrationElements.has(name)) {
              this.foreignContext.push(false);
            }
          }
          (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
          if (this.cbs.onopentag)
            this.attribs = {};
        };
        Parser2.prototype.endOpenTag = function(isImplied) {
          var _a, _b;
          this.startIndex = this.openTagStart;
          if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
          }
          if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
            this.cbs.onclosetag(this.tagname, true);
          }
          this.tagname = "";
        };
        Parser2.prototype.onopentagend = function(endIndex) {
          this.endIndex = endIndex;
          this.endOpenTag(false);
          this.startIndex = endIndex + 1;
        };
        Parser2.prototype.onclosetag = function(start, endIndex) {
          var _a, _b, _c, _d, _e, _f;
          this.endIndex = endIndex;
          var name = this.getSlice(start, endIndex);
          if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
          }
          if (foreignContextElements.has(name) || htmlIntegrationElements.has(name)) {
            this.foreignContext.pop();
          }
          if (!this.isVoidElement(name)) {
            var pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
              if (this.cbs.onclosetag) {
                var count = this.stack.length - pos;
                while (count--) {
                  this.cbs.onclosetag(this.stack.pop(), count !== 0);
                }
              } else
                this.stack.length = pos;
            } else if (!this.options.xmlMode && name === "p") {
              this.emitOpenTag("p");
              this.closeCurrentTag(true);
            }
          } else if (!this.options.xmlMode && name === "br") {
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, "br");
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, "br", {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, "br", false);
          }
          this.startIndex = endIndex + 1;
        };
        Parser2.prototype.onselfclosingtag = function(endIndex) {
          this.endIndex = endIndex;
          if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            this.startIndex = endIndex + 1;
          } else {
            this.onopentagend(endIndex);
          }
        };
        Parser2.prototype.closeCurrentTag = function(isOpenImplied) {
          var _a, _b;
          var name = this.tagname;
          this.endOpenTag(isOpenImplied);
          if (this.stack[this.stack.length - 1] === name) {
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
          }
        };
        Parser2.prototype.onattribname = function(start, endIndex) {
          this.startIndex = start;
          var name = this.getSlice(start, endIndex);
          this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
        };
        Parser2.prototype.onattribdata = function(start, endIndex) {
          this.attribvalue += this.getSlice(start, endIndex);
        };
        Parser2.prototype.onattribentity = function(cp) {
          this.attribvalue += (0, decode_js_1.fromCodePoint)(cp);
        };
        Parser2.prototype.onattribend = function(quote, endIndex) {
          var _a, _b;
          this.endIndex = endIndex;
          (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote === Tokenizer_js_1.QuoteType.Double ? '"' : quote === Tokenizer_js_1.QuoteType.Single ? "'" : quote === Tokenizer_js_1.QuoteType.NoValue ? void 0 : null);
          if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
            this.attribs[this.attribname] = this.attribvalue;
          }
          this.attribvalue = "";
        };
        Parser2.prototype.getInstructionName = function(value) {
          var idx = value.search(reNameEnd);
          var name = idx < 0 ? value : value.substr(0, idx);
          if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
          }
          return name;
        };
        Parser2.prototype.ondeclaration = function(start, endIndex) {
          this.endIndex = endIndex;
          var value = this.getSlice(start, endIndex);
          if (this.cbs.onprocessinginstruction) {
            var name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
          }
          this.startIndex = endIndex + 1;
        };
        Parser2.prototype.onprocessinginstruction = function(start, endIndex) {
          this.endIndex = endIndex;
          var value = this.getSlice(start, endIndex);
          if (this.cbs.onprocessinginstruction) {
            var name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
          }
          this.startIndex = endIndex + 1;
        };
        Parser2.prototype.oncomment = function(start, endIndex, offset) {
          var _a, _b, _c, _d;
          this.endIndex = endIndex;
          (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, this.getSlice(start, endIndex - offset));
          (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
          this.startIndex = endIndex + 1;
        };
        Parser2.prototype.oncdata = function(start, endIndex, offset) {
          var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
          this.endIndex = endIndex;
          var value = this.getSlice(start, endIndex - offset);
          if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
          } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, "[CDATA[".concat(value, "]]"));
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
          }
          this.startIndex = endIndex + 1;
        };
        Parser2.prototype.onend = function() {
          var _a, _b;
          if (this.cbs.onclosetag) {
            this.endIndex = this.startIndex;
            for (var i = this.stack.length; i > 0; this.cbs.onclosetag(this.stack[--i], true))
              ;
          }
          (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        Parser2.prototype.reset = function() {
          var _a, _b, _c, _d;
          (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
          this.tokenizer.reset();
          this.tagname = "";
          this.attribname = "";
          this.attribs = null;
          this.stack.length = 0;
          this.startIndex = 0;
          this.endIndex = 0;
          (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
          this.buffers.length = 0;
          this.bufferOffset = 0;
          this.writeIndex = 0;
          this.ended = false;
        };
        Parser2.prototype.parseComplete = function(data2) {
          this.reset();
          this.end(data2);
        };
        Parser2.prototype.getSlice = function(start, end) {
          while (start - this.bufferOffset >= this.buffers[0].length) {
            this.shiftBuffer();
          }
          var str = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
          while (end - this.bufferOffset > this.buffers[0].length) {
            this.shiftBuffer();
            str += this.buffers[0].slice(0, end - this.bufferOffset);
          }
          return str;
        };
        Parser2.prototype.shiftBuffer = function() {
          this.bufferOffset += this.buffers[0].length;
          this.writeIndex--;
          this.buffers.shift();
        };
        Parser2.prototype.write = function(chunk) {
          var _a, _b;
          if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".write() after done!"));
            return;
          }
          this.buffers.push(chunk);
          if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
          }
        };
        Parser2.prototype.end = function(chunk) {
          var _a, _b;
          if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, Error(".end() after done!"));
            return;
          }
          if (chunk)
            this.write(chunk);
          this.ended = true;
          this.tokenizer.end();
        };
        Parser2.prototype.pause = function() {
          this.tokenizer.pause();
        };
        Parser2.prototype.resume = function() {
          this.tokenizer.resume();
          while (this.tokenizer.running && this.writeIndex < this.buffers.length) {
            this.tokenizer.write(this.buffers[this.writeIndex++]);
          }
          if (this.ended)
            this.tokenizer.end();
        };
        Parser2.prototype.parseChunk = function(chunk) {
          this.write(chunk);
        };
        Parser2.prototype.done = function(chunk) {
          this.end(chunk);
        };
        return Parser2;
      }()
    );
    exports.Parser = Parser;
  }
});

// ../../node_modules/htmlparser2/node_modules/domelementtype/lib/index.js
var require_lib2 = __commonJS({
  "../../node_modules/htmlparser2/node_modules/domelementtype/lib/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
    var ElementType;
    (function(ElementType2) {
      ElementType2["Root"] = "root";
      ElementType2["Text"] = "text";
      ElementType2["Directive"] = "directive";
      ElementType2["Comment"] = "comment";
      ElementType2["Script"] = "script";
      ElementType2["Style"] = "style";
      ElementType2["Tag"] = "tag";
      ElementType2["CDATA"] = "cdata";
      ElementType2["Doctype"] = "doctype";
    })(ElementType = exports.ElementType || (exports.ElementType = {}));
    function isTag(elem) {
      return elem.type === ElementType.Tag || elem.type === ElementType.Script || elem.type === ElementType.Style;
    }
    exports.isTag = isTag;
    exports.Root = ElementType.Root;
    exports.Text = ElementType.Text;
    exports.Directive = ElementType.Directive;
    exports.Comment = ElementType.Comment;
    exports.Script = ElementType.Script;
    exports.Style = ElementType.Style;
    exports.Tag = ElementType.Tag;
    exports.CDATA = ElementType.CDATA;
    exports.Doctype = ElementType.Doctype;
  }
});

// ../../node_modules/htmlparser2/node_modules/domhandler/lib/node.js
var require_node = __commonJS({
  "../../node_modules/htmlparser2/node_modules/domhandler/lib/node.js"(exports) {
    "use strict";
    var __extends = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (Object.prototype.hasOwnProperty.call(b2, p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    var __assign = exports && exports.__assign || function() {
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.CDATA = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
    var domelementtype_1 = require_lib2();
    var Node = (
      /** @class */
      function() {
        function Node2() {
          this.parent = null;
          this.prev = null;
          this.next = null;
          this.startIndex = null;
          this.endIndex = null;
        }
        Object.defineProperty(Node2.prototype, "parentNode", {
          // Read-write aliases for properties
          /**
           * Same as {@link parent}.
           * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
           */
          get: function() {
            return this.parent;
          },
          set: function(parent) {
            this.parent = parent;
          },
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(Node2.prototype, "previousSibling", {
          /**
           * Same as {@link prev}.
           * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
           */
          get: function() {
            return this.prev;
          },
          set: function(prev) {
            this.prev = prev;
          },
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(Node2.prototype, "nextSibling", {
          /**
           * Same as {@link next}.
           * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
           */
          get: function() {
            return this.next;
          },
          set: function(next) {
            this.next = next;
          },
          enumerable: false,
          configurable: true
        });
        Node2.prototype.cloneNode = function(recursive) {
          if (recursive === void 0) {
            recursive = false;
          }
          return cloneNode(this, recursive);
        };
        return Node2;
      }()
    );
    exports.Node = Node;
    var DataNode = (
      /** @class */
      function(_super) {
        __extends(DataNode2, _super);
        function DataNode2(data2) {
          var _this = _super.call(this) || this;
          _this.data = data2;
          return _this;
        }
        Object.defineProperty(DataNode2.prototype, "nodeValue", {
          /**
           * Same as {@link data}.
           * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
           */
          get: function() {
            return this.data;
          },
          set: function(data2) {
            this.data = data2;
          },
          enumerable: false,
          configurable: true
        });
        return DataNode2;
      }(Node)
    );
    exports.DataNode = DataNode;
    var Text = (
      /** @class */
      function(_super) {
        __extends(Text2, _super);
        function Text2() {
          var _this = _super !== null && _super.apply(this, arguments) || this;
          _this.type = domelementtype_1.ElementType.Text;
          return _this;
        }
        Object.defineProperty(Text2.prototype, "nodeType", {
          get: function() {
            return 3;
          },
          enumerable: false,
          configurable: true
        });
        return Text2;
      }(DataNode)
    );
    exports.Text = Text;
    var Comment = (
      /** @class */
      function(_super) {
        __extends(Comment2, _super);
        function Comment2() {
          var _this = _super !== null && _super.apply(this, arguments) || this;
          _this.type = domelementtype_1.ElementType.Comment;
          return _this;
        }
        Object.defineProperty(Comment2.prototype, "nodeType", {
          get: function() {
            return 8;
          },
          enumerable: false,
          configurable: true
        });
        return Comment2;
      }(DataNode)
    );
    exports.Comment = Comment;
    var ProcessingInstruction = (
      /** @class */
      function(_super) {
        __extends(ProcessingInstruction2, _super);
        function ProcessingInstruction2(name, data2) {
          var _this = _super.call(this, data2) || this;
          _this.name = name;
          _this.type = domelementtype_1.ElementType.Directive;
          return _this;
        }
        Object.defineProperty(ProcessingInstruction2.prototype, "nodeType", {
          get: function() {
            return 1;
          },
          enumerable: false,
          configurable: true
        });
        return ProcessingInstruction2;
      }(DataNode)
    );
    exports.ProcessingInstruction = ProcessingInstruction;
    var NodeWithChildren = (
      /** @class */
      function(_super) {
        __extends(NodeWithChildren2, _super);
        function NodeWithChildren2(children2) {
          var _this = _super.call(this) || this;
          _this.children = children2;
          return _this;
        }
        Object.defineProperty(NodeWithChildren2.prototype, "firstChild", {
          // Aliases
          /** First child of the node. */
          get: function() {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
          },
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(NodeWithChildren2.prototype, "lastChild", {
          /** Last child of the node. */
          get: function() {
            return this.children.length > 0 ? this.children[this.children.length - 1] : null;
          },
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(NodeWithChildren2.prototype, "childNodes", {
          /**
           * Same as {@link children}.
           * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
           */
          get: function() {
            return this.children;
          },
          set: function(children2) {
            this.children = children2;
          },
          enumerable: false,
          configurable: true
        });
        return NodeWithChildren2;
      }(Node)
    );
    exports.NodeWithChildren = NodeWithChildren;
    var CDATA = (
      /** @class */
      function(_super) {
        __extends(CDATA2, _super);
        function CDATA2() {
          var _this = _super !== null && _super.apply(this, arguments) || this;
          _this.type = domelementtype_1.ElementType.CDATA;
          return _this;
        }
        Object.defineProperty(CDATA2.prototype, "nodeType", {
          get: function() {
            return 4;
          },
          enumerable: false,
          configurable: true
        });
        return CDATA2;
      }(NodeWithChildren)
    );
    exports.CDATA = CDATA;
    var Document = (
      /** @class */
      function(_super) {
        __extends(Document2, _super);
        function Document2() {
          var _this = _super !== null && _super.apply(this, arguments) || this;
          _this.type = domelementtype_1.ElementType.Root;
          return _this;
        }
        Object.defineProperty(Document2.prototype, "nodeType", {
          get: function() {
            return 9;
          },
          enumerable: false,
          configurable: true
        });
        return Document2;
      }(NodeWithChildren)
    );
    exports.Document = Document;
    var Element = (
      /** @class */
      function(_super) {
        __extends(Element2, _super);
        function Element2(name, attribs, children2, type) {
          if (children2 === void 0) {
            children2 = [];
          }
          if (type === void 0) {
            type = name === "script" ? domelementtype_1.ElementType.Script : name === "style" ? domelementtype_1.ElementType.Style : domelementtype_1.ElementType.Tag;
          }
          var _this = _super.call(this, children2) || this;
          _this.name = name;
          _this.attribs = attribs;
          _this.type = type;
          return _this;
        }
        Object.defineProperty(Element2.prototype, "nodeType", {
          get: function() {
            return 1;
          },
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(Element2.prototype, "tagName", {
          // DOM Level 1 aliases
          /**
           * Same as {@link name}.
           * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
           */
          get: function() {
            return this.name;
          },
          set: function(name) {
            this.name = name;
          },
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(Element2.prototype, "attributes", {
          get: function() {
            var _this = this;
            return Object.keys(this.attribs).map(function(name) {
              var _a, _b;
              return {
                name,
                value: _this.attribs[name],
                namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
              };
            });
          },
          enumerable: false,
          configurable: true
        });
        return Element2;
      }(NodeWithChildren)
    );
    exports.Element = Element;
    function isTag(node) {
      return (0, domelementtype_1.isTag)(node);
    }
    exports.isTag = isTag;
    function isCDATA(node) {
      return node.type === domelementtype_1.ElementType.CDATA;
    }
    exports.isCDATA = isCDATA;
    function isText(node) {
      return node.type === domelementtype_1.ElementType.Text;
    }
    exports.isText = isText;
    function isComment(node) {
      return node.type === domelementtype_1.ElementType.Comment;
    }
    exports.isComment = isComment;
    function isDirective(node) {
      return node.type === domelementtype_1.ElementType.Directive;
    }
    exports.isDirective = isDirective;
    function isDocument(node) {
      return node.type === domelementtype_1.ElementType.Root;
    }
    exports.isDocument = isDocument;
    function hasChildren2(node) {
      return Object.prototype.hasOwnProperty.call(node, "children");
    }
    exports.hasChildren = hasChildren2;
    function cloneNode(node, recursive) {
      if (recursive === void 0) {
        recursive = false;
      }
      var result;
      if (isText(node)) {
        result = new Text(node.data);
      } else if (isComment(node)) {
        result = new Comment(node.data);
      } else if (isTag(node)) {
        var children2 = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element(node.name, __assign({}, node.attribs), children2);
        children2.forEach(function(child) {
          return child.parent = clone_1;
        });
        if (node.namespace != null) {
          clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
          clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
          clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
      } else if (isCDATA(node)) {
        var children2 = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new CDATA(children2);
        children2.forEach(function(child) {
          return child.parent = clone_2;
        });
        result = clone_2;
      } else if (isDocument(node)) {
        var children2 = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children2);
        children2.forEach(function(child) {
          return child.parent = clone_3;
        });
        if (node["x-mode"]) {
          clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
      } else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
          instruction["x-name"] = node["x-name"];
          instruction["x-publicId"] = node["x-publicId"];
          instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
      } else {
        throw new Error("Not implemented yet: ".concat(node.type));
      }
      result.startIndex = node.startIndex;
      result.endIndex = node.endIndex;
      if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
      }
      return result;
    }
    exports.cloneNode = cloneNode;
    function cloneChildren(childs) {
      var children2 = childs.map(function(child) {
        return cloneNode(child, true);
      });
      for (var i = 1; i < children2.length; i++) {
        children2[i].prev = children2[i - 1];
        children2[i - 1].next = children2[i];
      }
      return children2;
    }
  }
});

// ../../node_modules/htmlparser2/node_modules/domhandler/lib/index.js
var require_lib3 = __commonJS({
  "../../node_modules/htmlparser2/node_modules/domhandler/lib/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m)
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
          __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DomHandler = void 0;
    var domelementtype_1 = require_lib2();
    var node_js_1 = require_node();
    __exportStar(require_node(), exports);
    var defaultOpts = {
      withStartIndices: false,
      withEndIndices: false,
      xmlMode: false
    };
    var DomHandler = (
      /** @class */
      function() {
        function DomHandler2(callback, options2, elementCB) {
          this.dom = [];
          this.root = new node_js_1.Document(this.dom);
          this.done = false;
          this.tagStack = [this.root];
          this.lastNode = null;
          this.parser = null;
          if (typeof options2 === "function") {
            elementCB = options2;
            options2 = defaultOpts;
          }
          if (typeof callback === "object") {
            options2 = callback;
            callback = void 0;
          }
          this.callback = callback !== null && callback !== void 0 ? callback : null;
          this.options = options2 !== null && options2 !== void 0 ? options2 : defaultOpts;
          this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
        }
        DomHandler2.prototype.onparserinit = function(parser) {
          this.parser = parser;
        };
        DomHandler2.prototype.onreset = function() {
          this.dom = [];
          this.root = new node_js_1.Document(this.dom);
          this.done = false;
          this.tagStack = [this.root];
          this.lastNode = null;
          this.parser = null;
        };
        DomHandler2.prototype.onend = function() {
          if (this.done)
            return;
          this.done = true;
          this.parser = null;
          this.handleCallback(null);
        };
        DomHandler2.prototype.onerror = function(error) {
          this.handleCallback(error);
        };
        DomHandler2.prototype.onclosetag = function() {
          this.lastNode = null;
          var elem = this.tagStack.pop();
          if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
          }
          if (this.elementCB)
            this.elementCB(elem);
        };
        DomHandler2.prototype.onopentag = function(name, attribs) {
          var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : void 0;
          var element = new node_js_1.Element(name, attribs, void 0, type);
          this.addNode(element);
          this.tagStack.push(element);
        };
        DomHandler2.prototype.ontext = function(data2) {
          var lastNode = this.lastNode;
          if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            lastNode.data += data2;
            if (this.options.withEndIndices) {
              lastNode.endIndex = this.parser.endIndex;
            }
          } else {
            var node = new node_js_1.Text(data2);
            this.addNode(node);
            this.lastNode = node;
          }
        };
        DomHandler2.prototype.oncomment = function(data2) {
          if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data2;
            return;
          }
          var node = new node_js_1.Comment(data2);
          this.addNode(node);
          this.lastNode = node;
        };
        DomHandler2.prototype.oncommentend = function() {
          this.lastNode = null;
        };
        DomHandler2.prototype.oncdatastart = function() {
          var text = new node_js_1.Text("");
          var node = new node_js_1.CDATA([text]);
          this.addNode(node);
          text.parent = node;
          this.lastNode = text;
        };
        DomHandler2.prototype.oncdataend = function() {
          this.lastNode = null;
        };
        DomHandler2.prototype.onprocessinginstruction = function(name, data2) {
          var node = new node_js_1.ProcessingInstruction(name, data2);
          this.addNode(node);
        };
        DomHandler2.prototype.handleCallback = function(error) {
          if (typeof this.callback === "function") {
            this.callback(error, this.dom);
          } else if (error) {
            throw error;
          }
        };
        DomHandler2.prototype.addNode = function(node) {
          var parent = this.tagStack[this.tagStack.length - 1];
          var previousSibling = parent.children[parent.children.length - 1];
          if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
          }
          if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
          }
          parent.children.push(node);
          if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
          }
          node.parent = parent;
          this.lastNode = null;
        };
        return DomHandler2;
      }()
    );
    exports.DomHandler = DomHandler;
    exports.default = DomHandler;
  }
});

// ../../node_modules/entities/lib/generated/encode-html.js
var require_encode_html = __commonJS({
  "../../node_modules/entities/lib/generated/encode-html.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function restoreDiff(arr) {
      for (var i = 1; i < arr.length; i++) {
        arr[i][0] += arr[i - 1][0] + 1;
      }
      return arr;
    }
    exports.default = new Map(/* @__PURE__ */ restoreDiff([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ restoreDiff([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
  }
});

// ../../node_modules/entities/lib/escape.js
var require_escape = __commonJS({
  "../../node_modules/entities/lib/escape.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.getCodePoint = exports.xmlReplacer = void 0;
    exports.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
    var xmlCodeMap = /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [39, "&apos;"],
      [60, "&lt;"],
      [62, "&gt;"]
    ]);
    exports.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? function(str, index) {
      return str.codePointAt(index);
    } : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(c, index) {
        return (c.charCodeAt(index) & 64512) === 55296 ? (c.charCodeAt(index) - 55296) * 1024 + c.charCodeAt(index + 1) - 56320 + 65536 : c.charCodeAt(index);
      }
    );
    function encodeXML(str) {
      var ret = "";
      var lastIdx = 0;
      var match2;
      while ((match2 = exports.xmlReplacer.exec(str)) !== null) {
        var i = match2.index;
        var char = str.charCodeAt(i);
        var next = xmlCodeMap.get(char);
        if (next !== void 0) {
          ret += str.substring(lastIdx, i) + next;
          lastIdx = i + 1;
        } else {
          ret += "".concat(str.substring(lastIdx, i), "&#x").concat((0, exports.getCodePoint)(str, i).toString(16), ";");
          lastIdx = exports.xmlReplacer.lastIndex += Number((char & 64512) === 55296);
        }
      }
      return ret + str.substr(lastIdx);
    }
    exports.encodeXML = encodeXML;
    exports.escape = encodeXML;
    function getEscaper(regex, map36) {
      return function escape2(data2) {
        var match2;
        var lastIdx = 0;
        var result = "";
        while (match2 = regex.exec(data2)) {
          if (lastIdx !== match2.index) {
            result += data2.substring(lastIdx, match2.index);
          }
          result += map36.get(match2[0].charCodeAt(0));
          lastIdx = match2.index + 1;
        }
        return result + data2.substring(lastIdx);
      };
    }
    exports.escapeUTF8 = getEscaper(/[&<>'"]/g, xmlCodeMap);
    exports.escapeAttribute = getEscaper(/["&\u00A0]/g, /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [160, "&nbsp;"]
    ]));
    exports.escapeText = getEscaper(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
      [38, "&amp;"],
      [60, "&lt;"],
      [62, "&gt;"],
      [160, "&nbsp;"]
    ]));
  }
});

// ../../node_modules/entities/lib/encode.js
var require_encode = __commonJS({
  "../../node_modules/entities/lib/encode.js"(exports) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.encodeNonAsciiHTML = exports.encodeHTML = void 0;
    var encode_html_js_1 = __importDefault(require_encode_html());
    var escape_js_1 = require_escape();
    var htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
    function encodeHTML(data2) {
      return encodeHTMLTrieRe(htmlReplacer, data2);
    }
    exports.encodeHTML = encodeHTML;
    function encodeNonAsciiHTML(data2) {
      return encodeHTMLTrieRe(escape_js_1.xmlReplacer, data2);
    }
    exports.encodeNonAsciiHTML = encodeNonAsciiHTML;
    function encodeHTMLTrieRe(regExp, str) {
      var ret = "";
      var lastIdx = 0;
      var match2;
      while ((match2 = regExp.exec(str)) !== null) {
        var i = match2.index;
        ret += str.substring(lastIdx, i);
        var char = str.charCodeAt(i);
        var next = encode_html_js_1.default.get(char);
        if (typeof next === "object") {
          if (i + 1 < str.length) {
            var nextChar = str.charCodeAt(i + 1);
            var value = typeof next.n === "number" ? next.n === nextChar ? next.o : void 0 : next.n.get(nextChar);
            if (value !== void 0) {
              ret += value;
              lastIdx = regExp.lastIndex += 1;
              continue;
            }
          }
          next = next.v;
        }
        if (next !== void 0) {
          ret += next;
          lastIdx = i + 1;
        } else {
          var cp = (0, escape_js_1.getCodePoint)(str, i);
          ret += "&#x".concat(cp.toString(16), ";");
          lastIdx = regExp.lastIndex += Number(cp !== char);
        }
      }
      return ret + str.substr(lastIdx);
    }
  }
});

// ../../node_modules/entities/lib/index.js
var require_lib4 = __commonJS({
  "../../node_modules/entities/lib/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.encodeHTML5 = exports.encodeHTML4 = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = exports.EncodingMode = exports.DecodingMode = exports.EntityLevel = void 0;
    var decode_js_1 = require_decode();
    var encode_js_1 = require_encode();
    var escape_js_1 = require_escape();
    var EntityLevel;
    (function(EntityLevel2) {
      EntityLevel2[EntityLevel2["XML"] = 0] = "XML";
      EntityLevel2[EntityLevel2["HTML"] = 1] = "HTML";
    })(EntityLevel = exports.EntityLevel || (exports.EntityLevel = {}));
    var DecodingMode;
    (function(DecodingMode2) {
      DecodingMode2[DecodingMode2["Legacy"] = 0] = "Legacy";
      DecodingMode2[DecodingMode2["Strict"] = 1] = "Strict";
    })(DecodingMode = exports.DecodingMode || (exports.DecodingMode = {}));
    var EncodingMode;
    (function(EncodingMode2) {
      EncodingMode2[EncodingMode2["UTF8"] = 0] = "UTF8";
      EncodingMode2[EncodingMode2["ASCII"] = 1] = "ASCII";
      EncodingMode2[EncodingMode2["Extensive"] = 2] = "Extensive";
      EncodingMode2[EncodingMode2["Attribute"] = 3] = "Attribute";
      EncodingMode2[EncodingMode2["Text"] = 4] = "Text";
    })(EncodingMode = exports.EncodingMode || (exports.EncodingMode = {}));
    function decode(data2, options2) {
      if (options2 === void 0) {
        options2 = EntityLevel.XML;
      }
      var opts = typeof options2 === "number" ? { level: options2 } : options2;
      if (opts.level === EntityLevel.HTML) {
        if (opts.mode === DecodingMode.Strict) {
          return (0, decode_js_1.decodeHTMLStrict)(data2);
        }
        return (0, decode_js_1.decodeHTML)(data2);
      }
      return (0, decode_js_1.decodeXML)(data2);
    }
    exports.decode = decode;
    function decodeStrict(data2, options2) {
      if (options2 === void 0) {
        options2 = EntityLevel.XML;
      }
      var opts = typeof options2 === "number" ? { level: options2 } : options2;
      if (opts.level === EntityLevel.HTML) {
        if (opts.mode === DecodingMode.Legacy) {
          return (0, decode_js_1.decodeHTML)(data2);
        }
        return (0, decode_js_1.decodeHTMLStrict)(data2);
      }
      return (0, decode_js_1.decodeXML)(data2);
    }
    exports.decodeStrict = decodeStrict;
    function encode(data2, options2) {
      if (options2 === void 0) {
        options2 = EntityLevel.XML;
      }
      var opts = typeof options2 === "number" ? { level: options2 } : options2;
      if (opts.mode === EncodingMode.UTF8)
        return (0, escape_js_1.escapeUTF8)(data2);
      if (opts.mode === EncodingMode.Attribute)
        return (0, escape_js_1.escapeAttribute)(data2);
      if (opts.mode === EncodingMode.Text)
        return (0, escape_js_1.escapeText)(data2);
      if (opts.level === EntityLevel.HTML) {
        if (opts.mode === EncodingMode.ASCII) {
          return (0, encode_js_1.encodeNonAsciiHTML)(data2);
        }
        return (0, encode_js_1.encodeHTML)(data2);
      }
      return (0, escape_js_1.encodeXML)(data2);
    }
    exports.encode = encode;
    var escape_js_2 = require_escape();
    Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function() {
      return escape_js_2.encodeXML;
    } });
    Object.defineProperty(exports, "escape", { enumerable: true, get: function() {
      return escape_js_2.escape;
    } });
    Object.defineProperty(exports, "escapeUTF8", { enumerable: true, get: function() {
      return escape_js_2.escapeUTF8;
    } });
    Object.defineProperty(exports, "escapeAttribute", { enumerable: true, get: function() {
      return escape_js_2.escapeAttribute;
    } });
    Object.defineProperty(exports, "escapeText", { enumerable: true, get: function() {
      return escape_js_2.escapeText;
    } });
    var encode_js_2 = require_encode();
    Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function() {
      return encode_js_2.encodeHTML;
    } });
    Object.defineProperty(exports, "encodeNonAsciiHTML", { enumerable: true, get: function() {
      return encode_js_2.encodeNonAsciiHTML;
    } });
    Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function() {
      return encode_js_2.encodeHTML;
    } });
    Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function() {
      return encode_js_2.encodeHTML;
    } });
    var decode_js_2 = require_decode();
    Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function() {
      return decode_js_2.decodeXML;
    } });
    Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function() {
      return decode_js_2.decodeHTML;
    } });
    Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function() {
      return decode_js_2.decodeHTMLStrict;
    } });
    Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function() {
      return decode_js_2.decodeHTML;
    } });
    Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function() {
      return decode_js_2.decodeHTML;
    } });
    Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function() {
      return decode_js_2.decodeHTMLStrict;
    } });
    Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function() {
      return decode_js_2.decodeHTMLStrict;
    } });
    Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function() {
      return decode_js_2.decodeXML;
    } });
  }
});

// ../../node_modules/htmlparser2/node_modules/dom-serializer/lib/foreignNames.js
var require_foreignNames = __commonJS({
  "../../node_modules/htmlparser2/node_modules/dom-serializer/lib/foreignNames.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.attributeNames = exports.elementNames = void 0;
    exports.elementNames = new Map([
      "altGlyph",
      "altGlyphDef",
      "altGlyphItem",
      "animateColor",
      "animateMotion",
      "animateTransform",
      "clipPath",
      "feBlend",
      "feColorMatrix",
      "feComponentTransfer",
      "feComposite",
      "feConvolveMatrix",
      "feDiffuseLighting",
      "feDisplacementMap",
      "feDistantLight",
      "feDropShadow",
      "feFlood",
      "feFuncA",
      "feFuncB",
      "feFuncG",
      "feFuncR",
      "feGaussianBlur",
      "feImage",
      "feMerge",
      "feMergeNode",
      "feMorphology",
      "feOffset",
      "fePointLight",
      "feSpecularLighting",
      "feSpotLight",
      "feTile",
      "feTurbulence",
      "foreignObject",
      "glyphRef",
      "linearGradient",
      "radialGradient",
      "textPath"
    ].map(function(val) {
      return [val.toLowerCase(), val];
    }));
    exports.attributeNames = new Map([
      "definitionURL",
      "attributeName",
      "attributeType",
      "baseFrequency",
      "baseProfile",
      "calcMode",
      "clipPathUnits",
      "diffuseConstant",
      "edgeMode",
      "filterUnits",
      "glyphRef",
      "gradientTransform",
      "gradientUnits",
      "kernelMatrix",
      "kernelUnitLength",
      "keyPoints",
      "keySplines",
      "keyTimes",
      "lengthAdjust",
      "limitingConeAngle",
      "markerHeight",
      "markerUnits",
      "markerWidth",
      "maskContentUnits",
      "maskUnits",
      "numOctaves",
      "pathLength",
      "patternContentUnits",
      "patternTransform",
      "patternUnits",
      "pointsAtX",
      "pointsAtY",
      "pointsAtZ",
      "preserveAlpha",
      "preserveAspectRatio",
      "primitiveUnits",
      "refX",
      "refY",
      "repeatCount",
      "repeatDur",
      "requiredExtensions",
      "requiredFeatures",
      "specularConstant",
      "specularExponent",
      "spreadMethod",
      "startOffset",
      "stdDeviation",
      "stitchTiles",
      "surfaceScale",
      "systemLanguage",
      "tableValues",
      "targetX",
      "targetY",
      "textLength",
      "viewBox",
      "viewTarget",
      "xChannelSelector",
      "yChannelSelector",
      "zoomAndPan"
    ].map(function(val) {
      return [val.toLowerCase(), val];
    }));
  }
});

// ../../node_modules/htmlparser2/node_modules/dom-serializer/lib/index.js
var require_lib5 = __commonJS({
  "../../node_modules/htmlparser2/node_modules/dom-serializer/lib/index.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || function() {
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.render = void 0;
    var ElementType = __importStar(require_lib2());
    var entities_1 = require_lib4();
    var foreignNames_js_1 = require_foreignNames();
    var unencodedElements = /* @__PURE__ */ new Set([
      "style",
      "script",
      "xmp",
      "iframe",
      "noembed",
      "noframes",
      "plaintext",
      "noscript"
    ]);
    function replaceQuotes(value) {
      return value.replace(/"/g, "&quot;");
    }
    function formatAttributes(attributes, opts) {
      var _a;
      if (!attributes)
        return;
      var encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? entities_1.encodeXML : entities_1.escapeAttribute;
      return Object.keys(attributes).map(function(key) {
        var _a2, _b;
        var value = (_a2 = attributes[key]) !== null && _a2 !== void 0 ? _a2 : "";
        if (opts.xmlMode === "foreign") {
          key = (_b = foreignNames_js_1.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
        }
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
          return key;
        }
        return "".concat(key, '="').concat(encode(value), '"');
      }).join(" ");
    }
    var singleTag = /* @__PURE__ */ new Set([
      "area",
      "base",
      "basefont",
      "br",
      "col",
      "command",
      "embed",
      "frame",
      "hr",
      "img",
      "input",
      "isindex",
      "keygen",
      "link",
      "meta",
      "param",
      "source",
      "track",
      "wbr"
    ]);
    function render2(node, options2) {
      if (options2 === void 0) {
        options2 = {};
      }
      var nodes = "length" in node ? node : [node];
      var output = "";
      for (var i = 0; i < nodes.length; i++) {
        output += renderNode(nodes[i], options2);
      }
      return output;
    }
    exports.render = render2;
    exports.default = render2;
    function renderNode(node, options2) {
      switch (node.type) {
        case ElementType.Root:
          return render2(node.children, options2);
        case ElementType.Doctype:
        case ElementType.Directive:
          return renderDirective(node);
        case ElementType.Comment:
          return renderComment(node);
        case ElementType.CDATA:
          return renderCdata(node);
        case ElementType.Script:
        case ElementType.Style:
        case ElementType.Tag:
          return renderTag(node, options2);
        case ElementType.Text:
          return renderText(node, options2);
      }
    }
    var foreignModeIntegrationPoints = /* @__PURE__ */ new Set([
      "mi",
      "mo",
      "mn",
      "ms",
      "mtext",
      "annotation-xml",
      "foreignObject",
      "desc",
      "title"
    ]);
    var foreignElements = /* @__PURE__ */ new Set(["svg", "math"]);
    function renderTag(elem, opts) {
      var _a;
      if (opts.xmlMode === "foreign") {
        elem.name = (_a = foreignNames_js_1.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        if (elem.parent && foreignModeIntegrationPoints.has(elem.parent.name)) {
          opts = __assign(__assign({}, opts), { xmlMode: false });
        }
      }
      if (!opts.xmlMode && foreignElements.has(elem.name)) {
        opts = __assign(__assign({}, opts), { xmlMode: "foreign" });
      }
      var tag = "<".concat(elem.name);
      var attribs = formatAttributes(elem.attribs, opts);
      if (attribs) {
        tag += " ".concat(attribs);
      }
      if (elem.children.length === 0 && (opts.xmlMode ? (
        // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
        opts.selfClosingTags !== false
      ) : (
        // User explicitly asked for self-closing tags, even in HTML mode
        opts.selfClosingTags && singleTag.has(elem.name)
      ))) {
        if (!opts.xmlMode)
          tag += " ";
        tag += "/>";
      } else {
        tag += ">";
        if (elem.children.length > 0) {
          tag += render2(elem.children, opts);
        }
        if (opts.xmlMode || !singleTag.has(elem.name)) {
          tag += "</".concat(elem.name, ">");
        }
      }
      return tag;
    }
    function renderDirective(elem) {
      return "<".concat(elem.data, ">");
    }
    function renderText(elem, opts) {
      var _a;
      var data2 = elem.data || "";
      if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && unencodedElements.has(elem.parent.name))) {
        data2 = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, entities_1.encodeXML)(data2) : (0, entities_1.escapeText)(data2);
      }
      return data2;
    }
    function renderCdata(elem) {
      return "<![CDATA[".concat(elem.children[0].data, "]]>");
    }
    function renderComment(elem) {
      return "<!--".concat(elem.data, "-->");
    }
  }
});

// ../../node_modules/htmlparser2/node_modules/domutils/lib/stringify.js
var require_stringify2 = __commonJS({
  "../../node_modules/htmlparser2/node_modules/domutils/lib/stringify.js"(exports) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.innerText = exports.textContent = exports.getText = exports.getInnerHTML = exports.getOuterHTML = void 0;
    var domhandler_1 = require_lib3();
    var dom_serializer_1 = __importDefault(require_lib5());
    var domelementtype_1 = require_lib2();
    function getOuterHTML(node, options2) {
      return (0, dom_serializer_1.default)(node, options2);
    }
    exports.getOuterHTML = getOuterHTML;
    function getInnerHTML(node, options2) {
      return (0, domhandler_1.hasChildren)(node) ? node.children.map(function(node2) {
        return getOuterHTML(node2, options2);
      }).join("") : "";
    }
    exports.getInnerHTML = getInnerHTML;
    function getText(node) {
      if (Array.isArray(node))
        return node.map(getText).join("");
      if ((0, domhandler_1.isTag)(node))
        return node.name === "br" ? "\n" : getText(node.children);
      if ((0, domhandler_1.isCDATA)(node))
        return getText(node.children);
      if ((0, domhandler_1.isText)(node))
        return node.data;
      return "";
    }
    exports.getText = getText;
    function textContent(node) {
      if (Array.isArray(node))
        return node.map(textContent).join("");
      if ((0, domhandler_1.hasChildren)(node) && !(0, domhandler_1.isComment)(node)) {
        return textContent(node.children);
      }
      if ((0, domhandler_1.isText)(node))
        return node.data;
      return "";
    }
    exports.textContent = textContent;
    function innerText(node) {
      if (Array.isArray(node))
        return node.map(innerText).join("");
      if ((0, domhandler_1.hasChildren)(node) && (node.type === domelementtype_1.ElementType.Tag || (0, domhandler_1.isCDATA)(node))) {
        return innerText(node.children);
      }
      if ((0, domhandler_1.isText)(node))
        return node.data;
      return "";
    }
    exports.innerText = innerText;
  }
});

// ../../node_modules/htmlparser2/node_modules/domutils/lib/traversal.js
var require_traversal = __commonJS({
  "../../node_modules/htmlparser2/node_modules/domutils/lib/traversal.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.prevElementSibling = exports.nextElementSibling = exports.getName = exports.hasAttrib = exports.getAttributeValue = exports.getSiblings = exports.getParent = exports.getChildren = void 0;
    var domhandler_1 = require_lib3();
    function getChildren(elem) {
      return (0, domhandler_1.hasChildren)(elem) ? elem.children : [];
    }
    exports.getChildren = getChildren;
    function getParent3(elem) {
      return elem.parent || null;
    }
    exports.getParent = getParent3;
    function getSiblings(elem) {
      var _a, _b;
      var parent = getParent3(elem);
      if (parent != null)
        return getChildren(parent);
      var siblings = [elem];
      var prev = elem.prev, next = elem.next;
      while (prev != null) {
        siblings.unshift(prev);
        _a = prev, prev = _a.prev;
      }
      while (next != null) {
        siblings.push(next);
        _b = next, next = _b.next;
      }
      return siblings;
    }
    exports.getSiblings = getSiblings;
    function getAttributeValue(elem, name) {
      var _a;
      return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
    }
    exports.getAttributeValue = getAttributeValue;
    function hasAttrib(elem, name) {
      return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
    }
    exports.hasAttrib = hasAttrib;
    function getName(elem) {
      return elem.name;
    }
    exports.getName = getName;
    function nextElementSibling(elem) {
      var _a;
      var next = elem.next;
      while (next !== null && !(0, domhandler_1.isTag)(next))
        _a = next, next = _a.next;
      return next;
    }
    exports.nextElementSibling = nextElementSibling;
    function prevElementSibling(elem) {
      var _a;
      var prev = elem.prev;
      while (prev !== null && !(0, domhandler_1.isTag)(prev))
        _a = prev, prev = _a.prev;
      return prev;
    }
    exports.prevElementSibling = prevElementSibling;
  }
});

// ../../node_modules/htmlparser2/node_modules/domutils/lib/manipulation.js
var require_manipulation = __commonJS({
  "../../node_modules/htmlparser2/node_modules/domutils/lib/manipulation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.prepend = exports.prependChild = exports.append = exports.appendChild = exports.replaceElement = exports.removeElement = void 0;
    function removeElement(elem) {
      if (elem.prev)
        elem.prev.next = elem.next;
      if (elem.next)
        elem.next.prev = elem.prev;
      if (elem.parent) {
        var childs = elem.parent.children;
        childs.splice(childs.lastIndexOf(elem), 1);
      }
    }
    exports.removeElement = removeElement;
    function replaceElement(elem, replacement2) {
      var prev = replacement2.prev = elem.prev;
      if (prev) {
        prev.next = replacement2;
      }
      var next = replacement2.next = elem.next;
      if (next) {
        next.prev = replacement2;
      }
      var parent = replacement2.parent = elem.parent;
      if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement2;
        elem.parent = null;
      }
    }
    exports.replaceElement = replaceElement;
    function appendChild(elem, child) {
      removeElement(child);
      child.next = null;
      child.parent = elem;
      if (elem.children.push(child) > 1) {
        var sibling = elem.children[elem.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
      } else {
        child.prev = null;
      }
    }
    exports.appendChild = appendChild;
    function append(elem, next) {
      removeElement(next);
      var parent = elem.parent;
      var currNext = elem.next;
      next.next = currNext;
      next.prev = elem;
      elem.next = next;
      next.parent = parent;
      if (currNext) {
        currNext.prev = next;
        if (parent) {
          var childs = parent.children;
          childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
      } else if (parent) {
        parent.children.push(next);
      }
    }
    exports.append = append;
    function prependChild(elem, child) {
      removeElement(child);
      child.parent = elem;
      child.prev = null;
      if (elem.children.unshift(child) !== 1) {
        var sibling = elem.children[1];
        sibling.prev = child;
        child.next = sibling;
      } else {
        child.next = null;
      }
    }
    exports.prependChild = prependChild;
    function prepend(elem, prev) {
      removeElement(prev);
      var parent = elem.parent;
      if (parent) {
        var childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
      }
      if (elem.prev) {
        elem.prev.next = prev;
      }
      prev.parent = parent;
      prev.prev = elem.prev;
      prev.next = elem;
      elem.prev = prev;
    }
    exports.prepend = prepend;
  }
});

// ../../node_modules/htmlparser2/node_modules/domutils/lib/querying.js
var require_querying = __commonJS({
  "../../node_modules/htmlparser2/node_modules/domutils/lib/querying.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.findAll = exports.existsOne = exports.findOne = exports.findOneChild = exports.find = exports.filter = void 0;
    var domhandler_1 = require_lib3();
    function filter12(test, node, recurse, limit) {
      if (recurse === void 0) {
        recurse = true;
      }
      if (limit === void 0) {
        limit = Infinity;
      }
      if (!Array.isArray(node))
        node = [node];
      return find17(test, node, recurse, limit);
    }
    exports.filter = filter12;
    function find17(test, nodes, recurse, limit) {
      var result = [];
      for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
        var elem = nodes_1[_i];
        if (test(elem)) {
          result.push(elem);
          if (--limit <= 0)
            break;
        }
        if (recurse && (0, domhandler_1.hasChildren)(elem) && elem.children.length > 0) {
          var children2 = find17(test, elem.children, recurse, limit);
          result.push.apply(result, children2);
          limit -= children2.length;
          if (limit <= 0)
            break;
        }
      }
      return result;
    }
    exports.find = find17;
    function findOneChild(test, nodes) {
      return nodes.find(test);
    }
    exports.findOneChild = findOneChild;
    function findOne(test, nodes, recurse) {
      if (recurse === void 0) {
        recurse = true;
      }
      var elem = null;
      for (var i = 0; i < nodes.length && !elem; i++) {
        var checked = nodes[i];
        if (!(0, domhandler_1.isTag)(checked)) {
          continue;
        } else if (test(checked)) {
          elem = checked;
        } else if (recurse && checked.children.length > 0) {
          elem = findOne(test, checked.children, true);
        }
      }
      return elem;
    }
    exports.findOne = findOne;
    function existsOne(test, nodes) {
      return nodes.some(function(checked) {
        return (0, domhandler_1.isTag)(checked) && (test(checked) || checked.children.length > 0 && existsOne(test, checked.children));
      });
    }
    exports.existsOne = existsOne;
    function findAll(test, nodes) {
      var _a;
      var result = [];
      var stack = nodes.filter(domhandler_1.isTag);
      var elem;
      while (elem = stack.shift()) {
        var children2 = (_a = elem.children) === null || _a === void 0 ? void 0 : _a.filter(domhandler_1.isTag);
        if (children2 && children2.length > 0) {
          stack.unshift.apply(stack, children2);
        }
        if (test(elem))
          result.push(elem);
      }
      return result;
    }
    exports.findAll = findAll;
  }
});

// ../../node_modules/htmlparser2/node_modules/domutils/lib/legacy.js
var require_legacy = __commonJS({
  "../../node_modules/htmlparser2/node_modules/domutils/lib/legacy.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getElementsByTagType = exports.getElementsByTagName = exports.getElementById = exports.getElements = exports.testElement = void 0;
    var domhandler_1 = require_lib3();
    var querying_js_1 = require_querying();
    var Checks = {
      tag_name: function(name) {
        if (typeof name === "function") {
          return function(elem) {
            return (0, domhandler_1.isTag)(elem) && name(elem.name);
          };
        } else if (name === "*") {
          return domhandler_1.isTag;
        }
        return function(elem) {
          return (0, domhandler_1.isTag)(elem) && elem.name === name;
        };
      },
      tag_type: function(type) {
        if (typeof type === "function") {
          return function(elem) {
            return type(elem.type);
          };
        }
        return function(elem) {
          return elem.type === type;
        };
      },
      tag_contains: function(data2) {
        if (typeof data2 === "function") {
          return function(elem) {
            return (0, domhandler_1.isText)(elem) && data2(elem.data);
          };
        }
        return function(elem) {
          return (0, domhandler_1.isText)(elem) && elem.data === data2;
        };
      }
    };
    function getAttribCheck(attrib, value) {
      if (typeof value === "function") {
        return function(elem) {
          return (0, domhandler_1.isTag)(elem) && value(elem.attribs[attrib]);
        };
      }
      return function(elem) {
        return (0, domhandler_1.isTag)(elem) && elem.attribs[attrib] === value;
      };
    }
    function combineFuncs(a, b) {
      return function(elem) {
        return a(elem) || b(elem);
      };
    }
    function compileTest(options2) {
      var funcs = Object.keys(options2).map(function(key) {
        var value = options2[key];
        return Object.prototype.hasOwnProperty.call(Checks, key) ? Checks[key](value) : getAttribCheck(key, value);
      });
      return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
    }
    function testElement(options2, node) {
      var test = compileTest(options2);
      return test ? test(node) : true;
    }
    exports.testElement = testElement;
    function getElements(options2, nodes, recurse, limit) {
      if (limit === void 0) {
        limit = Infinity;
      }
      var test = compileTest(options2);
      return test ? (0, querying_js_1.filter)(test, nodes, recurse, limit) : [];
    }
    exports.getElements = getElements;
    function getElementById(id2, nodes, recurse) {
      if (recurse === void 0) {
        recurse = true;
      }
      if (!Array.isArray(nodes))
        nodes = [nodes];
      return (0, querying_js_1.findOne)(getAttribCheck("id", id2), nodes, recurse);
    }
    exports.getElementById = getElementById;
    function getElementsByTagName(tagName, nodes, recurse, limit) {
      if (recurse === void 0) {
        recurse = true;
      }
      if (limit === void 0) {
        limit = Infinity;
      }
      return (0, querying_js_1.filter)(Checks["tag_name"](tagName), nodes, recurse, limit);
    }
    exports.getElementsByTagName = getElementsByTagName;
    function getElementsByTagType(type, nodes, recurse, limit) {
      if (recurse === void 0) {
        recurse = true;
      }
      if (limit === void 0) {
        limit = Infinity;
      }
      return (0, querying_js_1.filter)(Checks["tag_type"](type), nodes, recurse, limit);
    }
    exports.getElementsByTagType = getElementsByTagType;
  }
});

// ../../node_modules/htmlparser2/node_modules/domutils/lib/helpers.js
var require_helpers = __commonJS({
  "../../node_modules/htmlparser2/node_modules/domutils/lib/helpers.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uniqueSort = exports.compareDocumentPosition = exports.DocumentPosition = exports.removeSubsets = void 0;
    var domhandler_1 = require_lib3();
    function removeSubsets(nodes) {
      var idx = nodes.length;
      while (--idx >= 0) {
        var node = nodes[idx];
        if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
          nodes.splice(idx, 1);
          continue;
        }
        for (var ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
          if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
          }
        }
      }
      return nodes;
    }
    exports.removeSubsets = removeSubsets;
    var DocumentPosition;
    (function(DocumentPosition2) {
      DocumentPosition2[DocumentPosition2["DISCONNECTED"] = 1] = "DISCONNECTED";
      DocumentPosition2[DocumentPosition2["PRECEDING"] = 2] = "PRECEDING";
      DocumentPosition2[DocumentPosition2["FOLLOWING"] = 4] = "FOLLOWING";
      DocumentPosition2[DocumentPosition2["CONTAINS"] = 8] = "CONTAINS";
      DocumentPosition2[DocumentPosition2["CONTAINED_BY"] = 16] = "CONTAINED_BY";
    })(DocumentPosition = exports.DocumentPosition || (exports.DocumentPosition = {}));
    function compareDocumentPosition(nodeA, nodeB) {
      var aParents = [];
      var bParents = [];
      if (nodeA === nodeB) {
        return 0;
      }
      var current = (0, domhandler_1.hasChildren)(nodeA) ? nodeA : nodeA.parent;
      while (current) {
        aParents.unshift(current);
        current = current.parent;
      }
      current = (0, domhandler_1.hasChildren)(nodeB) ? nodeB : nodeB.parent;
      while (current) {
        bParents.unshift(current);
        current = current.parent;
      }
      var maxIdx = Math.min(aParents.length, bParents.length);
      var idx = 0;
      while (idx < maxIdx && aParents[idx] === bParents[idx]) {
        idx++;
      }
      if (idx === 0) {
        return DocumentPosition.DISCONNECTED;
      }
      var sharedParent = aParents[idx - 1];
      var siblings = sharedParent.children;
      var aSibling = aParents[idx];
      var bSibling = bParents[idx];
      if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) {
          return DocumentPosition.FOLLOWING | DocumentPosition.CONTAINED_BY;
        }
        return DocumentPosition.FOLLOWING;
      }
      if (sharedParent === nodeA) {
        return DocumentPosition.PRECEDING | DocumentPosition.CONTAINS;
      }
      return DocumentPosition.PRECEDING;
    }
    exports.compareDocumentPosition = compareDocumentPosition;
    function uniqueSort(nodes) {
      nodes = nodes.filter(function(node, i, arr) {
        return !arr.includes(node, i + 1);
      });
      nodes.sort(function(a, b) {
        var relative = compareDocumentPosition(a, b);
        if (relative & DocumentPosition.PRECEDING) {
          return -1;
        } else if (relative & DocumentPosition.FOLLOWING) {
          return 1;
        }
        return 0;
      });
      return nodes;
    }
    exports.uniqueSort = uniqueSort;
  }
});

// ../../node_modules/htmlparser2/node_modules/domutils/lib/feeds.js
var require_feeds = __commonJS({
  "../../node_modules/htmlparser2/node_modules/domutils/lib/feeds.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getFeed = void 0;
    var stringify_js_1 = require_stringify2();
    var legacy_js_1 = require_legacy();
    function getFeed(doc) {
      var feedRoot = getOneElement(isValidFeed, doc);
      return !feedRoot ? null : feedRoot.name === "feed" ? getAtomFeed(feedRoot) : getRssFeed(feedRoot);
    }
    exports.getFeed = getFeed;
    function getAtomFeed(feedRoot) {
      var _a;
      var childs = feedRoot.children;
      var feed = {
        type: "atom",
        items: (0, legacy_js_1.getElementsByTagName)("entry", childs).map(function(item) {
          var _a2;
          var children2 = item.children;
          var entry = { media: getMediaElements(children2) };
          addConditionally(entry, "id", "id", children2);
          addConditionally(entry, "title", "title", children2);
          var href2 = (_a2 = getOneElement("link", children2)) === null || _a2 === void 0 ? void 0 : _a2.attribs["href"];
          if (href2) {
            entry.link = href2;
          }
          var description = fetch("summary", children2) || fetch("content", children2);
          if (description) {
            entry.description = description;
          }
          var pubDate = fetch("updated", children2);
          if (pubDate) {
            entry.pubDate = new Date(pubDate);
          }
          return entry;
        })
      };
      addConditionally(feed, "id", "id", childs);
      addConditionally(feed, "title", "title", childs);
      var href = (_a = getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
      if (href) {
        feed.link = href;
      }
      addConditionally(feed, "description", "subtitle", childs);
      var updated = fetch("updated", childs);
      if (updated) {
        feed.updated = new Date(updated);
      }
      addConditionally(feed, "author", "email", childs, true);
      return feed;
    }
    function getRssFeed(feedRoot) {
      var _a, _b;
      var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
      var feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, legacy_js_1.getElementsByTagName)("item", feedRoot.children).map(function(item) {
          var children2 = item.children;
          var entry = { media: getMediaElements(children2) };
          addConditionally(entry, "id", "guid", children2);
          addConditionally(entry, "title", "title", children2);
          addConditionally(entry, "link", "link", children2);
          addConditionally(entry, "description", "description", children2);
          var pubDate = fetch("pubDate", children2);
          if (pubDate)
            entry.pubDate = new Date(pubDate);
          return entry;
        })
      };
      addConditionally(feed, "title", "title", childs);
      addConditionally(feed, "link", "link", childs);
      addConditionally(feed, "description", "description", childs);
      var updated = fetch("lastBuildDate", childs);
      if (updated) {
        feed.updated = new Date(updated);
      }
      addConditionally(feed, "author", "managingEditor", childs, true);
      return feed;
    }
    var MEDIA_KEYS_STRING = ["url", "type", "lang"];
    var MEDIA_KEYS_INT = [
      "fileSize",
      "bitrate",
      "framerate",
      "samplingrate",
      "channels",
      "duration",
      "height",
      "width"
    ];
    function getMediaElements(where) {
      return (0, legacy_js_1.getElementsByTagName)("media:content", where).map(function(elem) {
        var attribs = elem.attribs;
        var media = {
          medium: attribs["medium"],
          isDefault: !!attribs["isDefault"]
        };
        for (var _i = 0, MEDIA_KEYS_STRING_1 = MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++) {
          var attrib = MEDIA_KEYS_STRING_1[_i];
          if (attribs[attrib]) {
            media[attrib] = attribs[attrib];
          }
        }
        for (var _a = 0, MEDIA_KEYS_INT_1 = MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++) {
          var attrib = MEDIA_KEYS_INT_1[_a];
          if (attribs[attrib]) {
            media[attrib] = parseInt(attribs[attrib], 10);
          }
        }
        if (attribs["expression"]) {
          media.expression = attribs["expression"];
        }
        return media;
      });
    }
    function getOneElement(tagName, node) {
      return (0, legacy_js_1.getElementsByTagName)(tagName, node, true, 1)[0];
    }
    function fetch(tagName, where, recurse) {
      if (recurse === void 0) {
        recurse = false;
      }
      return (0, stringify_js_1.textContent)((0, legacy_js_1.getElementsByTagName)(tagName, where, recurse, 1)).trim();
    }
    function addConditionally(obj, prop, tagName, where, recurse) {
      if (recurse === void 0) {
        recurse = false;
      }
      var val = fetch(tagName, where, recurse);
      if (val)
        obj[prop] = val;
    }
    function isValidFeed(value) {
      return value === "rss" || value === "feed" || value === "rdf:RDF";
    }
  }
});

// ../../node_modules/htmlparser2/node_modules/domutils/lib/index.js
var require_lib6 = __commonJS({
  "../../node_modules/htmlparser2/node_modules/domutils/lib/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m)
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
          __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.hasChildren = exports.isDocument = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = void 0;
    __exportStar(require_stringify2(), exports);
    __exportStar(require_traversal(), exports);
    __exportStar(require_manipulation(), exports);
    __exportStar(require_querying(), exports);
    __exportStar(require_legacy(), exports);
    __exportStar(require_helpers(), exports);
    __exportStar(require_feeds(), exports);
    var domhandler_1 = require_lib3();
    Object.defineProperty(exports, "isTag", { enumerable: true, get: function() {
      return domhandler_1.isTag;
    } });
    Object.defineProperty(exports, "isCDATA", { enumerable: true, get: function() {
      return domhandler_1.isCDATA;
    } });
    Object.defineProperty(exports, "isText", { enumerable: true, get: function() {
      return domhandler_1.isText;
    } });
    Object.defineProperty(exports, "isComment", { enumerable: true, get: function() {
      return domhandler_1.isComment;
    } });
    Object.defineProperty(exports, "isDocument", { enumerable: true, get: function() {
      return domhandler_1.isDocument;
    } });
    Object.defineProperty(exports, "hasChildren", { enumerable: true, get: function() {
      return domhandler_1.hasChildren;
    } });
  }
});

// ../../node_modules/htmlparser2/lib/index.js
var require_lib7 = __commonJS({
  "../../node_modules/htmlparser2/lib/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DefaultHandler = exports.DomUtils = exports.parseFeed = exports.getFeed = exports.ElementType = exports.Tokenizer = exports.createDomStream = exports.parseDOM = exports.parseDocument = exports.DomHandler = exports.Parser = void 0;
    var Parser_js_1 = require_Parser();
    Object.defineProperty(exports, "Parser", { enumerable: true, get: function() {
      return Parser_js_1.Parser;
    } });
    var domhandler_1 = require_lib3();
    Object.defineProperty(exports, "DomHandler", { enumerable: true, get: function() {
      return domhandler_1.DomHandler;
    } });
    Object.defineProperty(exports, "DefaultHandler", { enumerable: true, get: function() {
      return domhandler_1.DomHandler;
    } });
    function parseDocument(data2, options2) {
      var handler = new domhandler_1.DomHandler(void 0, options2);
      new Parser_js_1.Parser(handler, options2).end(data2);
      return handler.root;
    }
    exports.parseDocument = parseDocument;
    function parseDOM(data2, options2) {
      return parseDocument(data2, options2).children;
    }
    exports.parseDOM = parseDOM;
    function createDomStream(cb, options2, elementCb) {
      var handler = new domhandler_1.DomHandler(cb, options2, elementCb);
      return new Parser_js_1.Parser(handler, options2);
    }
    exports.createDomStream = createDomStream;
    var Tokenizer_js_1 = require_Tokenizer();
    Object.defineProperty(exports, "Tokenizer", { enumerable: true, get: function() {
      return __importDefault(Tokenizer_js_1).default;
    } });
    var ElementType = __importStar(require_lib2());
    exports.ElementType = ElementType;
    var domutils_1 = require_lib6();
    Object.defineProperty(exports, "getFeed", { enumerable: true, get: function() {
      return domutils_1.getFeed;
    } });
    function parseFeed(feed, options2) {
      if (options2 === void 0) {
        options2 = { xmlMode: true };
      }
      return (0, domutils_1.getFeed)(parseDOM(feed, options2));
    }
    exports.parseFeed = parseFeed;
    exports.DomUtils = __importStar(require_lib6());
  }
});

// ../../node_modules/sanitize-html/node_modules/escape-string-regexp/index.js
var require_escape_string_regexp = __commonJS({
  "../../node_modules/sanitize-html/node_modules/escape-string-regexp/index.js"(exports, module) {
    "use strict";
    module.exports = (string) => {
      if (typeof string !== "string") {
        throw new TypeError("Expected a string");
      }
      return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
    };
  }
});

// ../../node_modules/sanitize-html/node_modules/is-plain-object/dist/is-plain-object.js
var require_is_plain_object = __commonJS({
  "../../node_modules/sanitize-html/node_modules/is-plain-object/dist/is-plain-object.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function isObject2(o) {
      return Object.prototype.toString.call(o) === "[object Object]";
    }
    function isPlainObject(o) {
      var ctor, prot;
      if (isObject2(o) === false)
        return false;
      ctor = o.constructor;
      if (ctor === void 0)
        return true;
      prot = ctor.prototype;
      if (isObject2(prot) === false)
        return false;
      if (prot.hasOwnProperty("isPrototypeOf") === false) {
        return false;
      }
      return true;
    }
    exports.isPlainObject = isPlainObject;
  }
});

// ../../node_modules/deepmerge/dist/cjs.js
var require_cjs = __commonJS({
  "../../node_modules/deepmerge/dist/cjs.js"(exports, module) {
    "use strict";
    var isMergeableObject = function isMergeableObject2(value) {
      return isNonNullObject(value) && !isSpecial(value);
    };
    function isNonNullObject(value) {
      return !!value && typeof value === "object";
    }
    function isSpecial(value) {
      var stringValue = Object.prototype.toString.call(value);
      return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
    }
    var canUseSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
    function isReactElement(value) {
      return value.$$typeof === REACT_ELEMENT_TYPE;
    }
    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }
    function cloneUnlessOtherwiseSpecified(value, options2) {
      return options2.clone !== false && options2.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options2) : value;
    }
    function defaultArrayMerge(target, source, options2) {
      return target.concat(source).map(function(element) {
        return cloneUnlessOtherwiseSpecified(element, options2);
      });
    }
    function getMergeFunction(key, options2) {
      if (!options2.customMerge) {
        return deepmerge;
      }
      var customMerge = options2.customMerge(key);
      return typeof customMerge === "function" ? customMerge : deepmerge;
    }
    function getEnumerableOwnPropertySymbols(target) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return target.propertyIsEnumerable(symbol);
      }) : [];
    }
    function getKeys(target) {
      return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
    }
    function propertyIsOnObject(object, property) {
      try {
        return property in object;
      } catch (_) {
        return false;
      }
    }
    function propertyIsUnsafe(target, key) {
      return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
    }
    function mergeObject(target, source, options2) {
      var destination = {};
      if (options2.isMergeableObject(target)) {
        getKeys(target).forEach(function(key) {
          destination[key] = cloneUnlessOtherwiseSpecified(target[key], options2);
        });
      }
      getKeys(source).forEach(function(key) {
        if (propertyIsUnsafe(target, key)) {
          return;
        }
        if (propertyIsOnObject(target, key) && options2.isMergeableObject(source[key])) {
          destination[key] = getMergeFunction(key, options2)(target[key], source[key], options2);
        } else {
          destination[key] = cloneUnlessOtherwiseSpecified(source[key], options2);
        }
      });
      return destination;
    }
    function deepmerge(target, source, options2) {
      options2 = options2 || {};
      options2.arrayMerge = options2.arrayMerge || defaultArrayMerge;
      options2.isMergeableObject = options2.isMergeableObject || isMergeableObject;
      options2.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
      var sourceIsArray = Array.isArray(source);
      var targetIsArray = Array.isArray(target);
      var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
      if (!sourceAndTargetTypesMatch) {
        return cloneUnlessOtherwiseSpecified(source, options2);
      } else if (sourceIsArray) {
        return options2.arrayMerge(target, source, options2);
      } else {
        return mergeObject(target, source, options2);
      }
    }
    deepmerge.all = function deepmergeAll(array, options2) {
      if (!Array.isArray(array)) {
        throw new Error("first argument should be an array");
      }
      return array.reduce(function(prev, next) {
        return deepmerge(prev, next, options2);
      }, {});
    };
    var deepmerge_1 = deepmerge;
    module.exports = deepmerge_1;
  }
});

// ../../node_modules/parse-srcset/src/parse-srcset.js
var require_parse_srcset = __commonJS({
  "../../node_modules/parse-srcset/src/parse-srcset.js"(exports, module) {
    (function(root2, factory) {
      if (typeof define === "function" && define.amd) {
        define([], factory);
      } else if (typeof module === "object" && module.exports) {
        module.exports = factory();
      } else {
        root2.parseSrcset = factory();
      }
    })(exports, function() {
      return function(input) {
        function isSpace(c2) {
          return c2 === " " || // space
          c2 === "	" || // horizontal tab
          c2 === "\n" || // new line
          c2 === "\f" || // form feed
          c2 === "\r";
        }
        function collectCharacters(regEx) {
          var chars, match2 = regEx.exec(input.substring(pos));
          if (match2) {
            chars = match2[0];
            pos += chars.length;
            return chars;
          }
        }
        var inputLength = input.length, regexLeadingSpaces = /^[ \t\n\r\u000c]+/, regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/, regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/, regexTrailingCommas = /[,]+$/, regexNonNegativeInteger = /^\d+$/, regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, url, descriptors2, currentDescriptor, state, c, pos = 0, candidates = [];
        while (true) {
          collectCharacters(regexLeadingCommasOrSpaces);
          if (pos >= inputLength) {
            return candidates;
          }
          url = collectCharacters(regexLeadingNotSpaces);
          descriptors2 = [];
          if (url.slice(-1) === ",") {
            url = url.replace(regexTrailingCommas, "");
            parseDescriptors();
          } else {
            tokenize();
          }
        }
        function tokenize() {
          collectCharacters(regexLeadingSpaces);
          currentDescriptor = "";
          state = "in descriptor";
          while (true) {
            c = input.charAt(pos);
            if (state === "in descriptor") {
              if (isSpace(c)) {
                if (currentDescriptor) {
                  descriptors2.push(currentDescriptor);
                  currentDescriptor = "";
                  state = "after descriptor";
                }
              } else if (c === ",") {
                pos += 1;
                if (currentDescriptor) {
                  descriptors2.push(currentDescriptor);
                }
                parseDescriptors();
                return;
              } else if (c === "(") {
                currentDescriptor = currentDescriptor + c;
                state = "in parens";
              } else if (c === "") {
                if (currentDescriptor) {
                  descriptors2.push(currentDescriptor);
                }
                parseDescriptors();
                return;
              } else {
                currentDescriptor = currentDescriptor + c;
              }
            } else if (state === "in parens") {
              if (c === ")") {
                currentDescriptor = currentDescriptor + c;
                state = "in descriptor";
              } else if (c === "") {
                descriptors2.push(currentDescriptor);
                parseDescriptors();
                return;
              } else {
                currentDescriptor = currentDescriptor + c;
              }
            } else if (state === "after descriptor") {
              if (isSpace(c)) {
              } else if (c === "") {
                parseDescriptors();
                return;
              } else {
                state = "in descriptor";
                pos -= 1;
              }
            }
            pos += 1;
          }
        }
        function parseDescriptors() {
          var pError = false, w, d, h, i, candidate = {}, desc, lastChar, value, intVal, floatVal;
          for (i = 0; i < descriptors2.length; i++) {
            desc = descriptors2[i];
            lastChar = desc[desc.length - 1];
            value = desc.substring(0, desc.length - 1);
            intVal = parseInt(value, 10);
            floatVal = parseFloat(value);
            if (regexNonNegativeInteger.test(value) && lastChar === "w") {
              if (w || d) {
                pError = true;
              }
              if (intVal === 0) {
                pError = true;
              } else {
                w = intVal;
              }
            } else if (regexFloatingPoint.test(value) && lastChar === "x") {
              if (w || d || h) {
                pError = true;
              }
              if (floatVal < 0) {
                pError = true;
              } else {
                d = floatVal;
              }
            } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
              if (h || d) {
                pError = true;
              }
              if (intVal === 0) {
                pError = true;
              } else {
                h = intVal;
              }
            } else {
              pError = true;
            }
          }
          if (!pError) {
            candidate.url = url;
            if (w) {
              candidate.w = w;
            }
            if (d) {
              candidate.d = d;
            }
            if (h) {
              candidate.h = h;
            }
            candidates.push(candidate);
          } else if (console && console.log) {
            console.log("Invalid srcset descriptor found in '" + input + "' at '" + desc + "'.");
          }
        }
      };
    });
  }
});

// ../../node_modules/picocolors/picocolors.browser.js
var require_picocolors_browser = __commonJS({
  "../../node_modules/picocolors/picocolors.browser.js"(exports, module) {
    var x = String;
    var create2 = function() {
      return { isColorSupported: false, reset: x, bold: x, dim: x, italic: x, underline: x, inverse: x, hidden: x, strikethrough: x, black: x, red: x, green: x, yellow: x, blue: x, magenta: x, cyan: x, white: x, gray: x, bgBlack: x, bgRed: x, bgGreen: x, bgYellow: x, bgBlue: x, bgMagenta: x, bgCyan: x, bgWhite: x };
    };
    module.exports = create2();
    module.exports.createColors = create2;
  }
});

// (disabled):../../node_modules/sanitize-html/node_modules/postcss/lib/terminal-highlight
var require_terminal_highlight = __commonJS({
  "(disabled):../../node_modules/sanitize-html/node_modules/postcss/lib/terminal-highlight"() {
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/css-syntax-error.js
var require_css_syntax_error = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/css-syntax-error.js"(exports, module) {
    "use strict";
    var pico = require_picocolors_browser();
    var terminalHighlight = require_terminal_highlight();
    var CssSyntaxError = class extends Error {
      constructor(message, line, column, source, file, plugin) {
        super(message);
        this.name = "CssSyntaxError";
        this.reason = message;
        if (file) {
          this.file = file;
        }
        if (source) {
          this.source = source;
        }
        if (plugin) {
          this.plugin = plugin;
        }
        if (typeof line !== "undefined" && typeof column !== "undefined") {
          if (typeof line === "number") {
            this.line = line;
            this.column = column;
          } else {
            this.line = line.line;
            this.column = line.column;
            this.endLine = column.line;
            this.endColumn = column.column;
          }
        }
        this.setMessage();
        if (Error.captureStackTrace) {
          Error.captureStackTrace(this, CssSyntaxError);
        }
      }
      setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") {
          this.message += ":" + this.line + ":" + this.column;
        }
        this.message += ": " + this.reason;
      }
      showSourceCode(color) {
        if (!this.source)
          return "";
        let css = this.source;
        if (color == null)
          color = pico.isColorSupported;
        if (terminalHighlight) {
          if (color)
            css = terminalHighlight(css);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        let mark, aside;
        if (color) {
          let { bold, red, gray } = pico.createColors(true);
          mark = (text) => bold(red(text));
          aside = (text) => gray(text);
        } else {
          mark = aside = (str) => str;
        }
        return lines.slice(start, end).map((line, index) => {
          let number = start + 1 + index;
          let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
          if (number === this.line) {
            let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
            return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
          }
          return " " + aside(gutter) + line;
        }).join("\n");
      }
      toString() {
        let code = this.showSourceCode();
        if (code) {
          code = "\n\n" + code + "\n";
        }
        return this.name + ": " + this.message + code;
      }
    };
    module.exports = CssSyntaxError;
    CssSyntaxError.default = CssSyntaxError;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/symbols.js
var require_symbols = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/symbols.js"(exports, module) {
    "use strict";
    module.exports.isClean = Symbol("isClean");
    module.exports.my = Symbol("my");
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/stringifier.js
var require_stringifier = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/stringifier.js"(exports, module) {
    "use strict";
    var DEFAULT_RAW = {
      colon: ": ",
      indent: "    ",
      beforeDecl: "\n",
      beforeRule: "\n",
      beforeOpen: " ",
      beforeClose: "\n",
      beforeComment: "\n",
      after: "\n",
      emptyBody: "",
      commentLeft: " ",
      commentRight: " ",
      semicolon: false
    };
    function capitalize5(str) {
      return str[0].toUpperCase() + str.slice(1);
    }
    var Stringifier = class {
      constructor(builder) {
        this.builder = builder;
      }
      stringify(node, semicolon) {
        if (!this[node.type]) {
          throw new Error(
            "Unknown AST node type " + node.type + ". Maybe you need to change PostCSS stringifier."
          );
        }
        this[node.type](node, semicolon);
      }
      document(node) {
        this.body(node);
      }
      root(node) {
        this.body(node);
        if (node.raws.after)
          this.builder(node.raws.after);
      }
      comment(node) {
        let left = this.raw(node, "left", "commentLeft");
        let right = this.raw(node, "right", "commentRight");
        this.builder("/*" + left + node.text + right + "*/", node);
      }
      decl(node, semicolon) {
        let between = this.raw(node, "between", "colon");
        let string = node.prop + between + this.rawValue(node, "value");
        if (node.important) {
          string += node.raws.important || " !important";
        }
        if (semicolon)
          string += ";";
        this.builder(string, node);
      }
      rule(node) {
        this.block(node, this.rawValue(node, "selector"));
        if (node.raws.ownSemicolon) {
          this.builder(node.raws.ownSemicolon, node, "end");
        }
      }
      atrule(node, semicolon) {
        let name = "@" + node.name;
        let params = node.params ? this.rawValue(node, "params") : "";
        if (typeof node.raws.afterName !== "undefined") {
          name += node.raws.afterName;
        } else if (params) {
          name += " ";
        }
        if (node.nodes) {
          this.block(node, name + params);
        } else {
          let end = (node.raws.between || "") + (semicolon ? ";" : "");
          this.builder(name + params + end, node);
        }
      }
      body(node) {
        let last = node.nodes.length - 1;
        while (last > 0) {
          if (node.nodes[last].type !== "comment")
            break;
          last -= 1;
        }
        let semicolon = this.raw(node, "semicolon");
        for (let i = 0; i < node.nodes.length; i++) {
          let child = node.nodes[i];
          let before = this.raw(child, "before");
          if (before)
            this.builder(before);
          this.stringify(child, last !== i || semicolon);
        }
      }
      block(node, start) {
        let between = this.raw(node, "between", "beforeOpen");
        this.builder(start + between + "{", node, "start");
        let after;
        if (node.nodes && node.nodes.length) {
          this.body(node);
          after = this.raw(node, "after");
        } else {
          after = this.raw(node, "after", "emptyBody");
        }
        if (after)
          this.builder(after);
        this.builder("}", node, "end");
      }
      raw(node, own, detect) {
        let value;
        if (!detect)
          detect = own;
        if (own) {
          value = node.raws[own];
          if (typeof value !== "undefined")
            return value;
        }
        let parent = node.parent;
        if (detect === "before") {
          if (!parent || parent.type === "root" && parent.first === node) {
            return "";
          }
          if (parent && parent.type === "document") {
            return "";
          }
        }
        if (!parent)
          return DEFAULT_RAW[detect];
        let root2 = node.root();
        if (!root2.rawCache)
          root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") {
          return root2.rawCache[detect];
        }
        if (detect === "before" || detect === "after") {
          return this.beforeAfter(node, detect);
        } else {
          let method = "raw" + capitalize5(detect);
          if (this[method]) {
            value = this[method](root2, node);
          } else {
            root2.walk((i) => {
              value = i.raws[own];
              if (typeof value !== "undefined")
                return false;
            });
          }
        }
        if (typeof value === "undefined")
          value = DEFAULT_RAW[detect];
        root2.rawCache[detect] = value;
        return value;
      }
      rawSemicolon(root2) {
        let value;
        root2.walk((i) => {
          if (i.nodes && i.nodes.length && i.last.type === "decl") {
            value = i.raws.semicolon;
            if (typeof value !== "undefined")
              return false;
          }
        });
        return value;
      }
      rawEmptyBody(root2) {
        let value;
        root2.walk((i) => {
          if (i.nodes && i.nodes.length === 0) {
            value = i.raws.after;
            if (typeof value !== "undefined")
              return false;
          }
        });
        return value;
      }
      rawIndent(root2) {
        if (root2.raws.indent)
          return root2.raws.indent;
        let value;
        root2.walk((i) => {
          let p = i.parent;
          if (p && p !== root2 && p.parent && p.parent === root2) {
            if (typeof i.raws.before !== "undefined") {
              let parts = i.raws.before.split("\n");
              value = parts[parts.length - 1];
              value = value.replace(/\S/g, "");
              return false;
            }
          }
        });
        return value;
      }
      rawBeforeComment(root2, node) {
        let value;
        root2.walkComments((i) => {
          if (typeof i.raws.before !== "undefined") {
            value = i.raws.before;
            if (value.includes("\n")) {
              value = value.replace(/[^\n]+$/, "");
            }
            return false;
          }
        });
        if (typeof value === "undefined") {
          value = this.raw(node, null, "beforeDecl");
        } else if (value) {
          value = value.replace(/\S/g, "");
        }
        return value;
      }
      rawBeforeDecl(root2, node) {
        let value;
        root2.walkDecls((i) => {
          if (typeof i.raws.before !== "undefined") {
            value = i.raws.before;
            if (value.includes("\n")) {
              value = value.replace(/[^\n]+$/, "");
            }
            return false;
          }
        });
        if (typeof value === "undefined") {
          value = this.raw(node, null, "beforeRule");
        } else if (value) {
          value = value.replace(/\S/g, "");
        }
        return value;
      }
      rawBeforeRule(root2) {
        let value;
        root2.walk((i) => {
          if (i.nodes && (i.parent !== root2 || root2.first !== i)) {
            if (typeof i.raws.before !== "undefined") {
              value = i.raws.before;
              if (value.includes("\n")) {
                value = value.replace(/[^\n]+$/, "");
              }
              return false;
            }
          }
        });
        if (value)
          value = value.replace(/\S/g, "");
        return value;
      }
      rawBeforeClose(root2) {
        let value;
        root2.walk((i) => {
          if (i.nodes && i.nodes.length > 0) {
            if (typeof i.raws.after !== "undefined") {
              value = i.raws.after;
              if (value.includes("\n")) {
                value = value.replace(/[^\n]+$/, "");
              }
              return false;
            }
          }
        });
        if (value)
          value = value.replace(/\S/g, "");
        return value;
      }
      rawBeforeOpen(root2) {
        let value;
        root2.walk((i) => {
          if (i.type !== "decl") {
            value = i.raws.between;
            if (typeof value !== "undefined")
              return false;
          }
        });
        return value;
      }
      rawColon(root2) {
        let value;
        root2.walkDecls((i) => {
          if (typeof i.raws.between !== "undefined") {
            value = i.raws.between.replace(/[^\s:]/g, "");
            return false;
          }
        });
        return value;
      }
      beforeAfter(node, detect) {
        let value;
        if (node.type === "decl") {
          value = this.raw(node, null, "beforeDecl");
        } else if (node.type === "comment") {
          value = this.raw(node, null, "beforeComment");
        } else if (detect === "before") {
          value = this.raw(node, null, "beforeRule");
        } else {
          value = this.raw(node, null, "beforeClose");
        }
        let buf = node.parent;
        let depth = 0;
        while (buf && buf.type !== "root") {
          depth += 1;
          buf = buf.parent;
        }
        if (value.includes("\n")) {
          let indent = this.raw(node, null, "indent");
          if (indent.length) {
            for (let step = 0; step < depth; step++)
              value += indent;
          }
        }
        return value;
      }
      rawValue(node, prop) {
        let value = node[prop];
        let raw = node.raws[prop];
        if (raw && raw.value === value) {
          return raw.raw;
        }
        return value;
      }
    };
    module.exports = Stringifier;
    Stringifier.default = Stringifier;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/stringify.js
var require_stringify3 = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/stringify.js"(exports, module) {
    "use strict";
    var Stringifier = require_stringifier();
    function stringify(node, builder) {
      let str = new Stringifier(builder);
      str.stringify(node);
    }
    module.exports = stringify;
    stringify.default = stringify;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/node.js
var require_node2 = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/node.js"(exports, module) {
    "use strict";
    var { isClean, my } = require_symbols();
    var CssSyntaxError = require_css_syntax_error();
    var Stringifier = require_stringifier();
    var stringify = require_stringify3();
    function cloneNode(obj, parent) {
      let cloned = new obj.constructor();
      for (let i in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, i)) {
          continue;
        }
        if (i === "proxyCache")
          continue;
        let value = obj[i];
        let type = typeof value;
        if (i === "parent" && type === "object") {
          if (parent)
            cloned[i] = parent;
        } else if (i === "source") {
          cloned[i] = value;
        } else if (Array.isArray(value)) {
          cloned[i] = value.map((j) => cloneNode(j, cloned));
        } else {
          if (type === "object" && value !== null)
            value = cloneNode(value);
          cloned[i] = value;
        }
      }
      return cloned;
    }
    var Node = class {
      constructor(defaults = {}) {
        this.raws = {};
        this[isClean] = false;
        this[my] = true;
        for (let name in defaults) {
          if (name === "nodes") {
            this.nodes = [];
            for (let node of defaults[name]) {
              if (typeof node.clone === "function") {
                this.append(node.clone());
              } else {
                this.append(node);
              }
            }
          } else {
            this[name] = defaults[name];
          }
        }
      }
      error(message, opts = {}) {
        if (this.source) {
          let { start, end } = this.rangeBy(opts);
          return this.source.input.error(
            message,
            { line: start.line, column: start.column },
            { line: end.line, column: end.column },
            opts
          );
        }
        return new CssSyntaxError(message);
      }
      warn(result, text, opts) {
        let data2 = { node: this };
        for (let i in opts)
          data2[i] = opts[i];
        return result.warn(text, data2);
      }
      remove() {
        if (this.parent) {
          this.parent.removeChild(this);
        }
        this.parent = void 0;
        return this;
      }
      toString(stringifier = stringify) {
        if (stringifier.stringify)
          stringifier = stringifier.stringify;
        let result = "";
        stringifier(this, (i) => {
          result += i;
        });
        return result;
      }
      assign(overrides = {}) {
        for (let name in overrides) {
          this[name] = overrides[name];
        }
        return this;
      }
      clone(overrides = {}) {
        let cloned = cloneNode(this);
        for (let name in overrides) {
          cloned[name] = overrides[name];
        }
        return cloned;
      }
      cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
      }
      cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
      }
      replaceWith(...nodes) {
        if (this.parent) {
          let bookmark = this;
          let foundSelf = false;
          for (let node of nodes) {
            if (node === this) {
              foundSelf = true;
            } else if (foundSelf) {
              this.parent.insertAfter(bookmark, node);
              bookmark = node;
            } else {
              this.parent.insertBefore(bookmark, node);
            }
          }
          if (!foundSelf) {
            this.remove();
          }
        }
        return this;
      }
      next() {
        if (!this.parent)
          return void 0;
        let index = this.parent.index(this);
        return this.parent.nodes[index + 1];
      }
      prev() {
        if (!this.parent)
          return void 0;
        let index = this.parent.index(this);
        return this.parent.nodes[index - 1];
      }
      before(add) {
        this.parent.insertBefore(this, add);
        return this;
      }
      after(add) {
        this.parent.insertAfter(this, add);
        return this;
      }
      root() {
        let result = this;
        while (result.parent && result.parent.type !== "document") {
          result = result.parent;
        }
        return result;
      }
      raw(prop, defaultType) {
        let str = new Stringifier();
        return str.raw(this, prop, defaultType);
      }
      cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween)
          delete this.raws.between;
      }
      toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        let inputsNextIndex = 0;
        for (let name in this) {
          if (!Object.prototype.hasOwnProperty.call(this, name)) {
            continue;
          }
          if (name === "parent" || name === "proxyCache")
            continue;
          let value = this[name];
          if (Array.isArray(value)) {
            fixed[name] = value.map((i) => {
              if (typeof i === "object" && i.toJSON) {
                return i.toJSON(null, inputs);
              } else {
                return i;
              }
            });
          } else if (typeof value === "object" && value.toJSON) {
            fixed[name] = value.toJSON(null, inputs);
          } else if (name === "source") {
            let inputId = inputs.get(value.input);
            if (inputId == null) {
              inputId = inputsNextIndex;
              inputs.set(value.input, inputsNextIndex);
              inputsNextIndex++;
            }
            fixed[name] = {
              inputId,
              start: value.start,
              end: value.end
            };
          } else {
            fixed[name] = value;
          }
        }
        if (emitInputs) {
          fixed.inputs = [...inputs.keys()].map((input) => input.toJSON());
        }
        return fixed;
      }
      positionInside(index) {
        let string = this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for (let i = 0; i < index; i++) {
          if (string[i] === "\n") {
            column = 1;
            line += 1;
          } else {
            column += 1;
          }
        }
        return { line, column };
      }
      positionBy(opts) {
        let pos = this.source.start;
        if (opts.index) {
          pos = this.positionInside(opts.index);
        } else if (opts.word) {
          let index = this.toString().indexOf(opts.word);
          if (index !== -1)
            pos = this.positionInside(index);
        }
        return pos;
      }
      rangeBy(opts) {
        let start = {
          line: this.source.start.line,
          column: this.source.start.column
        };
        let end = this.source.end ? {
          line: this.source.end.line,
          column: this.source.end.column + 1
        } : {
          line: start.line,
          column: start.column + 1
        };
        if (opts.word) {
          let index = this.toString().indexOf(opts.word);
          if (index !== -1) {
            start = this.positionInside(index);
            end = this.positionInside(index + opts.word.length);
          }
        } else {
          if (opts.start) {
            start = {
              line: opts.start.line,
              column: opts.start.column
            };
          } else if (opts.index) {
            start = this.positionInside(opts.index);
          }
          if (opts.end) {
            end = {
              line: opts.end.line,
              column: opts.end.column
            };
          } else if (opts.endIndex) {
            end = this.positionInside(opts.endIndex);
          } else if (opts.index) {
            end = this.positionInside(opts.index + 1);
          }
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) {
          end = { line: start.line, column: start.column + 1 };
        }
        return { start, end };
      }
      getProxyProcessor() {
        return {
          set(node, prop, value) {
            if (node[prop] === value)
              return true;
            node[prop] = value;
            if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */
            prop === "text") {
              node.markDirty();
            }
            return true;
          },
          get(node, prop) {
            if (prop === "proxyOf") {
              return node;
            } else if (prop === "root") {
              return () => node.root().toProxy();
            } else {
              return node[prop];
            }
          }
        };
      }
      toProxy() {
        if (!this.proxyCache) {
          this.proxyCache = new Proxy(this, this.getProxyProcessor());
        }
        return this.proxyCache;
      }
      addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
          let s = this.source;
          error.stack = error.stack.replace(
            /\n\s{4}at /,
            `$&${s.input.from}:${s.start.line}:${s.start.column}$&`
          );
        }
        return error;
      }
      markDirty() {
        if (this[isClean]) {
          this[isClean] = false;
          let next = this;
          while (next = next.parent) {
            next[isClean] = false;
          }
        }
      }
      get proxyOf() {
        return this;
      }
    };
    module.exports = Node;
    Node.default = Node;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/declaration.js
var require_declaration = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/declaration.js"(exports, module) {
    "use strict";
    var Node = require_node2();
    var Declaration = class extends Node {
      constructor(defaults) {
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") {
          defaults = { ...defaults, value: String(defaults.value) };
        }
        super(defaults);
        this.type = "decl";
      }
      get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
      }
    };
    module.exports = Declaration;
    Declaration.default = Declaration;
  }
});

// (disabled):../../node_modules/source-map-js/source-map.js
var require_source_map = __commonJS({
  "(disabled):../../node_modules/source-map-js/source-map.js"() {
  }
});

// (disabled):../../node_modules/path/path.js
var require_path = __commonJS({
  "(disabled):../../node_modules/path/path.js"() {
  }
});

// (disabled):url
var require_url = __commonJS({
  "(disabled):url"() {
  }
});

// ../../node_modules/sanitize-html/node_modules/nanoid/non-secure/index.cjs
var require_non_secure = __commonJS({
  "../../node_modules/sanitize-html/node_modules/nanoid/non-secure/index.cjs"(exports, module) {
    var urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
    var customAlphabet = (alphabet, defaultSize = 21) => {
      return (size6 = defaultSize) => {
        let id2 = "";
        let i = size6;
        while (i--) {
          id2 += alphabet[Math.random() * alphabet.length | 0];
        }
        return id2;
      };
    };
    var nanoid = (size6 = 21) => {
      let id2 = "";
      let i = size6;
      while (i--) {
        id2 += urlAlphabet[Math.random() * 64 | 0];
      }
      return id2;
    };
    module.exports = { nanoid, customAlphabet };
  }
});

// (disabled):fs
var require_fs = __commonJS({
  "(disabled):fs"() {
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/previous-map.js
var require_previous_map = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/previous-map.js"(exports, module) {
    "use strict";
    var { SourceMapConsumer, SourceMapGenerator } = require_source_map();
    var { existsSync, readFileSync } = require_fs();
    var { dirname, join: join3 } = require_path();
    function fromBase64(str) {
      if (Buffer) {
        return Buffer.from(str, "base64").toString();
      } else {
        return window.atob(str);
      }
    }
    var PreviousMap = class {
      constructor(css, opts) {
        if (opts.map === false)
          return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        let prev = opts.map ? opts.map.prev : void 0;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) {
          this.mapFile = opts.from;
        }
        if (this.mapFile)
          this.root = dirname(this.mapFile);
        if (text)
          this.text = text;
      }
      consumer() {
        if (!this.consumerCache) {
          this.consumerCache = new SourceMapConsumer(this.text);
        }
        return this.consumerCache;
      }
      withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
      }
      startWith(string, start) {
        if (!string)
          return false;
        return string.substr(0, start.length) === start;
      }
      getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
      }
      loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments)
          return;
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf("*/", start);
        if (start > -1 && end > -1) {
          this.annotation = this.getAnnotationURL(css.substring(start, end));
        }
      }
      decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) {
          return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        }
        if (baseCharsetUri.test(text) || baseUri.test(text)) {
          return fromBase64(text.substr(RegExp.lastMatch.length));
        }
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
      }
      loadFile(path2) {
        this.root = dirname(path2);
        if (existsSync(path2)) {
          this.mapFile = path2;
          return readFileSync(path2, "utf-8").toString().trim();
        }
      }
      loadMap(file, prev) {
        if (prev === false)
          return false;
        if (prev) {
          if (typeof prev === "string") {
            return prev;
          } else if (typeof prev === "function") {
            let prevPath = prev(file);
            if (prevPath) {
              let map36 = this.loadFile(prevPath);
              if (!map36) {
                throw new Error(
                  "Unable to load previous source map: " + prevPath.toString()
                );
              }
              return map36;
            }
          } else if (prev instanceof SourceMapConsumer) {
            return SourceMapGenerator.fromSourceMap(prev).toString();
          } else if (prev instanceof SourceMapGenerator) {
            return prev.toString();
          } else if (this.isMap(prev)) {
            return JSON.stringify(prev);
          } else {
            throw new Error(
              "Unsupported previous source map format: " + prev.toString()
            );
          }
        } else if (this.inline) {
          return this.decodeInline(this.annotation);
        } else if (this.annotation) {
          let map36 = this.annotation;
          if (file)
            map36 = join3(dirname(file), map36);
          return this.loadFile(map36);
        }
      }
      isMap(map36) {
        if (typeof map36 !== "object")
          return false;
        return typeof map36.mappings === "string" || typeof map36._mappings === "string" || Array.isArray(map36.sections);
      }
    };
    module.exports = PreviousMap;
    PreviousMap.default = PreviousMap;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/input.js
var require_input = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/input.js"(exports, module) {
    "use strict";
    var { SourceMapConsumer, SourceMapGenerator } = require_source_map();
    var { fileURLToPath, pathToFileURL } = require_url();
    var { resolve, isAbsolute } = require_path();
    var { nanoid } = require_non_secure();
    var terminalHighlight = require_terminal_highlight();
    var CssSyntaxError = require_css_syntax_error();
    var PreviousMap = require_previous_map();
    var fromOffsetCache = Symbol("fromOffsetCache");
    var sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
    var pathAvailable = Boolean(resolve && isAbsolute);
    var Input = class {
      constructor(css, opts = {}) {
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) {
          throw new Error(`PostCSS received ${css} instead of CSS string`);
        }
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
          this.hasBOM = true;
          this.css = this.css.slice(1);
        } else {
          this.hasBOM = false;
        }
        if (opts.from) {
          if (!pathAvailable || /^\w+:\/\//.test(opts.from) || isAbsolute(opts.from)) {
            this.file = opts.from;
          } else {
            this.file = resolve(opts.from);
          }
        }
        if (pathAvailable && sourceMapAvailable) {
          let map36 = new PreviousMap(this.css, opts);
          if (map36.text) {
            this.map = map36;
            let file = map36.consumer().file;
            if (!this.file && file)
              this.file = this.mapResolve(file);
          }
        }
        if (!this.file) {
          this.id = "<input css " + nanoid(6) + ">";
        }
        if (this.map)
          this.map.file = this.from;
      }
      fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[fromOffsetCache]) {
          let lines = this.css.split("\n");
          lineToIndex = new Array(lines.length);
          let prevIndex = 0;
          for (let i = 0, l = lines.length; i < l; i++) {
            lineToIndex[i] = prevIndex;
            prevIndex += lines[i].length + 1;
          }
          this[fromOffsetCache] = lineToIndex;
        } else {
          lineToIndex = this[fromOffsetCache];
        }
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min2 = 0;
        if (offset >= lastLine) {
          min2 = lineToIndex.length - 1;
        } else {
          let max2 = lineToIndex.length - 2;
          let mid;
          while (min2 < max2) {
            mid = min2 + (max2 - min2 >> 1);
            if (offset < lineToIndex[mid]) {
              max2 = mid - 1;
            } else if (offset >= lineToIndex[mid + 1]) {
              min2 = mid + 1;
            } else {
              min2 = mid;
              break;
            }
          }
        }
        return {
          line: min2 + 1,
          col: offset - lineToIndex[min2] + 1
        };
      }
      error(message, line, column, opts = {}) {
        let result, endLine, endColumn;
        if (line && typeof line === "object") {
          let start = line;
          let end = column;
          if (typeof line.offset === "number") {
            let pos = this.fromOffset(start.offset);
            line = pos.line;
            column = pos.col;
          } else {
            line = start.line;
            column = start.column;
          }
          if (typeof end.offset === "number") {
            let pos = this.fromOffset(end.offset);
            endLine = pos.line;
            endColumn = pos.col;
          } else {
            endLine = end.line;
            endColumn = end.column;
          }
        } else if (!column) {
          let pos = this.fromOffset(line);
          line = pos.line;
          column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) {
          result = new CssSyntaxError(
            message,
            origin.endLine === void 0 ? origin.line : { line: origin.line, column: origin.column },
            origin.endLine === void 0 ? origin.column : { line: origin.endLine, column: origin.endColumn },
            origin.source,
            origin.file,
            opts.plugin
          );
        } else {
          result = new CssSyntaxError(
            message,
            endLine === void 0 ? line : { line, column },
            endLine === void 0 ? column : { line: endLine, column: endColumn },
            this.css,
            this.file,
            opts.plugin
          );
        }
        result.input = { line, column, endLine, endColumn, source: this.css };
        if (this.file) {
          if (pathToFileURL) {
            result.input.url = pathToFileURL(this.file).toString();
          }
          result.input.file = this.file;
        }
        return result;
      }
      origin(line, column, endLine, endColumn) {
        if (!this.map)
          return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({ line, column });
        if (!from.source)
          return false;
        let to;
        if (typeof endLine === "number") {
          to = consumer.originalPositionFor({ line: endLine, column: endColumn });
        }
        let fromUrl;
        if (isAbsolute(from.source)) {
          fromUrl = pathToFileURL(from.source);
        } else {
          fromUrl = new URL(
            from.source,
            this.map.consumer().sourceRoot || pathToFileURL(this.map.mapFile)
          );
        }
        let result = {
          url: fromUrl.toString(),
          line: from.line,
          column: from.column,
          endLine: to && to.line,
          endColumn: to && to.column
        };
        if (fromUrl.protocol === "file:") {
          if (fileURLToPath) {
            result.file = fileURLToPath(fromUrl);
          } else {
            throw new Error(`file: protocol is not available in this PostCSS build`);
          }
        }
        let source = consumer.sourceContentFor(from.source);
        if (source)
          result.source = source;
        return result;
      }
      mapResolve(file) {
        if (/^\w+:\/\//.test(file)) {
          return file;
        }
        return resolve(this.map.consumer().sourceRoot || this.map.root || ".", file);
      }
      get from() {
        return this.file || this.id;
      }
      toJSON() {
        let json = {};
        for (let name of ["hasBOM", "css", "file", "id"]) {
          if (this[name] != null) {
            json[name] = this[name];
          }
        }
        if (this.map) {
          json.map = { ...this.map };
          if (json.map.consumerCache) {
            json.map.consumerCache = void 0;
          }
        }
        return json;
      }
    };
    module.exports = Input;
    Input.default = Input;
    if (terminalHighlight && terminalHighlight.registerInput) {
      terminalHighlight.registerInput(Input);
    }
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/map-generator.js
var require_map_generator = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/map-generator.js"(exports, module) {
    "use strict";
    var { SourceMapConsumer, SourceMapGenerator } = require_source_map();
    var { dirname, resolve, relative, sep } = require_path();
    var { pathToFileURL } = require_url();
    var Input = require_input();
    var sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
    var pathAvailable = Boolean(dirname && resolve && relative && sep);
    var MapGenerator = class {
      constructor(stringify, root2, opts, cssString) {
        this.stringify = stringify;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
      }
      isMap() {
        if (typeof this.opts.map !== "undefined") {
          return !!this.opts.map;
        }
        return this.previous().length > 0;
      }
      previous() {
        if (!this.previousMaps) {
          this.previousMaps = [];
          if (this.root) {
            this.root.walk((node) => {
              if (node.source && node.source.input.map) {
                let map36 = node.source.input.map;
                if (!this.previousMaps.includes(map36)) {
                  this.previousMaps.push(map36);
                }
              }
            });
          } else {
            let input = new Input(this.css, this.opts);
            if (input.map)
              this.previousMaps.push(input.map);
          }
        }
        return this.previousMaps;
      }
      isInline() {
        if (typeof this.mapOpts.inline !== "undefined") {
          return this.mapOpts.inline;
        }
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) {
          return false;
        }
        if (this.previous().length) {
          return this.previous().some((i) => i.inline);
        }
        return true;
      }
      isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") {
          return this.mapOpts.sourcesContent;
        }
        if (this.previous().length) {
          return this.previous().some((i) => i.withContent());
        }
        return true;
      }
      clearAnnotation() {
        if (this.mapOpts.annotation === false)
          return;
        if (this.root) {
          let node;
          for (let i = this.root.nodes.length - 1; i >= 0; i--) {
            node = this.root.nodes[i];
            if (node.type !== "comment")
              continue;
            if (node.text.indexOf("# sourceMappingURL=") === 0) {
              this.root.removeChild(i);
            }
          }
        } else if (this.css) {
          this.css = this.css.replace(/(\n)?\/\*#[\S\s]*?\*\/$/gm, "");
        }
      }
      setSourcesContent() {
        let already = {};
        if (this.root) {
          this.root.walk((node) => {
            if (node.source) {
              let from = node.source.input.from;
              if (from && !already[from]) {
                already[from] = true;
                let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                this.map.setSourceContent(fromUrl, node.source.input.css);
              }
            }
          });
        } else if (this.css) {
          let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
          this.map.setSourceContent(from, this.css);
        }
      }
      applyPrevMaps() {
        for (let prev of this.previous()) {
          let from = this.toUrl(this.path(prev.file));
          let root2 = prev.root || dirname(prev.file);
          let map36;
          if (this.mapOpts.sourcesContent === false) {
            map36 = new SourceMapConsumer(prev.text);
            if (map36.sourcesContent) {
              map36.sourcesContent = map36.sourcesContent.map(() => null);
            }
          } else {
            map36 = prev.consumer();
          }
          this.map.applySourceMap(map36, from, this.toUrl(this.path(root2)));
        }
      }
      isAnnotation() {
        if (this.isInline()) {
          return true;
        }
        if (typeof this.mapOpts.annotation !== "undefined") {
          return this.mapOpts.annotation;
        }
        if (this.previous().length) {
          return this.previous().some((i) => i.annotation);
        }
        return true;
      }
      toBase64(str) {
        if (Buffer) {
          return Buffer.from(str).toString("base64");
        } else {
          return window.btoa(unescape(encodeURIComponent(str)));
        }
      }
      addAnnotation() {
        let content;
        if (this.isInline()) {
          content = "data:application/json;base64," + this.toBase64(this.map.toString());
        } else if (typeof this.mapOpts.annotation === "string") {
          content = this.mapOpts.annotation;
        } else if (typeof this.mapOpts.annotation === "function") {
          content = this.mapOpts.annotation(this.opts.to, this.root);
        } else {
          content = this.outputFile() + ".map";
        }
        let eol = "\n";
        if (this.css.includes("\r\n"))
          eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
      }
      outputFile() {
        if (this.opts.to) {
          return this.path(this.opts.to);
        } else if (this.opts.from) {
          return this.path(this.opts.from);
        } else {
          return "to.css";
        }
      }
      generateMap() {
        if (this.root) {
          this.generateString();
        } else if (this.previous().length === 1) {
          let prev = this.previous()[0].consumer();
          prev.file = this.outputFile();
          this.map = SourceMapGenerator.fromSourceMap(prev);
        } else {
          this.map = new SourceMapGenerator({ file: this.outputFile() });
          this.map.addMapping({
            source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>",
            generated: { line: 1, column: 0 },
            original: { line: 1, column: 0 }
          });
        }
        if (this.isSourcesContent())
          this.setSourcesContent();
        if (this.root && this.previous().length > 0)
          this.applyPrevMaps();
        if (this.isAnnotation())
          this.addAnnotation();
        if (this.isInline()) {
          return [this.css];
        } else {
          return [this.css, this.map];
        }
      }
      path(file) {
        if (file.indexOf("<") === 0)
          return file;
        if (/^\w+:\/\//.test(file))
          return file;
        if (this.mapOpts.absolute)
          return file;
        let from = this.opts.to ? dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") {
          from = dirname(resolve(from, this.mapOpts.annotation));
        }
        file = relative(from, file);
        return file;
      }
      toUrl(path2) {
        if (sep === "\\") {
          path2 = path2.replace(/\\/g, "/");
        }
        return encodeURI(path2).replace(/[#?]/g, encodeURIComponent);
      }
      toFileUrl(path2) {
        if (pathToFileURL) {
          return pathToFileURL(path2).toString();
        } else {
          throw new Error(
            "`map.absolute` option is not available in this PostCSS build"
          );
        }
      }
      sourcePath(node) {
        if (this.mapOpts.from) {
          return this.toUrl(this.mapOpts.from);
        } else if (this.usesFileUrls) {
          return this.toFileUrl(node.source.input.from);
        } else {
          return this.toUrl(this.path(node.source.input.from));
        }
      }
      generateString() {
        this.css = "";
        this.map = new SourceMapGenerator({ file: this.outputFile() });
        let line = 1;
        let column = 1;
        let noSource = "<no source>";
        let mapping = {
          source: "",
          generated: { line: 0, column: 0 },
          original: { line: 0, column: 0 }
        };
        let lines, last;
        this.stringify(this.root, (str, node, type) => {
          this.css += str;
          if (node && type !== "end") {
            mapping.generated.line = line;
            mapping.generated.column = column - 1;
            if (node.source && node.source.start) {
              mapping.source = this.sourcePath(node);
              mapping.original.line = node.source.start.line;
              mapping.original.column = node.source.start.column - 1;
              this.map.addMapping(mapping);
            } else {
              mapping.source = noSource;
              mapping.original.line = 1;
              mapping.original.column = 0;
              this.map.addMapping(mapping);
            }
          }
          lines = str.match(/\n/g);
          if (lines) {
            line += lines.length;
            last = str.lastIndexOf("\n");
            column = str.length - last;
          } else {
            column += str.length;
          }
          if (node && type !== "start") {
            let p = node.parent || { raws: {} };
            if (node.type !== "decl" || node !== p.last || p.raws.semicolon) {
              if (node.source && node.source.end) {
                mapping.source = this.sourcePath(node);
                mapping.original.line = node.source.end.line;
                mapping.original.column = node.source.end.column - 1;
                mapping.generated.line = line;
                mapping.generated.column = column - 2;
                this.map.addMapping(mapping);
              } else {
                mapping.source = noSource;
                mapping.original.line = 1;
                mapping.original.column = 0;
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                this.map.addMapping(mapping);
              }
            }
          }
        });
      }
      generate() {
        this.clearAnnotation();
        if (pathAvailable && sourceMapAvailable && this.isMap()) {
          return this.generateMap();
        } else {
          let result = "";
          this.stringify(this.root, (i) => {
            result += i;
          });
          return [result];
        }
      }
    };
    module.exports = MapGenerator;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/comment.js
var require_comment = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/comment.js"(exports, module) {
    "use strict";
    var Node = require_node2();
    var Comment = class extends Node {
      constructor(defaults) {
        super(defaults);
        this.type = "comment";
      }
    };
    module.exports = Comment;
    Comment.default = Comment;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/container.js
var require_container = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/container.js"(exports, module) {
    "use strict";
    var { isClean, my } = require_symbols();
    var Declaration = require_declaration();
    var Comment = require_comment();
    var Node = require_node2();
    var parse;
    var Rule;
    var AtRule;
    var Root;
    function cleanSource(nodes) {
      return nodes.map((i) => {
        if (i.nodes)
          i.nodes = cleanSource(i.nodes);
        delete i.source;
        return i;
      });
    }
    function markDirtyUp(node) {
      node[isClean] = false;
      if (node.proxyOf.nodes) {
        for (let i of node.proxyOf.nodes) {
          markDirtyUp(i);
        }
      }
    }
    var Container = class extends Node {
      push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
      }
      each(callback) {
        if (!this.proxyOf.nodes)
          return void 0;
        let iterator = this.getIterator();
        let index, result;
        while (this.indexes[iterator] < this.proxyOf.nodes.length) {
          index = this.indexes[iterator];
          result = callback(this.proxyOf.nodes[index], index);
          if (result === false)
            break;
          this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result;
      }
      walk(callback) {
        return this.each((child, i) => {
          let result;
          try {
            result = callback(child, i);
          } catch (e) {
            throw child.addToError(e);
          }
          if (result !== false && child.walk) {
            result = child.walk(callback);
          }
          return result;
        });
      }
      walkDecls(prop, callback) {
        if (!callback) {
          callback = prop;
          return this.walk((child, i) => {
            if (child.type === "decl") {
              return callback(child, i);
            }
          });
        }
        if (prop instanceof RegExp) {
          return this.walk((child, i) => {
            if (child.type === "decl" && prop.test(child.prop)) {
              return callback(child, i);
            }
          });
        }
        return this.walk((child, i) => {
          if (child.type === "decl" && child.prop === prop) {
            return callback(child, i);
          }
        });
      }
      walkRules(selector, callback) {
        if (!callback) {
          callback = selector;
          return this.walk((child, i) => {
            if (child.type === "rule") {
              return callback(child, i);
            }
          });
        }
        if (selector instanceof RegExp) {
          return this.walk((child, i) => {
            if (child.type === "rule" && selector.test(child.selector)) {
              return callback(child, i);
            }
          });
        }
        return this.walk((child, i) => {
          if (child.type === "rule" && child.selector === selector) {
            return callback(child, i);
          }
        });
      }
      walkAtRules(name, callback) {
        if (!callback) {
          callback = name;
          return this.walk((child, i) => {
            if (child.type === "atrule") {
              return callback(child, i);
            }
          });
        }
        if (name instanceof RegExp) {
          return this.walk((child, i) => {
            if (child.type === "atrule" && name.test(child.name)) {
              return callback(child, i);
            }
          });
        }
        return this.walk((child, i) => {
          if (child.type === "atrule" && child.name === name) {
            return callback(child, i);
          }
        });
      }
      walkComments(callback) {
        return this.walk((child, i) => {
          if (child.type === "comment") {
            return callback(child, i);
          }
        });
      }
      append(...children2) {
        for (let child of children2) {
          let nodes = this.normalize(child, this.last);
          for (let node of nodes)
            this.proxyOf.nodes.push(node);
        }
        this.markDirty();
        return this;
      }
      prepend(...children2) {
        children2 = children2.reverse();
        for (let child of children2) {
          let nodes = this.normalize(child, this.first, "prepend").reverse();
          for (let node of nodes)
            this.proxyOf.nodes.unshift(node);
          for (let id2 in this.indexes) {
            this.indexes[id2] = this.indexes[id2] + nodes.length;
          }
        }
        this.markDirty();
        return this;
      }
      cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) {
          for (let node of this.nodes)
            node.cleanRaws(keepBetween);
        }
      }
      insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = exist === 0 ? "prepend" : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)
          this.proxyOf.nodes.splice(existIndex, 0, node);
        let index;
        for (let id2 in this.indexes) {
          index = this.indexes[id2];
          if (existIndex <= index) {
            this.indexes[id2] = index + nodes.length;
          }
        }
        this.markDirty();
        return this;
      }
      insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)
          this.proxyOf.nodes.splice(existIndex + 1, 0, node);
        let index;
        for (let id2 in this.indexes) {
          index = this.indexes[id2];
          if (existIndex < index) {
            this.indexes[id2] = index + nodes.length;
          }
        }
        this.markDirty();
        return this;
      }
      removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        let index;
        for (let id2 in this.indexes) {
          index = this.indexes[id2];
          if (index >= child) {
            this.indexes[id2] = index - 1;
          }
        }
        this.markDirty();
        return this;
      }
      removeAll() {
        for (let node of this.proxyOf.nodes)
          node.parent = void 0;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
      }
      replaceValues(pattern, opts, callback) {
        if (!callback) {
          callback = opts;
          opts = {};
        }
        this.walkDecls((decl) => {
          if (opts.props && !opts.props.includes(decl.prop))
            return;
          if (opts.fast && !decl.value.includes(opts.fast))
            return;
          decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
      }
      every(condition) {
        return this.nodes.every(condition);
      }
      some(condition) {
        return this.nodes.some(condition);
      }
      index(child) {
        if (typeof child === "number")
          return child;
        if (child.proxyOf)
          child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
      }
      get first() {
        if (!this.proxyOf.nodes)
          return void 0;
        return this.proxyOf.nodes[0];
      }
      get last() {
        if (!this.proxyOf.nodes)
          return void 0;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
      }
      normalize(nodes, sample) {
        if (typeof nodes === "string") {
          nodes = cleanSource(parse(nodes).nodes);
        } else if (Array.isArray(nodes)) {
          nodes = nodes.slice(0);
          for (let i of nodes) {
            if (i.parent)
              i.parent.removeChild(i, "ignore");
          }
        } else if (nodes.type === "root" && this.type !== "document") {
          nodes = nodes.nodes.slice(0);
          for (let i of nodes) {
            if (i.parent)
              i.parent.removeChild(i, "ignore");
          }
        } else if (nodes.type) {
          nodes = [nodes];
        } else if (nodes.prop) {
          if (typeof nodes.value === "undefined") {
            throw new Error("Value field is missed in node creation");
          } else if (typeof nodes.value !== "string") {
            nodes.value = String(nodes.value);
          }
          nodes = [new Declaration(nodes)];
        } else if (nodes.selector) {
          nodes = [new Rule(nodes)];
        } else if (nodes.name) {
          nodes = [new AtRule(nodes)];
        } else if (nodes.text) {
          nodes = [new Comment(nodes)];
        } else {
          throw new Error("Unknown node type in node creation");
        }
        let processed = nodes.map((i) => {
          if (!i[my])
            Container.rebuild(i);
          i = i.proxyOf;
          if (i.parent)
            i.parent.removeChild(i);
          if (i[isClean])
            markDirtyUp(i);
          if (typeof i.raws.before === "undefined") {
            if (sample && typeof sample.raws.before !== "undefined") {
              i.raws.before = sample.raws.before.replace(/\S/g, "");
            }
          }
          i.parent = this.proxyOf;
          return i;
        });
        return processed;
      }
      getProxyProcessor() {
        return {
          set(node, prop, value) {
            if (node[prop] === value)
              return true;
            node[prop] = value;
            if (prop === "name" || prop === "params" || prop === "selector") {
              node.markDirty();
            }
            return true;
          },
          get(node, prop) {
            if (prop === "proxyOf") {
              return node;
            } else if (!node[prop]) {
              return node[prop];
            } else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) {
              return (...args) => {
                return node[prop](
                  ...args.map((i) => {
                    if (typeof i === "function") {
                      return (child, index) => i(child.toProxy(), index);
                    } else {
                      return i;
                    }
                  })
                );
              };
            } else if (prop === "every" || prop === "some") {
              return (cb) => {
                return node[prop](
                  (child, ...other) => cb(child.toProxy(), ...other)
                );
              };
            } else if (prop === "root") {
              return () => node.root().toProxy();
            } else if (prop === "nodes") {
              return node.nodes.map((i) => i.toProxy());
            } else if (prop === "first" || prop === "last") {
              return node[prop].toProxy();
            } else {
              return node[prop];
            }
          }
        };
      }
      getIterator() {
        if (!this.lastEach)
          this.lastEach = 0;
        if (!this.indexes)
          this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
      }
    };
    Container.registerParse = (dependant) => {
      parse = dependant;
    };
    Container.registerRule = (dependant) => {
      Rule = dependant;
    };
    Container.registerAtRule = (dependant) => {
      AtRule = dependant;
    };
    Container.registerRoot = (dependant) => {
      Root = dependant;
    };
    module.exports = Container;
    Container.default = Container;
    Container.rebuild = (node) => {
      if (node.type === "atrule") {
        Object.setPrototypeOf(node, AtRule.prototype);
      } else if (node.type === "rule") {
        Object.setPrototypeOf(node, Rule.prototype);
      } else if (node.type === "decl") {
        Object.setPrototypeOf(node, Declaration.prototype);
      } else if (node.type === "comment") {
        Object.setPrototypeOf(node, Comment.prototype);
      } else if (node.type === "root") {
        Object.setPrototypeOf(node, Root.prototype);
      }
      node[my] = true;
      if (node.nodes) {
        node.nodes.forEach((child) => {
          Container.rebuild(child);
        });
      }
    };
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/document.js
var require_document = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/document.js"(exports, module) {
    "use strict";
    var Container = require_container();
    var LazyResult;
    var Processor;
    var Document = class extends Container {
      constructor(defaults) {
        super({ type: "document", ...defaults });
        if (!this.nodes) {
          this.nodes = [];
        }
      }
      toResult(opts = {}) {
        let lazy2 = new LazyResult(new Processor(), this, opts);
        return lazy2.stringify();
      }
    };
    Document.registerLazyResult = (dependant) => {
      LazyResult = dependant;
    };
    Document.registerProcessor = (dependant) => {
      Processor = dependant;
    };
    module.exports = Document;
    Document.default = Document;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/warn-once.js
var require_warn_once = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/warn-once.js"(exports, module) {
    "use strict";
    var printed = {};
    module.exports = function warnOnce(message) {
      if (printed[message])
        return;
      printed[message] = true;
      if (typeof console !== "undefined" && console.warn) {
        console.warn(message);
      }
    };
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/warning.js
var require_warning = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/warning.js"(exports, module) {
    "use strict";
    var Warning2 = class {
      constructor(text, opts = {}) {
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
          let range4 = opts.node.rangeBy(opts);
          this.line = range4.start.line;
          this.column = range4.start.column;
          this.endLine = range4.end.line;
          this.endColumn = range4.end.column;
        }
        for (let opt in opts)
          this[opt] = opts[opt];
      }
      toString() {
        if (this.node) {
          return this.node.error(this.text, {
            plugin: this.plugin,
            index: this.index,
            word: this.word
          }).message;
        }
        if (this.plugin) {
          return this.plugin + ": " + this.text;
        }
        return this.text;
      }
    };
    module.exports = Warning2;
    Warning2.default = Warning2;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/result.js
var require_result = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/result.js"(exports, module) {
    "use strict";
    var Warning2 = require_warning();
    var Result = class {
      constructor(processor, root2, opts) {
        this.processor = processor;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
      }
      toString() {
        return this.css;
      }
      warn(text, opts = {}) {
        if (!opts.plugin) {
          if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
            opts.plugin = this.lastPlugin.postcssPlugin;
          }
        }
        let warning = new Warning2(text, opts);
        this.messages.push(warning);
        return warning;
      }
      warnings() {
        return this.messages.filter((i) => i.type === "warning");
      }
      get content() {
        return this.css;
      }
    };
    module.exports = Result;
    Result.default = Result;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/tokenize.js
var require_tokenize = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/tokenize.js"(exports, module) {
    "use strict";
    var SINGLE_QUOTE = "'".charCodeAt(0);
    var DOUBLE_QUOTE = '"'.charCodeAt(0);
    var BACKSLASH = "\\".charCodeAt(0);
    var SLASH = "/".charCodeAt(0);
    var NEWLINE = "\n".charCodeAt(0);
    var SPACE = " ".charCodeAt(0);
    var FEED = "\f".charCodeAt(0);
    var TAB = "	".charCodeAt(0);
    var CR = "\r".charCodeAt(0);
    var OPEN_SQUARE = "[".charCodeAt(0);
    var CLOSE_SQUARE = "]".charCodeAt(0);
    var OPEN_PARENTHESES = "(".charCodeAt(0);
    var CLOSE_PARENTHESES = ")".charCodeAt(0);
    var OPEN_CURLY = "{".charCodeAt(0);
    var CLOSE_CURLY = "}".charCodeAt(0);
    var SEMICOLON = ";".charCodeAt(0);
    var ASTERISK = "*".charCodeAt(0);
    var COLON = ":".charCodeAt(0);
    var AT = "@".charCodeAt(0);
    var RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
    var RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
    var RE_BAD_BRACKET = /.[\n"'(/\\]/;
    var RE_HEX_ESCAPE = /[\da-f]/i;
    module.exports = function tokenizer(input, options2 = {}) {
      let css = input.css.valueOf();
      let ignore = options2.ignoreErrors;
      let code, next, quote, content, escape2;
      let escaped, escapePos, prev, n, currentToken;
      let length = css.length;
      let pos = 0;
      let buffer = [];
      let returned = [];
      function position() {
        return pos;
      }
      function unclosed(what) {
        throw input.error("Unclosed " + what, pos);
      }
      function endOfFile() {
        return returned.length === 0 && pos >= length;
      }
      function nextToken(opts) {
        if (returned.length)
          return returned.pop();
        if (pos >= length)
          return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch (code) {
          case NEWLINE:
          case SPACE:
          case TAB:
          case CR:
          case FEED: {
            next = pos;
            do {
              next += 1;
              code = css.charCodeAt(next);
            } while (code === SPACE || code === NEWLINE || code === TAB || code === CR || code === FEED);
            currentToken = ["space", css.slice(pos, next)];
            pos = next - 1;
            break;
          }
          case OPEN_SQUARE:
          case CLOSE_SQUARE:
          case OPEN_CURLY:
          case CLOSE_CURLY:
          case COLON:
          case SEMICOLON:
          case CLOSE_PARENTHESES: {
            let controlChar = String.fromCharCode(code);
            currentToken = [controlChar, controlChar, pos];
            break;
          }
          case OPEN_PARENTHESES: {
            prev = buffer.length ? buffer.pop()[1] : "";
            n = css.charCodeAt(pos + 1);
            if (prev === "url" && n !== SINGLE_QUOTE && n !== DOUBLE_QUOTE && n !== SPACE && n !== NEWLINE && n !== TAB && n !== FEED && n !== CR) {
              next = pos;
              do {
                escaped = false;
                next = css.indexOf(")", next + 1);
                if (next === -1) {
                  if (ignore || ignoreUnclosed) {
                    next = pos;
                    break;
                  } else {
                    unclosed("bracket");
                  }
                }
                escapePos = next;
                while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
                  escapePos -= 1;
                  escaped = !escaped;
                }
              } while (escaped);
              currentToken = ["brackets", css.slice(pos, next + 1), pos, next];
              pos = next;
            } else {
              next = css.indexOf(")", pos + 1);
              content = css.slice(pos, next + 1);
              if (next === -1 || RE_BAD_BRACKET.test(content)) {
                currentToken = ["(", "(", pos];
              } else {
                currentToken = ["brackets", content, pos, next];
                pos = next;
              }
            }
            break;
          }
          case SINGLE_QUOTE:
          case DOUBLE_QUOTE: {
            quote = code === SINGLE_QUOTE ? "'" : '"';
            next = pos;
            do {
              escaped = false;
              next = css.indexOf(quote, next + 1);
              if (next === -1) {
                if (ignore || ignoreUnclosed) {
                  next = pos + 1;
                  break;
                } else {
                  unclosed("string");
                }
              }
              escapePos = next;
              while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
                escapePos -= 1;
                escaped = !escaped;
              }
            } while (escaped);
            currentToken = ["string", css.slice(pos, next + 1), pos, next];
            pos = next;
            break;
          }
          case AT: {
            RE_AT_END.lastIndex = pos + 1;
            RE_AT_END.test(css);
            if (RE_AT_END.lastIndex === 0) {
              next = css.length - 1;
            } else {
              next = RE_AT_END.lastIndex - 2;
            }
            currentToken = ["at-word", css.slice(pos, next + 1), pos, next];
            pos = next;
            break;
          }
          case BACKSLASH: {
            next = pos;
            escape2 = true;
            while (css.charCodeAt(next + 1) === BACKSLASH) {
              next += 1;
              escape2 = !escape2;
            }
            code = css.charCodeAt(next + 1);
            if (escape2 && code !== SLASH && code !== SPACE && code !== NEWLINE && code !== TAB && code !== CR && code !== FEED) {
              next += 1;
              if (RE_HEX_ESCAPE.test(css.charAt(next))) {
                while (RE_HEX_ESCAPE.test(css.charAt(next + 1))) {
                  next += 1;
                }
                if (css.charCodeAt(next + 1) === SPACE) {
                  next += 1;
                }
              }
            }
            currentToken = ["word", css.slice(pos, next + 1), pos, next];
            pos = next;
            break;
          }
          default: {
            if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
              next = css.indexOf("*/", pos + 2) + 1;
              if (next === 0) {
                if (ignore || ignoreUnclosed) {
                  next = css.length;
                } else {
                  unclosed("comment");
                }
              }
              currentToken = ["comment", css.slice(pos, next + 1), pos, next];
              pos = next;
            } else {
              RE_WORD_END.lastIndex = pos + 1;
              RE_WORD_END.test(css);
              if (RE_WORD_END.lastIndex === 0) {
                next = css.length - 1;
              } else {
                next = RE_WORD_END.lastIndex - 2;
              }
              currentToken = ["word", css.slice(pos, next + 1), pos, next];
              buffer.push(currentToken);
              pos = next;
            }
            break;
          }
        }
        pos++;
        return currentToken;
      }
      function back(token) {
        returned.push(token);
      }
      return {
        back,
        nextToken,
        endOfFile,
        position
      };
    };
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/at-rule.js
var require_at_rule = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/at-rule.js"(exports, module) {
    "use strict";
    var Container = require_container();
    var AtRule = class extends Container {
      constructor(defaults) {
        super(defaults);
        this.type = "atrule";
      }
      append(...children2) {
        if (!this.proxyOf.nodes)
          this.nodes = [];
        return super.append(...children2);
      }
      prepend(...children2) {
        if (!this.proxyOf.nodes)
          this.nodes = [];
        return super.prepend(...children2);
      }
    };
    module.exports = AtRule;
    AtRule.default = AtRule;
    Container.registerAtRule(AtRule);
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/root.js
var require_root = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/root.js"(exports, module) {
    "use strict";
    var Container = require_container();
    var LazyResult;
    var Processor;
    var Root = class extends Container {
      constructor(defaults) {
        super(defaults);
        this.type = "root";
        if (!this.nodes)
          this.nodes = [];
      }
      removeChild(child, ignore) {
        let index = this.index(child);
        if (!ignore && index === 0 && this.nodes.length > 1) {
          this.nodes[1].raws.before = this.nodes[index].raws.before;
        }
        return super.removeChild(child);
      }
      normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
          if (type === "prepend") {
            if (this.nodes.length > 1) {
              sample.raws.before = this.nodes[1].raws.before;
            } else {
              delete sample.raws.before;
            }
          } else if (this.first !== sample) {
            for (let node of nodes) {
              node.raws.before = sample.raws.before;
            }
          }
        }
        return nodes;
      }
      toResult(opts = {}) {
        let lazy2 = new LazyResult(new Processor(), this, opts);
        return lazy2.stringify();
      }
    };
    Root.registerLazyResult = (dependant) => {
      LazyResult = dependant;
    };
    Root.registerProcessor = (dependant) => {
      Processor = dependant;
    };
    module.exports = Root;
    Root.default = Root;
    Container.registerRoot(Root);
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/list.js
var require_list = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/list.js"(exports, module) {
    "use strict";
    var list = {
      split(string, separators, last) {
        let array = [];
        let current = "";
        let split2 = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = "";
        let escape2 = false;
        for (let letter of string) {
          if (escape2) {
            escape2 = false;
          } else if (letter === "\\") {
            escape2 = true;
          } else if (inQuote) {
            if (letter === prevQuote) {
              inQuote = false;
            }
          } else if (letter === '"' || letter === "'") {
            inQuote = true;
            prevQuote = letter;
          } else if (letter === "(") {
            func += 1;
          } else if (letter === ")") {
            if (func > 0)
              func -= 1;
          } else if (func === 0) {
            if (separators.includes(letter))
              split2 = true;
          }
          if (split2) {
            if (current !== "")
              array.push(current.trim());
            current = "";
            split2 = false;
          } else {
            current += letter;
          }
        }
        if (last || current !== "")
          array.push(current.trim());
        return array;
      },
      space(string) {
        let spaces = [" ", "\n", "	"];
        return list.split(string, spaces);
      },
      comma(string) {
        return list.split(string, [","], true);
      }
    };
    module.exports = list;
    list.default = list;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/rule.js
var require_rule = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/rule.js"(exports, module) {
    "use strict";
    var Container = require_container();
    var list = require_list();
    var Rule = class extends Container {
      constructor(defaults) {
        super(defaults);
        this.type = "rule";
        if (!this.nodes)
          this.nodes = [];
      }
      get selectors() {
        return list.comma(this.selector);
      }
      set selectors(values) {
        let match2 = this.selector ? this.selector.match(/,\s*/) : null;
        let sep = match2 ? match2[0] : "," + this.raw("between", "beforeOpen");
        this.selector = values.join(sep);
      }
    };
    module.exports = Rule;
    Rule.default = Rule;
    Container.registerRule(Rule);
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/parser.js
var require_parser = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/parser.js"(exports, module) {
    "use strict";
    var Declaration = require_declaration();
    var tokenizer = require_tokenize();
    var Comment = require_comment();
    var AtRule = require_at_rule();
    var Root = require_root();
    var Rule = require_rule();
    var SAFE_COMMENT_NEIGHBOR = {
      empty: true,
      space: true
    };
    function findLastWithPosition(tokens) {
      for (let i = tokens.length - 1; i >= 0; i--) {
        let token = tokens[i];
        let pos = token[3] || token[2];
        if (pos)
          return pos;
      }
    }
    var Parser = class {
      constructor(input) {
        this.input = input;
        this.root = new Root();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.customProperty = false;
        this.createTokenizer();
        this.root.source = { input, start: { offset: 0, line: 1, column: 1 } };
      }
      createTokenizer() {
        this.tokenizer = tokenizer(this.input);
      }
      parse() {
        let token;
        while (!this.tokenizer.endOfFile()) {
          token = this.tokenizer.nextToken();
          switch (token[0]) {
            case "space":
              this.spaces += token[1];
              break;
            case ";":
              this.freeSemicolon(token);
              break;
            case "}":
              this.end(token);
              break;
            case "comment":
              this.comment(token);
              break;
            case "at-word":
              this.atrule(token);
              break;
            case "{":
              this.emptyRule(token);
              break;
            default:
              this.other(token);
              break;
          }
        }
        this.endFile();
      }
      comment(token) {
        let node = new Comment();
        this.init(node, token[2]);
        node.source.end = this.getPosition(token[3] || token[2]);
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
          node.text = "";
          node.raws.left = text;
          node.raws.right = "";
        } else {
          let match2 = text.match(/^(\s*)([^]*\S)(\s*)$/);
          node.text = match2[2];
          node.raws.left = match2[1];
          node.raws.right = match2[3];
        }
      }
      emptyRule(token) {
        let node = new Rule();
        this.init(node, token[2]);
        node.selector = "";
        node.raws.between = "";
        this.current = node;
      }
      other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith("--");
        let tokens = [];
        let token = start;
        while (token) {
          type = token[0];
          tokens.push(token);
          if (type === "(" || type === "[") {
            if (!bracket)
              bracket = token;
            brackets.push(type === "(" ? ")" : "]");
          } else if (customProperty && colon && type === "{") {
            if (!bracket)
              bracket = token;
            brackets.push("}");
          } else if (brackets.length === 0) {
            if (type === ";") {
              if (colon) {
                this.decl(tokens, customProperty);
                return;
              } else {
                break;
              }
            } else if (type === "{") {
              this.rule(tokens);
              return;
            } else if (type === "}") {
              this.tokenizer.back(tokens.pop());
              end = true;
              break;
            } else if (type === ":") {
              colon = true;
            }
          } else if (type === brackets[brackets.length - 1]) {
            brackets.pop();
            if (brackets.length === 0)
              bracket = null;
          }
          token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile())
          end = true;
        if (brackets.length > 0)
          this.unclosedBracket(bracket);
        if (end && colon) {
          if (!customProperty) {
            while (tokens.length) {
              token = tokens[tokens.length - 1][0];
              if (token !== "space" && token !== "comment")
                break;
              this.tokenizer.back(tokens.pop());
            }
          }
          this.decl(tokens, customProperty);
        } else {
          this.unknownWord(tokens);
        }
      }
      rule(tokens) {
        tokens.pop();
        let node = new Rule();
        this.init(node, tokens[0][2]);
        node.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node, "selector", tokens);
        this.current = node;
      }
      decl(tokens, customProperty) {
        let node = new Declaration();
        this.init(node, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ";") {
          this.semicolon = true;
          tokens.pop();
        }
        node.source.end = this.getPosition(
          last[3] || last[2] || findLastWithPosition(tokens)
        );
        while (tokens[0][0] !== "word") {
          if (tokens.length === 1)
            this.unknownWord(tokens);
          node.raws.before += tokens.shift()[1];
        }
        node.source.start = this.getPosition(tokens[0][2]);
        node.prop = "";
        while (tokens.length) {
          let type = tokens[0][0];
          if (type === ":" || type === "space" || type === "comment") {
            break;
          }
          node.prop += tokens.shift()[1];
        }
        node.raws.between = "";
        let token;
        while (tokens.length) {
          token = tokens.shift();
          if (token[0] === ":") {
            node.raws.between += token[1];
            break;
          } else {
            if (token[0] === "word" && /\w/.test(token[1])) {
              this.unknownWord([token]);
            }
            node.raws.between += token[1];
          }
        }
        if (node.prop[0] === "_" || node.prop[0] === "*") {
          node.raws.before += node.prop[0];
          node.prop = node.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while (tokens.length) {
          next = tokens[0][0];
          if (next !== "space" && next !== "comment")
            break;
          firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for (let i = tokens.length - 1; i >= 0; i--) {
          token = tokens[i];
          if (token[1].toLowerCase() === "!important") {
            node.important = true;
            let string = this.stringFrom(tokens, i);
            string = this.spacesFromEnd(tokens) + string;
            if (string !== " !important")
              node.raws.important = string;
            break;
          } else if (token[1].toLowerCase() === "important") {
            let cache = tokens.slice(0);
            let str = "";
            for (let j = i; j > 0; j--) {
              let type = cache[j][0];
              if (str.trim().indexOf("!") === 0 && type !== "space") {
                break;
              }
              str = cache.pop()[1] + str;
            }
            if (str.trim().indexOf("!") === 0) {
              node.important = true;
              node.raws.important = str;
              tokens = cache;
            }
          }
          if (token[0] !== "space" && token[0] !== "comment") {
            break;
          }
        }
        let hasWord = tokens.some((i) => i[0] !== "space" && i[0] !== "comment");
        if (hasWord) {
          node.raws.between += firstSpaces.map((i) => i[1]).join("");
          firstSpaces = [];
        }
        this.raw(node, "value", firstSpaces.concat(tokens), customProperty);
        if (node.value.includes(":") && !customProperty) {
          this.checkMissedSemicolon(tokens);
        }
      }
      atrule(token) {
        let node = new AtRule();
        node.name = token[1].slice(1);
        if (node.name === "") {
          this.unnamedAtrule(node, token);
        }
        this.init(node, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while (!this.tokenizer.endOfFile()) {
          token = this.tokenizer.nextToken();
          type = token[0];
          if (type === "(" || type === "[") {
            brackets.push(type === "(" ? ")" : "]");
          } else if (type === "{" && brackets.length > 0) {
            brackets.push("}");
          } else if (type === brackets[brackets.length - 1]) {
            brackets.pop();
          }
          if (brackets.length === 0) {
            if (type === ";") {
              node.source.end = this.getPosition(token[2]);
              this.semicolon = true;
              break;
            } else if (type === "{") {
              open = true;
              break;
            } else if (type === "}") {
              if (params.length > 0) {
                shift = params.length - 1;
                prev = params[shift];
                while (prev && prev[0] === "space") {
                  prev = params[--shift];
                }
                if (prev) {
                  node.source.end = this.getPosition(prev[3] || prev[2]);
                }
              }
              this.end(token);
              break;
            } else {
              params.push(token);
            }
          } else {
            params.push(token);
          }
          if (this.tokenizer.endOfFile()) {
            last = true;
            break;
          }
        }
        node.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
          node.raws.afterName = this.spacesAndCommentsFromStart(params);
          this.raw(node, "params", params);
          if (last) {
            token = params[params.length - 1];
            node.source.end = this.getPosition(token[3] || token[2]);
            this.spaces = node.raws.between;
            node.raws.between = "";
          }
        } else {
          node.raws.afterName = "";
          node.params = "";
        }
        if (open) {
          node.nodes = [];
          this.current = node;
        }
      }
      end(token) {
        if (this.current.nodes && this.current.nodes.length) {
          this.current.raws.semicolon = this.semicolon;
        }
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
          this.current.source.end = this.getPosition(token[2]);
          this.current = this.current.parent;
        } else {
          this.unexpectedClose(token);
        }
      }
      endFile() {
        if (this.current.parent)
          this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) {
          this.current.raws.semicolon = this.semicolon;
        }
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
      }
      freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
          let prev = this.current.nodes[this.current.nodes.length - 1];
          if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
            prev.raws.ownSemicolon = this.spaces;
            this.spaces = "";
          }
        }
      }
      // Helpers
      getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
          offset,
          line: pos.line,
          column: pos.col
        };
      }
      init(node, offset) {
        this.current.push(node);
        node.source = {
          start: this.getPosition(offset),
          input: this.input
        };
        node.raws.before = this.spaces;
        this.spaces = "";
        if (node.type !== "comment")
          this.semicolon = false;
      }
      raw(node, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = "";
        let clean = true;
        let next, prev;
        for (let i = 0; i < length; i += 1) {
          token = tokens[i];
          type = token[0];
          if (type === "space" && i === length - 1 && !customProperty) {
            clean = false;
          } else if (type === "comment") {
            prev = tokens[i - 1] ? tokens[i - 1][0] : "empty";
            next = tokens[i + 1] ? tokens[i + 1][0] : "empty";
            if (!SAFE_COMMENT_NEIGHBOR[prev] && !SAFE_COMMENT_NEIGHBOR[next]) {
              if (value.slice(-1) === ",") {
                clean = false;
              } else {
                value += token[1];
              }
            } else {
              clean = false;
            }
          } else {
            value += token[1];
          }
        }
        if (!clean) {
          let raw = tokens.reduce((all, i) => all + i[1], "");
          node.raws[prop] = { value, raw };
        }
        node[prop] = value;
      }
      spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while (tokens.length) {
          lastTokenType = tokens[tokens.length - 1][0];
          if (lastTokenType !== "space" && lastTokenType !== "comment")
            break;
          spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
      }
      spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = "";
        while (tokens.length) {
          next = tokens[0][0];
          if (next !== "space" && next !== "comment")
            break;
          spaces += tokens.shift()[1];
        }
        return spaces;
      }
      spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while (tokens.length) {
          lastTokenType = tokens[tokens.length - 1][0];
          if (lastTokenType !== "space")
            break;
          spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
      }
      stringFrom(tokens, from) {
        let result = "";
        for (let i = from; i < tokens.length; i++) {
          result += tokens[i][1];
        }
        tokens.splice(from, tokens.length - from);
        return result;
      }
      colon(tokens) {
        let brackets = 0;
        let token, type, prev;
        for (let [i, element] of tokens.entries()) {
          token = element;
          type = token[0];
          if (type === "(") {
            brackets += 1;
          }
          if (type === ")") {
            brackets -= 1;
          }
          if (brackets === 0 && type === ":") {
            if (!prev) {
              this.doubleColon(token);
            } else if (prev[0] === "word" && prev[1] === "progid") {
              continue;
            } else {
              return i;
            }
          }
          prev = token;
        }
        return false;
      }
      // Errors
      unclosedBracket(bracket) {
        throw this.input.error(
          "Unclosed bracket",
          { offset: bracket[2] },
          { offset: bracket[2] + 1 }
        );
      }
      unknownWord(tokens) {
        throw this.input.error(
          "Unknown word",
          { offset: tokens[0][2] },
          { offset: tokens[0][2] + tokens[0][1].length }
        );
      }
      unexpectedClose(token) {
        throw this.input.error(
          "Unexpected }",
          { offset: token[2] },
          { offset: token[2] + 1 }
        );
      }
      unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
      }
      doubleColon(token) {
        throw this.input.error(
          "Double colon",
          { offset: token[2] },
          { offset: token[2] + token[1].length }
        );
      }
      unnamedAtrule(node, token) {
        throw this.input.error(
          "At-rule without name",
          { offset: token[2] },
          { offset: token[2] + token[1].length }
        );
      }
      precheckMissedSemicolon() {
      }
      checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false)
          return;
        let founded = 0;
        let token;
        for (let j = colon - 1; j >= 0; j--) {
          token = tokens[j];
          if (token[0] !== "space") {
            founded += 1;
            if (founded === 2)
              break;
          }
        }
        throw this.input.error(
          "Missed semicolon",
          token[0] === "word" ? token[3] + 1 : token[2]
        );
      }
    };
    module.exports = Parser;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/parse.js
var require_parse2 = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/parse.js"(exports, module) {
    "use strict";
    var Container = require_container();
    var Parser = require_parser();
    var Input = require_input();
    function parse(css, opts) {
      let input = new Input(css, opts);
      let parser = new Parser(input);
      try {
        parser.parse();
      } catch (e) {
        if (true) {
          if (e.name === "CssSyntaxError" && opts && opts.from) {
            if (/\.scss$/i.test(opts.from)) {
              e.message += "\nYou tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser";
            } else if (/\.sass/i.test(opts.from)) {
              e.message += "\nYou tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser";
            } else if (/\.less$/i.test(opts.from)) {
              e.message += "\nYou tried to parse Less with the standard CSS parser; try again with the postcss-less parser";
            }
          }
        }
        throw e;
      }
      return parser.root;
    }
    module.exports = parse;
    parse.default = parse;
    Container.registerParse(parse);
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/lazy-result.js
var require_lazy_result = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/lazy-result.js"(exports, module) {
    "use strict";
    var { isClean, my } = require_symbols();
    var MapGenerator = require_map_generator();
    var stringify = require_stringify3();
    var Container = require_container();
    var Document = require_document();
    var warnOnce = require_warn_once();
    var Result = require_result();
    var parse = require_parse2();
    var Root = require_root();
    var TYPE_TO_CLASS_NAME = {
      document: "Document",
      root: "Root",
      atrule: "AtRule",
      rule: "Rule",
      decl: "Declaration",
      comment: "Comment"
    };
    var PLUGIN_PROPS = {
      postcssPlugin: true,
      prepare: true,
      Once: true,
      Document: true,
      Root: true,
      Declaration: true,
      Rule: true,
      AtRule: true,
      Comment: true,
      DeclarationExit: true,
      RuleExit: true,
      AtRuleExit: true,
      CommentExit: true,
      RootExit: true,
      DocumentExit: true,
      OnceExit: true
    };
    var NOT_VISITORS = {
      postcssPlugin: true,
      prepare: true,
      Once: true
    };
    var CHILDREN = 0;
    function isPromise(obj) {
      return typeof obj === "object" && typeof obj.then === "function";
    }
    function getEvents(node) {
      let key = false;
      let type = TYPE_TO_CLASS_NAME[node.type];
      if (node.type === "decl") {
        key = node.prop.toLowerCase();
      } else if (node.type === "atrule") {
        key = node.name.toLowerCase();
      }
      if (key && node.append) {
        return [
          type,
          type + "-" + key,
          CHILDREN,
          type + "Exit",
          type + "Exit-" + key
        ];
      } else if (key) {
        return [type, type + "-" + key, type + "Exit", type + "Exit-" + key];
      } else if (node.append) {
        return [type, CHILDREN, type + "Exit"];
      } else {
        return [type, type + "Exit"];
      }
    }
    function toStack(node) {
      let events;
      if (node.type === "document") {
        events = ["Document", CHILDREN, "DocumentExit"];
      } else if (node.type === "root") {
        events = ["Root", CHILDREN, "RootExit"];
      } else {
        events = getEvents(node);
      }
      return {
        node,
        events,
        eventIndex: 0,
        visitors: [],
        visitorIndex: 0,
        iterator: 0
      };
    }
    function cleanMarks(node) {
      node[isClean] = false;
      if (node.nodes)
        node.nodes.forEach((i) => cleanMarks(i));
      return node;
    }
    var postcss = {};
    var LazyResult = class {
      constructor(processor, css, opts) {
        this.stringified = false;
        this.processed = false;
        let root2;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) {
          root2 = cleanMarks(css);
        } else if (css instanceof LazyResult || css instanceof Result) {
          root2 = cleanMarks(css.root);
          if (css.map) {
            if (typeof opts.map === "undefined")
              opts.map = {};
            if (!opts.map.inline)
              opts.map.inline = false;
            opts.map.prev = css.map;
          }
        } else {
          let parser = parse;
          if (opts.syntax)
            parser = opts.syntax.parse;
          if (opts.parser)
            parser = opts.parser;
          if (parser.parse)
            parser = parser.parse;
          try {
            root2 = parser(css, opts);
          } catch (error) {
            this.processed = true;
            this.error = error;
          }
          if (root2 && !root2[my]) {
            Container.rebuild(root2);
          }
        }
        this.result = new Result(processor, root2, opts);
        this.helpers = { ...postcss, result: this.result, postcss };
        this.plugins = this.processor.plugins.map((plugin) => {
          if (typeof plugin === "object" && plugin.prepare) {
            return { ...plugin, ...plugin.prepare(this.result) };
          } else {
            return plugin;
          }
        });
      }
      get [Symbol.toStringTag]() {
        return "LazyResult";
      }
      get processor() {
        return this.result.processor;
      }
      get opts() {
        return this.result.opts;
      }
      get css() {
        return this.stringify().css;
      }
      get content() {
        return this.stringify().content;
      }
      get map() {
        return this.stringify().map;
      }
      get root() {
        return this.sync().root;
      }
      get messages() {
        return this.sync().messages;
      }
      warnings() {
        return this.sync().warnings();
      }
      toString() {
        return this.css;
      }
      then(onFulfilled, onRejected) {
        if (true) {
          if (!("from" in this.opts)) {
            warnOnce(
              "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
            );
          }
        }
        return this.async().then(onFulfilled, onRejected);
      }
      catch(onRejected) {
        return this.async().catch(onRejected);
      }
      finally(onFinally) {
        return this.async().then(onFinally, onFinally);
      }
      async() {
        if (this.error)
          return Promise.reject(this.error);
        if (this.processed)
          return Promise.resolve(this.result);
        if (!this.processing) {
          this.processing = this.runAsync();
        }
        return this.processing;
      }
      sync() {
        if (this.error)
          throw this.error;
        if (this.processed)
          return this.result;
        this.processed = true;
        if (this.processing) {
          throw this.getAsyncError();
        }
        for (let plugin of this.plugins) {
          let promise = this.runOnRoot(plugin);
          if (isPromise(promise)) {
            throw this.getAsyncError();
          }
        }
        this.prepareVisitors();
        if (this.hasListener) {
          let root2 = this.result.root;
          while (!root2[isClean]) {
            root2[isClean] = true;
            this.walkSync(root2);
          }
          if (this.listeners.OnceExit) {
            if (root2.type === "document") {
              for (let subRoot of root2.nodes) {
                this.visitSync(this.listeners.OnceExit, subRoot);
              }
            } else {
              this.visitSync(this.listeners.OnceExit, root2);
            }
          }
        }
        return this.result;
      }
      stringify() {
        if (this.error)
          throw this.error;
        if (this.stringified)
          return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = stringify;
        if (opts.syntax)
          str = opts.syntax.stringify;
        if (opts.stringifier)
          str = opts.stringifier;
        if (str.stringify)
          str = str.stringify;
        let map36 = new MapGenerator(str, this.result.root, this.result.opts);
        let data2 = map36.generate();
        this.result.css = data2[0];
        this.result.map = data2[1];
        return this.result;
      }
      walkSync(node) {
        node[isClean] = true;
        let events = getEvents(node);
        for (let event2 of events) {
          if (event2 === CHILDREN) {
            if (node.nodes) {
              node.each((child) => {
                if (!child[isClean])
                  this.walkSync(child);
              });
            }
          } else {
            let visitors = this.listeners[event2];
            if (visitors) {
              if (this.visitSync(visitors, node.toProxy()))
                return;
            }
          }
        }
      }
      visitSync(visitors, node) {
        for (let [plugin, visitor] of visitors) {
          this.result.lastPlugin = plugin;
          let promise;
          try {
            promise = visitor(node, this.helpers);
          } catch (e) {
            throw this.handleError(e, node.proxyOf);
          }
          if (node.type !== "root" && node.type !== "document" && !node.parent) {
            return true;
          }
          if (isPromise(promise)) {
            throw this.getAsyncError();
          }
        }
      }
      runOnRoot(plugin) {
        this.result.lastPlugin = plugin;
        try {
          if (typeof plugin === "object" && plugin.Once) {
            if (this.result.root.type === "document") {
              let roots = this.result.root.nodes.map(
                (root2) => plugin.Once(root2, this.helpers)
              );
              if (isPromise(roots[0])) {
                return Promise.all(roots);
              }
              return roots;
            }
            return plugin.Once(this.result.root, this.helpers);
          } else if (typeof plugin === "function") {
            return plugin(this.result.root, this.result);
          }
        } catch (error) {
          throw this.handleError(error);
        }
      }
      getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
      }
      handleError(error, node) {
        let plugin = this.result.lastPlugin;
        try {
          if (node)
            node.addToError(error);
          this.error = error;
          if (error.name === "CssSyntaxError" && !error.plugin) {
            error.plugin = plugin.postcssPlugin;
            error.setMessage();
          } else if (plugin.postcssVersion) {
            if (true) {
              let pluginName = plugin.postcssPlugin;
              let pluginVer = plugin.postcssVersion;
              let runtimeVer = this.result.processor.version;
              let a = pluginVer.split(".");
              let b = runtimeVer.split(".");
              if (a[0] !== b[0] || parseInt(a[1]) > parseInt(b[1])) {
                console.error(
                  "Unknown error from PostCSS plugin. Your current PostCSS version is " + runtimeVer + ", but " + pluginName + " uses " + pluginVer + ". Perhaps this is the source of the error below."
                );
              }
            }
          }
        } catch (err) {
          if (console && console.error)
            console.error(err);
        }
        return error;
      }
      async runAsync() {
        this.plugin = 0;
        for (let i = 0; i < this.plugins.length; i++) {
          let plugin = this.plugins[i];
          let promise = this.runOnRoot(plugin);
          if (isPromise(promise)) {
            try {
              await promise;
            } catch (error) {
              throw this.handleError(error);
            }
          }
        }
        this.prepareVisitors();
        if (this.hasListener) {
          let root2 = this.result.root;
          while (!root2[isClean]) {
            root2[isClean] = true;
            let stack = [toStack(root2)];
            while (stack.length > 0) {
              let promise = this.visitTick(stack);
              if (isPromise(promise)) {
                try {
                  await promise;
                } catch (e) {
                  let node = stack[stack.length - 1].node;
                  throw this.handleError(e, node);
                }
              }
            }
          }
          if (this.listeners.OnceExit) {
            for (let [plugin, visitor] of this.listeners.OnceExit) {
              this.result.lastPlugin = plugin;
              try {
                if (root2.type === "document") {
                  let roots = root2.nodes.map(
                    (subRoot) => visitor(subRoot, this.helpers)
                  );
                  await Promise.all(roots);
                } else {
                  await visitor(root2, this.helpers);
                }
              } catch (e) {
                throw this.handleError(e);
              }
            }
          }
        }
        this.processed = true;
        return this.stringify();
      }
      prepareVisitors() {
        this.listeners = {};
        let add = (plugin, type, cb) => {
          if (!this.listeners[type])
            this.listeners[type] = [];
          this.listeners[type].push([plugin, cb]);
        };
        for (let plugin of this.plugins) {
          if (typeof plugin === "object") {
            for (let event2 in plugin) {
              if (!PLUGIN_PROPS[event2] && /^[A-Z]/.test(event2)) {
                throw new Error(
                  `Unknown event ${event2} in ${plugin.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
                );
              }
              if (!NOT_VISITORS[event2]) {
                if (typeof plugin[event2] === "object") {
                  for (let filter12 in plugin[event2]) {
                    if (filter12 === "*") {
                      add(plugin, event2, plugin[event2][filter12]);
                    } else {
                      add(
                        plugin,
                        event2 + "-" + filter12.toLowerCase(),
                        plugin[event2][filter12]
                      );
                    }
                  }
                } else if (typeof plugin[event2] === "function") {
                  add(plugin, event2, plugin[event2]);
                }
              }
            }
          }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
      }
      visitTick(stack) {
        let visit = stack[stack.length - 1];
        let { node, visitors } = visit;
        if (node.type !== "root" && node.type !== "document" && !node.parent) {
          stack.pop();
          return;
        }
        if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
          let [plugin, visitor] = visitors[visit.visitorIndex];
          visit.visitorIndex += 1;
          if (visit.visitorIndex === visitors.length) {
            visit.visitors = [];
            visit.visitorIndex = 0;
          }
          this.result.lastPlugin = plugin;
          try {
            return visitor(node.toProxy(), this.helpers);
          } catch (e) {
            throw this.handleError(e, node);
          }
        }
        if (visit.iterator !== 0) {
          let iterator = visit.iterator;
          let child;
          while (child = node.nodes[node.indexes[iterator]]) {
            node.indexes[iterator] += 1;
            if (!child[isClean]) {
              child[isClean] = true;
              stack.push(toStack(child));
              return;
            }
          }
          visit.iterator = 0;
          delete node.indexes[iterator];
        }
        let events = visit.events;
        while (visit.eventIndex < events.length) {
          let event2 = events[visit.eventIndex];
          visit.eventIndex += 1;
          if (event2 === CHILDREN) {
            if (node.nodes && node.nodes.length) {
              node[isClean] = true;
              visit.iterator = node.getIterator();
            }
            return;
          } else if (this.listeners[event2]) {
            visit.visitors = this.listeners[event2];
            return;
          }
        }
        stack.pop();
      }
    };
    LazyResult.registerPostcss = (dependant) => {
      postcss = dependant;
    };
    module.exports = LazyResult;
    LazyResult.default = LazyResult;
    Root.registerLazyResult(LazyResult);
    Document.registerLazyResult(LazyResult);
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/no-work-result.js
var require_no_work_result = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/no-work-result.js"(exports, module) {
    "use strict";
    var MapGenerator = require_map_generator();
    var stringify = require_stringify3();
    var warnOnce = require_warn_once();
    var parse = require_parse2();
    var Result = require_result();
    var NoWorkResult = class {
      constructor(processor, css, opts) {
        css = css.toString();
        this.stringified = false;
        this._processor = processor;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        let root2;
        let str = stringify;
        this.result = new Result(this._processor, root2, this._opts);
        this.result.css = css;
        let self2 = this;
        Object.defineProperty(this.result, "root", {
          get() {
            return self2.root;
          }
        });
        let map36 = new MapGenerator(str, root2, this._opts, css);
        if (map36.isMap()) {
          let [generatedCSS, generatedMap] = map36.generate();
          if (generatedCSS) {
            this.result.css = generatedCSS;
          }
          if (generatedMap) {
            this.result.map = generatedMap;
          }
        }
      }
      get [Symbol.toStringTag]() {
        return "NoWorkResult";
      }
      get processor() {
        return this.result.processor;
      }
      get opts() {
        return this.result.opts;
      }
      get css() {
        return this.result.css;
      }
      get content() {
        return this.result.css;
      }
      get map() {
        return this.result.map;
      }
      get root() {
        if (this._root) {
          return this._root;
        }
        let root2;
        let parser = parse;
        try {
          root2 = parser(this._css, this._opts);
        } catch (error) {
          this.error = error;
        }
        if (this.error) {
          throw this.error;
        } else {
          this._root = root2;
          return root2;
        }
      }
      get messages() {
        return [];
      }
      warnings() {
        return [];
      }
      toString() {
        return this._css;
      }
      then(onFulfilled, onRejected) {
        if (true) {
          if (!("from" in this._opts)) {
            warnOnce(
              "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
            );
          }
        }
        return this.async().then(onFulfilled, onRejected);
      }
      catch(onRejected) {
        return this.async().catch(onRejected);
      }
      finally(onFinally) {
        return this.async().then(onFinally, onFinally);
      }
      async() {
        if (this.error)
          return Promise.reject(this.error);
        return Promise.resolve(this.result);
      }
      sync() {
        if (this.error)
          throw this.error;
        return this.result;
      }
    };
    module.exports = NoWorkResult;
    NoWorkResult.default = NoWorkResult;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/processor.js
var require_processor = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/processor.js"(exports, module) {
    "use strict";
    var NoWorkResult = require_no_work_result();
    var LazyResult = require_lazy_result();
    var Document = require_document();
    var Root = require_root();
    var Processor = class {
      constructor(plugins = []) {
        this.version = "8.4.18";
        this.plugins = this.normalize(plugins);
      }
      use(plugin) {
        this.plugins = this.plugins.concat(this.normalize([plugin]));
        return this;
      }
      process(css, opts = {}) {
        if (this.plugins.length === 0 && typeof opts.parser === "undefined" && typeof opts.stringifier === "undefined" && typeof opts.syntax === "undefined") {
          return new NoWorkResult(this, css, opts);
        } else {
          return new LazyResult(this, css, opts);
        }
      }
      normalize(plugins) {
        let normalized = [];
        for (let i of plugins) {
          if (i.postcss === true) {
            i = i();
          } else if (i.postcss) {
            i = i.postcss;
          }
          if (typeof i === "object" && Array.isArray(i.plugins)) {
            normalized = normalized.concat(i.plugins);
          } else if (typeof i === "object" && i.postcssPlugin) {
            normalized.push(i);
          } else if (typeof i === "function") {
            normalized.push(i);
          } else if (typeof i === "object" && (i.parse || i.stringify)) {
            if (true) {
              throw new Error(
                "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
              );
            }
          } else {
            throw new Error(i + " is not a PostCSS plugin");
          }
        }
        return normalized;
      }
    };
    module.exports = Processor;
    Processor.default = Processor;
    Root.registerProcessor(Processor);
    Document.registerProcessor(Processor);
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/fromJSON.js
var require_fromJSON = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/fromJSON.js"(exports, module) {
    "use strict";
    var Declaration = require_declaration();
    var PreviousMap = require_previous_map();
    var Comment = require_comment();
    var AtRule = require_at_rule();
    var Input = require_input();
    var Root = require_root();
    var Rule = require_rule();
    function fromJSON(json, inputs) {
      if (Array.isArray(json))
        return json.map((n) => fromJSON(n));
      let { inputs: ownInputs, ...defaults } = json;
      if (ownInputs) {
        inputs = [];
        for (let input of ownInputs) {
          let inputHydrated = { ...input, __proto__: Input.prototype };
          if (inputHydrated.map) {
            inputHydrated.map = {
              ...inputHydrated.map,
              __proto__: PreviousMap.prototype
            };
          }
          inputs.push(inputHydrated);
        }
      }
      if (defaults.nodes) {
        defaults.nodes = json.nodes.map((n) => fromJSON(n, inputs));
      }
      if (defaults.source) {
        let { inputId, ...source } = defaults.source;
        defaults.source = source;
        if (inputId != null) {
          defaults.source.input = inputs[inputId];
        }
      }
      if (defaults.type === "root") {
        return new Root(defaults);
      } else if (defaults.type === "decl") {
        return new Declaration(defaults);
      } else if (defaults.type === "rule") {
        return new Rule(defaults);
      } else if (defaults.type === "comment") {
        return new Comment(defaults);
      } else if (defaults.type === "atrule") {
        return new AtRule(defaults);
      } else {
        throw new Error("Unknown node type: " + json.type);
      }
    }
    module.exports = fromJSON;
    fromJSON.default = fromJSON;
  }
});

// ../../node_modules/sanitize-html/node_modules/postcss/lib/postcss.js
var require_postcss = __commonJS({
  "../../node_modules/sanitize-html/node_modules/postcss/lib/postcss.js"(exports, module) {
    "use strict";
    var CssSyntaxError = require_css_syntax_error();
    var Declaration = require_declaration();
    var LazyResult = require_lazy_result();
    var Container = require_container();
    var Processor = require_processor();
    var stringify = require_stringify3();
    var fromJSON = require_fromJSON();
    var Document = require_document();
    var Warning2 = require_warning();
    var Comment = require_comment();
    var AtRule = require_at_rule();
    var Result = require_result();
    var Input = require_input();
    var parse = require_parse2();
    var list = require_list();
    var Rule = require_rule();
    var Root = require_root();
    var Node = require_node2();
    function postcss(...plugins) {
      if (plugins.length === 1 && Array.isArray(plugins[0])) {
        plugins = plugins[0];
      }
      return new Processor(plugins);
    }
    postcss.plugin = function plugin(name, initializer) {
      let warningPrinted = false;
      function creator(...args) {
        if (console && console.warn && !warningPrinted) {
          warningPrinted = true;
          console.warn(
            name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration"
          );
          if (process.env.LANG && process.env.LANG.startsWith("cn")) {
            console.warn(
              name + ": \u91CC\u9762 postcss.plugin \u88AB\u5F03\u7528. \u8FC1\u79FB\u6307\u5357:\nhttps://www.w3ctech.com/topic/2226"
            );
          }
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new Processor().version;
        return transformer;
      }
      let cache;
      Object.defineProperty(creator, "postcss", {
        get() {
          if (!cache)
            cache = creator();
          return cache;
        }
      });
      creator.process = function(css, processOpts, pluginOpts) {
        return postcss([creator(pluginOpts)]).process(css, processOpts);
      };
      return creator;
    };
    postcss.stringify = stringify;
    postcss.parse = parse;
    postcss.fromJSON = fromJSON;
    postcss.list = list;
    postcss.comment = (defaults) => new Comment(defaults);
    postcss.atRule = (defaults) => new AtRule(defaults);
    postcss.decl = (defaults) => new Declaration(defaults);
    postcss.rule = (defaults) => new Rule(defaults);
    postcss.root = (defaults) => new Root(defaults);
    postcss.document = (defaults) => new Document(defaults);
    postcss.CssSyntaxError = CssSyntaxError;
    postcss.Declaration = Declaration;
    postcss.Container = Container;
    postcss.Processor = Processor;
    postcss.Document = Document;
    postcss.Comment = Comment;
    postcss.Warning = Warning2;
    postcss.AtRule = AtRule;
    postcss.Result = Result;
    postcss.Input = Input;
    postcss.Rule = Rule;
    postcss.Root = Root;
    postcss.Node = Node;
    LazyResult.registerPostcss(postcss);
    module.exports = postcss;
    postcss.default = postcss;
  }
});

// ../../node_modules/sanitize-html/index.js
var require_sanitize_html = __commonJS({
  "../../node_modules/sanitize-html/index.js"(exports, module) {
    var htmlparser = require_lib7();
    var escapeStringRegexp = require_escape_string_regexp();
    var { isPlainObject } = require_is_plain_object();
    var deepmerge = require_cjs();
    var parseSrcset = require_parse_srcset();
    var { parse: postcssParse } = require_postcss();
    var mediaTags = [
      "img",
      "audio",
      "video",
      "picture",
      "svg",
      "object",
      "map",
      "iframe",
      "embed"
    ];
    var vulnerableTags = ["script", "style"];
    function each(obj, cb) {
      if (obj) {
        Object.keys(obj).forEach(function(key) {
          cb(obj[key], key);
        });
      }
    }
    function has3(obj, key) {
      return {}.hasOwnProperty.call(obj, key);
    }
    function filter12(a, cb) {
      const n = [];
      each(a, function(v) {
        if (cb(v)) {
          n.push(v);
        }
      });
      return n;
    }
    function isEmptyObject(obj) {
      for (const key in obj) {
        if (has3(obj, key)) {
          return false;
        }
      }
      return true;
    }
    function stringifySrcset(parsedSrcset) {
      return parsedSrcset.map(function(part) {
        if (!part.url) {
          throw new Error("URL missing");
        }
        return part.url + (part.w ? ` ${part.w}w` : "") + (part.h ? ` ${part.h}h` : "") + (part.d ? ` ${part.d}x` : "");
      }).join(", ");
    }
    module.exports = sanitizeHtml2;
    var VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
    function sanitizeHtml2(html2, options2, _recursing) {
      if (html2 == null) {
        return "";
      }
      if (typeof html2 === "number") {
        html2 = html2.toString();
      }
      let result = "";
      let tempResult = "";
      function Frame(tag, attribs) {
        const that = this;
        this.tag = tag;
        this.attribs = attribs || {};
        this.tagPosition = result.length;
        this.text = "";
        this.mediaChildren = [];
        this.updateParentNodeText = function() {
          if (stack.length) {
            const parentFrame = stack[stack.length - 1];
            parentFrame.text += that.text;
          }
        };
        this.updateParentNodeMediaChildren = function() {
          if (stack.length && mediaTags.includes(this.tag)) {
            const parentFrame = stack[stack.length - 1];
            parentFrame.mediaChildren.push(this.tag);
          }
        };
      }
      options2 = Object.assign({}, sanitizeHtml2.defaults, options2);
      options2.parser = Object.assign({}, htmlParserDefaults, options2.parser);
      const tagAllowed = function(name) {
        return options2.allowedTags === false || (options2.allowedTags || []).indexOf(name) > -1;
      };
      vulnerableTags.forEach(function(tag) {
        if (tagAllowed(tag) && !options2.allowVulnerableTags) {
          console.warn(`

\u26A0\uFE0F Your \`allowedTags\` option includes, \`${tag}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
        }
      });
      const nonTextTagsArray = options2.nonTextTags || [
        "script",
        "style",
        "textarea",
        "option"
      ];
      let allowedAttributesMap;
      let allowedAttributesGlobMap;
      if (options2.allowedAttributes) {
        allowedAttributesMap = {};
        allowedAttributesGlobMap = {};
        each(options2.allowedAttributes, function(attributes, tag) {
          allowedAttributesMap[tag] = [];
          const globRegex = [];
          attributes.forEach(function(obj) {
            if (typeof obj === "string" && obj.indexOf("*") >= 0) {
              globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, ".*"));
            } else {
              allowedAttributesMap[tag].push(obj);
            }
          });
          if (globRegex.length) {
            allowedAttributesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
          }
        });
      }
      const allowedClassesMap = {};
      const allowedClassesGlobMap = {};
      const allowedClassesRegexMap = {};
      each(options2.allowedClasses, function(classes, tag) {
        if (allowedAttributesMap) {
          if (!has3(allowedAttributesMap, tag)) {
            allowedAttributesMap[tag] = [];
          }
          allowedAttributesMap[tag].push("class");
        }
        allowedClassesMap[tag] = [];
        allowedClassesRegexMap[tag] = [];
        const globRegex = [];
        classes.forEach(function(obj) {
          if (typeof obj === "string" && obj.indexOf("*") >= 0) {
            globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, ".*"));
          } else if (obj instanceof RegExp) {
            allowedClassesRegexMap[tag].push(obj);
          } else {
            allowedClassesMap[tag].push(obj);
          }
        });
        if (globRegex.length) {
          allowedClassesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
        }
      });
      const transformTagsMap = {};
      let transformTagsAll;
      each(options2.transformTags, function(transform, tag) {
        let transFun;
        if (typeof transform === "function") {
          transFun = transform;
        } else if (typeof transform === "string") {
          transFun = sanitizeHtml2.simpleTransform(transform);
        }
        if (tag === "*") {
          transformTagsAll = transFun;
        } else {
          transformTagsMap[tag] = transFun;
        }
      });
      let depth;
      let stack;
      let skipMap;
      let transformMap;
      let skipText;
      let skipTextDepth;
      let addedText = false;
      initializeState();
      const parser = new htmlparser.Parser({
        onopentag: function(name, attribs) {
          if (options2.enforceHtmlBoundary && name === "html") {
            initializeState();
          }
          if (skipText) {
            skipTextDepth++;
            return;
          }
          const frame = new Frame(name, attribs);
          stack.push(frame);
          let skip = false;
          const hasText = !!frame.text;
          let transformedTag;
          if (has3(transformTagsMap, name)) {
            transformedTag = transformTagsMap[name](name, attribs);
            frame.attribs = attribs = transformedTag.attribs;
            if (transformedTag.text !== void 0) {
              frame.innerText = transformedTag.text;
            }
            if (name !== transformedTag.tagName) {
              frame.name = name = transformedTag.tagName;
              transformMap[depth] = transformedTag.tagName;
            }
          }
          if (transformTagsAll) {
            transformedTag = transformTagsAll(name, attribs);
            frame.attribs = attribs = transformedTag.attribs;
            if (name !== transformedTag.tagName) {
              frame.name = name = transformedTag.tagName;
              transformMap[depth] = transformedTag.tagName;
            }
          }
          if (!tagAllowed(name) || options2.disallowedTagsMode === "recursiveEscape" && !isEmptyObject(skipMap) || options2.nestingLimit != null && depth >= options2.nestingLimit) {
            skip = true;
            skipMap[depth] = true;
            if (options2.disallowedTagsMode === "discard") {
              if (nonTextTagsArray.indexOf(name) !== -1) {
                skipText = true;
                skipTextDepth = 1;
              }
            }
            skipMap[depth] = true;
          }
          depth++;
          if (skip) {
            if (options2.disallowedTagsMode === "discard") {
              return;
            }
            tempResult = result;
            result = "";
          }
          result += "<" + name;
          if (name === "script") {
            if (options2.allowedScriptHostnames || options2.allowedScriptDomains) {
              frame.innerText = "";
            }
          }
          if (!allowedAttributesMap || has3(allowedAttributesMap, name) || allowedAttributesMap["*"]) {
            each(attribs, function(value, a) {
              if (!VALID_HTML_ATTRIBUTE_NAME.test(a)) {
                delete frame.attribs[a];
                return;
              }
              let passedAllowedAttributesMapCheck = false;
              if (!allowedAttributesMap || has3(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap["*"] && allowedAttributesMap["*"].indexOf(a) !== -1 || has3(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap["*"] && allowedAttributesGlobMap["*"].test(a)) {
                passedAllowedAttributesMapCheck = true;
              } else if (allowedAttributesMap && allowedAttributesMap[name]) {
                for (const o of allowedAttributesMap[name]) {
                  if (isPlainObject(o) && o.name && o.name === a) {
                    passedAllowedAttributesMapCheck = true;
                    let newValue = "";
                    if (o.multiple === true) {
                      const splitStrArray = value.split(" ");
                      for (const s of splitStrArray) {
                        if (o.values.indexOf(s) !== -1) {
                          if (newValue === "") {
                            newValue = s;
                          } else {
                            newValue += " " + s;
                          }
                        }
                      }
                    } else if (o.values.indexOf(value) >= 0) {
                      newValue = value;
                    }
                    value = newValue;
                  }
                }
              }
              if (passedAllowedAttributesMapCheck) {
                if (options2.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
                  if (naughtyHref(name, value)) {
                    delete frame.attribs[a];
                    return;
                  }
                }
                if (name === "script" && a === "src") {
                  let allowed = true;
                  try {
                    const parsed = parseUrl(value);
                    if (options2.allowedScriptHostnames || options2.allowedScriptDomains) {
                      const allowedHostname = (options2.allowedScriptHostnames || []).find(function(hostname) {
                        return hostname === parsed.url.hostname;
                      });
                      const allowedDomain = (options2.allowedScriptDomains || []).find(function(domain) {
                        return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                      });
                      allowed = allowedHostname || allowedDomain;
                    }
                  } catch (e) {
                    allowed = false;
                  }
                  if (!allowed) {
                    delete frame.attribs[a];
                    return;
                  }
                }
                if (name === "iframe" && a === "src") {
                  let allowed = true;
                  try {
                    const parsed = parseUrl(value);
                    if (parsed.isRelativeUrl) {
                      allowed = has3(options2, "allowIframeRelativeUrls") ? options2.allowIframeRelativeUrls : !options2.allowedIframeHostnames && !options2.allowedIframeDomains;
                    } else if (options2.allowedIframeHostnames || options2.allowedIframeDomains) {
                      const allowedHostname = (options2.allowedIframeHostnames || []).find(function(hostname) {
                        return hostname === parsed.url.hostname;
                      });
                      const allowedDomain = (options2.allowedIframeDomains || []).find(function(domain) {
                        return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                      });
                      allowed = allowedHostname || allowedDomain;
                    }
                  } catch (e) {
                    allowed = false;
                  }
                  if (!allowed) {
                    delete frame.attribs[a];
                    return;
                  }
                }
                if (a === "srcset") {
                  try {
                    let parsed = parseSrcset(value);
                    parsed.forEach(function(value2) {
                      if (naughtyHref("srcset", value2.url)) {
                        value2.evil = true;
                      }
                    });
                    parsed = filter12(parsed, function(v) {
                      return !v.evil;
                    });
                    if (!parsed.length) {
                      delete frame.attribs[a];
                      return;
                    } else {
                      value = stringifySrcset(filter12(parsed, function(v) {
                        return !v.evil;
                      }));
                      frame.attribs[a] = value;
                    }
                  } catch (e) {
                    delete frame.attribs[a];
                    return;
                  }
                }
                if (a === "class") {
                  const allowedSpecificClasses = allowedClassesMap[name];
                  const allowedWildcardClasses = allowedClassesMap["*"];
                  const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
                  const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
                  const allowedWildcardClassesGlob = allowedClassesGlobMap["*"];
                  const allowedClassesGlobs = [
                    allowedSpecificClassesGlob,
                    allowedWildcardClassesGlob
                  ].concat(allowedSpecificClassesRegex).filter(function(t) {
                    return t;
                  });
                  if (allowedSpecificClasses && allowedWildcardClasses) {
                    value = filterClasses(value, deepmerge(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
                  } else {
                    value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
                  }
                  if (!value.length) {
                    delete frame.attribs[a];
                    return;
                  }
                }
                if (a === "style") {
                  if (options2.parseStyleAttributes) {
                    try {
                      const abstractSyntaxTree = postcssParse(name + " {" + value + "}");
                      const filteredAST = filterCss(abstractSyntaxTree, options2.allowedStyles);
                      value = stringifyStyleAttributes(filteredAST);
                      if (value.length === 0) {
                        delete frame.attribs[a];
                        return;
                      }
                    } catch (e) {
                      console.warn('Failed to parse "' + name + " {" + value + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`);
                      delete frame.attribs[a];
                      return;
                    }
                  } else if (options2.allowedStyles) {
                    throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
                  }
                }
                result += " " + a;
                if (value && value.length) {
                  result += '="' + escapeHtml(value, true) + '"';
                }
              } else {
                delete frame.attribs[a];
              }
            });
          }
          if (options2.selfClosing.indexOf(name) !== -1) {
            result += " />";
          } else {
            result += ">";
            if (frame.innerText && !hasText && !options2.textFilter) {
              result += escapeHtml(frame.innerText);
              addedText = true;
            }
          }
          if (skip) {
            result = tempResult + escapeHtml(result);
            tempResult = "";
          }
        },
        ontext: function(text) {
          if (skipText) {
            return;
          }
          const lastFrame = stack[stack.length - 1];
          let tag;
          if (lastFrame) {
            tag = lastFrame.tag;
            text = lastFrame.innerText !== void 0 ? lastFrame.innerText : text;
          }
          if (options2.disallowedTagsMode === "discard" && (tag === "script" || tag === "style")) {
            result += text;
          } else {
            const escaped = escapeHtml(text, false);
            if (options2.textFilter && !addedText) {
              result += options2.textFilter(escaped, tag);
            } else if (!addedText) {
              result += escaped;
            }
          }
          if (stack.length) {
            const frame = stack[stack.length - 1];
            frame.text += text;
          }
        },
        onclosetag: function(name, isImplied) {
          if (skipText) {
            skipTextDepth--;
            if (!skipTextDepth) {
              skipText = false;
            } else {
              return;
            }
          }
          const frame = stack.pop();
          if (!frame) {
            return;
          }
          if (frame.tag !== name) {
            stack.push(frame);
            return;
          }
          skipText = options2.enforceHtmlBoundary ? name === "html" : false;
          depth--;
          const skip = skipMap[depth];
          if (skip) {
            delete skipMap[depth];
            if (options2.disallowedTagsMode === "discard") {
              frame.updateParentNodeText();
              return;
            }
            tempResult = result;
            result = "";
          }
          if (transformMap[depth]) {
            name = transformMap[depth];
            delete transformMap[depth];
          }
          if (options2.exclusiveFilter && options2.exclusiveFilter(frame)) {
            result = result.substr(0, frame.tagPosition);
            return;
          }
          frame.updateParentNodeMediaChildren();
          frame.updateParentNodeText();
          if (
            // Already output />
            options2.selfClosing.indexOf(name) !== -1 || // Escaped tag, closing tag is implied
            isImplied && !tagAllowed(name) && ["escape", "recursiveEscape"].indexOf(options2.disallowedTagsMode) >= 0
          ) {
            if (skip) {
              result = tempResult;
              tempResult = "";
            }
            return;
          }
          result += "</" + name + ">";
          if (skip) {
            result = tempResult + escapeHtml(result);
            tempResult = "";
          }
          addedText = false;
        }
      }, options2.parser);
      parser.write(html2);
      parser.end();
      return result;
      function initializeState() {
        result = "";
        depth = 0;
        stack = [];
        skipMap = {};
        transformMap = {};
        skipText = false;
        skipTextDepth = 0;
      }
      function escapeHtml(s, quote) {
        if (typeof s !== "string") {
          s = s + "";
        }
        if (options2.parser.decodeEntities) {
          s = s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
          if (quote) {
            s = s.replace(/"/g, "&quot;");
          }
        }
        s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        if (quote) {
          s = s.replace(/"/g, "&quot;");
        }
        return s;
      }
      function naughtyHref(name, href) {
        href = href.replace(/[\x00-\x20]+/g, "");
        while (true) {
          const firstIndex = href.indexOf("<!--");
          if (firstIndex === -1) {
            break;
          }
          const lastIndex = href.indexOf("-->", firstIndex + 4);
          if (lastIndex === -1) {
            break;
          }
          href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
        }
        const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
        if (!matches) {
          if (href.match(/^[/\\]{2}/)) {
            return !options2.allowProtocolRelative;
          }
          return false;
        }
        const scheme = matches[1].toLowerCase();
        if (has3(options2.allowedSchemesByTag, name)) {
          return options2.allowedSchemesByTag[name].indexOf(scheme) === -1;
        }
        return !options2.allowedSchemes || options2.allowedSchemes.indexOf(scheme) === -1;
      }
      function parseUrl(value) {
        value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//");
        if (value.startsWith("relative:")) {
          throw new Error("relative: exploit attempt");
        }
        let base = "relative://relative-site";
        for (let i = 0; i < 100; i++) {
          base += `/${i}`;
        }
        const parsed = new URL(value, base);
        const isRelativeUrl = parsed && parsed.hostname === "relative-site" && parsed.protocol === "relative:";
        return {
          isRelativeUrl,
          url: parsed
        };
      }
      function filterCss(abstractSyntaxTree, allowedStyles) {
        if (!allowedStyles) {
          return abstractSyntaxTree;
        }
        const astRules = abstractSyntaxTree.nodes[0];
        let selectedRule;
        if (allowedStyles[astRules.selector] && allowedStyles["*"]) {
          selectedRule = deepmerge(
            allowedStyles[astRules.selector],
            allowedStyles["*"]
          );
        } else {
          selectedRule = allowedStyles[astRules.selector] || allowedStyles["*"];
        }
        if (selectedRule) {
          abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
        }
        return abstractSyntaxTree;
      }
      function stringifyStyleAttributes(filteredAST) {
        return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes, attrObject) {
          extractedAttributes.push(
            `${attrObject.prop}:${attrObject.value}${attrObject.important ? " !important" : ""}`
          );
          return extractedAttributes;
        }, []).join(";");
      }
      function filterDeclarations(selectedRule) {
        return function(allowedDeclarationsList, attributeObject) {
          if (has3(selectedRule, attributeObject.prop)) {
            const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
              return regularExpression.test(attributeObject.value);
            });
            if (matchesRegex) {
              allowedDeclarationsList.push(attributeObject);
            }
          }
          return allowedDeclarationsList;
        };
      }
      function filterClasses(classes, allowed, allowedGlobs) {
        if (!allowed) {
          return classes;
        }
        classes = classes.split(/\s+/);
        return classes.filter(function(clss) {
          return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
            return glob.test(clss);
          });
        }).join(" ");
      }
    }
    var htmlParserDefaults = {
      decodeEntities: true
    };
    sanitizeHtml2.defaults = {
      allowedTags: [
        // Sections derived from MDN element categories and limited to the more
        // benign categories.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
        // Content sectioning
        "address",
        "article",
        "aside",
        "footer",
        "header",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hgroup",
        "main",
        "nav",
        "section",
        // Text content
        "blockquote",
        "dd",
        "div",
        "dl",
        "dt",
        "figcaption",
        "figure",
        "hr",
        "li",
        "main",
        "ol",
        "p",
        "pre",
        "ul",
        // Inline text semantics
        "a",
        "abbr",
        "b",
        "bdi",
        "bdo",
        "br",
        "cite",
        "code",
        "data",
        "dfn",
        "em",
        "i",
        "kbd",
        "mark",
        "q",
        "rb",
        "rp",
        "rt",
        "rtc",
        "ruby",
        "s",
        "samp",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "time",
        "u",
        "var",
        "wbr",
        // Table content
        "caption",
        "col",
        "colgroup",
        "table",
        "tbody",
        "td",
        "tfoot",
        "th",
        "thead",
        "tr"
      ],
      disallowedTagsMode: "discard",
      allowedAttributes: {
        a: ["href", "name", "target"],
        // We don't currently allow img itself by default, but
        // these attributes would make sense if we did.
        img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
      },
      // Lots of these won't come up by default because we don't allow them
      selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
      // URL schemes we permit
      allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
      allowedSchemesByTag: {},
      allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
      allowProtocolRelative: true,
      enforceHtmlBoundary: false,
      parseStyleAttributes: true
    };
    sanitizeHtml2.simpleTransform = function(newTagName, newAttribs, merge) {
      merge = merge === void 0 ? true : merge;
      newAttribs = newAttribs || {};
      return function(tagName, attribs) {
        let attrib;
        if (merge) {
          for (attrib in newAttribs) {
            attribs[attrib] = newAttribs[attrib];
          }
        } else {
          attribs = newAttribs;
        }
        return {
          tagName: newTagName,
          attribs
        };
      };
    };
  }
});

// ../../node_modules/screenfull/dist/screenfull.js
var require_screenfull = __commonJS({
  "../../node_modules/screenfull/dist/screenfull.js"(exports, module) {
    (function() {
      "use strict";
      var document2 = typeof window !== "undefined" && typeof window.document !== "undefined" ? window.document : {};
      var isCommonjs = typeof module !== "undefined" && module.exports;
      var fn = function() {
        var val;
        var fnMap = [
          [
            "requestFullscreen",
            "exitFullscreen",
            "fullscreenElement",
            "fullscreenEnabled",
            "fullscreenchange",
            "fullscreenerror"
          ],
          // New WebKit
          [
            "webkitRequestFullscreen",
            "webkitExitFullscreen",
            "webkitFullscreenElement",
            "webkitFullscreenEnabled",
            "webkitfullscreenchange",
            "webkitfullscreenerror"
          ],
          // Old WebKit
          [
            "webkitRequestFullScreen",
            "webkitCancelFullScreen",
            "webkitCurrentFullScreenElement",
            "webkitCancelFullScreen",
            "webkitfullscreenchange",
            "webkitfullscreenerror"
          ],
          [
            "mozRequestFullScreen",
            "mozCancelFullScreen",
            "mozFullScreenElement",
            "mozFullScreenEnabled",
            "mozfullscreenchange",
            "mozfullscreenerror"
          ],
          [
            "msRequestFullscreen",
            "msExitFullscreen",
            "msFullscreenElement",
            "msFullscreenEnabled",
            "MSFullscreenChange",
            "MSFullscreenError"
          ]
        ];
        var i = 0;
        var l = fnMap.length;
        var ret = {};
        for (; i < l; i++) {
          val = fnMap[i];
          if (val && val[1] in document2) {
            for (i = 0; i < val.length; i++) {
              ret[fnMap[0][i]] = val[i];
            }
            return ret;
          }
        }
        return false;
      }();
      var eventNameMap = {
        change: fn.fullscreenchange,
        error: fn.fullscreenerror
      };
      var screenfull2 = {
        request: function(element, options2) {
          return new Promise(function(resolve, reject) {
            var onFullScreenEntered = function() {
              this.off("change", onFullScreenEntered);
              resolve();
            }.bind(this);
            this.on("change", onFullScreenEntered);
            element = element || document2.documentElement;
            var returnPromise = element[fn.requestFullscreen](options2);
            if (returnPromise instanceof Promise) {
              returnPromise.then(onFullScreenEntered).catch(reject);
            }
          }.bind(this));
        },
        exit: function() {
          return new Promise(function(resolve, reject) {
            if (!this.isFullscreen) {
              resolve();
              return;
            }
            var onFullScreenExit = function() {
              this.off("change", onFullScreenExit);
              resolve();
            }.bind(this);
            this.on("change", onFullScreenExit);
            var returnPromise = document2[fn.exitFullscreen]();
            if (returnPromise instanceof Promise) {
              returnPromise.then(onFullScreenExit).catch(reject);
            }
          }.bind(this));
        },
        toggle: function(element, options2) {
          return this.isFullscreen ? this.exit() : this.request(element, options2);
        },
        onchange: function(callback) {
          this.on("change", callback);
        },
        onerror: function(callback) {
          this.on("error", callback);
        },
        on: function(event2, callback) {
          var eventName = eventNameMap[event2];
          if (eventName) {
            document2.addEventListener(eventName, callback, false);
          }
        },
        off: function(event2, callback) {
          var eventName = eventNameMap[event2];
          if (eventName) {
            document2.removeEventListener(eventName, callback, false);
          }
        },
        raw: fn
      };
      if (!fn) {
        if (isCommonjs) {
          module.exports = { isEnabled: false };
        } else {
          window.screenfull = { isEnabled: false };
        }
        return;
      }
      Object.defineProperties(screenfull2, {
        isFullscreen: {
          get: function() {
            return Boolean(document2[fn.fullscreenElement]);
          }
        },
        element: {
          enumerable: true,
          get: function() {
            return document2[fn.fullscreenElement];
          }
        },
        isEnabled: {
          enumerable: true,
          get: function() {
            return Boolean(document2[fn.fullscreenEnabled]);
          }
        }
      });
      if (isCommonjs) {
        module.exports = screenfull2;
      } else {
        window.screenfull = screenfull2;
      }
    })();
  }
});

// src/common/GoogleStaticMap.tsx
import * as React from "react";
import { isEmpty as isEmpty2, partial, reduce } from "lodash-es";

// src/utils/constant.ts
var WidgetList = [
  "ic-sgb4-mandate-creator",
  "ic-sgb4-contact-creator",
  "ic-sgb4-contact-editor",
  "ic-sgb4-last-activities",
  "ic-sgb4-upcoming-meetings",
  "ic-sgb4-mandate-list",
  "ic-sgb4-light-contact-creator",
  "ic-sgb4-deals-status",
  "ic-sgb4-deals-breakdown",
  "ic-sgb4-deals-success-probability",
  "rsn-opportunities-list",
  "rsn-opportunity-details",
  "rsn-opportunity-modal-accept",
  "rsn-opportunity-modal-decline",
  "cli-chatmap-detailed-view",
  "sgr-emailing",
  "sgwt-web-analytics",
  "pdf-ic-tag-helper",
  "markeng-pdf-ic-tag-helper",
  // ic widgets v1
  "ic-contact-multi-picker",
  "ic-contact-single-picker",
  "ic-account-multi-picker",
  "ic-account-single-picker",
  "ic-college-multi-picker",
  "ic-user-single-picker",
  "ic-user-multi-picker",
  "ic-maestro-multi-picker",
  "ic-maestro-single-picker",
  "ic-country-multi-picker",
  "ic-country-single-picker",
  "ic-underlying-multi-picker",
  "ic-typology-single-picker",
  "ic-hashtag-multi-picker",
  "ic-person-contact-single-picker",
  "ic-person-contact-multi-picker",
  "ic-account-viewer",
  "ic-mandate-creator",
  "ic-mandate-list",
  "ic-person-contact-creator",
  "ic-person-contact-creator-modal",
  "ic-contact-creator",
  "ic-light-contact-creator",
  "ic-contact-editor",
  "ic-contact-quality",
  "ic-segmentation-single-picker",
  "ic-last-activities",
  "ic-power-tree-picker",
  "sgmarkets-request-access",
  "sgm-docs-document-viewer",
  "idy-request-access",
  "ic-client-team-viewer",
  "ic-work-positions",
  "sg-picker"
];
var urlWidgetType = [
  {
    widgetType: "sgidentity",
    urlProd: "https://shared.fr.world.socgen/sgidentity/v1",
    urlNotProd: "https://shared-uat.fr.world.socgen/sgidentity/v1"
  },
  {
    widgetType: "cprofit",
    urlProd: "https://clm-chatmap.azureedge.net",
    urlNotProd: "https://clm-chatmap-uat.azureedge.net"
  },
  {
    widgetType: "rsn",
    urlProd: "https://clm-bodifront.azureedge.net",
    urlNotProd: "https://clm-bodifront-uat.azureedge.net"
  },
  {
    widgetType: "sgr-request-access",
    urlProd: "https://shared.sgmarkets.com/sgr-widgets/sgmarkets-request-access",
    urlNotProd: "https://shared-uat.fr.world.socgen/sgr-widgets/sgmarkets-request-access"
  },
  {
    widgetType: "sgr",
    urlProd: "https://shared.sgmarkets.com/sgr-widgets/sgr-emailing",
    urlNotProd: "https://shared-uat.fr.world.socgen/sgr-widgets/sgr-emailing"
  },
  {
    widgetType: "ic-v1",
    urlProd: "https://shared.sgmarkets.com/ic-widgets/v1",
    urlNotProd: "https://shared-uat.sgmarkets.com/ic-widgets/v1"
  },
  {
    widgetType: "ic",
    urlProd: "https://ic-widgets.azureedge.net",
    urlNotProd: "https://ic-widgets-uat.azureedge.net"
  },
  {
    widgetType: "sgwt-analytics",
    urlProd: "https://sgwt-cdn-widgets.sgmarkets.com/widgets/sgwt-web-analytics/v4",
    urlNotProd: "https://sgwt-widgets-dev.sgmarkets.com/widgets/sgwt-web-analytics/v4"
  },
  {
    widgetType: "mark-eng-dat",
    urlProd: "https://shared.sgmarkets.com/mark-eng-dat-public/pdf-ic-tag-helper/0/esm/markeng-pdf-ic-tag-helper.js",
    urlNotProd: "https://shared-uat.sgmarkets.com/mark-eng-dat-public/pdf-ic-tag-helper/latest/esm/markeng-pdf-ic-tag-helper.js"
  },
  {
    widgetType: "sgwt-analytics",
    urlProd: "https://sgwt-cdn-widgets.sgmarkets.com/widgets/sgwt-web-analytics/v4",
    urlNotProd: "https://sgwt-widgets-dev.sgmarkets.com/widgets/sgwt-web-analytics/v4"
  },
  {
    widgetType: "sgmdocs",
    urlProd: "https://docs-widgets.sgmarkets.com/last",
    urlNotProd: "https://docs-widgets-uat.sgmarkets.com/last"
  }
];
var bulletCode = "\u2022";

// src/utils/urlUtils.ts
var import_qs = __toESM(require_lib());
import { get, isEmpty, isEqual, map } from "lodash-es";
var StringifyUrlOptions = { arrayFormat: "brackets", encode: true };
var ParseUrlOptions = { ignoreQueryPrefix: true };
var buildUrlWithQueryParams = (location, queryParams = {}, options2 = {}) => {
  const query = import_qs.default.stringify({ ...queryParams }, { ...StringifyUrlOptions, ...options2 });
  return `${location}?${query}`;
};
var parseUrlQueryString = (query, param, paramType = "string", defaultValue) => {
  const parsed = import_qs.default.parse(query, ParseUrlOptions);
  const value = get(parsed, param, void 0);
  if (isEmpty(value)) {
    return defaultValue;
  }
  switch (paramType) {
    case "string":
      return value;
    case "array":
      return typeof value === "string" ? value.split(",") : value;
    case "array-number":
      return typeof value === "string" ? map(value.split(","), (val) => parseInt(val, 10)) : parseInt(value, 10);
    case "boolean":
      return isEqual(value, "true");
    case "number":
      return parseInt(value, 10);
    default:
      return void 0;
  }
};

// src/utils/mapper.ts
var stringifyBoolean = (value) => {
  return value === true || value === false ? JSON.stringify(value) : void 0;
};

// src/utils/licenses.ts
var getGoogleMapsKey = () => {
  var _a;
  return (_a = window == null ? void 0 : window.gMapsLK) != null ? _a : "KEY_NOT_FOUND";
};
var getAgGridKey = () => {
  var _a;
  return (_a = window == null ? void 0 : window.agGridLK) != null ? _a : "KEY_NOT_FOUND";
};

// src/common/GoogleStaticMap.tsx
var STATIC_URL = "https://maps.googleapis.com/maps/api/staticmap?";
var NAVIGATE_URL = "https://www.google.fr/maps/place";
var getGoogleUrlsWithKey = (API_KEY, address, scale = 1, zoom = 14, width = 540, height = 220) => {
  var _a, _b;
  const label = `${(_a = address == null ? void 0 : address.street1) != null ? _a : ""},${(_b = address == null ? void 0 : address.city) != null ? _b : ""}`;
  const formattedAddress = formatAddress(address);
  return {
    formattedAddress,
    staticMapUrl: `${STATIC_URL}key=${API_KEY}&scale=${scale}&zoom=${zoom}&size=${width}x${height}&center=${formattedAddress}&markers=label:${label}|${formattedAddress}`,
    navigateToUrl: `${NAVIGATE_URL}/${formattedAddress}`
  };
};
var useGetGoogleUrls = () => {
  const API_KEY = React.useMemo(() => getGoogleMapsKey(), []);
  return partial(getGoogleUrlsWithKey, API_KEY);
};
var formatAddress = (address) => {
  if (!address) {
    return "";
  }
  const { street1 = "", city = "", zipCode = "", country = "" } = address;
  return reduce([street1, city, zipCode, country ? country.country || "" : ""], formatterAddress, "");
};
var formatterAddress = (current, next) => {
  if (isEmpty2(next)) {
    return current;
  }
  if (isEmpty2(current)) {
    return next;
  }
  return `${current}-${next}`;
};
var GoogleStaticMap = ({
  scale = 1,
  zoom = 14,
  width = 540,
  height = 220,
  containerClass = "",
  address,
  displayAddressLabel = true,
  mode = "desktop"
}) => {
  const getGoogleUrls = useGetGoogleUrls();
  if (!address) {
    return null;
  }
  const { formattedAddress, staticMapUrl, navigateToUrl } = getGoogleUrls(address, scale, zoom, width, height);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, mode === "desktop" && /* @__PURE__ */ React.createElement("div", { className: containerClass }, /* @__PURE__ */ React.createElement("a", { href: navigateToUrl, target: "_blank", rel: "noopener noreferrer", className: "border-bottom-0" }, /* @__PURE__ */ React.createElement("img", { alt: "google map", className: "img-fluid", src: staticMapUrl })), displayAddressLabel && /* @__PURE__ */ React.createElement("span", { className: "font-weight-500 text-secondary" }, /* @__PURE__ */ React.createElement("a", { href: navigateToUrl }, formattedAddress))), mode === "mobile" && /* @__PURE__ */ React.createElement("span", { className: "text-secondary font-weight-500" }, /* @__PURE__ */ React.createElement("a", { href: navigateToUrl }, formattedAddress)));
};

// src/common/LabelValueComponent.tsx
import * as React2 from "react";
var LabelValueComponent = ({
  label,
  spacing = "150px",
  children: children2,
  className = "",
  childrenClassName = ""
}) => /* @__PURE__ */ React2.createElement("div", { className: `d-flex ${className}` }, /* @__PURE__ */ React2.createElement("div", { className: "text-secondary", style: { minWidth: spacing } }, label), /* @__PURE__ */ React2.createElement("div", { className: childrenClassName }, children2));

// src/common/InfiniteList.tsx
import * as React3 from "react";
import { times } from "lodash-es";
var containerMarkupFromLayout = {
  Grid: "tbody",
  List: "div",
  UList: "ul"
};
var itemMarkupFromLayout = {
  Grid: "tr",
  List: "div",
  UList: "li"
};
var InfiniteList = ({
  renderRow,
  totalRows,
  className = "",
  rowsPerScroll = 50,
  layout = "Grid",
  fromIndexSelected,
  onRenderingRows
}) => {
  const [displayedRows, setDisplayedRows] = React3.useState();
  const [isLoading, setIsLoading] = React3.useState(false);
  const intersectionObserver = React3.useRef(null);
  React3.useEffect(() => {
    setDisplayedRows(rowsPerScroll);
    if (onRenderingRows) {
      onRenderingRows(0, rowsPerScroll);
    }
    return () => {
      var _a;
      return (_a = intersectionObserver == null ? void 0 : intersectionObserver.current) == null ? void 0 : _a.disconnect();
    };
  }, []);
  const loaderRefCallback = (newLoaderRef) => {
    var _a;
    if (isLoading) {
      return;
    }
    if (newLoaderRef === null) {
      (_a = intersectionObserver == null ? void 0 : intersectionObserver.current) == null ? void 0 : _a.disconnect();
      return;
    }
    if (intersectionObserver.current) {
      intersectionObserver.current.disconnect();
    }
    intersectionObserver.current = new IntersectionObserver(([entry]) => {
      if (fromIndexSelected && displayedRows && fromIndexSelected > displayedRows || (entry == null ? void 0 : entry.isIntersecting)) {
        setIsLoading(true);
        loadMore(fromIndexSelected);
        setIsLoading(false);
      }
    });
    if (newLoaderRef) {
      intersectionObserver.current.observe(newLoaderRef);
    }
  };
  const loadMore = (idxSelected) => {
    const nextStepIndex = displayedRows + rowsPerScroll;
    const fromIdx = idxSelected && idxSelected > displayedRows ? idxSelected : nextStepIndex;
    setDisplayedRows(Math.min(fromIdx, totalRows));
    if (onRenderingRows) {
      onRenderingRows(displayedRows, fromIdx);
    }
  };
  const children2 = /* @__PURE__ */ React3.createElement(React3.Fragment, null, times(displayedRows, renderRow), displayedRows < totalRows && // eslint-disable-next-line react/no-children-prop
  React3.createElement(itemMarkupFromLayout[layout].toString(), {
    className,
    children: /* @__PURE__ */ React3.createElement(React3.Fragment, null, "Loading..."),
    ref: loaderRefCallback
  }));
  return React3.createElement(containerMarkupFromLayout[layout].toString(), { className, children: children2 });
};

// src/common/CheckboxCard.tsx
import * as React4 from "react";
import { noop } from "lodash-es";
var CheckboxCard = ({ onChange = noop, id: id2, checked = false, disabled, containerClass }) => {
  const [checkedState, toggle] = React4.useState(checked);
  React4.useEffect(() => {
    toggle(checked);
  }, [checked]);
  const handleOnChange = () => {
    const newCheckedState = !checkedState;
    toggle(newCheckedState);
    onChange(newCheckedState);
  };
  return /* @__PURE__ */ React4.createElement("div", { className: `custom-control custom-checkbox custom-control-info d-none d-sm-block ${containerClass}` }, /* @__PURE__ */ React4.createElement(
    "input",
    {
      id: id2,
      "data-testid": id2,
      className: "custom-control-input",
      type: "checkbox",
      checked: checkedState,
      disabled,
      onChange: handleOnChange
    }
  ), /* @__PURE__ */ React4.createElement("label", { className: "custom-control-label", htmlFor: id2 }));
};

// src/common/NavigationCard/NavigationCard.tsx
import * as React6 from "react";
import { Dropdown } from "@sgbs-ui/core";

// src/common/Icon/Icon.tsx
import { join, noop as noop2 } from "lodash-es";
import * as React5 from "react";
var generateIconClassName = (size6, className) => join(["icon", size6 ? `icon-${size6}` : "", className || ""], " ").trim();
var Icon = ({ iconName, size: size6, className, onClick = noop2 }) => /* @__PURE__ */ React5.createElement("i", { className: generateIconClassName(size6, className), onClick }, iconName);

// src/common/NavigationCard/NavigationCard.tsx
import { isEmpty as isEmpty3 } from "lodash-es";
import { classNames } from "@ic-anywhere/ic-utils";
var NavigationCard = ({
  title,
  description,
  children: children2,
  cardActions = { type: "items", items: [] },
  cardSize = "md",
  height,
  width,
  className = "",
  titleDescription,
  cardTitleclassName = "justify-content-between"
}) => {
  return /* @__PURE__ */ React6.createElement("div", { className: classNames("card card-bordered", className), style: { height, width } }, /* @__PURE__ */ React6.createElement("div", { className: `card-body card-${cardSize} d-flex flex-column` }, /* @__PURE__ */ React6.createElement("div", { className: `card-title d-flex flex-shrink-0 ${cardTitleclassName}` }, title && /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement("div", { className: "d-flex align-items-center" }, /* @__PURE__ */ React6.createElement("h2", { className: "d-inline mb-0" }, title), titleDescription && /* @__PURE__ */ React6.createElement(React6.Fragment, null, titleDescription))), cardActions.type === "items" ? !isEmpty3(cardActions.items) && /* @__PURE__ */ React6.createElement(
    Dropdown,
    {
      label: /* @__PURE__ */ React6.createElement(Icon, { iconName: "more_vert", size: "lg" }),
      items: cardActions.items,
      className: "d-inline-flex",
      type: "flat-secondary",
      size: "lg",
      direction: "down",
      disableDefaultIcon: true
    }
  ) : cardActions.items), description && /* @__PURE__ */ React6.createElement("pre", { className: "card-text" }, description), /* @__PURE__ */ React6.createElement("div", { style: { overflowY: "auto" } }, children2)));
};

// src/common/AppliedFilters.tsx
import * as React7 from "react";
import { find, isEmpty as isEmpty4, map as map2 } from "lodash-es";
import { Badge } from "@sgbs-ui/core";
function Tags({ onClose, tags }) {
  const handleClose = (tagId) => {
    const tag = find(tags, ({ id: id2 }) => id2.toString() === tagId);
    onClose(tag);
  };
  return /* @__PURE__ */ React7.createElement(React7.Fragment, null, map2(tags, ({ id: id2, name }, key) => /* @__PURE__ */ React7.createElement("div", { key, className: "mb-1 d-inline-block" }, /* @__PURE__ */ React7.createElement(
    Badge,
    {
      id: id2.toString(),
      closable: true,
      onClose: handleClose,
      text: name,
      color: "info",
      badgeType: "discreet",
      className: "mr-1"
    }
  ))));
}
var AppliedFilters = ({
  onClose,
  onClear,
  tags,
  containerClass
}) => !isEmpty4(tags) ? /* @__PURE__ */ React7.createElement("div", { className: containerClass }, /* @__PURE__ */ React7.createElement("span", { className: "font-weight-500 mr-2" }, "Applied filters"), /* @__PURE__ */ React7.createElement(Tags, { tags, onClose }), onClear && /* @__PURE__ */ React7.createElement("a", { className: "ml-2 text-secondary font-weight-500 cursor action", onClick: onClear }, "Clear")) : null;

// src/common/SearchNoResult.tsx
import * as React8 from "react";
import { noop as noop3 } from "lodash-es";
import { Button } from "@sgbs-ui/core";
var SearchNoResult = ({
  rootClassName,
  containerClassName,
  title,
  actionName,
  actionButtonClassName,
  icon,
  content,
  size: size6 = "lg",
  onAction = noop3,
  style = { maxWidth: "320px" }
}) => /* @__PURE__ */ React8.createElement("div", { className: rootClassName }, /* @__PURE__ */ React8.createElement("div", { className: `container text-center text-secondary ${containerClassName}`, style }, icon && /* @__PURE__ */ React8.createElement("i", { className: `icon icon-xl d-inline-block` }, icon), /* @__PURE__ */ React8.createElement("h4", { className: "mb-1" }, title), /* @__PURE__ */ React8.createElement("span", null, content), /* @__PURE__ */ React8.createElement("div", { className: actionButtonClassName }, actionName && /* @__PURE__ */ React8.createElement(Button, { btnType: "outline", color: "secondary", className: "mt-3", size: size6, onClick: onAction }, actionName))));

// src/common/FormGroup.tsx
import * as React9 from "react";
var FormGroup = ({
  label,
  labelClass = "",
  containerClass = "",
  id: id2,
  display = true,
  isOptional = false,
  tooltip = void 0,
  children: children2
}) => {
  return display ? /* @__PURE__ */ React9.createElement("div", { className: `form-group ${containerClass}` }, label ? /* @__PURE__ */ React9.createElement("label", { className: `text-secondary ${labelClass}`, ...id2 ? { htmlFor: id2 } : {} }, label, isOptional ? " (optional)" : "", tooltip) : null, children2) : null;
};

// src/common/BulletSeparator.tsx
import * as React10 from "react";
var BulletSeparator = ({
  hidden = false,
  className = "",
  textColor = "primary",
  fontWeight = "normal"
}) => !hidden ? /* @__PURE__ */ React10.createElement("span", { className: `mr-1 text-${textColor} font-weight-${fontWeight} ${className}`.trim() }, "\u2022") : null;

// src/common/NoRecord.tsx
import * as React11 from "react";
var NoRecord = ({ message, reason, icon = "folder_shared", isSmall = false }) => /* @__PURE__ */ React11.createElement("div", { className: `container text-center text-secondary ${!isSmall ? "my-5" : ""}` }, /* @__PURE__ */ React11.createElement("div", { className: "mb-2" }, /* @__PURE__ */ React11.createElement("i", { className: "icon icon-xl" }, icon)), /* @__PURE__ */ React11.createElement("div", null, message && /* @__PURE__ */ React11.createElement("h4", null, " ", message, " "), reason && /* @__PURE__ */ React11.createElement("p", { className: "m-0" }, reason)));

// src/common/ButtonLinkDropDown.tsx
import { head, isEmpty as isEmpty5, map as map3 } from "lodash-es";
import * as React12 from "react";
var ButtonLinkDropDown = ({
  onClick,
  isDropDownPositionRight = true,
  initValue,
  items,
  disabled = false
}) => {
  const [buttonLabel, setButtonLabel] = React12.useState(initValue != null ? initValue : head(items));
  const handleAction = (item) => {
    setButtonLabel(item);
    onClick == null ? void 0 : onClick(item);
  };
  const disabledValue = disabled ? { disabled: true } : {};
  return isEmpty5(items) ? null : /* @__PURE__ */ React12.createElement("div", { className: "btn-group btn-group-lg" }, /* @__PURE__ */ React12.createElement("button", { className: "btn btn-flat-secondary dropdown-toggle", "data-toggle": "dropdown", ...disabledValue }, buttonLabel), /* @__PURE__ */ React12.createElement("div", { className: `dropdown-menu ${isDropDownPositionRight ? "dropdown-menu-right" : ""}` }, map3(items, (item, index) => /* @__PURE__ */ React12.createElement("span", { key: index, className: "dropdown-item action", onClick: () => handleAction(item) }, item))));
};

// src/common/IconSpinner.tsx
import * as React13 from "react";
var IconSpinner = ({ size: size6 = "md", className = "" }) => /* @__PURE__ */ React13.createElement(
  "svg",
  {
    className: `spinner spinner-${size6} ${className}`,
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React13.createElement("circle", { className: "spinner-circle", fill: "none", strokeWidth: "6", strokeLinecap: "round", cx: "33", cy: "33", r: "30" })
);

// src/common/Select/SelectDropDown.tsx
import { isEmpty as isEmpty6, noop as noop4 } from "lodash-es";
import * as React17 from "react";
import { classNames as classNames2 } from "@ic-anywhere/ic-utils";

// src/common/Select/ClearButton.tsx
import * as React14 from "react";
var ClearButton = ({ className = "", onClick }) => {
  return /* @__PURE__ */ React14.createElement("button", { type: "button", className: `btn btn-link p-0 pointer ${className}`, onClick }, "Clear");
};
var ClearButton_default = ClearButton;

// src/common/Select/ToggleDropDownButton.tsx
import * as React15 from "react";
var ToggleDropDownButton = ({
  isDropDownShown,
  onClick,
  size: size6 = "md"
}) => /* @__PURE__ */ React15.createElement("button", { type: "button", className: "btn btn-link p-0", onClick }, /* @__PURE__ */ React15.createElement(Icon, { iconName: isDropDownShown ? "arrow_drop_up" : "arrow_drop_down", size: size6, className: "pointer" }));

// src/hooks/useDropDownState.ts
import * as React16 from "react";
var useDropdownState = (ref, initialValue = false) => {
  const [isDropDownShown, toggleDropdown] = React16.useState(initialValue);
  const onWindowsClick = (event2) => {
    if (!ref || !ref.current) {
      return;
    }
    if (!ref.current.contains(event2.target)) {
      toggleDropdown(false);
    }
  };
  const onEscKey = (event2) => {
    if (event2.key === "Escape") {
      toggleDropdown(false);
    }
  };
  React16.useEffect(() => toggleDropdown(initialValue), [initialValue]);
  React16.useEffect(() => {
    document.body.addEventListener("click", onWindowsClick);
    return () => document.body.removeEventListener("click", onWindowsClick);
  }, []);
  React16.useEffect(() => {
    window.addEventListener("keyup", onEscKey);
    return () => window.removeEventListener("keyup", onEscKey);
  }, []);
  return [isDropDownShown, toggleDropdown];
};

// src/common/Select/SelectDropDown.tsx
var SelectDropDown = ({
  iconName,
  classes = "",
  size: size6 = "md",
  displayedText = "",
  children: children2 = null,
  isDropDownShown = false,
  onToggleDropDown = noop4,
  withOverflow,
  placeHolder = "",
  onClear = noop4,
  selectedItemsCount = 0
}) => {
  const ref = React17.useRef(null);
  const [isDropDownShownState, setToggleDropdown] = useDropdownState(ref, isDropDownShown);
  const [displayedTextState, setDisplayedTextState] = React17.useState(displayedText);
  const handleOnInputClick = () => setToggleDropdown(!isDropDownShownState);
  React17.useEffect(() => onToggleDropDown(isDropDownShownState), [isDropDownShownState]);
  React17.useEffect(() => setDisplayedTextState(displayedText), [displayedText]);
  return /* @__PURE__ */ React17.createElement("div", { ref, className: classNames2(`input-group input-group-${size6}`, classes) }, iconName && /* @__PURE__ */ React17.createElement("div", { className: "input-group-prepend input-group-merged" }, /* @__PURE__ */ React17.createElement(Icon, { iconName, className: "text-secondary" })), !isEmpty6(children2) && /* @__PURE__ */ React17.createElement("div", { className: "input-group-append input-group-merged right4" }, selectedItemsCount > 0 && /* @__PURE__ */ React17.createElement(ClearButton_default, { onClick: onClear, className: "text-medium" }), /* @__PURE__ */ React17.createElement(ToggleDropDownButton, { isDropDownShown: isDropDownShownState, size: size6, onClick: handleOnInputClick })), /* @__PURE__ */ React17.createElement(
    "input",
    {
      type: "text",
      className: `form-control form-control-${size6} ignore-read-only-style`,
      readOnly: true,
      value: displayedTextState,
      onClick: handleOnInputClick,
      placeholder: placeHolder
    }
  ), isDropDownShownState && /* @__PURE__ */ React17.createElement("div", { className: `card card-dropdown shadow-lg ${withOverflow ? "card-dropdown-overflow" : ""}` }, /* @__PURE__ */ React17.createElement("div", { className: "card-body p-0 text-medium" }, children2)));
};

// src/common/MultiSelectDateFilter/MultiSelectDateFilter.tsx
import * as React29 from "react";
import { isEqual as isEqual2, map as map5 } from "lodash-es";

// src/common/MultiSelectDateFilter/MultiSelectDateFilter.logic.ts
import { DateFilterEnum, DateFilterEnumExtended } from "@ic-anywhere/ic-dal";
import {
  farFuture,
  lastMonth,
  lastWeek,
  lastYear,
  today,
  last6Months,
  last3Months
} from "@ic-anywhere/ic-utils";
var DATE_FILTERS = [
  DateFilterEnum.Upcoming,
  DateFilterEnum.FromLastYear,
  DateFilterEnum.Past,
  DateFilterEnum.All,
  DateFilterEnum.CustomRange
];
var MY_FEED_DATE_FILTERS = [
  DateFilterEnum.FromLastYear,
  DateFilterEnum.FromLastMonth,
  DateFilterEnum.FromLastWeek,
  DateFilterEnum.CustomRange
];
var USER_MONITORING_FILTERS = [
  DateFilterEnum.FromLastYear,
  DateFilterEnum.FromLast6Months,
  DateFilterEnum.FromLast3Months
];
var ACTION_PLAN_FILTERS = [
  DateFilterEnum.Upcoming,
  DateFilterEnum.FromLast3Months,
  DateFilterEnum.FromLast6Months,
  DateFilterEnum.CustomRange
];
var DEFAULT_DATE_FILTERS = [
  DateFilterEnum.Upcoming,
  DateFilterEnum.FromLastYear,
  DateFilterEnum.FromLast6Months,
  DateFilterEnum.FromLastMonth,
  DateFilterEnum.FromLastWeek,
  DateFilterEnum.CustomRange
];
var COMMERCIAL_TREE_DATE_FILTERS = [
  DateFilterEnum.UpcomingFixed,
  DateFilterEnum.FromLastYearFixed,
  DateFilterEnumExtended.FromLastMonthFixed,
  DateFilterEnumExtended.FromLastWeekFixed,
  DateFilterEnum.CustomRange
];
var UPCOMING_DATE_RANGE = { start: today().stringFormat, end: null };
var UPCOMING_DATE_RANGE_FIXED = {
  start: today().stringFormat,
  end: farFuture().stringFormat
};
var FROM_LAST_YEAR_DATE_RANGE = { start: lastYear().stringFormat, end: null };
var FROM_LAST_YEAR_DATE_RANGE_FIXED = {
  start: lastYear().stringFormat,
  end: farFuture().stringFormat
};
var FROM_LAST_MONTH_DATE_RANGE = { start: lastMonth().stringFormat, end: null };
var FROM_LAST_MONTH_DATE_RANGE_FIXED = {
  start: lastMonth().stringFormat,
  end: farFuture().stringFormat
};
var FROM_LAST_WEEK_DATE_RANGE = { start: lastWeek().stringFormat, end: null };
var FROM_LAST_WEEK_DATE_RANGE_FIXED = {
  start: lastWeek().stringFormat,
  end: farFuture().stringFormat
};
var FROM_LAST_6_MONTHS_RANGE = {
  start: last6Months().stringFormat,
  end: null
};
var FROM_LAST_3_MONTHS_RANGE = {
  start: last3Months().stringFormat,
  end: null
};
var PAST_DATE_RANGE = { start: null, end: today().stringFormat };
var ALL_DATE_RANGE = { start: null, end: null };
var getRangeByDateFilterType = (dateFilterEnum) => {
  switch (dateFilterEnum) {
    case DateFilterEnum.Upcoming:
      return UPCOMING_DATE_RANGE;
    case DateFilterEnum.UpcomingFixed:
      return UPCOMING_DATE_RANGE_FIXED;
    case DateFilterEnum.FromLastYear:
      return FROM_LAST_YEAR_DATE_RANGE;
    case DateFilterEnum.FromLastYearFixed:
      return FROM_LAST_YEAR_DATE_RANGE_FIXED;
    case DateFilterEnum.Past:
      return PAST_DATE_RANGE;
    case DateFilterEnum.All:
      return ALL_DATE_RANGE;
    case DateFilterEnum.FromLastMonth:
      return FROM_LAST_MONTH_DATE_RANGE;
    case DateFilterEnum.FromLastWeek:
      return FROM_LAST_WEEK_DATE_RANGE;
    case DateFilterEnumExtended.FromLastMonthFixed:
      return FROM_LAST_MONTH_DATE_RANGE_FIXED;
    case DateFilterEnumExtended.FromLastWeekFixed:
      return FROM_LAST_WEEK_DATE_RANGE_FIXED;
    case DateFilterEnum.FromLast6Months:
      return FROM_LAST_6_MONTHS_RANGE;
    case DateFilterEnum.FromLast3Months:
      return FROM_LAST_3_MONTHS_RANGE;
    default:
      return null;
  }
};

// src/common/MultiSelectDateFilter/CustomRange.tsx
import * as React28 from "react";
import { get as get4 } from "lodash-es";
import { Button as Button2 } from "@sgbs-ui/core";

// src/common/Form/DateRangePickerValidationForm.tsx
import { isDateAfter, isStringEmpty } from "@ic-anywhere/ic-utils";
import * as React27 from "react";

// src/common/Form/DateRangePickerForm.tsx
import * as React26 from "react";

// src/common/TimerPicker/TimePicker.tsx
import * as React19 from "react";
import { range } from "lodash-es";

// src/common/TimerPicker/TimePickerAutocomplete.tsx
import * as React18 from "react";
import { get as get2, map as map4 } from "lodash-es";
var TimePickerAutocomplete = ({ rangeHours, onClick, customClass = "" }) => {
  const handleSelectHour = (event2) => {
    onClick(get2(event2, "target.innerText", ""));
  };
  return /* @__PURE__ */ React18.createElement(
    "div",
    {
      className: `card card-combobox shadow-lg position-absolute zindex-autocomplete ${customClass}`,
      style: { right: 0, top: 34 }
    },
    /* @__PURE__ */ React18.createElement("div", { className: "card-body p-0" }, /* @__PURE__ */ React18.createElement("div", { className: "content-row" }, /* @__PURE__ */ React18.createElement("div", { className: "content-col px-0 col-12" }, /* @__PURE__ */ React18.createElement("div", { className: "list-group" }, map4(rangeHours, (hour) => /* @__PURE__ */ React18.createElement(
      "div",
      {
        id: `${hour}`,
        key: hour,
        onClick: handleSelectHour,
        className: "py-1 pl-2 list-group-item list-group-item-action pointer"
      },
      /* @__PURE__ */ React18.createElement("div", { className: "text-primary" }, hour < 10 ? `0${hour}` : hour, ":00")
    ))))))
  );
};
var TimePickerAutocomplete_default = TimePickerAutocomplete;

// src/common/TimerPicker/TimePicker.tsx
var defaultDisplayHour = "00:00";
var validTime = /^((([0-1]?[0-9])|(2[0-3])):[0-5][0-9])?$/;
var validateInput = (input) => RegExp(validTime).test(input);
var TimePicker = ({
  inputValue,
  timeStart,
  timeEnd,
  onChange,
  step = 1,
  customClass = "",
  size: size6 = "large"
}) => {
  const rangeHours = range(timeStart, timeEnd, step);
  const [displayAutocomplete, setDisplayAutocomplete] = React19.useState(false);
  const [selectedHour, setSelectedHour] = React19.useState(inputValue || "");
  const handleButtonClick = () => {
    setDisplayAutocomplete(!displayAutocomplete);
  };
  const handleSelectHour = (displayHour) => {
    setSelectedHour(displayHour);
    handleButtonClick();
    onChange(displayHour);
  };
  const handleOnChange = (event2) => {
    setSelectedHour(event2.target.value);
  };
  const handleOnBlur = () => {
    const isInputValid = validateInput(selectedHour);
    if (!isInputValid) {
      setSelectedHour(defaultDisplayHour);
    }
    onChange(isInputValid ? selectedHour : defaultDisplayHour);
  };
  React19.useEffect(() => {
    setSelectedHour(inputValue || "");
  }, [inputValue]);
  return /* @__PURE__ */ React19.createElement("div", { className: `input-group ${customClass} ${size6 === "large" ? "input-group-lg" : ""}` }, /* @__PURE__ */ React19.createElement("div", { className: "input-group-append input-group-merged" }, /* @__PURE__ */ React19.createElement(
    "button",
    {
      className: "btn btn-xl btn-flat-primary dropdown-toggle dropdown-caret-secondary ",
      type: "button",
      onClick: handleButtonClick
    }
  )), /* @__PURE__ */ React19.createElement(
    "input",
    {
      type: "search",
      className: `form-control ${size6 === "large" ? "form-control-lg" : ""}`,
      placeholder: "hh:mm",
      value: selectedHour,
      onChange: handleOnChange,
      onBlur: handleOnBlur
    }
  ), displayAutocomplete && /* @__PURE__ */ React19.createElement(TimePickerAutocomplete_default, { rangeHours, onClick: handleSelectHour, customClass }));
};

// src/common/DatePicker/DatePicker.tsx
import { noop as noop6 } from "lodash-es";
import * as React21 from "react";

// src/common/DatePicker/SgwtDatePicker.tsx
import { get as get3, noop as noop5 } from "lodash-es";
import * as React20 from "react";
var defaultDateFormat = "DD MMM YYYY";
var dateFormatIso = "YYYY-MM-DD";
var SgwtDatePicker = ({
  name,
  dateFormat = dateFormatIso,
  displayDateFormat = defaultDateFormat,
  type = "all",
  value,
  onChange = noop5,
  disabled,
  isLarge = false
}) => {
  const ref = React20.useRef(null);
  const onSelectionDateChanged = React20.useCallback(
    (event2) => {
      const selectedDate = get3(event2, "detail.value", null);
      onChange(selectedDate);
    },
    [onChange]
  );
  React20.useEffect(() => {
    const cur = ref.current;
    if (cur) {
      cur.addEventListener("sgwt-datetime-picker--datetime-updated", onSelectionDateChanged);
    }
    return () => cur == null ? void 0 : cur.removeEventListener("sgwt-datetime-picker--datetime-updated", onSelectionDateChanged);
  }, [onSelectionDateChanged]);
  return /* @__PURE__ */ React20.createElement(
    "sgwt-datetime-picker",
    {
      class: isLarge ? "dtp-lg" : "",
      disabled: disabled ? "true" : void 0,
      ref,
      "date-format": dateFormat,
      "display-date-format": displayDateFormat,
      type,
      keyName: name,
      value
    }
  );
};

// src/common/DatePicker/DatePicker.tsx
var DatePicker = ({
  name,
  value,
  type = "date",
  onChange = noop6,
  displayDateFormat = "DD/MM/YYYY",
  dateFormat = "YYYY-MM-DD"
}) => {
  return /* @__PURE__ */ React21.createElement(
    SgwtDatePicker,
    {
      value,
      name,
      onChange,
      type,
      dateFormat,
      displayDateFormat
    }
  );
};

// src/common/Form/InvalidFeedback.tsx
import * as React22 from "react";
var InvalidFeedback = ({ errorMessage, errorType = "danger" }) => /* @__PURE__ */ React22.createElement("div", { className: errorType === "danger" ? "invalid-feedback" : "warning-feedback", style: { display: "block" } }, (errorMessage == null ? void 0 : errorMessage.toString()) || "Error");
var getErrorClass = (inError, errorType = "danger") => {
  const errorTypeToDisplay = errorType === "danger" ? "is-invalid" : "is-warning";
  return inError === void 0 || inError === false ? "" : errorTypeToDisplay;
};

// src/common/Form/ReadOnlyDateRangePickerForm.tsx
import * as React24 from "react";

// src/common/Form/Fields/ReadOnlyInputLabelField.tsx
import * as React23 from "react";
var ReadOnlyInputLabelField = ({
  id: id2,
  label,
  labelClass,
  value = "",
  suffix,
  containerClass
}) => /* @__PURE__ */ React23.createElement(FormGroup, { containerClass: containerClass ? containerClass : "", labelClass, label, id: id2 }, /* @__PURE__ */ React23.createElement("div", { className: "input-group" }, /* @__PURE__ */ React23.createElement("input", { type: "input", id: id2, value: value || "", className: "form-control", readOnly: true }), suffix && /* @__PURE__ */ React23.createElement("div", { className: "input-group-append" }, /* @__PURE__ */ React23.createElement("span", { className: "input-group-text" }, suffix))));

// src/common/Form/ReadOnlyDateRangePickerForm.tsx
import { defaultLuxonDateTimeFormatAMPM, toDisplayedDate } from "@ic-anywhere/ic-utils";
var ReadOnlyDateRangePickerForm = ({ firstDate, secondDate }) => {
  return /* @__PURE__ */ React24.createElement(React24.Fragment, null, /* @__PURE__ */ React24.createElement(
    ReadOnlyInputLabelField,
    {
      value: toDisplayedDate(firstDate, defaultLuxonDateTimeFormatAMPM),
      label: "Start Date",
      containerClass: "col-4",
      id: "startDate",
      labelClass: "text-secondary"
    }
  ), /* @__PURE__ */ React24.createElement(
    ReadOnlyInputLabelField,
    {
      value: toDisplayedDate(secondDate, defaultLuxonDateTimeFormatAMPM),
      label: "End Date",
      containerClass: "col-4",
      id: "endDate",
      labelClass: "text-secondary"
    }
  ));
};
var ReadOnlyDateRangePickerForm_default = ReadOnlyDateRangePickerForm;

// src/common/Form/DateRangePickerForm.tsx
import { noop as noop7 } from "lodash-es";

// src/common/TimerPicker/SgTimePicker.tsx
import { range as range2 } from "lodash-es";
import * as React25 from "react";
var SgTimePicker = ({ onChange, value = "", timeStart, timeEnd, stepMinute = 15, size: size6 }) => {
  const ref = React25.useRef(null);
  const rangeHours = range2(timeStart, timeEnd, 1);
  const onSelectionTimeChanged = React25.useCallback(
    (event2) => {
      if (!event2.detail) {
        return;
      }
      const [hour, minute] = event2.detail.time.split(":");
      const time = `${hour}:${minute ? minute : "00"}`;
      onChange(time);
    },
    [onChange]
  );
  React25.useEffect(() => {
    const current = ref.current;
    if (current) {
      current.addEventListener("timeSelected", onSelectionTimeChanged);
    }
    return () => {
      current == null ? void 0 : current.removeEventListener("timeSelected", onSelectionTimeChanged);
    };
  }, [onSelectionTimeChanged]);
  return /* @__PURE__ */ React25.createElement(
    "sg-timepicker",
    {
      size: size6,
      "available-hours": JSON.stringify(rangeHours),
      ref,
      value,
      "minute-step": stepMinute,
      "no-clear-button": true
    }
  );
};

// src/common/Form/DateRangePickerForm.tsx
var DateRangePickerForm = ({
  firstDate,
  secondDate,
  firstTime,
  secondTime,
  labelFrom,
  labelTo,
  onFirstDateChange,
  onFirstTimeChange,
  onSecondDateChange,
  onSecondTimeChange,
  inError,
  errorMessage,
  datePickerType = "all",
  disabled = false,
  className = "col-auto",
  isSgTimePicker = false
}) => {
  const displayTime = datePickerType === "all";
  return /* @__PURE__ */ React26.createElement(React26.Fragment, null, disabled ? /* @__PURE__ */ React26.createElement(
    ReadOnlyDateRangePickerForm_default,
    {
      firstDate: `${firstDate}T${firstTime}`,
      secondDate: `${secondDate}T${secondTime}`
    }
  ) : /* @__PURE__ */ React26.createElement(React26.Fragment, null, /* @__PURE__ */ React26.createElement(FormGroup, { label: labelFrom, containerClass: `${className} mr-2`, labelClass: "text-secondary", id: "firstDate" }, /* @__PURE__ */ React26.createElement(React26.Fragment, null, /* @__PURE__ */ React26.createElement(DatePicker, { value: firstDate || "", name: "firstDate", onChange: onFirstDateChange, type: "date" }), inError && /* @__PURE__ */ React26.createElement(InvalidFeedback, { errorMessage, errorType: "danger" }))), displayTime && /* @__PURE__ */ React26.createElement(React26.Fragment, null, isSgTimePicker ? /* @__PURE__ */ React26.createElement(FormGroup, { label: "Start time", labelClass: "invisible", containerClass: "mr-2" }, /* @__PURE__ */ React26.createElement(SgTimePicker, { value: firstTime, timeStart: 0, timeEnd: 24, onChange: onFirstTimeChange || noop7 })) : /* @__PURE__ */ React26.createElement(FormGroup, { label: "Start time", labelClass: "invisible", containerClass: `mr-2 mtXsN5` }, /* @__PURE__ */ React26.createElement(
    TimePicker,
    {
      inputValue: firstTime,
      timeStart: 9,
      timeEnd: 19,
      onChange: onFirstTimeChange || noop7,
      customClass: "timePickerWidth",
      size: "normal"
    }
  ))), /* @__PURE__ */ React26.createElement(FormGroup, { label: labelTo, containerClass: `${className} mr-2`, labelClass: "text-secondary", id: "secondDate" }, /* @__PURE__ */ React26.createElement(DatePicker, { value: secondDate || "", name: "secondDate", onChange: onSecondDateChange || noop7, type: "date" })), displayTime && /* @__PURE__ */ React26.createElement(React26.Fragment, null, isSgTimePicker ? /* @__PURE__ */ React26.createElement(FormGroup, { label: "End time", labelClass: "invisible", containerClass: "mr-2" }, /* @__PURE__ */ React26.createElement(SgTimePicker, { value: secondTime, timeStart: 0, timeEnd: 24, onChange: onSecondTimeChange || noop7 })) : /* @__PURE__ */ React26.createElement(FormGroup, { label: "End time", labelClass: "invisible", containerClass: "mtXsN5" }, /* @__PURE__ */ React26.createElement(
    TimePicker,
    {
      inputValue: secondTime,
      timeStart: 9,
      timeEnd: 19,
      customClass: "timePickerWidth",
      onChange: onSecondTimeChange || noop7,
      size: "normal"
    }
  )))));
};

// src/common/Form/DateRangePickerValidationForm.tsx
var DateRangePickerValidationForm = ({
  className,
  datePickerType = "date",
  labelFrom = "From",
  labelTo = "To",
  firstDate: initFirstDate,
  secondDate: initSecondDate,
  onChange
}) => {
  const [errorMessage, setErrorMessage] = React27.useState();
  const [firstDate, setFirstDate] = React27.useState(initFirstDate);
  const [secondDate, setSecondDate] = React27.useState(initSecondDate);
  React27.useEffect(() => setFirstDate(initFirstDate), [initFirstDate]);
  React27.useEffect(() => setSecondDate(initSecondDate), [initSecondDate]);
  React27.useEffect(() => {
    const validationMessage = validateDateRange(firstDate, secondDate);
    setErrorMessage(validationMessage);
    onChange(firstDate || "", secondDate || "", !validationMessage);
  }, [firstDate, secondDate]);
  const handleChangeFirstDate = (date) => {
    setFirstDate(date);
  };
  const handleChangeSecondDate = (date) => {
    setSecondDate(date);
  };
  return /* @__PURE__ */ React27.createElement("div", { className }, /* @__PURE__ */ React27.createElement(
    DateRangePickerForm,
    {
      labelFrom,
      firstDate,
      labelTo,
      secondDate,
      applyDateConversion: true,
      onFirstDateChange: handleChangeFirstDate,
      datePickerType,
      onSecondDateChange: handleChangeSecondDate
    }
  ), /* @__PURE__ */ React27.createElement(FormGroup, { containerClass: "col-auto", display: errorMessage != null }, /* @__PURE__ */ React27.createElement("span", { className: "text-small text-danger" }, errorMessage)));
};
var validateDateRange = (firstDate, secondDate) => (!isStringEmpty(firstDate != null ? firstDate : void 0) || !isStringEmpty(secondDate != null ? secondDate : void 0)) && isDateAfter(firstDate, secondDate) ? "The start date must be before the end date" : null;

// src/common/MultiSelectDateFilter/CustomRange.tsx
var CustomRange = ({ dateRange: initDateRange, onCustomRangeSelection, onGoBack }) => {
  const [dateRange, setDateRange] = React28.useState(initDateRange);
  const [isValid, setIsValid] = React28.useState(true);
  React28.useEffect(() => setDateRange(initDateRange), [initDateRange]);
  const handleOnChange = (start, end, valid) => {
    setIsValid(valid);
    setDateRange({ start, end });
  };
  const handleSubmit = () => onCustomRangeSelection(dateRange);
  return /* @__PURE__ */ React28.createElement("div", { className: "m-2", "data-testid": "CustomRangeContainer" }, /* @__PURE__ */ React28.createElement(
    Button2,
    {
      btnType: "flat",
      color: "secondary",
      text: "Back",
      icon: "arrow_back",
      iconPosition: "left",
      className: "d-flex",
      onClick: onGoBack
    }
  ), /* @__PURE__ */ React28.createElement(
    DateRangePickerValidationForm,
    {
      className: "mt-2",
      datePickerType: "date",
      firstDate: get4(dateRange, "start"),
      secondDate: get4(dateRange, "end"),
      onChange: handleOnChange
    }
  ), /* @__PURE__ */ React28.createElement("div", { className: "m-2 float-right" }, /* @__PURE__ */ React28.createElement("button", { className: "btn btn-flat-primary", onClick: handleSubmit, disabled: !isValid }, "Apply")));
};

// src/common/MultiSelectDateFilter/MultiSelectDateFilter.tsx
import { DateFilterEnum as DateFilterEnum2 } from "@ic-anywhere/ic-dal";
import { formatDateRange, isStringEqual } from "@ic-anywhere/ic-utils";
var MultiSelectDateFilter = ({
  onSelectionChange,
  dateRangeFilter,
  size: size6,
  filterLabels = DATE_FILTERS,
  isWhiteBg = true,
  defaultDateType = DateFilterEnum2.FromLastYear
}) => {
  const [selectedPeriod, setSelectedPeriod] = React29.useState(dateRangeFilter);
  const [isDropDownShown, toggleDropDown] = React29.useState(false);
  React29.useEffect(() => {
    const { dateRange, type } = dateRangeFilter;
    if (!isEqual2(selectedPeriod.dateRange, dateRange) || selectedPeriod.type !== type) {
      setSelectedPeriod(dateRangeFilter);
    }
  }, [dateRangeFilter]);
  const updateSelectedPeriodAndFireChange = (period) => {
    setSelectedPeriod(period);
    onSelectionChange(period);
  };
  const handleSelectionChange = (type) => {
    if (!type) {
      return;
    }
    if (isStringEqual(type, DateFilterEnum2.CustomRange)) {
      setSelectedPeriod({ type, dateRange: dateRangeFilter.dateRange });
    } else {
      const dateRange = getRangeByDateFilterType(type);
      if (dateRange) {
        toggleDropDown(false);
        updateSelectedPeriodAndFireChange({ type, dateRange });
      }
    }
  };
  const handleCustomRangeSelection = (dateRange) => {
    let period;
    if (!dateRange.start && !dateRange.end) {
      period = { type: DateFilterEnum2.All, dateRange: ALL_DATE_RANGE };
    } else {
      period = { type: DateFilterEnum2.CustomRange, dateRange };
    }
    updateSelectedPeriodAndFireChange(period);
    toggleDropDown(false);
  };
  const handleGoBack = () => {
    handleSelectionChange(defaultDateType);
    setSelectedPeriod({ type: DateFilterEnum2.FromLastYear, dateRange: FROM_LAST_YEAR_DATE_RANGE });
  };
  const displayedText = isStringEqual(selectedPeriod.type, DateFilterEnum2.CustomRange) ? formatDateRange(selectedPeriod.dateRange) : selectedPeriod.type;
  return /* @__PURE__ */ React29.createElement(
    SelectDropDown,
    {
      iconName: "event",
      displayedText,
      onToggleDropDown: toggleDropDown,
      isDropDownShown,
      size: size6,
      classes: isWhiteBg ? "not-bg-white" : ""
    },
    selectedPeriod.type === DateFilterEnum2.CustomRange ? /* @__PURE__ */ React29.createElement(
      CustomRange,
      {
        dateRange: selectedPeriod.dateRange,
        onGoBack: handleGoBack,
        onCustomRangeSelection: handleCustomRangeSelection
      }
    ) : map5(filterLabels, (label) => /* @__PURE__ */ React29.createElement(
      "div",
      {
        key: label,
        className: "list-group-item list-group-item-action pointer",
        onClick: () => handleSelectionChange(label)
      },
      label
    ))
  );
};

// src/common/Badges/A2DStatusBadge.tsx
import * as React30 from "react";
import { Badge as Badge2 } from "@sgbs-ui/core";
import { isStringEqual as isStringEqual2 } from "@ic-anywhere/ic-utils";
var A2DStatusBadge = ({
  a2dStatus,
  displayOnlyRedStatus = false,
  children: children2,
  className = ""
}) => {
  if (!a2dStatus) {
    return null;
  }
  if (displayOnlyRedStatus) {
    return isStringEqual2(a2dStatus, "red") ? /* @__PURE__ */ React30.createElement(Badge2, { pill: true, badgeType: "discreet", color: "danger", className, text: "!" }) : null;
  }
  const color = a2dStatus === "Red" ? "danger" : a2dStatus === "Green" ? "success" : "warning";
  return /* @__PURE__ */ React30.createElement(Badge2, { pill: true, badgeType: "discreet", color, text: a2dStatus, className }, children2 ? /* @__PURE__ */ React30.createElement(React30.Fragment, null, a2dStatus, " ", children2) : null);
};

// src/common/ToggleButtons/ToggleButtons.tsx
import { map as map6, noop as noop8, some } from "lodash-es";
import * as React31 from "react";
import { Button as Button3 } from "@sgbs-ui/core";
import { isStringEmpty as isStringEmpty2, isStringEqual as isStringEqual3 } from "@ic-anywhere/ic-utils";
var ToggleButtons = ({
  buttons,
  initialValue = "",
  initialValues = [],
  onChange = noop8,
  onChangeWithMultiSelection = noop8,
  isMultipleSelection = false,
  size: size6 = "md",
  classes = ""
}) => {
  const [currentValue, setCurrentValue] = React31.useState(initialValue);
  const [currentValues, setCurrentValues] = React31.useState(initialValues);
  const [buttonsSelected, setButtonsSelected] = React31.useState(map6(buttons, () => false));
  const [firstRender, setFirstRender] = React31.useState(false);
  React31.useEffect(() => {
    if (!firstRender) {
      onChange(currentValue);
    }
    setFirstRender(false);
  }, [currentValue]);
  React31.useEffect(() => {
    if (!firstRender) {
      onChangeWithMultiSelection(currentValues);
    }
    setFirstRender(false);
  }, [currentValues]);
  const handleOnChange = (value, buttonIndex) => {
    const selectedButtons = map6(
      buttonsSelected,
      (buttonSelected, buttonSelectedIndex) => buttonSelectedIndex === buttonIndex ? !buttonsSelected[buttonIndex] : buttonSelected
    );
    setButtonsSelected(selectedButtons);
    if (!isMultipleSelection) {
      if (!isStringEqual3(currentValue, value)) {
        setCurrentValue(value);
      }
    } else {
      const selectedValues = map6(buttons, (button, index) => selectedButtons[index] ? button.value : "");
      if (some(selectedValues, (selectedValue) => !isStringEmpty2(selectedValue))) {
        setCurrentValues(selectedValues);
      } else {
        setCurrentValues([]);
      }
    }
  };
  return /* @__PURE__ */ React31.createElement("div", { className: `btn-group btn-group-toggle btn-group-${size6} ${classes}`, role: "group" }, map6(buttons, ({ value, label, icon }, index) => {
    const activeClass = isStringEqual3(currentValue, value) || isMultipleSelection && buttonsSelected[index] ? "active" : "";
    const marginClass = isMultipleSelection ? "mr-1" : "";
    return /* @__PURE__ */ React31.createElement(
      Button3,
      {
        key: index,
        btnType: "toggle",
        icon,
        iconPosition: "left",
        text: label,
        className: `${activeClass} ${marginClass}`,
        onClick: () => handleOnChange(value, index)
      }
    );
  }));
};

// src/common/Tooltip.tsx
import * as React33 from "react";

// ../../node_modules/react-tooltip/dist/index.es.js
var import_prop_types = __toESM(require_prop_types());
import React32 from "react";

// ../../node_modules/react-tooltip/node_modules/uuid/dist/esm-browser/rng.js
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  }
  return getRandomValues(rnds8);
}

// ../../node_modules/react-tooltip/node_modules/uuid/dist/esm-browser/bytesToUuid.js
var byteToHex = [];
for (i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 256).toString(16).substr(1);
}
var i;
function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], "-", bth[buf[i++]], bth[buf[i++]], "-", bth[buf[i++]], bth[buf[i++]], "-", bth[buf[i++]], bth[buf[i++]], "-", bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join("");
}
var bytesToUuid_default = bytesToUuid;

// ../../node_modules/react-tooltip/node_modules/uuid/dist/esm-browser/v4.js
function v4(options2, buf, offset) {
  var i = buf && offset || 0;
  if (typeof options2 == "string") {
    buf = options2 === "binary" ? new Array(16) : null;
    options2 = null;
  }
  options2 = options2 || {};
  var rnds = options2.random || (options2.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }
  return buf || bytesToUuid_default(rnds);
}
var v4_default = v4;

// ../../node_modules/react-tooltip/dist/index.es.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor2 = props[i];
    descriptor2.enumerable = descriptor2.enumerable || false;
    descriptor2.configurable = true;
    if ("value" in descriptor2)
      descriptor2.writable = true;
    Object.defineProperty(target, descriptor2.key, descriptor2);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys4 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn(self2, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self2);
}
var CONSTANT = {
  GLOBAL: {
    HIDE: "__react_tooltip_hide_event",
    REBUILD: "__react_tooltip_rebuild_event",
    SHOW: "__react_tooltip_show_event"
  }
};
var dispatchGlobalEvent = function dispatchGlobalEvent2(eventName, opts) {
  var event2;
  if (typeof window.CustomEvent === "function") {
    event2 = new window.CustomEvent(eventName, {
      detail: opts
    });
  } else {
    event2 = document.createEvent("Event");
    event2.initEvent(eventName, false, true, opts);
  }
  window.dispatchEvent(event2);
};
function staticMethods(target) {
  target.hide = function(target2) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
      target: target2
    });
  };
  target.rebuild = function() {
    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
  };
  target.show = function(target2) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
      target: target2
    });
  };
  target.prototype.globalRebuild = function() {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };
  target.prototype.globalShow = function(event2) {
    if (this.mount) {
      var hasTarget = event2 && event2.detail && event2.detail.target && true || false;
      this.showTooltip({
        currentTarget: hasTarget && event2.detail.target
      }, true);
    }
  };
  target.prototype.globalHide = function(event2) {
    if (this.mount) {
      var hasTarget = event2 && event2.detail && event2.detail.target && true || false;
      this.hideTooltip({
        currentTarget: hasTarget && event2.detail.target
      }, hasTarget);
    }
  };
}
function windowListener(target) {
  target.prototype.bindWindowEvents = function(resizeHide) {
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false);
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false);
    if (resizeHide) {
      window.removeEventListener("resize", this.onWindowResize);
      window.addEventListener("resize", this.onWindowResize, false);
    }
  };
  target.prototype.unbindWindowEvents = function() {
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener("resize", this.onWindowResize);
  };
  target.prototype.onWindowResize = function() {
    if (!this.mount)
      return;
    this.hideTooltip();
  };
}
var checkStatus = function checkStatus2(dataEventOff, e) {
  var show = this.state.show;
  var id2 = this.props.id;
  var isCapture2 = this.isCapture(e.currentTarget);
  var currentItem = e.currentTarget.getAttribute("currentItem");
  if (!isCapture2)
    e.stopPropagation();
  if (show && currentItem === "true") {
    if (!dataEventOff)
      this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute("currentItem", "true");
    setUntargetItems(e.currentTarget, this.getTargetArray(id2));
    this.showTooltip(e);
  }
};
var setUntargetItems = function setUntargetItems2(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute("currentItem", "false");
    } else {
      targetArray[i].setAttribute("currentItem", "true");
    }
  }
};
var customListeners = {
  id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
  set: function set(target, event2, listener) {
    if (this.id in target) {
      var map36 = target[this.id];
      map36[event2] = listener;
    } else {
      Object.defineProperty(target, this.id, {
        configurable: true,
        value: _defineProperty({}, event2, listener)
      });
    }
  },
  get: function get5(target, event2) {
    var map36 = target[this.id];
    if (map36 !== void 0) {
      return map36[event2];
    }
  }
};
function customEvent(target) {
  target.prototype.isCustomEvent = function(ele) {
    var event2 = this.state.event;
    return event2 || !!ele.getAttribute("data-event");
  };
  target.prototype.customBindListener = function(ele) {
    var _this = this;
    var _this$state = this.state, event2 = _this$state.event, eventOff = _this$state.eventOff;
    var dataEvent = ele.getAttribute("data-event") || event2;
    var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
    dataEvent.split(" ").forEach(function(event3) {
      ele.removeEventListener(event3, customListeners.get(ele, event3));
      var customListener = checkStatus.bind(_this, dataEventOff);
      customListeners.set(ele, event3, customListener);
      ele.addEventListener(event3, customListener, false);
    });
    if (dataEventOff) {
      dataEventOff.split(" ").forEach(function(event3) {
        ele.removeEventListener(event3, _this.hideTooltip);
        ele.addEventListener(event3, _this.hideTooltip, false);
      });
    }
  };
  target.prototype.customUnbindListener = function(ele) {
    var _this$state2 = this.state, event2 = _this$state2.event, eventOff = _this$state2.eventOff;
    var dataEvent = event2 || ele.getAttribute("data-event");
    var dataEventOff = eventOff || ele.getAttribute("data-event-off");
    ele.removeEventListener(dataEvent, customListeners.get(ele, event2));
    if (dataEventOff)
      ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
}
function isCapture(target) {
  target.prototype.isCapture = function(currentTarget) {
    return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
  };
}
function getEffect(target) {
  target.prototype.getEffect = function(currentTarget) {
    var dataEffect = currentTarget.getAttribute("data-effect");
    return dataEffect || this.props.effect || "float";
  };
}
var makeProxy = function makeProxy2(e) {
  var proxy = {};
  for (var key in e) {
    if (typeof e[key] === "function") {
      proxy[key] = e[key].bind(e);
    } else {
      proxy[key] = e[key];
    }
  }
  return proxy;
};
var bodyListener = function bodyListener2(callback, options2, e) {
  var _options$respectEffec = options2.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options2.customEvent, customEvent2 = _options$customEvent === void 0 ? false : _options$customEvent;
  var id2 = this.props.id;
  var tip = e.target.getAttribute("data-tip") || null;
  var forId = e.target.getAttribute("data-for") || null;
  var target = e.target;
  if (this.isCustomEvent(target) && !customEvent2) {
    return;
  }
  var isTargetBelongsToTooltip = id2 == null && forId == null || forId === id2;
  if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
    var proxy = makeProxy(e);
    proxy.currentTarget = target;
    callback(proxy);
  }
};
var findCustomEvents = function findCustomEvents2(targetArray, dataAttribute) {
  var events = {};
  targetArray.forEach(function(target) {
    var event2 = target.getAttribute(dataAttribute);
    if (event2)
      event2.split(" ").forEach(function(event3) {
        return events[event3] = true;
      });
  });
  return events;
};
var getBody = function getBody2() {
  return document.getElementsByTagName("body")[0];
};
function bodyMode(target) {
  target.prototype.isBodyMode = function() {
    return !!this.props.bodyMode;
  };
  target.prototype.bindBodyListener = function(targetArray) {
    var _this = this;
    var _this$state = this.state, event2 = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
    var body = getBody();
    var customEvents = findCustomEvents(targetArray, "data-event");
    var customEventsOff = findCustomEvents(targetArray, "data-event-off");
    if (event2 != null)
      customEvents[event2] = true;
    if (eventOff != null)
      customEventsOff[eventOff] = true;
    possibleCustomEvents.split(" ").forEach(function(event3) {
      return customEvents[event3] = true;
    });
    possibleCustomEventsOff.split(" ").forEach(function(event3) {
      return customEventsOff[event3] = true;
    });
    this.unbindBodyListener(body);
    var listeners = this.bodyModeListeners = {};
    if (event2 == null) {
      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
        respectEffect: true
      });
      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
    }
    for (var _event in customEvents) {
      listeners[_event] = bodyListener.bind(this, function(e) {
        var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
        checkStatus.call(_this, targetEventOff, e);
      }, {
        customEvent: true
      });
    }
    for (var _event2 in customEventsOff) {
      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
        customEvent: true
      });
    }
    for (var _event3 in listeners) {
      body.addEventListener(_event3, listeners[_event3]);
    }
  };
  target.prototype.unbindBodyListener = function(body) {
    body = body || getBody();
    var listeners = this.bodyModeListeners;
    for (var event2 in listeners) {
      body.removeEventListener(event2, listeners[event2]);
    }
  };
}
var getMutationObserverClass = function getMutationObserverClass2() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function trackRemoval(target) {
  target.prototype.bindRemovalTracker = function() {
    var _this = this;
    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null)
      return;
    var observer = new MutationObserver(function(mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];
        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];
          if (element === _this.state.currentTarget) {
            _this.hideTooltip();
            return;
          }
        }
      }
    });
    observer.observe(window.document, {
      childList: true,
      subtree: true
    });
    this.removalTracker = observer;
  };
  target.prototype.unbindRemovalTracker = function() {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
}
function getPosition(e, target, node, place, desiredPlace, effect, offset) {
  var _getDimensions = getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
  var _getDimensions2 = getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
  var _getCurrentOffset = getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
  var _calculateOffset = calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;
  var _getParent = getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft;
  var getTipOffsetLeft = function getTipOffsetLeft2(place2) {
    var offsetX = defaultOffset[place2].l;
    return mouseX + offsetX + extraOffsetX;
  };
  var getTipOffsetRight = function getTipOffsetRight2(place2) {
    var offsetX = defaultOffset[place2].r;
    return mouseX + offsetX + extraOffsetX;
  };
  var getTipOffsetTop = function getTipOffsetTop2(place2) {
    var offsetY = defaultOffset[place2].t;
    return mouseY + offsetY + extraOffsetY;
  };
  var getTipOffsetBottom = function getTipOffsetBottom2(place2) {
    var offsetY = defaultOffset[place2].b;
    return mouseY + offsetY + extraOffsetY;
  };
  var outsideLeft = function outsideLeft2(p2) {
    return getTipOffsetLeft(p2) < 0;
  };
  var outsideRight = function outsideRight2(p2) {
    return getTipOffsetRight(p2) > windowWidth;
  };
  var outsideTop = function outsideTop2(p2) {
    return getTipOffsetTop(p2) < 0;
  };
  var outsideBottom = function outsideBottom2(p2) {
    return getTipOffsetBottom(p2) > windowHeight;
  };
  var outside = function outside2(p2) {
    return outsideLeft(p2) || outsideRight(p2) || outsideTop(p2) || outsideBottom(p2);
  };
  var inside = function inside2(p2) {
    return !outside(p2);
  };
  var placesList = ["top", "bottom", "left", "right"];
  var insideList = [];
  for (var i = 0; i < 4; i++) {
    var p = placesList[i];
    if (inside(p)) {
      insideList.push(p);
    }
  }
  var isNewState = false;
  var newPlace;
  var shouldUpdatePlace = desiredPlace !== place;
  if (inside(desiredPlace) && shouldUpdatePlace) {
    isNewState = true;
    newPlace = desiredPlace;
  } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
    isNewState = true;
    newPlace = insideList[0];
  }
  if (isNewState) {
    return {
      isNewState: true,
      newState: {
        place: newPlace
      }
    };
  }
  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
}
var getDimensions = function getDimensions2(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
  return {
    height: parseInt(height, 10),
    width: parseInt(width, 10)
  };
};
var getCurrentOffset = function getCurrentOffset2(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;
  var _getDimensions3 = getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
  if (effect === "float") {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }
  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
};
var getDefaultPosition = function getDefaultPosition2(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top;
  var right;
  var bottom;
  var left;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12;
  if (effect === "float") {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === "solid") {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }
  return {
    top,
    bottom,
    left,
    right
  };
};
var calculateOffset = function calculateOffset2(offset) {
  var extraOffsetX = 0;
  var extraOffsetY = 0;
  if (Object.prototype.toString.apply(offset) === "[object String]") {
    offset = JSON.parse(offset.toString().replace(/'/g, '"'));
  }
  for (var key in offset) {
    if (key === "top") {
      extraOffsetY -= parseInt(offset[key], 10);
    } else if (key === "bottom") {
      extraOffsetY += parseInt(offset[key], 10);
    } else if (key === "left") {
      extraOffsetX -= parseInt(offset[key], 10);
    } else if (key === "right") {
      extraOffsetX += parseInt(offset[key], 10);
    }
  }
  return {
    extraOffsetX,
    extraOffsetY
  };
};
var getParent = function getParent2(currentTarget) {
  var currentParent = currentTarget;
  while (currentParent) {
    var computedStyle = window.getComputedStyle(currentParent);
    if (computedStyle.getPropertyValue("transform") !== "none" || computedStyle.getPropertyValue("will-change") === "transform")
      break;
    currentParent = currentParent.parentElement;
  }
  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
  return {
    parentTop,
    parentLeft
  };
};
function getTipContent(tip, children2, getContent, multiline) {
  if (children2)
    return children2;
  if (getContent !== void 0 && getContent !== null)
    return getContent;
  if (getContent === null)
    return null;
  var regexp = /<br\s*\/?>/;
  if (!multiline || multiline === "false" || !regexp.test(tip)) {
    return tip;
  }
  return tip.split(regexp).map(function(d, i) {
    return React32.createElement("span", {
      key: i,
      className: "multi-line"
    }, d);
  });
}
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function(prop) {
    return /(^aria-\w+$|^role$)/.test(prop);
  }).forEach(function(prop) {
    ariaObj[prop] = props[prop];
  });
  return ariaObj;
}
function nodeListToArray(nodeList) {
  var length = nodeList.length;
  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }
  return new Array(length).fill().map(function(index) {
    return nodeList[index];
  });
}
function generateUUID() {
  return "t" + v4_default();
}
var baseCss = '.__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: "";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}';
var defaultColors = {
  dark: {
    text: "#fff",
    background: "#222",
    border: "transparent",
    arrow: "#222"
  },
  success: {
    text: "#fff",
    background: "#8DC572",
    border: "transparent",
    arrow: "#8DC572"
  },
  warning: {
    text: "#fff",
    background: "#F0AD4E",
    border: "transparent",
    arrow: "#F0AD4E"
  },
  error: {
    text: "#fff",
    background: "#BE6464",
    border: "transparent",
    arrow: "#BE6464"
  },
  info: {
    text: "#fff",
    background: "#337AB7",
    border: "transparent",
    arrow: "#337AB7"
  },
  light: {
    text: "#222",
    background: "#fff",
    border: "transparent",
    arrow: "#fff"
  }
};
function getDefaultPopupColors(type) {
  return defaultColors[type] ? _objectSpread2({}, defaultColors[type]) : void 0;
}
function generateTooltipStyle(uuid, customColors, type, hasBorder) {
  return generateStyle(uuid, getPopupColors(customColors, type, hasBorder));
}
function generateStyle(uuid, colors) {
  var textColor = colors.text;
  var backgroundColor = colors.background;
  var borderColor = colors.border;
  var arrowColor = colors.arrow;
  return "\n  	.".concat(uuid, " {\n	    color: ").concat(textColor, ";\n	    background: ").concat(backgroundColor, ";\n	    border: 1px solid ").concat(borderColor, ";\n  	}\n\n  	.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        border-top: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-top::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-top-color: ").concat(arrowColor, ";\n        border-top-style: solid;\n        border-top-width: 6px;\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        border-bottom: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-bottom::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-bottom-color: ").concat(arrowColor, ";\n        border-bottom-style: solid;\n        border-bottom-width: 6px;\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        border-left: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-left::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-left-color: ").concat(arrowColor, ";\n        border-left-style: solid;\n        border-left-width: 6px;\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        border-right: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-right::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-right-color: ").concat(arrowColor, ";\n        border-right-style: solid;\n        border-right-width: 6px;\n    }\n  ");
}
function getPopupColors(customColors, type, hasBorder) {
  var textColor = customColors.text;
  var backgroundColor = customColors.background;
  var borderColor = customColors.border;
  var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
  var colors = getDefaultPopupColors(type);
  if (textColor) {
    colors.text = textColor;
  }
  if (backgroundColor) {
    colors.background = backgroundColor;
  }
  if (hasBorder) {
    if (borderColor) {
      colors.border = borderColor;
    } else {
      colors.border = type === "light" ? "black" : "white";
    }
  }
  if (arrowColor) {
    colors.arrow = arrowColor;
  }
  return colors;
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function createCommonjsModule(fn, module) {
  return module = { exports: {} }, fn(module, module.exports), module.exports;
}
var check = function(it) {
  return it && it.Math == Math && it;
};
var global_1 = (
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == "object" && self) || check(typeof commonjsGlobal == "object" && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Function("return this")()
);
var fails = function(exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};
var descriptors = !fails(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
});
var $propertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);
var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor2 = getOwnPropertyDescriptor(this, V);
  return !!descriptor2 && descriptor2.enumerable;
} : $propertyIsEnumerable;
var objectPropertyIsEnumerable = {
  f
};
var createPropertyDescriptor = function(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value
  };
};
var toString = {}.toString;
var classofRaw = function(it) {
  return toString.call(it).slice(8, -1);
};
var split = "".split;
var indexedObject = fails(function() {
  return !Object("z").propertyIsEnumerable(0);
}) ? function(it) {
  return classofRaw(it) == "String" ? split.call(it, "") : Object(it);
} : Object;
var requireObjectCoercible = function(it) {
  if (it == void 0)
    throw TypeError("Can't call method on " + it);
  return it;
};
var toIndexedObject = function(it) {
  return indexedObject(requireObjectCoercible(it));
};
var isObject = function(it) {
  return typeof it === "object" ? it !== null : typeof it === "function";
};
var toPrimitive = function(input, PREFERRED_STRING) {
  if (!isObject(input))
    return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == "function" && !isObject(val = fn.call(input)))
    return val;
  if (typeof (fn = input.valueOf) == "function" && !isObject(val = fn.call(input)))
    return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == "function" && !isObject(val = fn.call(input)))
    return val;
  throw TypeError("Can't convert object to primitive value");
};
var toObject = function(argument) {
  return Object(requireObjectCoercible(argument));
};
var hasOwnProperty = {}.hasOwnProperty;
var has = function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};
var document$1 = global_1.document;
var EXISTS = isObject(document$1) && isObject(document$1.createElement);
var documentCreateElement = function(it) {
  return EXISTS ? document$1.createElement(it) : {};
};
var ie8DomDefine = !descriptors && !fails(function() {
  return Object.defineProperty(documentCreateElement("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
});
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var f$1 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor2(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine)
    try {
      return $getOwnPropertyDescriptor(O, P);
    } catch (error) {
    }
  if (has(O, P))
    return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};
var objectGetOwnPropertyDescriptor = {
  f: f$1
};
var anObject = function(it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + " is not an object");
  }
  return it;
};
var $defineProperty = Object.defineProperty;
var f$2 = descriptors ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine)
    try {
      return $defineProperty(O, P, Attributes);
    } catch (error) {
    }
  if ("get" in Attributes || "set" in Attributes)
    throw TypeError("Accessors not supported");
  if ("value" in Attributes)
    O[P] = Attributes.value;
  return O;
};
var objectDefineProperty = {
  f: f$2
};
var createNonEnumerableProperty = descriptors ? function(object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function(object, key, value) {
  object[key] = value;
  return object;
};
var setGlobal = function(key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  }
  return value;
};
var SHARED = "__core-js_shared__";
var store = global_1[SHARED] || setGlobal(SHARED, {});
var sharedStore = store;
var functionToString = Function.toString;
if (typeof sharedStore.inspectSource != "function") {
  sharedStore.inspectSource = function(it) {
    return functionToString.call(it);
  };
}
var inspectSource = sharedStore.inspectSource;
var WeakMap2 = global_1.WeakMap;
var nativeWeakMap = typeof WeakMap2 === "function" && /native code/.test(inspectSource(WeakMap2));
var shared = createCommonjsModule(function(module) {
  (module.exports = function(key, value) {
    return sharedStore[key] || (sharedStore[key] = value !== void 0 ? value : {});
  })("versions", []).push({
    version: "3.12.1",
    mode: "global",
    copyright: "\xA9 2021 Denis Pushkarev (zloirock.ru)"
  });
});
var id = 0;
var postfix = Math.random();
var uid = function(key) {
  return "Symbol(" + String(key === void 0 ? "" : key) + ")_" + (++id + postfix).toString(36);
};
var keys = shared("keys");
var sharedKey = function(key) {
  return keys[key] || (keys[key] = uid(key));
};
var hiddenKeys = {};
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var WeakMap$1 = global_1.WeakMap;
var set2;
var get6;
var has$1;
var enforce = function(it) {
  return has$1(it) ? get6(it) : set2(it, {});
};
var getterFor = function(TYPE2) {
  return function(it) {
    var state;
    if (!isObject(it) || (state = get6(it)).type !== TYPE2) {
      throw TypeError("Incompatible receiver, " + TYPE2 + " required");
    }
    return state;
  };
};
if (nativeWeakMap || sharedStore.state) {
  store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1());
  wmget = store$1.get;
  wmhas = store$1.has;
  wmset = store$1.set;
  set2 = function(it, metadata) {
    if (wmhas.call(store$1, it))
      throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get6 = function(it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function(it) {
    return wmhas.call(store$1, it);
  };
} else {
  STATE = sharedKey("state");
  hiddenKeys[STATE] = true;
  set2 = function(it, metadata) {
    if (has(it, STATE))
      throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get6 = function(it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function(it) {
    return has(it, STATE);
  };
}
var store$1;
var wmget;
var wmhas;
var wmset;
var STATE;
var internalState = {
  set: set2,
  get: get6,
  has: has$1,
  enforce,
  getterFor
};
var redefine = createCommonjsModule(function(module) {
  var getInternalState = internalState.get;
  var enforceInternalState = internalState.enforce;
  var TEMPLATE = String(String).split("String");
  (module.exports = function(O, key, value, options2) {
    var unsafe = options2 ? !!options2.unsafe : false;
    var simple = options2 ? !!options2.enumerable : false;
    var noTargetGet = options2 ? !!options2.noTargetGet : false;
    var state;
    if (typeof value == "function") {
      if (typeof key == "string" && !has(value, "name")) {
        createNonEnumerableProperty(value, "name", key);
      }
      state = enforceInternalState(value);
      if (!state.source) {
        state.source = TEMPLATE.join(typeof key == "string" ? key : "");
      }
    }
    if (O === global_1) {
      if (simple)
        O[key] = value;
      else
        setGlobal(key, value);
      return;
    } else if (!unsafe) {
      delete O[key];
    } else if (!noTargetGet && O[key]) {
      simple = true;
    }
    if (simple)
      O[key] = value;
    else
      createNonEnumerableProperty(O, key, value);
  })(Function.prototype, "toString", function toString2() {
    return typeof this == "function" && getInternalState(this).source || inspectSource(this);
  });
});
var path = global_1;
var aFunction = function(variable) {
  return typeof variable == "function" ? variable : void 0;
};
var getBuiltIn = function(namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace]) : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};
var ceil = Math.ceil;
var floor = Math.floor;
var toInteger = function(argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};
var min = Math.min;
var toLength = function(argument) {
  return argument > 0 ? min(toInteger(argument), 9007199254740991) : 0;
};
var max = Math.max;
var min$1 = Math.min;
var toAbsoluteIndex = function(index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};
var createMethod = function(IS_INCLUDES) {
  return function($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    if (IS_INCLUDES && el != el)
      while (length > index) {
        value = O[index++];
        if (value != value)
          return true;
      }
    else
      for (; length > index; index++) {
        if ((IS_INCLUDES || index in O) && O[index] === el)
          return IS_INCLUDES || index || 0;
      }
    return !IS_INCLUDES && -1;
  };
};
var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};
var indexOf = arrayIncludes.indexOf;
var objectKeysInternal = function(object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O)
    !has(hiddenKeys, key) && has(O, key) && result.push(key);
  while (names.length > i)
    if (has(O, key = names[i++])) {
      ~indexOf(result, key) || result.push(key);
    }
  return result;
};
var enumBugKeys = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
];
var hiddenKeys$1 = enumBugKeys.concat("length", "prototype");
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};
var objectGetOwnPropertyNames = {
  f: f$3
};
var f$4 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols = {
  f: f$4
};
var ownKeys$1 = getBuiltIn("Reflect", "ownKeys") || function ownKeys2(it) {
  var keys4 = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys4.concat(getOwnPropertySymbols(it)) : keys4;
};
var copyConstructorProperties = function(target, source) {
  var keys4 = ownKeys$1(source);
  var defineProperty2 = objectDefineProperty.f;
  var getOwnPropertyDescriptor3 = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys4.length; i++) {
    var key = keys4[i];
    if (!has(target, key))
      defineProperty2(target, key, getOwnPropertyDescriptor3(source, key));
  }
};
var replacement = /#|\.prototype\./;
var isForced = function(feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == "function" ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function(string) {
  return String(string).replace(replacement, ".").toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = "N";
var POLYFILL = isForced.POLYFILL = "P";
var isForced_1 = isForced;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var _export = function(options2, source) {
  var TARGET = options2.target;
  var GLOBAL = options2.global;
  var STATIC = options2.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor2;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target)
    for (key in source) {
      sourceProperty = source[key];
      if (options2.noTargetGet) {
        descriptor2 = getOwnPropertyDescriptor$1(target, key);
        targetProperty = descriptor2 && descriptor2.value;
      } else
        targetProperty = target[key];
      FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options2.forced);
      if (!FORCED && targetProperty !== void 0) {
        if (typeof sourceProperty === typeof targetProperty)
          continue;
        copyConstructorProperties(sourceProperty, targetProperty);
      }
      if (options2.sham || targetProperty && targetProperty.sham) {
        createNonEnumerableProperty(sourceProperty, "sham", true);
      }
      redefine(target, key, sourceProperty, options2);
    }
};
var aFunction$1 = function(it) {
  if (typeof it != "function") {
    throw TypeError(String(it) + " is not a function");
  }
  return it;
};
var functionBindContext = function(fn, that, length) {
  aFunction$1(fn);
  if (that === void 0)
    return fn;
  switch (length) {
    case 0:
      return function() {
        return fn.call(that);
      };
    case 1:
      return function(a) {
        return fn.call(that, a);
      };
    case 2:
      return function(a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function(a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function() {
    return fn.apply(that, arguments);
  };
};
var isArray = Array.isArray || function isArray2(arg) {
  return classofRaw(arg) == "Array";
};
var engineUserAgent = getBuiltIn("navigator", "userAgent") || "";
var process2 = global_1.process;
var versions = process2 && process2.versions;
var v8 = versions && versions.v8;
var match;
var version;
if (v8) {
  match = v8.split(".");
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match)
      version = match[1];
  }
}
var engineV8Version = version && +version;
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function() {
  return !String(Symbol()) || // Chrome 38 Symbol has incorrect toString conversion
  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && engineV8Version && engineV8Version < 41;
});
var useSymbolAsUid = nativeSymbol && !Symbol.sham && typeof Symbol.iterator == "symbol";
var WellKnownSymbolsStore = shared("wks");
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;
var wellKnownSymbol = function(name) {
  if (!has(WellKnownSymbolsStore, name) || !(nativeSymbol || typeof WellKnownSymbolsStore[name] == "string")) {
    if (nativeSymbol && has(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol("Symbol." + name);
    }
  }
  return WellKnownSymbolsStore[name];
};
var SPECIES = wellKnownSymbol("species");
var arraySpeciesCreate = function(originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    if (typeof C == "function" && (C === Array || isArray(C.prototype)))
      C = void 0;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null)
        C = void 0;
    }
  }
  return new (C === void 0 ? Array : C)(length === 0 ? 0 : length);
};
var push = [].push;
var createMethod$1 = function(TYPE2) {
  var IS_MAP = TYPE2 == 1;
  var IS_FILTER = TYPE2 == 2;
  var IS_SOME = TYPE2 == 3;
  var IS_EVERY = TYPE2 == 4;
  var IS_FIND_INDEX = TYPE2 == 6;
  var IS_FILTER_OUT = TYPE2 == 7;
  var NO_HOLES = TYPE2 == 5 || IS_FIND_INDEX;
  return function($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self2 = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength(self2.length);
    var index = 0;
    var create2 = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create2($this, length) : IS_FILTER || IS_FILTER_OUT ? create2($this, 0) : void 0;
    var value, result;
    for (; length > index; index++)
      if (NO_HOLES || index in self2) {
        value = self2[index];
        result = boundFunction(value, index, O);
        if (TYPE2) {
          if (IS_MAP)
            target[index] = result;
          else if (result)
            switch (TYPE2) {
              case 3:
                return true;
              case 5:
                return value;
              case 6:
                return index;
              case 2:
                push.call(target, value);
            }
          else
            switch (TYPE2) {
              case 4:
                return false;
              case 7:
                push.call(target, value);
            }
        }
      }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};
var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod$1(7)
};
var objectKeys = Object.keys || function keys2(O) {
  return objectKeysInternal(O, enumBugKeys);
};
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys4 = objectKeys(Properties);
  var length = keys4.length;
  var index = 0;
  var key;
  while (length > index)
    objectDefineProperty.f(O, key = keys4[index++], Properties[key]);
  return O;
};
var html = getBuiltIn("document", "documentElement");
var GT = ">";
var LT = "<";
var PROTOTYPE = "prototype";
var SCRIPT = "script";
var IE_PROTO = sharedKey("IE_PROTO");
var EmptyConstructor = function() {
};
var scriptTag = function(content) {
  return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};
var NullProtoObjectViaActiveX = function(activeXDocument2) {
  activeXDocument2.write(scriptTag(""));
  activeXDocument2.close();
  var temp = activeXDocument2.parentWindow.Object;
  activeXDocument2 = null;
  return temp;
};
var NullProtoObjectViaIFrame = function() {
  var iframe = documentCreateElement("iframe");
  var JS = "java" + SCRIPT + ":";
  var iframeDocument;
  iframe.style.display = "none";
  html.appendChild(iframe);
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag("document.F=Object"));
  iframeDocument.close();
  return iframeDocument.F;
};
var activeXDocument;
var NullProtoObject = function() {
  try {
    activeXDocument = document.domain && new ActiveXObject("htmlfile");
  } catch (error) {
  }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--)
    delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    result[IE_PROTO] = O;
  } else
    result = NullProtoObject();
  return Properties === void 0 ? result : objectDefineProperties(result, Properties);
};
var UNSCOPABLES = wellKnownSymbol("unscopables");
var ArrayPrototype = Array.prototype;
if (ArrayPrototype[UNSCOPABLES] == void 0) {
  objectDefineProperty.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}
var addToUnscopables = function(key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};
var $find = arrayIteration.find;
var FIND = "find";
var SKIPS_HOLES = true;
if (FIND in [])
  Array(1)[FIND](function() {
    SKIPS_HOLES = false;
  });
_export({ target: "Array", proto: true, forced: SKIPS_HOLES }, {
  find: function find2(callbackfn) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  }
});
addToUnscopables(FIND);
var _class;
var _class2;
var _temp;
var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 = /* @__PURE__ */ function(_React$Component) {
  _inherits(ReactTooltip2, _React$Component);
  _createClass(ReactTooltip2, null, [{
    key: "propTypes",
    get: function get9() {
      return {
        uuid: import_prop_types.default.string,
        children: import_prop_types.default.any,
        place: import_prop_types.default.string,
        type: import_prop_types.default.string,
        effect: import_prop_types.default.string,
        offset: import_prop_types.default.object,
        multiline: import_prop_types.default.bool,
        border: import_prop_types.default.bool,
        textColor: import_prop_types.default.string,
        backgroundColor: import_prop_types.default.string,
        borderColor: import_prop_types.default.string,
        arrowColor: import_prop_types.default.string,
        insecure: import_prop_types.default.bool,
        "class": import_prop_types.default.string,
        className: import_prop_types.default.string,
        id: import_prop_types.default.string,
        html: import_prop_types.default.bool,
        delayHide: import_prop_types.default.number,
        delayUpdate: import_prop_types.default.number,
        delayShow: import_prop_types.default.number,
        event: import_prop_types.default.string,
        eventOff: import_prop_types.default.string,
        isCapture: import_prop_types.default.bool,
        globalEventOff: import_prop_types.default.string,
        getContent: import_prop_types.default.any,
        afterShow: import_prop_types.default.func,
        afterHide: import_prop_types.default.func,
        overridePosition: import_prop_types.default.func,
        disable: import_prop_types.default.bool,
        scrollHide: import_prop_types.default.bool,
        resizeHide: import_prop_types.default.bool,
        wrapper: import_prop_types.default.string,
        bodyMode: import_prop_types.default.bool,
        possibleCustomEvents: import_prop_types.default.string,
        possibleCustomEventsOff: import_prop_types.default.string,
        clickable: import_prop_types.default.bool
      };
    }
  }]);
  function ReactTooltip2(props) {
    var _this;
    _classCallCheck(this, ReactTooltip2);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip2).call(this, props));
    _this.state = {
      uuid: props.uuid || generateUUID(),
      place: props.place || "top",
      // Direction of tooltip
      desiredPlace: props.place || "top",
      type: "dark",
      // Color theme of tooltip
      effect: "float",
      // float or fixed
      show: false,
      border: false,
      customColors: {},
      offset: {},
      extraClass: "",
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null,
      // Current mouse event
      currentTarget: null,
      // Current target of mouse event
      ariaProps: parseAria(props),
      // aria- and role attributes
      isEmptyTip: false,
      disable: false,
      possibleCustomEvents: props.possibleCustomEvents || "",
      possibleCustomEventsOff: props.possibleCustomEventsOff || "",
      originTooltip: null,
      isMultiline: false
    };
    _this.bind(["showTooltip", "updateTooltip", "hideTooltip", "hideTooltipOnScroll", "getTooltipContent", "globalRebuild", "globalShow", "globalHide", "onWindowResize", "mouseOnToolTip"]);
    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.delayReshow = null;
    _this.intervalUpdateContent = null;
    return _this;
  }
  _createClass(ReactTooltip2, [{
    key: "bind",
    value: function bind(methodArray) {
      var _this2 = this;
      methodArray.forEach(function(method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props, insecure = _this$props.insecure, resizeHide = _this$props.resizeHide;
      this.bindListener();
      this.bindWindowEvents(resizeHide);
      this.injectStyles();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mount = false;
      this.clearTimer();
      this.unbindListener();
      this.removeScrollListener(this.state.currentTarget);
      this.unbindWindowEvents();
    }
    /* Look for the closest DOM root having tooltip and inject styles. */
  }, {
    key: "injectStyles",
    value: function injectStyles() {
      var tooltipRef = this.tooltipRef;
      if (!tooltipRef) {
        return;
      }
      var parentNode = tooltipRef.parentNode;
      while (parentNode.parentNode) {
        parentNode = parentNode.parentNode;
      }
      var domRoot;
      switch (parentNode.constructor.name) {
        case "Document":
        case "HTMLDocument":
        case void 0:
          domRoot = parentNode.head;
          break;
        case "ShadowRoot":
        default:
          domRoot = parentNode;
          break;
      }
      if (!domRoot.querySelector("style[data-react-tooltip]")) {
        var style = document.createElement("style");
        style.textContent = baseCss;
        style.setAttribute("data-react-tooltip", "true");
        domRoot.appendChild(style);
      }
    }
    /**
     * Return if the mouse is on the tooltip.
     * @returns {boolean} true - mouse is on the tooltip
     */
  }, {
    key: "mouseOnToolTip",
    value: function mouseOnToolTip() {
      var show = this.state.show;
      if (show && this.tooltipRef) {
        if (!this.tooltipRef.matches) {
          if (this.tooltipRef.msMatchesSelector) {
            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
          } else {
            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
          }
        }
        return this.tooltipRef.matches(":hover");
      }
      return false;
    }
    /**
     * Pick out corresponded target elements
     */
  }, {
    key: "getTargetArray",
    value: function getTargetArray(id2) {
      var targetArray = [];
      var selector;
      if (!id2) {
        selector = "[data-tip]:not([data-for])";
      } else {
        var escaped = id2.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        selector = '[data-tip][data-for="'.concat(escaped, '"]');
      }
      nodeListToArray(document.getElementsByTagName("*")).filter(function(element) {
        return element.shadowRoot;
      }).forEach(function(element) {
        targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
      });
      return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
    }
    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */
  }, {
    key: "bindListener",
    value: function bindListener() {
      var _this3 = this;
      var _this$props2 = this.props, id2 = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture2 = _this$props2.isCapture;
      var targetArray = this.getTargetArray(id2);
      targetArray.forEach(function(target) {
        if (target.getAttribute("currentItem") === null) {
          target.setAttribute("currentItem", "false");
        }
        _this3.unbindBasicListener(target);
        if (_this3.isCustomEvent(target)) {
          _this3.customUnbindListener(target);
        }
      });
      if (this.isBodyMode()) {
        this.bindBodyListener(targetArray);
      } else {
        targetArray.forEach(function(target) {
          var isCaptureMode = _this3.isCapture(target);
          var effect = _this3.getEffect(target);
          if (_this3.isCustomEvent(target)) {
            _this3.customBindListener(target);
            return;
          }
          target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
          target.addEventListener("focus", _this3.showTooltip, isCaptureMode);
          if (effect === "float") {
            target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
          }
          target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
          target.addEventListener("blur", _this3.hideTooltip, isCaptureMode);
        });
      }
      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, isCapture2);
      }
      this.bindRemovalTracker();
    }
    /**
     * Unbind listeners on target elements
     */
  }, {
    key: "unbindListener",
    value: function unbindListener() {
      var _this4 = this;
      var _this$props3 = this.props, id2 = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
      if (this.isBodyMode()) {
        this.unbindBodyListener();
      } else {
        var targetArray = this.getTargetArray(id2);
        targetArray.forEach(function(target) {
          _this4.unbindBasicListener(target);
          if (_this4.isCustomEvent(target))
            _this4.customUnbindListener(target);
        });
      }
      if (globalEventOff)
        window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }
    /**
     * Invoke this before bind listener and unmount the component
     * it is necessary to invoke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */
  }, {
    key: "unbindBasicListener",
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
      target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
      target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
    }
  }, {
    key: "getTooltipContent",
    value: function getTooltipContent() {
      var _this$props4 = this.props, getContent = _this$props4.getContent, children2 = _this$props4.children;
      var content;
      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0](this.state.originTooltip);
        } else {
          content = getContent(this.state.originTooltip);
        }
      }
      return getTipContent(this.state.originTooltip, children2, content, this.state.isMultiline);
    }
  }, {
    key: "isEmptyTip",
    value: function isEmptyTip(placeholder) {
      return typeof placeholder === "string" && placeholder === "" || placeholder === null;
    }
    /**
     * When mouse enter, show the tooltip
     */
  }, {
    key: "showTooltip",
    value: function showTooltip(e, isGlobalCall) {
      if (!this.tooltipRef) {
        return;
      }
      if (isGlobalCall) {
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function(ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement)
          return;
      }
      var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
      var originTooltip = e.currentTarget.getAttribute("data-tip");
      var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false;
      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
      var scrollHide = true;
      if (e.currentTarget.getAttribute("data-scroll-hide")) {
        scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      }
      if (e && e.currentTarget && e.currentTarget.setAttribute) {
        e.currentTarget.setAttribute("aria-describedby", this.state.uuid);
      }
      var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
      var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
      var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
      }
      var place = result.isNewState ? result.newState.place : desiredPlace;
      this.clearTimer();
      var target = e.currentTarget;
      var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
      var self2 = this;
      var updateState = function updateState2() {
        self2.setState({
          originTooltip,
          isMultiline,
          desiredPlace,
          place,
          type: target.getAttribute("data-type") || self2.props.type || "dark",
          customColors: {
            text: target.getAttribute("data-text-color") || self2.props.textColor || null,
            background: target.getAttribute("data-background-color") || self2.props.backgroundColor || null,
            border: target.getAttribute("data-border-color") || self2.props.borderColor || null,
            arrow: target.getAttribute("data-arrow-color") || self2.props.arrowColor || null
          },
          effect,
          offset,
          html: (target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self2.props.html) || false,
          delayShow: target.getAttribute("data-delay-show") || self2.props.delayShow || 0,
          delayHide: target.getAttribute("data-delay-hide") || self2.props.delayHide || 0,
          delayUpdate: target.getAttribute("data-delay-update") || self2.props.delayUpdate || 0,
          border: (target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self2.props.border) || false,
          extraClass: target.getAttribute("data-class") || self2.props["class"] || self2.props.className || "",
          disable: (target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self2.props.disable) || false,
          currentTarget: target
        }, function() {
          if (scrollHide) {
            self2.addScrollListener(self2.state.currentTarget);
          }
          self2.updateTooltip(e);
          if (getContent && Array.isArray(getContent)) {
            self2.intervalUpdateContent = setInterval(function() {
              if (self2.mount) {
                var _getContent = self2.props.getContent;
                var placeholder = getTipContent(originTooltip, "", _getContent[0](), isMultiline);
                var isEmptyTip = self2.isEmptyTip(placeholder);
                self2.setState({
                  isEmptyTip
                });
                self2.updatePosition();
              }
            }, getContent[1]);
          }
        });
      };
      if (reshowDelay) {
        this.delayReshow = setTimeout(updateState, reshowDelay);
      } else {
        updateState();
      }
    }
    /**
     * When mouse hover, update tool tip
     */
  }, {
    key: "updateTooltip",
    value: function updateTooltip(e) {
      var _this5 = this;
      var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
      var afterShow = this.props.afterShow;
      var placeholder = this.getTooltipContent();
      var eventTarget = e.currentTarget || e.target;
      if (this.mouseOnToolTip()) {
        return;
      }
      if (this.isEmptyTip(placeholder) || disable) {
        return;
      }
      var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
      var updateState = function updateState2() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this5.state.show;
          _this5.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function() {
            _this5.updatePosition();
            if (isInvisible && afterShow) {
              afterShow(e);
            }
          });
        }
      };
      clearTimeout(this.delayShowLoop);
      if (delayTime) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }
    /*
     * If we're mousing over the tooltip remove it when we leave.
     */
  }, {
    key: "listenForTooltipExit",
    value: function listenForTooltipExit() {
      var show = this.state.show;
      if (show && this.tooltipRef) {
        this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
      }
    }
  }, {
    key: "removeListenerForTooltipExit",
    value: function removeListenerForTooltipExit() {
      var show = this.state.show;
      if (show && this.tooltipRef) {
        this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
      }
    }
    /**
     * When mouse leave, hide tooltip
     */
  }, {
    key: "hideTooltip",
    value: function hideTooltip(e, hasTarget) {
      var _this6 = this;
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        isScroll: false
      };
      var disable = this.state.disable;
      var isScroll = options2.isScroll;
      var delayHide = isScroll ? 0 : this.state.delayHide;
      var afterHide = this.props.afterHide;
      var placeholder = this.getTooltipContent();
      if (!this.mount)
        return;
      if (this.isEmptyTip(placeholder) || disable)
        return;
      if (hasTarget) {
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function(ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show)
          return;
      }
      if (e && e.currentTarget && e.currentTarget.removeAttribute) {
        e.currentTarget.removeAttribute("aria-describedby");
      }
      var resetState = function resetState2() {
        var isVisible = _this6.state.show;
        if (_this6.mouseOnToolTip()) {
          _this6.listenForTooltipExit();
          return;
        }
        _this6.removeListenerForTooltipExit();
        _this6.setState({
          show: false
        }, function() {
          _this6.removeScrollListener(_this6.state.currentTarget);
          if (isVisible && afterHide) {
            afterHide(e);
          }
        });
      };
      this.clearTimer();
      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }
    /**
     * When scroll, hide tooltip
     */
  }, {
    key: "hideTooltipOnScroll",
    value: function hideTooltipOnScroll(event2, hasTarget) {
      this.hideTooltip(event2, hasTarget, {
        isScroll: true
      });
    }
    /**
     * Add scroll event listener when tooltip show
     * automatically hide the tooltip when scrolling
     */
  }, {
    key: "addScrollListener",
    value: function addScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
    }
  }, {
    key: "removeScrollListener",
    value: function removeScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.removeEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
    }
    // Calculation the position
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var _this7 = this;
      var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
      var node = this.tooltipRef;
      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      }
      if (result.isNewState) {
        return this.setState(result.newState, function() {
          _this7.updatePosition();
        });
      }
      node.style.left = result.position.left + "px";
      node.style.top = result.position.top + "px";
    }
    /**
     * CLear all kinds of timeout of interval
     */
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearTimeout(this.delayReshow);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: "hasCustomColors",
    value: function hasCustomColors() {
      var _this8 = this;
      return Boolean(Object.keys(this.state.customColors).find(function(color) {
        return color !== "border" && _this8.state.customColors[color];
      }) || this.state.border && this.state.customColors["border"]);
    }
  }, {
    key: "render",
    value: function render2() {
      var _this9 = this;
      var _this$state3 = this.state, extraClass = _this$state3.extraClass, html2 = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
      var content = this.getTooltipContent();
      var isEmptyTip = this.isEmptyTip(content);
      var style = generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border);
      var tooltipClass = "__react_component_tooltip" + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " border" : "") + " place-".concat(this.state.place) + // top, bottom, left, right
      " type-".concat(this.hasCustomColors() ? "custom" : this.state.type) + // dark, success, warning, error, info, light, custom
      (this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
      var Wrapper = this.props.wrapper;
      if (ReactTooltip2.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip2.defaultProps.wrapper;
      }
      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(" ");
      if (html2) {
        var htmlContent = "".concat(content, '\n<style aria-hidden="true">').concat(style, "</style>");
        return React32.createElement(Wrapper, _extends({
          className: "".concat(wrapperClassName),
          id: this.props.id || uuid,
          ref: function ref(_ref) {
            return _this9.tooltipRef = _ref;
          }
        }, ariaProps, {
          "data-id": "tooltip",
          dangerouslySetInnerHTML: {
            __html: htmlContent
          }
        }));
      } else {
        return React32.createElement(Wrapper, _extends({
          className: "".concat(wrapperClassName),
          id: this.props.id || uuid
        }, ariaProps, {
          ref: function ref(_ref2) {
            return _this9.tooltipRef = _ref2;
          },
          "data-id": "tooltip"
        }), React32.createElement("style", {
          dangerouslySetInnerHTML: {
            __html: style
          },
          "aria-hidden": "true"
        }), content);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var ariaProps = prevState.ariaProps;
      var newAriaProps = parseAria(nextProps);
      var isChanged = Object.keys(newAriaProps).some(function(props) {
        return newAriaProps[props] !== ariaProps[props];
      });
      if (!isChanged) {
        return null;
      }
      return _objectSpread2({}, prevState, {
        ariaProps: newAriaProps
      });
    }
  }]);
  return ReactTooltip2;
}(React32.Component), _defineProperty(_class2, "defaultProps", {
  insecure: true,
  resizeHide: true,
  wrapper: "div",
  clickable: false
}), _defineProperty(_class2, "supportedWrappers", ["div", "span"]), _defineProperty(_class2, "displayName", "ReactTooltip"), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;
var index_es_default = ReactTooltip;

// src/common/Tooltip.tsx
var Tooltip = ({
  id: id2,
  content,
  placement,
  children: children2,
  delayShow,
  className,
  onAfterShow,
  effect = "solid"
}) => {
  const childrenWithTooltipMetadata = React33.createElement(
    "span",
    {
      "data-tip": true,
      "data-for": id2
    },
    children2 != null ? children2 : /* @__PURE__ */ React33.createElement("em", { className: "icon icon-sm text-secondary ml-1" }, "info")
  );
  return /* @__PURE__ */ React33.createElement(React33.Fragment, null, childrenWithTooltipMetadata, /* @__PURE__ */ React33.createElement(
    index_es_default,
    {
      place: placement,
      id: id2,
      effect,
      uuid: id2,
      delayShow,
      afterShow: onAfterShow,
      className
    },
    content
  ));
};

// src/common/NavPills/NavPills.tsx
import * as React34 from "react";
var NavPills = ({ className = "", children: children2 }) => /* @__PURE__ */ React34.createElement("ul", { className: `nav nav-pills ${className}` }, children2);

// src/common/AlertCustom/AlertCustom.tsx
import * as React35 from "react";
var AlertCustom = ({ outline, color, className, content }) => {
  const alertClassName = outline ? `alert-outline-${color}` : `alert-${color}`;
  return /* @__PURE__ */ React35.createElement("div", { className: `alert ${alertClassName} ${className}`, role: "alert" }, content);
};

// src/common/ButtonGroup/ButtonGroup.tsx
import * as React36 from "react";
import { isString } from "lodash-es";
function ButtonGroup({
  elements,
  selected,
  onSelect,
  className = "btn-group-lg"
}) {
  return /* @__PURE__ */ React36.createElement("div", { className: `btn-group btn-group-toggle ${className}` }, elements.map(({ id: id2, element }) => /* @__PURE__ */ React36.createElement(
    "button",
    {
      key: id2,
      className: `btn btn-toggle-primary d-flex align-items-center ${id2 === selected ? "active" : ""}`,
      onClick: () => onSelect(id2)
    },
    /* @__PURE__ */ React36.createElement("input", { type: "radio", name: id2, id: id2, autoComplete: "off" }),
    isString(element) ? /* @__PURE__ */ React36.createElement("span", null, element) : element
  )));
}

// src/common/ButtonGroup/ButtonGroupAccount.tsx
import * as React37 from "react";
import { isStringEqual as isStringEqual4 } from "@ic-anywhere/ic-utils";
var choices = (hasRootAccount = false) => {
  const choices2 = [];
  if (hasRootAccount) {
    choices2.push({
      id: "GROUP",
      element: /* @__PURE__ */ React37.createElement("span", null, "All group entities")
    });
  }
  choices2.push({
    id: "ENTITY",
    element: /* @__PURE__ */ React37.createElement("span", null, "Entity")
  });
  choices2.push({
    id: "SUB-ENTITY",
    element: /* @__PURE__ */ React37.createElement("span", null, "Entity and sub entities")
  });
  return choices2;
};
var ButtonGroupAccount = ({ entityType, hasRootAccount = false, onChange }) => {
  const handleOnSelect = (id2) => {
    if (!isStringEqual4(id2, entityType)) {
      onChange(id2);
    }
  };
  return /* @__PURE__ */ React37.createElement(
    ButtonGroup,
    {
      className: "btn-group-lg",
      selected: entityType,
      elements: choices(hasRootAccount),
      onSelect: handleOnSelect
    }
  );
};

// src/common/BackButton.tsx
import * as React38 from "react";
import { Button as Button4 } from "@sgbs-ui/core";
var BackButton = ({ label = "Back", size: size6 = "lg", className = "", onClick }) => {
  const handleOnclick = () => {
    if (onClick) {
      onClick();
      return;
    }
    history.back();
  };
  return /* @__PURE__ */ React38.createElement(
    Button4,
    {
      btnType: "link",
      size: size6,
      className: `${className} ${size6 === "lg" ? "text-large" : ""}`,
      icon: "arrow_back",
      iconPosition: "left",
      text: label,
      onClick: handleOnclick
    }
  );
};

// src/common/Tables/SortableTableColumn.tsx
import * as React39 from "react";
import { Button as Button5 } from "@sgbs-ui/core";
var SortableTableColumn = ({
  isVisible = true,
  label,
  onSort,
  sortStatus,
  sortKey
}) => {
  const handleOnSort = () => {
    onSort(sortKey);
  };
  const iconName = sortStatus ? sortStatus === "asc" ? "south" : "north" : null;
  return isVisible ? /* @__PURE__ */ React39.createElement("th", { scope: "col", className: "align-middle" }, /* @__PURE__ */ React39.createElement(
    Button5,
    {
      btnType: "link",
      icon: iconName != null ? iconName : "",
      className: "shadow-none text-nowrap",
      text: label,
      onClick: handleOnSort
    }
  )) : null;
};

// src/common/Tables/ThWithSort.tsx
import * as React40 from "react";
function ThWithSort({
  children: children2,
  sortKey,
  sortStatus,
  onSort
}) {
  const applySort = () => {
    const direction = !sortStatus || sortStatus.direction === "desc" ? "asc" : "desc";
    onSort({ col: sortKey, direction });
  };
  const icon = (sortStatus == null ? void 0 : sortStatus.direction) === "asc" ? "arrow_upward" : "arrow_downward";
  return /* @__PURE__ */ React40.createElement("th", { onClick: applySort, className: "pointer" }, children2, (sortStatus == null ? void 0 : sortStatus.col) === sortKey && /* @__PURE__ */ React40.createElement("em", { className: "icon text-secodary ml-2" }, icon));
}

// src/common/FilesUpload/DropZone.tsx
import * as React42 from "react";

// src/common/FilesUpload/UploadSquares.tsx
import * as React41 from "react";
var UploadSquares = ({ children: children2 }) => /* @__PURE__ */ React41.createElement(React41.Fragment, null, /* @__PURE__ */ React41.createElement("div", { className: "upload-squares" }), children2, /* @__PURE__ */ React41.createElement("div", { className: "upload-squares" }));

// src/common/FilesUpload/DropZone.tsx
var DropZone = ({ onFilesAdded, accept, size: size6 = "normal" }) => {
  const fileInputRef = React42.useRef(null);
  const openFileDialog = () => {
    var _a;
    if (fileInputRef && fileInputRef.current) {
      (_a = fileInputRef.current) == null ? void 0 : _a.click();
    }
  };
  const handleOnDrop = (event2) => {
    event2.preventDefault();
    onFilesAdded(event2.dataTransfer.files);
  };
  const handleOnFileAdded = (event2) => {
    var _a;
    onFilesAdded((_a = event2.target.files) != null ? _a : []);
    event2.target.value = "";
  };
  const handleOnDragOver = (event2) => {
    event2.preventDefault();
  };
  return /* @__PURE__ */ React42.createElement("div", { className: "position-relative d-block", onDrop: handleOnDrop, onDragOver: handleOnDragOver }, /* @__PURE__ */ React42.createElement(UploadSquares, null, /* @__PURE__ */ React42.createElement(
    "div",
    {
      className: `upload-inner ${size6 === "normal" ? "py-3" : "py-2"} text-center d-flex align-items-center justify-content-center`
    },
    size6 === "normal" && /* @__PURE__ */ React42.createElement("em", { className: "icon icon-xl text-light mx-5" }, "attach_file"),
    /* @__PURE__ */ React42.createElement("p", { className: "text-secondary m-0 line-height-1" }, "Drag or", /* @__PURE__ */ React42.createElement("label", { className: `text-info px-1 mb-0 pointer`, onClick: openFileDialog }, "select"), "your file to this area to upload"),
    /* @__PURE__ */ React42.createElement("input", { ref: fileInputRef, className: "d-none", type: "file", onChange: handleOnFileAdded, accept })
  )));
};

// src/common/FilesUpload/FilesUpload.tsx
import * as React52 from "react";
import { filter, isEqual as isEqual3, noop as noop10, size, sumBy } from "lodash-es";

// src/common/FilesUpload/FileUploadValidate.tsx
import * as React49 from "react";
import { get as get7, map as map7, sum } from "lodash-es";
import {
  allowedFileTypes as defaultAllowedFileTypes,
  bytesToSize,
  getFileType,
  pluralize
} from "@ic-anywhere/ic-utils";

// src/layout/PageHeader.tsx
import * as React45 from "react";

// src/hooks/useHideNavBarBorder.ts
import { some as some2 } from "lodash-es";
import * as React43 from "react";

// ../../node_modules/react-cool-inview/dist/index.esm.js
import { useRef as useRef6, useEffect as useEffect12, useState as useState11, useCallback as useCallback3 } from "react";
function _extends2() {
  _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
var useLatest = function(val) {
  var ref = useRef6(val);
  useEffect12(function() {
    ref.current = val;
  });
  return ref;
};
var observerErr = "\u{1F4A1} react-cool-inview: the browser doesn't support Intersection Observer, please install polyfill: https://github.com/wellyshen/react-cool-inview#intersection-observer-polyfill";
var observerWarn = "\u{1F4A1} react-cool-inview: the browser doesn't support Intersection Observer v2, fallback to v1 behavior";
var useInView = function useInView2(_temp2) {
  var _ref = _temp2 === void 0 ? {} : _temp2, refOpt = _ref.ref, root2 = _ref.root, rootMargin = _ref.rootMargin, _ref$threshold = _ref.threshold, threshold = _ref$threshold === void 0 ? 0 : _ref$threshold, trackVisibility = _ref.trackVisibility, delay = _ref.delay, unobserveOnEnter = _ref.unobserveOnEnter, onChange = _ref.onChange, onEnter = _ref.onEnter, onLeave = _ref.onLeave;
  var _useState = useState11({
    inView: false,
    scrollDirection: {}
  }), state = _useState[0], setState = _useState[1];
  var prevInViewRef = useRef6(false);
  var prevPosRef = useRef6({});
  var observerRef = useRef6(null);
  var warnedRef = useRef6(false);
  var onChangeRef = useLatest(onChange);
  var onEnterRef = useLatest(onEnter);
  var onLeaveRef = useLatest(onLeave);
  var refVar = useRef6(null);
  var ref = useRef6(refVar == null ? void 0 : refVar.current);
  ref = refOpt || ref;
  var observe = useCallback3(function(element) {
    if (element)
      ref.current = element;
    if (observerRef.current && ref.current)
      observerRef.current.observe(ref.current);
  }, [ref]);
  var unobserve = useCallback3(function() {
    if (observerRef.current)
      observerRef.current.disconnect();
  }, []);
  var updatePosition = useCallback3(function() {
    if (!ref.current)
      return;
    var _ref$current$getBound = ref.current.getBoundingClientRect(), x = _ref$current$getBound.x, y = _ref$current$getBound.y;
    prevPosRef.current = {
      x,
      y
    };
  }, [ref]);
  useEffect12(function() {
    if (!("IntersectionObserver" in window) || !("IntersectionObserverEntry" in window)) {
      console.error(observerErr);
      return function() {
        return null;
      };
    }
    observerRef.current = new IntersectionObserver(function(_ref2) {
      var entry = _ref2[0];
      var intersectionRatio = entry.intersectionRatio, isIntersecting = entry.isIntersecting, _entry$boundingClient = entry.boundingClientRect, x = _entry$boundingClient.x, y = _entry$boundingClient.y, isVisible = entry.isVisible;
      var scrollDirection = {};
      var min2 = Array.isArray(threshold) ? Math.min.apply(Math, threshold) : threshold;
      var inView = isIntersecting !== void 0 ? isIntersecting : intersectionRatio > 0;
      inView = min2 > 0 ? intersectionRatio >= min2 : inView;
      if (x < prevPosRef.current.x)
        scrollDirection.horizontal = "left";
      if (x > prevPosRef.current.x)
        scrollDirection.horizontal = "right";
      prevPosRef.current.x = x;
      if (y < prevPosRef.current.y)
        scrollDirection.vertical = "up";
      if (y > prevPosRef.current.y)
        scrollDirection.vertical = "down";
      prevPosRef.current.y = y;
      var e = {
        entry,
        scrollDirection,
        observe,
        unobserve
      };
      if (trackVisibility) {
        if (isVisible === void 0 && !warnedRef.current) {
          console.warn(observerWarn);
          warnedRef.current = true;
        }
        if (isVisible !== void 0)
          inView = isVisible;
      }
      if (inView && !prevInViewRef.current) {
        if (unobserveOnEnter)
          unobserve();
        if (onEnterRef.current)
          onEnterRef.current(e);
      }
      if (!inView && prevInViewRef.current && onLeaveRef.current)
        onLeaveRef.current(e);
      if (onChangeRef.current)
        onChangeRef.current(_extends2({}, e, {
          inView
        }));
      setState({
        inView,
        scrollDirection,
        entry
      });
      prevInViewRef.current = inView;
    }, {
      root: root2,
      rootMargin,
      threshold,
      trackVisibility,
      delay
    });
    observe();
    return function() {
      return unobserve();
    };
  }, [
    unobserveOnEnter,
    root2,
    rootMargin,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(threshold),
    trackVisibility,
    delay,
    observe,
    unobserve
  ]);
  return _extends2({
    ref
  }, state, {
    observe,
    unobserve,
    updatePosition
  });
};
var index_esm_default = useInView;

// src/hooks/useHideNavBarBorder.ts
var useHideNavBarBorder = () => {
  const { ref } = index_esm_default({
    threshold: 0.25,
    onEnter: () => toggleBorderClass(false),
    onLeave: () => toggleBorderClass(true)
  });
  const toggleBorderClass = React43.useCallback((isShown) => {
    var _a;
    const header = (_a = document.querySelector("#ic-navbar")) == null ? void 0 : _a.classList;
    if (header) {
      isShown ? header.add("border-bottom") : header.remove("border-bottom");
    }
  }, []);
  React43.useEffect(() => {
    var _a;
    const headerClasses = (_a = document.querySelector("#ic-navbar")) == null ? void 0 : _a.classList;
    const initiallyDisplayed = some2(headerClasses, (c) => c === "border-bottom");
    return () => {
      toggleBorderClass(initiallyDisplayed);
    };
  }, [toggleBorderClass]);
  return ref;
};

// src/layout/PageHeader.tsx
import { Button as Button6 } from "@sgbs-ui/core";

// src/layout/Loader.tsx
import * as React44 from "react";
var Loader = ({ isVisible = true, message = "Loading..." }) => isVisible ? /* @__PURE__ */ React44.createElement("div", { className: "spinner-grow" }, message) : /* @__PURE__ */ React44.createElement(React44.Fragment, null);

// src/layout/PageHeader.tsx
var PageHeader = ({
  pageTitle = "",
  pageSubTitle = "",
  containerClass,
  renderAction,
  border = true,
  displayBack = true,
  isFetching = false,
  onBackClick,
  children: children2,
  backText = "Back"
}) => {
  const ref = useHideNavBarBorder();
  const handleOnClick = () => {
    if (onBackClick) {
      onBackClick();
      return;
    }
    history.back();
  };
  return /* @__PURE__ */ React45.createElement(React45.Fragment, null, /* @__PURE__ */ React45.createElement("div", { ref }, /* @__PURE__ */ React45.createElement("div", { className: "d-none" })), /* @__PURE__ */ React45.createElement("div", { className: `${border ? "border-bottom" : ""}` }, /* @__PURE__ */ React45.createElement("div", { className: containerClass != null ? containerClass : "pb-3" }, displayBack && /* @__PURE__ */ React45.createElement("div", { className: "row mb-2" }, /* @__PURE__ */ React45.createElement(
    Button6,
    {
      btnType: "link",
      size: "lg",
      className: "text-large",
      icon: "arrow_back",
      iconPosition: "left",
      text: backText,
      onClick: handleOnClick
    }
  )), isFetching ? /* @__PURE__ */ React45.createElement(Loader, { isVisible: true }) : /* @__PURE__ */ React45.createElement(React45.Fragment, null, /* @__PURE__ */ React45.createElement("div", { className: "row" }, /* @__PURE__ */ React45.createElement("div", { className: "col-12 col-md mb-2 mb-md-0" }, /* @__PURE__ */ React45.createElement("span", { className: "display-3 line-height-1" }, pageTitle), /* @__PURE__ */ React45.createElement("div", { className: "text-large text-secondary my-2" }, pageSubTitle)), /* @__PURE__ */ React45.createElement("div", { className: "col-12 col-md-auto mb-2 align-self-center" }, renderAction))), children2)));
};

// src/layout/toastify/ToastContent.tsx
import * as React46 from "react";
var ToastContent = ({ title, message, detail }) => /* @__PURE__ */ React46.createElement(React46.Fragment, null, /* @__PURE__ */ React46.createElement("div", { className: "toast-header" }, /* @__PURE__ */ React46.createElement("strong", null, title), /* @__PURE__ */ React46.createElement("button", { type: "button", className: "ml-2 mb-1 close pointer", "data-dismiss": "toast", "aria-label": "Close" }, /* @__PURE__ */ React46.createElement("i", { className: "icon" }, "close"))), /* @__PURE__ */ React46.createElement("div", { className: "toast-body" }, /* @__PURE__ */ React46.createElement("div", { className: "text-primary" }, message), detail && /* @__PURE__ */ React46.createElement("div", { className: "text-primary" }, detail)));

// src/layout/toastify/toasterNotifyer.tsx
import { upperFirst } from "lodash-es";
import * as React47 from "react";
import { useEffect as useEffect15 } from "react";

// ../../node_modules/react-toastify/dist/react-toastify.esm.js
import React__default, { isValidElement, useRef as useRef7, useLayoutEffect, useEffect as useEffect14, useReducer, useState as useState12, cloneElement, createElement as createElement44 } from "react";

// ../../node_modules/clsx/dist/clsx.m.js
function toVal(mix) {
  var k, y, str = "";
  if (typeof mix === "string" || typeof mix === "number") {
    str += mix;
  } else if (typeof mix === "object") {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if (y = toVal(mix[k])) {
            str && (str += " ");
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += " ");
          str += k;
        }
      }
    }
  }
  return str;
}
function clsx_m_default() {
  var i = 0, tmp, x, str = "";
  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += " ");
        str += x;
      }
    }
  }
  return str;
}

// ../../node_modules/react-toastify/dist/react-toastify.esm.js
import { render } from "react-dom";
function _extends3() {
  _extends3 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends3.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function isNum(v) {
  return typeof v === "number" && !isNaN(v);
}
function isBool(v) {
  return typeof v === "boolean";
}
function isStr(v) {
  return typeof v === "string";
}
function isFn(v) {
  return typeof v === "function";
}
function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}
function isToastIdValid(toastId) {
  return toastId === 0 || toastId;
}
function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var canUseDom = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function canBeRendered(content) {
  return isValidElement(content) || isStr(content) || isFn(content) || isNum(content);
}
var POSITION = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center"
};
var TYPE = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default"
};
function collapseToast(node, done, duration4) {
  if (duration4 === void 0) {
    duration4 = 300;
  }
  var scrollHeight = node.scrollHeight, style = node.style;
  requestAnimationFrame(function() {
    style.minHeight = "initial";
    style.height = scrollHeight + "px";
    style.transition = "all " + duration4 + "ms";
    requestAnimationFrame(function() {
      style.height = "0";
      style.padding = "0";
      style.margin = "0";
      setTimeout(done, duration4);
    });
  });
}
function cssTransition(_ref) {
  var enter = _ref.enter, exit2 = _ref.exit, _ref$appendPosition = _ref.appendPosition, appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition, _ref$collapse = _ref.collapse, collapse = _ref$collapse === void 0 ? true : _ref$collapse, _ref$collapseDuration = _ref.collapseDuration, collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  return function ToastTransition(_ref2) {
    var children2 = _ref2.children, position = _ref2.position, preventExitTransition = _ref2.preventExitTransition, done = _ref2.done, nodeRef = _ref2.nodeRef, isIn = _ref2.isIn;
    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit2 + "--" + position : exit2;
    var baseClassName = useRef7();
    var animationStep = useRef7(
      0
      /* Enter */
    );
    useLayoutEffect(function() {
      onEnter();
    }, []);
    useEffect14(function() {
      if (!isIn)
        preventExitTransition ? onExited() : onExit();
    }, [isIn]);
    function onEnter() {
      var node = nodeRef.current;
      baseClassName.current = node.className;
      node.className += " " + enterClassName;
      node.addEventListener("animationend", onEntered);
      node.addEventListener("animationcancel", onEntered);
    }
    function onEntered(e) {
      if (e.target !== nodeRef.current)
        return;
      var node = nodeRef.current;
      node.dispatchEvent(new Event(
        "d"
        /* ENTRANCE_ANIMATION_END */
      ));
      node.removeEventListener("animationend", onEntered);
      node.removeEventListener("animationcancel", onEntered);
      if (animationStep.current === 0) {
        node.className = baseClassName.current;
      }
    }
    function onExit() {
      animationStep.current = 1;
      var node = nodeRef.current;
      node.className += " " + exitClassName;
      node.addEventListener("animationend", onExited);
    }
    function onExited() {
      var node = nodeRef.current;
      node.removeEventListener("animationend", onExited);
      collapse ? collapseToast(node, done, collapseDuration) : done();
    }
    return React__default.createElement(React__default.Fragment, null, children2);
  };
}
var eventManager = {
  list: /* @__PURE__ */ new Map(),
  emitQueue: /* @__PURE__ */ new Map(),
  on: function on(event2, callback) {
    this.list.has(event2) || this.list.set(event2, []);
    this.list.get(event2).push(callback);
    return this;
  },
  off: function off(event2, callback) {
    if (callback) {
      var cb = this.list.get(event2).filter(function(cb2) {
        return cb2 !== callback;
      });
      this.list.set(event2, cb);
      return this;
    }
    this.list["delete"](event2);
    return this;
  },
  cancelEmit: function cancelEmit(event2) {
    var timers = this.emitQueue.get(event2);
    if (timers) {
      timers.forEach(clearTimeout);
      this.emitQueue["delete"](event2);
    }
    return this;
  },
  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function emit(event2) {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    this.list.has(event2) && this.list.get(event2).forEach(function(callback) {
      var timer = setTimeout(function() {
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event2) || _this.emitQueue.set(event2, []);
      _this.emitQueue.get(event2).push(timer);
    });
  }
};
var _excluded = ["delay", "staleId"];
function useToastContainer(props) {
  var _useReducer = useReducer(function(x) {
    return x + 1;
  }, 0), forceUpdate = _useReducer[1];
  var _useState = useState12([]), toastIds = _useState[0], setToastIds = _useState[1];
  var containerRef = useRef7(null);
  var toastToRender = useRef7(/* @__PURE__ */ new Map()).current;
  var isToastActive = function isToastActive2(id2) {
    return toastIds.indexOf(id2) !== -1;
  };
  var instance = useRef7({
    toastKey: 1,
    displayedToast: 0,
    count: 0,
    queue: [],
    props,
    containerId: null,
    isToastActive,
    getToast: function getToast2(id2) {
      return toastToRender.get(id2);
    }
  }).current;
  useEffect14(function() {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(
      3
      /* WillUnmount */
    ).on(
      0,
      buildToast
    ).on(
      1,
      function(toastId) {
        return containerRef.current && removeToast(toastId);
      }
    ).on(
      5,
      clearWaitingQueue
    ).emit(
      2,
      instance
    );
    return function() {
      return eventManager.emit(
        3,
        instance
      );
    };
  }, []);
  useEffect14(function() {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toastIds.length;
    eventManager.emit(
      4,
      toastIds.length,
      props.containerId
    );
  }, [toastIds]);
  useEffect14(function() {
    instance.props = props;
  });
  function clearWaitingQueue(_ref) {
    var containerId = _ref.containerId;
    var limit = instance.props.limit;
    if (limit && (!containerId || instance.containerId === containerId)) {
      instance.count -= instance.queue.length;
      instance.queue = [];
    }
  }
  function removeToast(toastId) {
    setToastIds(function(state) {
      return isToastIdValid(toastId) ? state.filter(function(id2) {
        return id2 !== toastId;
      }) : [];
    });
  }
  function dequeueToast() {
    var _instance$queue$shift = instance.queue.shift(), toastContent = _instance$queue$shift.toastContent, toastProps = _instance$queue$shift.toastProps, staleId = _instance$queue$shift.staleId;
    appendToast(toastContent, toastProps, staleId);
  }
  function isNotValid(options2) {
    return !containerRef.current || instance.props.enableMultiContainer && options2.containerId !== instance.props.containerId || toastToRender.has(options2.toastId) && options2.updateId == null;
  }
  function buildToast(content, _ref2) {
    var delay = _ref2.delay, staleId = _ref2.staleId, options2 = _objectWithoutPropertiesLoose(_ref2, _excluded);
    if (!canBeRendered(content) || isNotValid(options2))
      return;
    var toastId = options2.toastId, updateId = options2.updateId, data2 = options2.data;
    var props2 = instance.props;
    var closeToast = function closeToast2() {
      return removeToast(toastId);
    };
    var isNotAnUpdate = updateId == null;
    if (isNotAnUpdate)
      instance.count++;
    var toastProps = {
      toastId,
      updateId,
      isLoading: options2.isLoading,
      theme: options2.theme || props2.theme,
      icon: options2.icon != null ? options2.icon : props2.icon,
      isIn: false,
      key: options2.key || instance.toastKey++,
      type: options2.type,
      closeToast,
      closeButton: options2.closeButton,
      rtl: props2.rtl,
      position: options2.position || props2.position,
      transition: options2.transition || props2.transition,
      className: parseClassName(options2.className || props2.toastClassName),
      bodyClassName: parseClassName(options2.bodyClassName || props2.bodyClassName),
      style: options2.style || props2.toastStyle,
      bodyStyle: options2.bodyStyle || props2.bodyStyle,
      onClick: options2.onClick || props2.onClick,
      pauseOnHover: isBool(options2.pauseOnHover) ? options2.pauseOnHover : props2.pauseOnHover,
      pauseOnFocusLoss: isBool(options2.pauseOnFocusLoss) ? options2.pauseOnFocusLoss : props2.pauseOnFocusLoss,
      draggable: isBool(options2.draggable) ? options2.draggable : props2.draggable,
      draggablePercent: options2.draggablePercent || props2.draggablePercent,
      draggableDirection: options2.draggableDirection || props2.draggableDirection,
      closeOnClick: isBool(options2.closeOnClick) ? options2.closeOnClick : props2.closeOnClick,
      progressClassName: parseClassName(options2.progressClassName || props2.progressClassName),
      progressStyle: options2.progressStyle || props2.progressStyle,
      autoClose: options2.isLoading ? false : getAutoCloseDelay(options2.autoClose, props2.autoClose),
      hideProgressBar: isBool(options2.hideProgressBar) ? options2.hideProgressBar : props2.hideProgressBar,
      progress: options2.progress,
      role: options2.role || props2.role,
      deleteToast: function deleteToast() {
        toastToRender["delete"](toastId);
        var queueLen = instance.queue.length;
        instance.count = isToastIdValid(toastId) ? instance.count - 1 : instance.count - instance.displayedToast;
        if (instance.count < 0)
          instance.count = 0;
        if (queueLen > 0) {
          var freeSlot = isToastIdValid(toastId) ? 1 : instance.props.limit;
          if (queueLen === 1 || freeSlot === 1) {
            instance.displayedToast++;
            dequeueToast();
          } else {
            var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
            instance.displayedToast = toDequeue;
            for (var i = 0; i < toDequeue; i++) {
              dequeueToast();
            }
          }
        } else {
          forceUpdate();
        }
      }
    };
    if (isFn(options2.onOpen))
      toastProps.onOpen = options2.onOpen;
    if (isFn(options2.onClose))
      toastProps.onClose = options2.onClose;
    toastProps.closeButton = props2.closeButton;
    if (options2.closeButton === false || canBeRendered(options2.closeButton)) {
      toastProps.closeButton = options2.closeButton;
    } else if (options2.closeButton === true) {
      toastProps.closeButton = canBeRendered(props2.closeButton) ? props2.closeButton : true;
    }
    var toastContent = content;
    if (isValidElement(content) && !isStr(content.type)) {
      toastContent = cloneElement(content, {
        closeToast,
        toastProps,
        data: data2
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast,
        toastProps,
        data: data2
      });
    }
    if (props2.limit && props2.limit > 0 && instance.count > props2.limit && isNotAnUpdate) {
      instance.queue.push({
        toastContent,
        toastProps,
        staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function() {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }
  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    if (staleId)
      toastToRender["delete"](staleId);
    toastToRender.set(toastId, {
      content,
      props: toastProps
    });
    setToastIds(function(state) {
      return [].concat(state, [toastId]).filter(function(id2) {
        return id2 !== staleId;
      });
    });
  }
  function getToastToRender(cb) {
    var toRender = /* @__PURE__ */ new Map();
    var collection = Array.from(toastToRender.values());
    if (props.newestOnTop)
      collection.reverse();
    collection.forEach(function(toast2) {
      var position = toast2.props.position;
      toRender.has(position) || toRender.set(position, []);
      toRender.get(position).push(toast2);
    });
    return Array.from(toRender, function(p) {
      return cb(p[0], p[1]);
    });
  }
  return {
    getToastToRender,
    containerRef,
    isToastActive
  };
}
function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}
function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}
function useToast(props) {
  var _useState = useState12(false), isRunning = _useState[0], setIsRunning = _useState[1];
  var _useState2 = useState12(false), preventExitTransition = _useState2[0], setPreventExitTransition = _useState2[1];
  var toastRef = useRef7(null);
  var drag = useRef7({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null,
    didMove: false
  }).current;
  var syncProps = useRef7(props);
  var autoClose = props.autoClose, pauseOnHover = props.pauseOnHover, closeToast = props.closeToast, onClick = props.onClick, closeOnClick = props.closeOnClick;
  useEffect14(function() {
    syncProps.current = props;
  });
  useEffect14(function() {
    if (toastRef.current)
      toastRef.current.addEventListener(
        "d",
        playToast,
        {
          once: true
        }
      );
    if (isFn(props.onOpen))
      props.onOpen(isValidElement(props.children) && props.children.props);
    return function() {
      var props2 = syncProps.current;
      if (isFn(props2.onClose))
        props2.onClose(isValidElement(props2.children) && props2.children.props);
    };
  }, []);
  useEffect14(function() {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function() {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);
  function onDragStart(e) {
    if (props.draggable) {
      bindDragEvents();
      var toast2 = toastRef.current;
      drag.canCloseOnClick = true;
      drag.canDrag = true;
      drag.boundingRect = toast2.getBoundingClientRect();
      toast2.style.transition = "";
      drag.x = getX(e.nativeEvent);
      drag.y = getY(e.nativeEvent);
      if (props.draggableDirection === "x") {
        drag.start = drag.x;
        drag.removalDistance = toast2.offsetWidth * (props.draggablePercent / 100);
      } else {
        drag.start = drag.y;
        drag.removalDistance = toast2.offsetHeight * (props.draggablePercent === 80 ? props.draggablePercent * 1.5 : props.draggablePercent / 100);
      }
    }
  }
  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect, top = _drag$boundingRect.top, bottom = _drag$boundingRect.bottom, left = _drag$boundingRect.left, right = _drag$boundingRect.right;
      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }
  function playToast() {
    setIsRunning(true);
  }
  function pauseToast() {
    setIsRunning(false);
  }
  function bindFocusEvents() {
    if (!document.hasFocus())
      pauseToast();
    window.addEventListener("focus", playToast);
    window.addEventListener("blur", pauseToast);
  }
  function unbindFocusEvents() {
    window.removeEventListener("focus", playToast);
    window.removeEventListener("blur", pauseToast);
  }
  function bindDragEvents() {
    drag.didMove = false;
    document.addEventListener("mousemove", onDragMove);
    document.addEventListener("mouseup", onDragEnd);
    document.addEventListener("touchmove", onDragMove);
    document.addEventListener("touchend", onDragEnd);
  }
  function unbindDragEvents() {
    document.removeEventListener("mousemove", onDragMove);
    document.removeEventListener("mouseup", onDragEnd);
    document.removeEventListener("touchmove", onDragMove);
    document.removeEventListener("touchend", onDragEnd);
  }
  function onDragMove(e) {
    var toast2 = toastRef.current;
    if (drag.canDrag && toast2) {
      drag.didMove = true;
      if (isRunning)
        pauseToast();
      drag.x = getX(e);
      drag.y = getY(e);
      if (props.draggableDirection === "x") {
        drag.delta = drag.x - drag.start;
      } else {
        drag.delta = drag.y - drag.start;
      }
      if (drag.start !== drag.x)
        drag.canCloseOnClick = false;
      toast2.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
      toast2.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
    }
  }
  function onDragEnd() {
    unbindDragEvents();
    var toast2 = toastRef.current;
    if (drag.canDrag && drag.didMove && toast2) {
      drag.canDrag = false;
      if (Math.abs(drag.delta) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }
      toast2.style.transition = "transform 0.2s, opacity 0.2s";
      toast2.style.transform = "translate" + props.draggableDirection + "(0)";
      toast2.style.opacity = "1";
    }
  }
  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };
  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  }
  if (closeOnClick) {
    eventHandlers.onClick = function(e) {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }
  return {
    playToast,
    pauseToast,
    isRunning,
    preventExitTransition,
    toastRef,
    eventHandlers
  };
}
function CloseButton(_ref) {
  var closeToast = _ref.closeToast, theme = _ref.theme, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? "close" : _ref$ariaLabel;
  return createElement44("button", {
    className: "Toastify__close-button Toastify__close-button--" + theme,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, createElement44("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, createElement44("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}
function ProgressBar(_ref) {
  var _cx, _animationEvent;
  var delay = _ref.delay, isRunning = _ref.isRunning, closeToast = _ref.closeToast, type = _ref.type, hide = _ref.hide, className = _ref.className, userStyle = _ref.style, controlledProgress = _ref.controlledProgress, progress = _ref.progress, rtl = _ref.rtl, isIn = _ref.isIn, theme = _ref.theme;
  var style = _extends3({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? "running" : "paused",
    opacity: hide ? 0 : 1
  });
  if (controlledProgress)
    style.transform = "scaleX(" + progress + ")";
  var defaultClassName = clsx_m_default("Toastify__progress-bar", controlledProgress ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar-theme--" + theme, "Toastify__progress-bar--" + type, (_cx = {}, _cx["Toastify__progress-bar--rtl"] = rtl, _cx));
  var classNames11 = isFn(className) ? className({
    rtl,
    type,
    defaultClassName
  }) : clsx_m_default(defaultClassName, className);
  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? "onTransitionEnd" : "onAnimationEnd"] = controlledProgress && progress < 1 ? null : function() {
    isIn && closeToast();
  }, _animationEvent);
  return createElement44("div", Object.assign({
    role: "progressbar",
    "aria-hidden": hide ? "true" : "false",
    "aria-label": "notification timer",
    className: classNames11,
    style
  }, animationEvent));
}
ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};
var _excluded$1 = ["theme", "type"];
var Svg = function Svg2(_ref) {
  var theme = _ref.theme, type = _ref.type, rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  return createElement44("svg", Object.assign({
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    fill: theme === "colored" ? "currentColor" : "var(--toastify-icon-color-" + type + ")"
  }, rest));
};
function Warning(props) {
  return createElement44(Svg, Object.assign({}, props), createElement44("path", {
    d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
  }));
}
function Info(props) {
  return createElement44(Svg, Object.assign({}, props), createElement44("path", {
    d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
  }));
}
function Success(props) {
  return createElement44(Svg, Object.assign({}, props), createElement44("path", {
    d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
  }));
}
function Error2(props) {
  return createElement44(Svg, Object.assign({}, props), createElement44("path", {
    d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
  }));
}
function Spinner() {
  return createElement44("div", {
    className: "Toastify__spinner"
  });
}
var Icons = {
  info: Info,
  warning: Warning,
  success: Success,
  error: Error2,
  spinner: Spinner
};
var Toast = function Toast2(props) {
  var _cx, _cx2;
  var _useToast = useToast(props), isRunning = _useToast.isRunning, preventExitTransition = _useToast.preventExitTransition, toastRef = _useToast.toastRef, eventHandlers = _useToast.eventHandlers;
  var closeButton = props.closeButton, children2 = props.children, autoClose = props.autoClose, onClick = props.onClick, type = props.type, hideProgressBar = props.hideProgressBar, closeToast = props.closeToast, Transition = props.transition, position = props.position, className = props.className, style = props.style, bodyClassName = props.bodyClassName, bodyStyle = props.bodyStyle, progressClassName = props.progressClassName, progressStyle = props.progressStyle, updateId = props.updateId, role = props.role, progress = props.progress, rtl = props.rtl, toastId = props.toastId, deleteToast = props.deleteToast, isIn = props.isIn, isLoading = props.isLoading, icon = props.icon, theme = props.theme;
  var defaultClassName = clsx_m_default("Toastify__toast", "Toastify__toast-theme--" + theme, "Toastify__toast--" + type, (_cx = {}, _cx["Toastify__toast--rtl"] = rtl, _cx));
  var cssClasses = isFn(className) ? className({
    rtl,
    position,
    type,
    defaultClassName
  }) : clsx_m_default(defaultClassName, className);
  var isProgressControlled = !!progress;
  var maybeIcon = Icons[type];
  var iconProps = {
    theme,
    type
  };
  var Icon2 = maybeIcon && maybeIcon(iconProps);
  if (icon === false) {
    Icon2 = void 0;
  } else if (isFn(icon)) {
    Icon2 = icon(iconProps);
  } else if (isValidElement(icon)) {
    Icon2 = cloneElement(icon, iconProps);
  } else if (isStr(icon)) {
    Icon2 = icon;
  } else if (isLoading) {
    Icon2 = Icons.spinner();
  }
  function renderCloseButton(closeButton2) {
    if (!closeButton2)
      return;
    var props2 = {
      closeToast,
      type,
      theme
    };
    if (isFn(closeButton2))
      return closeButton2(props2);
    if (isValidElement(closeButton2))
      return cloneElement(closeButton2, props2);
  }
  return createElement44(Transition, {
    isIn,
    done: deleteToast,
    position,
    preventExitTransition,
    nodeRef: toastRef
  }, createElement44("div", Object.assign({
    id: toastId,
    onClick,
    className: cssClasses
  }, eventHandlers, {
    style,
    ref: toastRef
  }), createElement44("div", Object.assign({}, isIn && {
    role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type
    }) : clsx_m_default("Toastify__toast-body", bodyClassName),
    style: bodyStyle
  }), Icon2 && createElement44("div", {
    className: clsx_m_default("Toastify__toast-icon", (_cx2 = {}, _cx2["Toastify--animate-icon Toastify__zoom-enter"] = !isLoading, _cx2))
  }, Icon2), createElement44("div", null, children2)), renderCloseButton(closeButton), (autoClose || isProgressControlled) && createElement44(ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
    key: "pb-" + updateId
  } : {}, {
    rtl,
    theme,
    delay: autoClose,
    isRunning,
    isIn,
    closeToast,
    hide: hideProgressBar,
    type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: isProgressControlled,
    progress
  }))));
};
var Bounce = /* @__PURE__ */ cssTransition({
  enter: "Toastify--animate Toastify__bounce-enter",
  exit: "Toastify--animate Toastify__bounce-exit",
  appendPosition: true
});
var ToastContainer = function ToastContainer2(props) {
  var _useToastContainer = useToastContainer(props), getToastToRender = _useToastContainer.getToastToRender, containerRef = _useToastContainer.containerRef, isToastActive = _useToastContainer.isToastActive;
  var className = props.className, style = props.style, rtl = props.rtl, containerId = props.containerId;
  function getClassName(position) {
    var _cx;
    var defaultClassName = clsx_m_default("Toastify__toast-container", "Toastify__toast-container--" + position, (_cx = {}, _cx["Toastify__toast-container--rtl"] = rtl, _cx));
    return isFn(className) ? className({
      position,
      rtl,
      defaultClassName
    }) : clsx_m_default(defaultClassName, parseClassName(className));
  }
  return createElement44("div", {
    ref: containerRef,
    className: "Toastify",
    id: containerId
  }, getToastToRender(function(position, toastList) {
    var containerStyle = !toastList.length ? _extends3({}, style, {
      pointerEvents: "none"
    }) : _extends3({}, style);
    return createElement44("div", {
      className: getClassName(position),
      style: containerStyle,
      key: "container-" + position
    }, toastList.map(function(_ref) {
      var content = _ref.content, toastProps = _ref.props;
      return createElement44(Toast, Object.assign({}, toastProps, {
        isIn: isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};
ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5e3,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80,
  draggableDirection: "x",
  role: "alert",
  theme: "light"
};
var containers = /* @__PURE__ */ new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;
function getToast(toastId, _ref) {
  var containerId = _ref.containerId;
  var container = containers.get(containerId || latestInstance);
  if (!container)
    return null;
  return container.getToast(toastId);
}
function generateToastId() {
  return Math.random().toString(36).substring(2, 9);
}
function getToastId(options2) {
  if (options2 && (isStr(options2.toastId) || isNum(options2.toastId))) {
    return options2.toastId;
  }
  return generateToastId();
}
function dispatchToast(content, options2) {
  if (containers.size > 0) {
    eventManager.emit(
      0,
      content,
      options2
    );
  } else {
    queue.push({
      content,
      options: options2
    });
    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement("div");
      document.body.appendChild(containerDomNode);
      render(createElement44(ToastContainer, Object.assign({}, containerConfig)), containerDomNode);
    }
  }
  return options2.toastId;
}
function mergeOptions(type, options2) {
  return _extends3({}, options2, {
    type: options2 && options2.type || type,
    toastId: getToastId(options2)
  });
}
function createToastByType(type) {
  return function(content, options2) {
    return dispatchToast(content, mergeOptions(type, options2));
  };
}
function toast(content, options2) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options2));
}
toast.loading = function(content, options2) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, _extends3({
    isLoading: true,
    autoClose: false,
    closeOnClick: false,
    closeButton: false,
    draggable: false
  }, options2)));
};
function handlePromise(promise, _ref2, options2) {
  var pending = _ref2.pending, error = _ref2.error, success = _ref2.success;
  var id2;
  if (pending) {
    id2 = isStr(pending) ? toast.loading(pending, options2) : toast.loading(pending.render, _extends3({}, options2, pending));
  }
  var resetParams = {
    isLoading: null,
    autoClose: null,
    closeOnClick: null,
    closeButton: null,
    draggable: null
  };
  var resolver = function resolver2(type, input, result) {
    if (input == null) {
      toast.dismiss(id2);
      return;
    }
    var baseParams = _extends3({
      type
    }, resetParams, options2, {
      data: result
    });
    var params = isStr(input) ? {
      render: input
    } : input;
    if (id2) {
      toast.update(id2, _extends3({}, baseParams, params));
    } else {
      toast(params.render, _extends3({}, baseParams, params));
    }
    return result;
  };
  var p = isFn(promise) ? promise() : promise;
  p.then(function(result) {
    return resolver("success", success, result);
  })["catch"](function(err) {
    return resolver("error", error, err);
  });
  return p;
}
toast.promise = handlePromise;
toast.success = /* @__PURE__ */ createToastByType(TYPE.SUCCESS);
toast.info = /* @__PURE__ */ createToastByType(TYPE.INFO);
toast.error = /* @__PURE__ */ createToastByType(TYPE.ERROR);
toast.warning = /* @__PURE__ */ createToastByType(TYPE.WARNING);
toast.warn = toast.warning;
toast.dark = function(content, options2) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, _extends3({
    theme: "dark"
  }, options2)));
};
toast.dismiss = function(id2) {
  return eventManager.emit(
    1,
    id2
  );
};
toast.clearWaitingQueue = function(params) {
  if (params === void 0) {
    params = {};
  }
  return eventManager.emit(
    5,
    params
  );
};
toast.isActive = function(id2) {
  var isToastActive = false;
  containers.forEach(function(container) {
    if (container.isToastActive && container.isToastActive(id2)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};
toast.update = function(toastId, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  setTimeout(function() {
    var toast2 = getToast(toastId, options2);
    if (toast2) {
      var oldOptions = toast2.props, oldContent = toast2.content;
      var nextOptions = _extends3({}, oldOptions, options2, {
        toastId: options2.toastId || toastId,
        updateId: generateToastId()
      });
      if (nextOptions.toastId !== toastId)
        nextOptions.staleId = toastId;
      var content = nextOptions.render || oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
toast.done = function(id2) {
  toast.update(id2, {
    progress: 1
  });
};
toast.onChange = function(callback) {
  if (isFn(callback)) {
    eventManager.on(
      4,
      callback
    );
  }
  return function() {
    isFn(callback) && eventManager.off(
      4,
      callback
    );
  };
};
toast.configure = function(config) {
  if (config === void 0) {
    config = {};
  }
  lazy = true;
  containerConfig = config;
};
toast.POSITION = POSITION;
toast.TYPE = TYPE;
eventManager.on(
  2,
  function(containerInstance) {
    latestInstance = containerInstance.containerId || containerInstance;
    containers.set(latestInstance, containerInstance);
    queue.forEach(function(item) {
      eventManager.emit(
        0,
        item.content,
        item.options
      );
    });
    queue = [];
  }
).on(
  3,
  function(containerInstance) {
    containers["delete"](containerInstance.containerId || containerInstance);
    if (containers.size === 0) {
      eventManager.off(
        0
        /* Show */
      ).off(
        1
        /* Clear */
      ).off(
        5
        /* ClearWaitingQueue */
      );
    }
    if (canUseDom && containerDomNode) {
      document.body.removeChild(containerDomNode);
    }
  }
);

// src/layout/toastify/toasterNotifyer.tsx
var toastify = (message, color, title = "", detail) => {
  if (message || title) {
    toast(/* @__PURE__ */ React47.createElement(ToastContent, { title: title || upperFirst(color), message, detail }), {
      closeButton: false,
      className: `toast fade show toast-${color}`
    });
  }
};
var toastifySuccess = (message, title) => toastify(message, "success", title);
var toastifyErrorMessage = (message, title = "Error") => toastify(message, "danger", title);
var toastifyWarningMessage = (message, title, detail) => toastify(message, "warning", title, detail);
var toastifyInfo = (message) => toastify(message, "info");
var useQueryErrorHandler = (isError, error) => {
  useEffect15(() => {
    if (isError) {
      toastifyErrorMessage(error == null ? void 0 : error.message);
    }
  }, [isError, error]);
};

// src/layout/Footer.tsx
import * as React48 from "react";
var Footer = ({ applicationId }) => {
  return /* @__PURE__ */ React48.createElement("footer", { className: "mt-3 bg-light-1 zindex-sticky", style: { zIndex: 1020 } }, /* @__PURE__ */ React48.createElement(
    "sgwt-mini-footer",
    {
      id: applicationId != null ? applicationId : "ic-mini-footer",
      mode: "sg-markets",
      type: "compact",
      design: "light",
      container: "container-fluid",
      "contact-us": "{'mail': 'sgmarkets@sgcib.com'}"
    }
  ));
};

// src/common/FilesUpload/FileUploadValidate.tsx
var UnsupportedFileType = ({ file, supportedFileTypes }) => /* @__PURE__ */ React49.createElement(React49.Fragment, null, /* @__PURE__ */ React49.createElement("b", null, "The type of the file ", get7(file, "name", ""), " is not supported. ", /* @__PURE__ */ React49.createElement("br", null)), /* @__PURE__ */ React49.createElement("b", null, `${pluralize("Allowed type", supportedFileTypes.length)}: ${supportedFileTypes.join(", ")}.`));
var TooLargeFile = ({ file, maxFileSize }) => /* @__PURE__ */ React49.createElement("b", null, `The file ${get7(file, "name", "")} is too large (${bytesToSize(get7(file, "size", 0))} > ${bytesToSize(
  maxFileSize
)})
          for the destination.`);
var MaxSizeReached = ({ totalSize, maxFileSize }) => /* @__PURE__ */ React49.createElement("b", null, "The total size of files (", bytesToSize(totalSize), ") should not exceed ", bytesToSize(maxFileSize));
var validateUploadedFile = (existingFiles, addedFile, maxFileSize, maxSize, allowedFileTypes = defaultAllowedFileTypes) => {
  if (!allowedFileTypes.includes(getFileType(addedFile))) {
    toastifyErrorMessage(/* @__PURE__ */ React49.createElement(UnsupportedFileType, { file: addedFile, supportedFileTypes: allowedFileTypes }));
    return null;
  }
  if (maxFileSize && addedFile.size >= maxFileSize) {
    toastifyErrorMessage(/* @__PURE__ */ React49.createElement(TooLargeFile, { file: addedFile, maxFileSize }));
    return null;
  }
  const uploadedFiles = [...Array.from(existingFiles), addedFile];
  const totalSize = sum(map7(uploadedFiles, ({ size: size6 }) => size6));
  if (maxSize && totalSize >= maxSize) {
    toastifyErrorMessage(/* @__PURE__ */ React49.createElement(MaxSizeReached, { totalSize, maxFileSize: maxSize }));
    return null;
  }
  return uploadedFiles;
};

// src/common/FilesUpload/FilesUpload.tsx
import { allowedFileTypes as defaultAllowedFileTypes2 } from "@ic-anywhere/ic-utils";

// src/common/FilesUpload/UploadedFiles.tsx
import * as React51 from "react";
import { map as map8, noop as noop9, partial as partial2 } from "lodash-es";

// src/common/FilesUpload/IconUploadedFile.tsx
import * as React50 from "react";
var IconUploadedFile = () => /* @__PURE__ */ React50.createElement("svg", { className: "text-info px-4", height: "48", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 41.817 50" }, /* @__PURE__ */ React50.createElement("g", { transform: "translate(-878 -148)" }, /* @__PURE__ */ React50.createElement(
  "path",
  {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M0,2.515V48H39.817V16.4L23.415,0H0Z",
    transform: "translate(879 149)"
  }
), /* @__PURE__ */ React50.createElement("g", { transform: "translate(887 163)" }, /* @__PURE__ */ React50.createElement("path", { fill: "none", d: "M0,0H24V24H0Z" }), /* @__PURE__ */ React50.createElement("path", { fill: "#fff", d: "M9,16.17,4.83,12,3.41,13.41,9,19,21,7,19.59,5.59Z" }))));

// src/common/FilesUpload/UploadedFiles.tsx
var CloseFileButton = ({ onDelete, file }) => /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement("button", { "data-testid": "buttonId", className: "btn btn-lg btn-flat-light mx-4", onClick: partial2(onDelete, file) }, /* @__PURE__ */ React51.createElement("em", { className: "icon icon-md pointer" }, "close")));
var FileInfo = ({
  file,
  disabled,
  onFileClick
}) => {
  const handleClick = () => {
    onFileClick == null ? void 0 : onFileClick(file);
  };
  const { name } = file;
  const fileNameClass = "font-weight-medium text-primary pointer";
  return /* @__PURE__ */ React51.createElement("div", { className: "pl-3 flex-grow-1" }, /* @__PURE__ */ React51.createElement("div", null, !disabled && /* @__PURE__ */ React51.createElement("span", { className: "font-weight-medium text-info" }, name), disabled && /* @__PURE__ */ React51.createElement("a", { className: fileNameClass, onClick: handleClick }, name), /* @__PURE__ */ React51.createElement("br", null)));
};
var UploadedFile = ({ file, onDelete, disabled, index, onFileClick = noop9, size: size6 }) => /* @__PURE__ */ React51.createElement(
  "div",
  {
    key: `file_upload_${index}`,
    className: `bg-lvl2 ${size6 === "normal" ? "py-4" : "py-1"} d-flex align-items-center mb-2`
  },
  !disabled && size6 === "normal" ? /* @__PURE__ */ React51.createElement(IconUploadedFile, null) : /* @__PURE__ */ React51.createElement("em", { className: `icon px-4 text-secondary icon-${size6 === "normal" ? "xl" : "sm"}` }, "insert_drive_file"),
  /* @__PURE__ */ React51.createElement(FileInfo, { file, disabled, onFileClick }),
  !disabled && /* @__PURE__ */ React51.createElement(CloseFileButton, { onDelete, file })
);
var UploadedFiles = ({
  files,
  onDelete,
  disabled,
  onFileClick = noop9,
  size: size6
}) => /* @__PURE__ */ React51.createElement(React51.Fragment, null, map8(files, (file, index) => /* @__PURE__ */ React51.createElement(
  UploadedFile,
  {
    key: index,
    file,
    index,
    onDelete,
    onFileClick,
    disabled,
    size: size6
  }
)));

// src/common/FilesUpload/FilesUpload.tsx
var _1MB = 1e6;
var _5MB = Math.pow(1024, 2) * 5;
var FilesUpload = ({
  maxSize = _5MB,
  maxFileSize = _5MB,
  onFilesChange,
  files = [],
  disabled = false,
  onFileClick = noop10,
  allowedFileTypes = defaultAllowedFileTypes2,
  maxFilesCount,
  displaySize = "normal"
}) => {
  const [filesState, setFiles] = React52.useState(files);
  React52.useEffect(() => {
    if (!isEqual3(filesState, files)) {
      setFiles(files);
    }
  }, [files]);
  const handleOnFilesAdded = (addedFiles) => {
    const uploadedFiles = validateUploadedFile(filesState, addedFiles[0], maxFileSize, maxSize, allowedFileTypes);
    if (!uploadedFiles) {
      return;
    }
    setFiles(uploadedFiles);
    onFilesChange(uploadedFiles);
  };
  const handleOnFileDeleted = (file) => {
    const updatedFiles = filter(filesState, (uploadedFile) => uploadedFile !== file);
    setFiles(updatedFiles);
    onFilesChange(updatedFiles);
  };
  const totalSize = sumBy(files, ({ size: size6 }) => size6);
  return /* @__PURE__ */ React52.createElement(React52.Fragment, null, /* @__PURE__ */ React52.createElement(
    UploadedFiles,
    {
      files: filesState,
      onDelete: handleOnFileDeleted,
      onFileClick,
      disabled,
      size: displaySize
    }
  ), !disabled && totalSize < maxSize && (!maxFilesCount || size(files) < maxFilesCount) && /* @__PURE__ */ React52.createElement(
    DropZone,
    {
      onFilesAdded: handleOnFilesAdded,
      accept: allowedFileTypes.map((type) => `.${type}`).join(","),
      size: displaySize
    }
  ));
};

// src/common/CurrencyPicker/CurrencyPicker.tsx
import * as React53 from "react";
import { Loader as Loader2, Select } from "@sgbs-ui/core";
import { useCurrenciesQuery } from "@ic-anywhere/ic-dal";
var CurrencyPicker = ({ repo, onChange, defaultValue = "EUR" }) => {
  const [currency, setCurrency] = React53.useState({ value: defaultValue, label: defaultValue });
  const { data: currencies, isLoading, isSuccess } = useCurrenciesQuery(repo);
  const handleOnChange = (item) => {
    if (!item) {
      return;
    }
    setCurrency(item);
    onChange(item == null ? void 0 : item.value);
  };
  return /* @__PURE__ */ React53.createElement(React53.Fragment, null, /* @__PURE__ */ React53.createElement(Loader2, { isVisible: isLoading }), isSuccess && currencies && /* @__PURE__ */ React53.createElement(
    Select.SingleSelect,
    {
      selectedItem: currency,
      onChange: handleOnChange,
      idField: "label",
      labelField: "label",
      items: currencies,
      size: "md",
      inError: !currency
    }
  ));
};

// src/common/CountryPicker/CountrySinglePicker.tsx
import * as React55 from "react";
import { Select as Select2 } from "@sgbs-ui/core";

// src/hooks/useGenerateId.ts
import React54 from "react";
import { generateUID } from "@sgbs-ui/core";
import { isStringEmpty as isStringEmpty3 } from "@ic-anywhere/ic-utils";
var useGenerateId = (initialId) => React54.useMemo(() => {
  if (initialId === void 0 || isStringEmpty3(initialId)) {
    return generateUID("picker");
  }
  return initialId;
}, [initialId]);

// src/common/CountryPicker/CountrySinglePicker.tsx
import { useGetCountriesQuery } from "@ic-anywhere/ic-dal";
import { find as find3 } from "lodash-es";
var CountrySinglePicker = ({
  repo,
  id: id2,
  selectedId,
  placeholder = "Search countries",
  onChange,
  size: size6 = "lg",
  disabled,
  outline,
  onReady,
  inError,
  errorMessage
}) => {
  var _a;
  React55.useEffect(() => {
    onReady == null ? void 0 : onReady();
  }, []);
  const pickerId = useGenerateId(id2);
  const { data: countries = [], isError: isFetchError, error: fetchError } = useGetCountriesQuery(repo);
  const selectedItem = find3(countries, (c) => c.iso3 === selectedId);
  return /* @__PURE__ */ React55.createElement(React55.Fragment, null, /* @__PURE__ */ React55.createElement(
    Select2.SingleSelect,
    {
      id: pickerId,
      items: countries,
      selectedItem: selectedItem != null ? selectedItem : null,
      idField: "iso3",
      labelField: "name",
      onChange,
      iconName: "public",
      placeholder,
      inError: inError || isFetchError,
      errorMessage: (_a = errorMessage != null ? errorMessage : fetchError) != null ? _a : void 0,
      size: size6,
      keepOrder: false,
      isOutline: outline,
      disabled
    }
  ), inError && /* @__PURE__ */ React55.createElement(InvalidFeedback, { errorMessage }), isFetchError && /* @__PURE__ */ React55.createElement(InvalidFeedback, { errorMessage: fetchError != null ? fetchError : void 0 }));
};

// src/common/TypologyPicker/TypologySinglePicker.tsx
import * as React56 from "react";
import { Select as Select3 } from "@sgbs-ui/core";
import { useGetTypologiesQuery } from "@ic-anywhere/ic-dal";
import { find as find4 } from "lodash-es";
var TypologySinglePicker = ({
  repo,
  id: id2,
  selectedId,
  placeholder = "Search typologies",
  onChange,
  size: size6 = "lg",
  disabled,
  outline,
  onReady,
  inError,
  errorMessage
}) => {
  var _a;
  React56.useEffect(() => {
    onReady == null ? void 0 : onReady();
  }, []);
  const pickerId = useGenerateId(id2);
  const { data: typologies = [], isError: isFetchError, error: fetchError } = useGetTypologiesQuery(repo);
  const selectedItem = find4(typologies, (c) => c.id === selectedId);
  return /* @__PURE__ */ React56.createElement(React56.Fragment, null, /* @__PURE__ */ React56.createElement(
    Select3.SingleSelect,
    {
      id: pickerId,
      items: typologies,
      selectedItem: selectedItem != null ? selectedItem : null,
      idField: "iso3",
      labelField: "name",
      onChange,
      iconName: "public",
      placeholder,
      inError: inError || isFetchError,
      errorMessage: (_a = errorMessage != null ? errorMessage : fetchError) != null ? _a : void 0,
      size: size6,
      keepOrder: false,
      isOutline: outline,
      disabled
    }
  ), inError && /* @__PURE__ */ React56.createElement(InvalidFeedback, { errorMessage }), isFetchError && /* @__PURE__ */ React56.createElement(InvalidFeedback, { errorMessage: fetchError != null ? fetchError : void 0 }));
};

// src/common/TimeZones/timeZone.utils.ts
var import_timezones = __toESM(require_timezones2());
import { drop, filter as filter2, flatMap, includes } from "lodash-es";
var filterIanaCodes = (codes) => filter2(codes, (code) => !code.startsWith("Etc/") && includes(code, "/"));
var mapIanaToLabel = (iana, offset) => {
  const splitted = iana.split("/");
  const labels = splitted.map((lbl) => lbl.replace("_", " "));
  return `(GMT${offset < 0 ? "" : "+"}${offset}) ${labels.join(" - ")}`;
};
var timezoneModels = flatMap(
  import_timezones.default,
  ({ utc: ianaCodes }) => filterIanaCodes(ianaCodes).map((iana) => ({
    id: iana
  }))
);
var mapIanaToShortLabel = (iana) => {
  if (!iana) {
    return "";
  }
  const splitted = drop(iana.split("/"), 1);
  const labels = splitted.map((lbl) => lbl.replace("_", " "));
  return labels.join(" - ");
};
var getOffsetForDate = (targetDate, ianaCode) => {
  const { offset, isInDST } = targetDate.setZone(ianaCode);
  return { offset: offset / 60, isInDST };
};
var getTimeZonesItemsForDate = (targetDate) => {
  return timezoneModels.map(({ id: id2 }) => {
    const { offset, isInDST } = getOffsetForDate(targetDate, id2);
    return {
      id: id2,
      label: mapIanaToLabel(id2, offset),
      isDaylight: isInDST,
      offset
    };
  });
};

// src/common/TimeZones/TimeZonePicker.tsx
import * as React57 from "react";
import { Select as Select4 } from "@sgbs-ui/core";
import { find as find5 } from "lodash-es";
import { DateTime } from "luxon";
var TimeZonePicker = ({
  id: id2,
  placeholder = "Select time zone",
  selectedId,
  targetDate = DateTime.utc().startOf("day"),
  onChange,
  size: size6 = "lg",
  disabled,
  outline,
  inError,
  errorMessage
}) => {
  const pickerId = useGenerateId(id2);
  const [selectedItem, setSelectedItem] = React57.useState(null);
  const targetDataMillis = targetDate == null ? void 0 : targetDate.toMillis();
  const tzItems = React57.useMemo(() => getTimeZonesItemsForDate(targetDate), [targetDataMillis]);
  React57.useEffect(() => {
    var _a;
    setSelectedItem((_a = find5(tzItems, (c) => c.id === selectedId)) != null ? _a : null);
  }, [selectedId, tzItems]);
  const handleOnChange = (selected) => {
    setSelectedItem(selected);
    onChange(selected);
  };
  return /* @__PURE__ */ React57.createElement(React57.Fragment, null, /* @__PURE__ */ React57.createElement(
    Select4.SingleSelect,
    {
      id: pickerId,
      items: tzItems,
      selectedItem: selectedItem != null ? selectedItem : null,
      idField: "label",
      labelField: "label",
      onChange: handleOnChange,
      iconName: "public",
      placeholder,
      inError,
      errorMessage,
      size: size6,
      keepOrder: false,
      isOutline: outline,
      disabled
    }
  ), inError && /* @__PURE__ */ React57.createElement(InvalidFeedback, { errorMessage }));
};

// src/common/TimeZones/TimeZoneInfo.tsx
import { defaultUserTimeZone, mapToDisplayPeriodWithTimezone } from "@ic-anywhere/ic-utils";
import * as React58 from "react";
var TimeZoneInfo = ({ period, timeZone, id: id2, hideEndDate, className }) => {
  const { startDate, endDate } = period;
  if (!startDate || !endDate) {
    return null;
  }
  return /* @__PURE__ */ React58.createElement("div", { className }, mapToDisplayPeriodWithTimezone({ startDate, endDate }, timeZone, hideEndDate), timeZone && timeZone !== defaultUserTimeZone && /* @__PURE__ */ React58.createElement(
    Tooltip,
    {
      id: `timezone-${id2}`,
      content: mapToDisplayPeriodWithTimezone({ startDate, endDate }, defaultUserTimeZone),
      placement: "right"
    },
    /* @__PURE__ */ React58.createElement("em", { className: "ml-1 icon icon-sm text-secondary" }, "info")
  ));
};

// src/common/Cards/Card.tsx
import * as React59 from "react";
import { classNames as classNames3 } from "@ic-anywhere/ic-utils";
var Card = ({ title, children: children2, className }) => /* @__PURE__ */ React59.createElement("div", { className: classNames3("card card-bordered mb-4", className) }, /* @__PURE__ */ React59.createElement("div", { className: "card-body p-4" }, title && /* @__PURE__ */ React59.createElement("h2", { className: "card-title mb-4" }, title), children2));

// src/common/Cards/CardLabelItem.tsx
import * as React60 from "react";
import { classNames as classNames4 } from "@ic-anywhere/ic-utils";
var CardLabelItem = ({ label, children: children2, labelClass, valueClass, cardClass }) => children2 ? /* @__PURE__ */ React60.createElement("div", { className: classNames4("col", "mb-3", cardClass) }, /* @__PURE__ */ React60.createElement("label", { className: labelClass || "text-secondary font-weight-500" }, label), /* @__PURE__ */ React60.createElement("div", { className: valueClass || "" }, children2)) : /* @__PURE__ */ React60.createElement(React60.Fragment, null);

// src/common/ResponsiveTitle.tsx
import * as React61 from "react";
var ResponsiveTitle = ({ title, className = "" }) => /* @__PURE__ */ React61.createElement("div", { className }, /* @__PURE__ */ React61.createElement("h4", { className: "text-truncate d-md-none d-sm-block" }, title), /* @__PURE__ */ React61.createElement("h3", { className: "text-truncate d-none d-md-block" }, title));

// src/common/AutoCompleteTextPicker/AutoCompleteTextPicker.tsx
import * as React62 from "react";

// node_modules/react-cool-onclickoutside/dist/index.esm.js
import { useState as useState16, useRef as useRef8, useCallback as useCallback5, useEffect as useEffect20 } from "react";
var canUsePassiveEvents = function() {
  if (typeof window === "undefined" || typeof window.addEventListener !== "function")
    return false;
  var passive = false;
  var options2 = Object.defineProperty({}, "passive", {
    // eslint-disable-next-line getter-return
    get: function get9() {
      passive = true;
    }
  });
  var noop28 = function noop29() {
    return null;
  };
  window.addEventListener("test", noop28, options2);
  window.removeEventListener("test", noop28, options2);
  return passive;
};
var DEFAULT_IGNORE_CLASS = "ignore-onclickoutside";
var checkClass = function checkClass2(el, cl) {
  var _el$classList;
  return (_el$classList = el.classList) == null ? void 0 : _el$classList.contains(cl);
};
var hasIgnoreClass = function hasIgnoreClass2(e, ignoreClass) {
  var el = e.target || e;
  while (el) {
    if (Array.isArray(ignoreClass)) {
      if (ignoreClass.some(function(c) {
        return checkClass(el, c);
      }))
        return true;
    } else if (checkClass(el, ignoreClass)) {
      return true;
    }
    el = el.parentElement;
  }
  return false;
};
var clickedOnScrollbar = function clickedOnScrollbar2(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
};
var getEventOptions = function getEventOptions2(type) {
  return type.includes("touch") && canUsePassiveEvents() ? {
    passive: true
  } : false;
};
var useOnclickOutside = function useOnclickOutside2(callback, _temp2) {
  var _ref = _temp2 === void 0 ? {} : _temp2, refsOpt = _ref.refs, disabled = _ref.disabled, _ref$eventTypes = _ref.eventTypes, eventTypes = _ref$eventTypes === void 0 ? ["mousedown", "touchstart"] : _ref$eventTypes, excludeScrollbar = _ref.excludeScrollbar, _ref$ignoreClass = _ref.ignoreClass, ignoreClass = _ref$ignoreClass === void 0 ? DEFAULT_IGNORE_CLASS : _ref$ignoreClass, _ref$detectIFrame = _ref.detectIFrame, detectIFrame = _ref$detectIFrame === void 0 ? true : _ref$detectIFrame;
  var _useState = useState16([]), refsState = _useState[0], setRefsState = _useState[1];
  var callbackRef = useRef8(callback);
  callbackRef.current = callback;
  var ref = useCallback5(function(el) {
    return setRefsState(function(prevState) {
      return [].concat(prevState, [{
        current: el
      }]);
    });
  }, []);
  useEffect20(
    function() {
      if (!(refsOpt != null && refsOpt.length) && !refsState.length)
        return;
      var getEls = function getEls2() {
        var els = [];
        (refsOpt || refsState).forEach(function(_ref2) {
          var current = _ref2.current;
          return current && els.push(current);
        });
        return els;
      };
      var handler = function handler2(e) {
        if (!hasIgnoreClass(e, ignoreClass) && !(excludeScrollbar && clickedOnScrollbar(e)) && getEls().every(function(el) {
          return !el.contains(e.target);
        }))
          callbackRef.current(e);
      };
      var blurHandler = function blurHandler2(e) {
        return (
          // On firefox the iframe becomes document.activeElement in the next event loop
          setTimeout(function() {
            var _document = document, activeElement = _document.activeElement;
            if ((activeElement == null ? void 0 : activeElement.tagName) === "IFRAME" && !hasIgnoreClass(activeElement, ignoreClass) && !getEls().includes(activeElement))
              callbackRef.current(e);
          }, 0)
        );
      };
      var removeEventListener = function removeEventListener2() {
        eventTypes.forEach(function(type) {
          return (
            // @ts-expect-error
            document.removeEventListener(type, handler, getEventOptions(type))
          );
        });
        if (detectIFrame)
          window.removeEventListener("blur", blurHandler);
      };
      if (disabled) {
        removeEventListener();
        return;
      }
      eventTypes.forEach(function(type) {
        return document.addEventListener(type, handler, getEventOptions(type));
      });
      if (detectIFrame)
        window.addEventListener("blur", blurHandler);
      return function() {
        return removeEventListener();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      refsState,
      ignoreClass,
      excludeScrollbar,
      disabled,
      detectIFrame,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(eventTypes)
    ]
  );
  return ref;
};
var index_esm_default2 = useOnclickOutside;

// src/common/AutoCompleteTextPicker/AutoCompleteTextPicker.tsx
import { SearchInput } from "@sgbs-ui/core";
import { filter as filter3, size as _size, some as some3, startsWith, toLower } from "lodash-es";
var itemsClass = `d-flex list-group-item border-0 mt-0 list-group-item-action list-group-item-primary align-items-center`;
var AutoCompleteTextPicker = ({
  placeholder,
  autocompleteItems,
  onChange,
  size: size6 = "lg",
  disabled,
  defaultValue,
  minCharsForSuggestion = 1
}) => {
  const compoId = useGenerateId("autocompletepicker");
  const [currentInput, setCurrentInput] = React62.useState("");
  const [shouldDisplayDropdown, setShouldDisplayDropdown] = React62.useState(false);
  const rootRef = index_esm_default2(() => {
    setShouldDisplayDropdown(false);
  });
  React62.useEffect(() => {
    setCurrentInput(defaultValue != null ? defaultValue : "");
  }, [defaultValue]);
  const handleOnFocus = () => {
    setShouldDisplayDropdown(true);
  };
  const onInputChanged = (value) => {
    setCurrentInput(value);
    setShouldDisplayDropdown(true);
    onChange(value);
  };
  const onSelectSuggestion = (value) => {
    setCurrentInput(value);
    setShouldDisplayDropdown(false);
    onChange(value);
  };
  const displayedItems = _size(currentInput) >= minCharsForSuggestion ? filter3(autocompleteItems, (item) => startsWith(toLower(item), toLower(currentInput))) : [];
  const lastItemIsCurrentInput = _size(displayedItems) === 1 && displayedItems[0].trim() === currentInput.trim();
  const isDropdownOpen = shouldDisplayDropdown && some3(displayedItems) && !lastItemIsCurrentInput;
  return /* @__PURE__ */ React62.createElement("div", { className: "dropdown position-relative", id: compoId, ref: rootRef }, /* @__PURE__ */ React62.createElement(
    SearchInput,
    {
      placeholder,
      onChange: onInputChanged,
      size: size6,
      disabled,
      value: currentInput,
      onFocus: handleOnFocus
    }
  ), isDropdownOpen && /* @__PURE__ */ React62.createElement("div", { className: "bg-lvl1 shadow-lg w-100", style: { position: "absolute", right: 0, zIndex: 1e3 } }, /* @__PURE__ */ React62.createElement("div", { className: "p-0", style: { maxHeight: "220px", overflowY: "auto" } }, /* @__PURE__ */ React62.createElement("ul", { className: "list-group" }, displayedItems.map((item, index) => /* @__PURE__ */ React62.createElement(
    "div",
    {
      key: index,
      onClick: () => onSelectSuggestion(item),
      style: { cursor: "pointer" },
      title: "item",
      className: itemsClass
    },
    /* @__PURE__ */ React62.createElement("div", { className: "w-100" }, item)
  ))))));
};

// src/common/HtmlSanitizer.tsx
var import_sanitize_html = __toESM(require_sanitize_html());
import * as React63 from "react";
var additionalAttributes = {
  table: ["border", "cellspacing", "style"],
  td: ["style"],
  img: ["src", "style"]
};
var additionalAllowedStyles = {
  table: {
    "border-collapse": [/^(collapse)$/]
  },
  td: {
    width: [/^[\d.]+(?:px|em|%|pt)$/]
  }
};
var HtmlSanitizer = ({ content }) => {
  const sanitize = (dirty) => (0, import_sanitize_html.default)(dirty, {
    allowedTags: [...import_sanitize_html.default.defaults.allowedTags, "img"],
    allowedAttributes: { ...import_sanitize_html.default.defaults.allowedAttributes, ...additionalAttributes },
    allowedStyles: additionalAllowedStyles,
    allowedSchemesByTag: {
      ...import_sanitize_html.default.defaults.allowedSchemesByTag,
      img: ["data", "https"]
    }
  });
  return /* @__PURE__ */ React63.createElement("div", { dangerouslySetInnerHTML: { __html: sanitize(content) } });
};
var OutlookHtmlSanitizer = ({ content }) => {
  const sanitize = (dirty) => (0, import_sanitize_html.default)(dirty, {
    allowedTags: [...import_sanitize_html.default.defaults.allowedTags, "img", "style"],
    allowedAttributes: false,
    allowedSchemesByTag: {
      ...import_sanitize_html.default.defaults.allowedSchemesByTag,
      img: ["data", "https"]
    }
  });
  return /* @__PURE__ */ React63.createElement("div", { dangerouslySetInnerHTML: { __html: sanitize(content) } });
};

// src/common/JobTypePicker/JobTypePicker.tsx
import { Select as Select5 } from "@sgbs-ui/core";
import * as React64 from "react";
var JOB_TYPES = [
  { label: "Advisory", key: "Advisory" },
  { label: "Analyst", key: "Analyst" },
  { label: "Assistant", key: "Assistant" },
  { label: "Chief executive officer", key: "Chief executive officer" },
  { label: "Chief financial officer", key: "Chief financial officer" },
  { label: "Chief investment officer", key: "Chief investment officer" },
  { label: "Chief operation officer", key: "Chief operation officer" },
  { label: "Chief risk officer", key: "Chief risk officer" },
  { label: "Communication & media", key: "Communication & media" },
  { label: "Consulting", key: "Consulting" },
  { label: "HR", key: "HR" },
  { label: "Legal and tax", key: "Legal and tax" },
  { label: "Management", key: "Management" },
  { label: "Operations", key: "Operations" },
  { label: "Political", key: "Political" },
  { label: "Portfolio management", key: "Portfolio management" },
  { label: "Sales and trading", key: "Sales and trading" },
  { label: "Senior management", key: "Senior management" },
  { label: "Stakeholder", key: "Stakeholder" },
  { label: "Treasury & finance", key: "Treasury & finance" },
  { label: "Journalist", key: "Journalist" },
  { label: "Other", key: "-" }
];
var JobTypePicker = ({ initValues, size: size6, onChange }) => /* @__PURE__ */ React64.createElement(
  Select5,
  {
    placeholder: "Select job types",
    items: JOB_TYPES,
    onChange: (items) => onChange(items.map(({ key }) => key)),
    selectedItems: JOB_TYPES.filter(({ key }) => initValues.includes(key)),
    iconName: "work",
    size: size6,
    idField: "key",
    labelField: "label"
  }
);

// src/common/ContactListPicker/ContactListMultiPicker.tsx
import * as React65 from "react";
import { Select as Select6 } from "@sgbs-ui/core";
import { useGetContactLists } from "@ic-anywhere/ic-dal";
import { filter as filter4, includes as includes2 } from "lodash-es";
var ContactListMultiPicker = ({
  id: id2,
  repo,
  onChange,
  size: size6 = "lg",
  disabled = false,
  selectedIds,
  onlySharedWithMe = false
}) => {
  const pickerId = useGenerateId(id2);
  const { data: contactLists } = useGetContactLists(repo, { onlySharedWithMe });
  const selectedContactsLists = filter4(contactLists, ({ id: id3 }) => includes2(selectedIds, id3));
  const filteredContactLists = (contactLists2) => {
    if (contactLists2) {
      return contactLists2.filter((contact) => {
        var _a;
        return ((_a = contact.contactsCount) != null ? _a : 0) < 101;
      });
    }
    return [];
  };
  return /* @__PURE__ */ React65.createElement(
    Select6,
    {
      id: pickerId,
      items: filteredContactLists(contactLists),
      selectedItems: selectedContactsLists,
      idField: "id",
      labelField: "name",
      onChange,
      iconName: "public",
      placeholder: "Search contact list",
      size: size6,
      keepOrder: false,
      disabled
    }
  );
};

// src/common/Avatar/Avatar.tsx
import { classNames as classNames5, mapToInitials } from "@ic-anywhere/ic-utils";
import * as React66 from "react";
var Avatar = ({ avatarType, name, sizePx = 32, additionalClassName = "" }) => {
  const sizeStyle = { width: sizePx, height: sizePx };
  return /* @__PURE__ */ React66.createElement(
    "div",
    {
      className: classNames5(
        "rounded-circle bg-lvl3 d-flex align-items-center justify-content-center",
        additionalClassName
      ),
      style: sizeStyle
    },
    /* @__PURE__ */ React66.createElement("span", { className: "text-secondary text-uppercase display-4" }, avatarType === "initials" ? mapToInitials(name) : /* @__PURE__ */ React66.createElement("em", { className: "icon icon-lg" }, name))
  );
};

// src/common/PageErrorContainer.tsx
import * as React67 from "react";
import { noop as noop11 } from "lodash-es";
var PageErrorContainer = ({ errorMessage, isRetryShow = false, onRetry = noop11 }) => {
  return /* @__PURE__ */ React67.createElement(React67.Fragment, null, /* @__PURE__ */ React67.createElement("div", { className: "text-center" }, /* @__PURE__ */ React67.createElement("div", { className: "mx-auto" }, "We didn't get a response from the server due to network or server error"), errorMessage && /* @__PURE__ */ React67.createElement("div", { className: "w-25 mx-auto mt-3" }, errorMessage), /* @__PURE__ */ React67.createElement("div", { className: "mt-3" }, isRetryShow && /* @__PURE__ */ React67.createElement("button", { className: "btn btn-discreet-dark ml-2", onClick: onRetry }, "Retry"))));
};

// src/common/CollapseButton/CollapseButton.tsx
import * as React68 from "react";
var CollapseButton = ({
  isCollapse,
  onClick,
  classNameArrowUp = "keyboard_arrow_right",
  size: size6 = "lg",
  className = "btn-flat-primary",
  children: children2
}) => {
  return /* @__PURE__ */ React68.createElement(
    "a",
    {
      className: `btn collapseButtonFocus ${className} p-0`,
      "data-toggle": "collapse",
      "data-testid": "collapse",
      onClick
    },
    /* @__PURE__ */ React68.createElement("em", { className: `icon icon-${size6} pb-1` }, isCollapse ? classNameArrowUp : "keyboard_arrow_down"),
    children2
  );
};

// src/common/TimeLine.tsx
import * as React69 from "react";
var TimeLine = ({ orientation = "vertical", className = "", children: children2 }) => /* @__PURE__ */ React69.createElement("ul", { className: `sgbs-timeline sgbs-timeline-${orientation} ${className}` }, children2);

// src/common/TimeLineItem.tsx
import * as React70 from "react";
import { parseDate } from "@ic-anywhere/ic-utils";
import { noop as noop12 } from "lodash-es";
var TimeLineItem = ({
  date,
  children: children2,
  active = false,
  noDate = false,
  noYear = false,
  canEditDate = false,
  onEditDate = noop12
}) => {
  if (date === null) {
    return null;
  }
  const utcDate = parseDate(date);
  return /* @__PURE__ */ React70.createElement("li", { className: `sgbs-timeline-item w-100 col-12 ${active ? "active" : ""}` }, /* @__PURE__ */ React70.createElement("div", { className: "d-flex align-items-end" }, /* @__PURE__ */ React70.createElement("div", null, !noYear && /* @__PURE__ */ React70.createElement("span", { className: "sgbs-timeline-day" }, utcDate == null ? void 0 : utcDate.toFormat("yyyy")), !noDate && /* @__PURE__ */ React70.createElement("span", { className: "sgbs-timeline-date display-4" }, utcDate == null ? void 0 : utcDate.toFormat("dd MMM"))), canEditDate && (!noYear || !noDate) && /* @__PURE__ */ React70.createElement("i", { onClick: () => onEditDate(date), className: "icon pl-2 icon-md", style: { cursor: "pointer" } }, "edit")), children2 ? children2 : null);
};

// src/common/BankAccountMutliPicker/BankAccountMutliPicker.tsx
import * as React71 from "react";
import { Loader as Loader3, Select as Select7 } from "@sgbs-ui/core";
import { useGetBankAccounts } from "@ic-anywhere/ic-dal";
import { isEmpty as isEmpty7, sortBy } from "lodash-es";
var formatMessageCallBack = (message) => {
  var _a;
  return (_a = message.defaultMessage) != null ? _a : "";
};
var mapThirdIdToBankAccountFilter = (thirdIds) => {
  var _a;
  return (_a = thirdIds == null ? void 0 : thirdIds.map(({ bdrId, level }) => ({ bdrLegalId: bdrId, level }))) != null ? _a : [];
};
var BankAccountMutliPicker = ({
  id: id2,
  repo,
  onChange,
  size: size6 = "lg",
  disabled = false,
  bankAccount,
  thirdIds,
  placeholder,
  inErrorPlaceholder,
  accountNumbers,
  removeAll = false,
  formatMessage = formatMessageCallBack
}) => {
  const pickerId = useGenerateId(id2);
  const filteredThirdId = thirdIds.filter((t) => t.level && ["LE", "EC"].includes(t.level));
  const { data: data2, isFetching: isLoading } = useGetBankAccounts(repo, mapThirdIdToBankAccountFilter(filteredThirdId));
  const allAccounts = {
    accountNumberValue: formatMessage({
      id: "bankAccount.all",
      defaultMessage: "All accounts"
    })
  };
  const allCurrentAccounts = {
    accountNumberValue: formatMessage({
      id: "bankAccount.all.current",
      defaultMessage: "All currently open accounts below"
    })
  };
  const filterBankAccounts = (bankAccounts2) => {
    if (bankAccounts2 == null ? void 0 : bankAccounts2.length) {
      const sortedBankAccount = sortBy(bankAccounts2, (b) => b.accountNumberValue);
      const bankAccountsFiltered = removeAll ? sortedBankAccount : [allAccounts, allCurrentAccounts, ...sortedBankAccount];
      return (accountNumbers == null ? void 0 : accountNumbers.length) ? bankAccountsFiltered.filter((d) => accountNumbers.includes(d.accountNumberValue)) : bankAccountsFiltered;
    }
    return removeAll ? [] : [allAccounts];
  };
  const findSelectedBankAccounts = (bankAccount2) => {
    return bankAccount2.all ? [allAccounts] : bankAccounts.filter(
      (account) => bankAccount2.accountNumbers.map((a) => a.accountNumberValue).includes(account.accountNumberValue)
    );
  };
  const bankAccounts = filterBankAccounts(data2);
  const selectedBankAccounts = bankAccount ? findSelectedBankAccounts(bankAccount) : [];
  const handleOnChange = (accountNumbers2) => {
    const isAll = (bankAccount == null ? void 0 : bankAccount.all) ? false : !!accountNumbers2.find((account) => account.accountNumberValue === allAccounts.accountNumberValue);
    const isAllCurrent = !!accountNumbers2.find(
      (account) => account.accountNumberValue === allCurrentAccounts.accountNumberValue
    );
    const output = isEmpty7(accountNumbers2) ? void 0 : {
      all: isAll,
      accountNumbers: isAll ? [] : isAllCurrent ? data2 != null ? data2 : [] : accountNumbers2.filter((account) => account.accountNumberValue !== allAccounts.accountNumberValue)
    };
    onChange(output);
  };
  const globalPickerBankAccountPlaceholderErrorLabel = "global.picker.bankAccount.placeholder.inError";
  return /* @__PURE__ */ React71.createElement(React71.Fragment, null, /* @__PURE__ */ React71.createElement(Loader3, { isVisible: isLoading }), !isLoading && /* @__PURE__ */ React71.createElement(
    Select7,
    {
      id: pickerId,
      items: bankAccounts,
      selectedItems: selectedBankAccounts,
      idField: "accountNumberValue",
      labelField: "accountNumberValue",
      onChange: handleOnChange,
      iconName: "account_balance",
      placeholder: !(filteredThirdId == null ? void 0 : filteredThirdId.length) ? inErrorPlaceholder != null ? inErrorPlaceholder : formatMessage({
        id: globalPickerBankAccountPlaceholderErrorLabel,
        defaultMessage: "Only LE or EC level can have a bank account"
      }) : placeholder != null ? placeholder : formatMessage({
        id: globalPickerBankAccountPlaceholderErrorLabel,
        defaultMessage: formatMessage({
          id: globalPickerBankAccountPlaceholderErrorLabel,
          defaultMessage: "Only LE or EC level can have a bank account"
        })
      }),
      size: size6,
      keepOrder: true,
      disabled: !(filteredThirdId == null ? void 0 : filteredThirdId.length) || disabled
    },
    (bankAccount2) => /* @__PURE__ */ React71.createElement("span", { className: "d-flex align-items-center" }, bankAccount2.accountNumberValue, bankAccount2.accountBic && /* @__PURE__ */ React71.createElement("span", { className: "text-secondary" }, /* @__PURE__ */ React71.createElement(BulletSeparator, { className: "text-small mx-2 text-secondary" }), bankAccount2.accountBic))
  ));
};

// src/common/StarRating/IconStarFilled.tsx
import * as React72 from "react";
var IconStarFilled = () => /* @__PURE__ */ React72.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-hidden": "true",
    className: "bi bi-star-fill",
    viewBox: "0 0 24 24",
    height: "32",
    width: "32"
  },
  /* @__PURE__ */ React72.createElement("path", { d: "M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" })
);

// src/common/StarRating/IconStarUnfilled.tsx
import * as React73 from "react";
var IconStarUnfilled = () => /* @__PURE__ */ React73.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    height: "32",
    width: "32",
    fill: "currentColor",
    className: "bi bi-star",
    viewBox: "0 0 24 24"
  },
  /* @__PURE__ */ React73.createElement("path", { d: "M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z" })
);

// src/common/StarRating/StarRating.tsx
import * as React74 from "react";
import range3 from "lodash-es/range";
var StarRating = ({ score }) => {
  return /* @__PURE__ */ React74.createElement("div", { className: "container" }, /* @__PURE__ */ React74.createElement("div", { className: "row justify-content-end" }, range3(0, 5).map((i) => {
    return /* @__PURE__ */ React74.createElement("div", { key: i < score ? `filledStar${i}` : `unfilledStar${i}`, className: "p-1" }, i < score ? /* @__PURE__ */ React74.createElement(IconStarFilled, null) : /* @__PURE__ */ React74.createElement(IconStarUnfilled, null));
  })));
};

// src/common/BusinessFunctionPicker/BusinessFunctionMultiPicker.tsx
import * as React75 from "react";
import { Select as Select8 } from "@sgbs-ui/core";
import {
  useGetBusinessFunctions
} from "@ic-anywhere/ic-dal";
import { filter as filter5, includes as includes3 } from "lodash-es";
var BusinessFunctionMultiPicker = ({
  id: id2,
  headers,
  onChange,
  onReady,
  size: size6 = "lg",
  disabled = false,
  selectedIds,
  onlyAssignableByMe = false,
  onlyGrantedOnContactId,
  onlyGrantableByMe = false,
  onlyGrantedOnTeamId,
  pageSize = 500,
  errorMessage,
  inError
}) => {
  React75.useEffect(() => {
    onReady == null ? void 0 : onReady();
  }, []);
  const pickerId = useGenerateId(id2);
  const {
    data: businessFunctions = [],
    isError,
    error
  } = useGetBusinessFunctions(
    { ...headers },
    { pageSize, onlyGrantedOnTeamId, onlyAssignableByMe, onlyGrantedOnContactId, onlyGrantableByMe }
  );
  const selectedBusinessFunctions = filter5(businessFunctions, ({ id: id3 }) => includes3(selectedIds, id3));
  return /* @__PURE__ */ React75.createElement(React75.Fragment, null, /* @__PURE__ */ React75.createElement(
    Select8,
    {
      id: pickerId,
      items: businessFunctions,
      selectedItems: selectedBusinessFunctions,
      idField: "id",
      labelField: "fullTreeName",
      onChange,
      iconName: "public",
      placeholder: "Search business functions",
      size: size6,
      keepOrder: false,
      disabled
    }
  ), inError && /* @__PURE__ */ React75.createElement(InvalidFeedback, { errorMessage }), isError && /* @__PURE__ */ React75.createElement(InvalidFeedback, { errorMessage: error != null ? error : void 0 }));
};

// src/common/AccessRights/AccessRightsField.tsx
import * as React88 from "react";
import { Loader as Loader5 } from "@sgbs-ui/core";

// src/common/AccessRights/common/Services/Utils.ts
import {
  TeamReason
} from "@ic-anywhere/ic-dal";
var replaceTeamsByReason = (teams, newTeams, reason) => {
  return teams.filter((x) => x.reason !== reason).concat(newTeams);
};
var isEditable = (accessRight) => {
  return (accessRight == null ? void 0 : accessRight.grantedRights) === "WriteAccess";
};
var mapToAccessRightsDTO = (accessRights) => {
  var _a, _b, _c, _d;
  if (!accessRights || !accessRights.visibility) {
    return;
  }
  const teamsOwner = (_b = (_a = accessRights.owners) == null ? void 0 : _a.teams) == null ? void 0 : _b.filter((team) => team.reason !== TeamReason.implicit);
  const teamsViewer = (_d = (_c = accessRights.viewers) == null ? void 0 : _c.teams) == null ? void 0 : _d.filter((team) => team.reason !== TeamReason.implicit);
  const payload = accessRights.visibility.toLocaleLowerCase() === "confidential" ? {
    owners: teamsOwner ? {
      teams: teamsOwner.map(({ id: id2, reason }) => ({ id: id2, reason }))
    } : void 0,
    viewers: teamsViewer ? { teams: teamsViewer.map(({ id: id2 }) => ({ id: id2 })) } : void 0
  } : {};
  return {
    visibility: accessRights.visibility,
    ...payload
  };
};
var getDefaultOwnersTeams = (organizationTeam, owners) => {
  var _a;
  const newTeams = (_a = owners == null ? void 0 : owners.teams) != null ? _a : [];
  return {
    teams: [
      { ...organizationTeam, reason: TeamReason.main },
      ...newTeams.map(({ id: id2, fullName }) => ({ id: id2, fullName, reason: TeamReason.implicit }))
    ]
  };
};
var getDefaultViewersTeams = (viewers) => {
  var _a;
  const newTeams = (_a = viewers == null ? void 0 : viewers.teams) != null ? _a : [];
  return {
    teams: [...newTeams.map(({ id: id2, fullName }) => ({ id: id2, fullName, reason: TeamReason.implicit }))]
  };
};
var getDefaultAccessRight = (currentAccessRights, { visibility, owners, viewers } = {}, organizationTeam) => {
  var _a, _b;
  return {
    visibility: (_b = (_a = currentAccessRights == null ? void 0 : currentAccessRights.visibility) != null ? _a : visibility == null ? void 0 : visibility.toLocaleLowerCase()) != null ? _b : "public",
    owners: getDefaultOwnersTeams(organizationTeam, owners),
    viewers: getDefaultViewersTeams(viewers)
  };
};

// src/common/AccessRights/common/AccessRightsForm/Visibility.tsx
import * as React76 from "react";
import { Radio } from "@sgbs-ui/core";
import { noop as noop13 } from "lodash-es";
var Visibility = ({ selectedOption = "public", canEdit = false, formatMessage, onChangeRestriction }) => {
  const options2 = [
    { label: "Public", value: "public" },
    {
      label: formatMessage({
        id: "accessRights.restricted",
        defaultMessage: "Restricted"
      }),
      value: "confidential"
    }
  ];
  return /* @__PURE__ */ React76.createElement(React76.Fragment, null, /* @__PURE__ */ React76.createElement(
    FormGroup,
    {
      label: formatMessage({
        id: "accessRights.visibility",
        defaultMessage: "Visibility"
      })
    },
    /* @__PURE__ */ React76.createElement("div", { className: "ml-2" }, options2.map((option) => /* @__PURE__ */ React76.createElement(
      Radio,
      {
        key: option.value,
        text: option.label,
        value: option.value,
        onChange: (checked) => checked ? onChangeRestriction(option.value) : noop13,
        checked: selectedOption === option.value,
        disabled: !canEdit
      }
    )))
  ));
};
var Visibility_default = Visibility;

// src/common/AccessRights/common/AccessRightsForm/Ownership.tsx
import * as React85 from "react";
import { TeamReason as TeamReason3 } from "@ic-anywhere/ic-dal";

// src/common/AccessRights/common/Components/TeamsRow.tsx
import * as React84 from "react";

// src/common/AccessRights/common/Components/TeamLinkList.tsx
import * as React78 from "react";

// src/common/AccessRights/common/Components/TeamLink.tsx
import { Badge as Badge3 } from "@sgbs-ui/core";
import * as React77 from "react";
var TeamLink = ({
  team,
  onClickTeam,
  disabled = false
}) => {
  const formatTeamName = (fullName) => {
    var _a, _b;
    return (_b = (_a = fullName == null ? void 0 : fullName.split("SGCIB/")) == null ? void 0 : _a[1]) != null ? _b : "";
  };
  const color = disabled ? "secondary" : "info";
  return /* @__PURE__ */ React77.createElement(React77.Fragment, null, team && /* @__PURE__ */ React77.createElement(React77.Fragment, null, /* @__PURE__ */ React77.createElement(
    "a",
    {
      className: "ml-2 badge-pill",
      color: "secondary",
      onClick: () => !!team && onClickTeam(team.id),
      style: { cursor: "pointer" }
    },
    /* @__PURE__ */ React77.createElement(
      Badge3,
      {
        key: team.id,
        text: formatTeamName(team == null ? void 0 : team.fullName),
        color,
        badgeType: "discreet",
        closable: false
      }
    )
  )));
};
var TeamLink_default = TeamLink;

// src/common/AccessRights/common/Components/TeamLinkList.tsx
var TeamLinkList = ({ teams, onClickTeam, disabled = false }) => /* @__PURE__ */ React78.createElement(React78.Fragment, null, teams == null ? void 0 : teams.map((team) => /* @__PURE__ */ React78.createElement(TeamLink_default, { key: team.id, team, onClickTeam, disabled })));
var TeamLinkList_default = TeamLinkList;

// src/common/AccessRights/common/Components/TeamsRow.tsx
import {
  TeamReason as TeamReason2,
  contactDbHeader,
  mapToTeamTree,
  useGetAllTeamsQuery
} from "@ic-anywhere/ic-dal";

// src/common/TeamsModal/TeamsModal.tsx
import { isEmpty as isEmpty11, size as size5 } from "lodash-es";
import * as React83 from "react";
import { Button as Button7, Modal } from "@sgbs-ui/core";

// src/common/TeamsModal/TeamTree.logic.ts
import { concat, filter as filter6, forEach, includes as includes4, isEmpty as isEmpty8, map as map9 } from "lodash-es";
import { isContainSubString } from "@ic-anywhere/ic-utils";
var updateSelectedTeams = (fromTeams, teamToSelect) => {
  if (isEmpty8(teamToSelect)) {
    return { teams: fromTeams, selectedTeams: [] };
  }
  const teams = toggleSelectNodes(fromTeams, teamToSelect);
  const selectedTeams = [];
  findSelected(teams, selectedTeams);
  return { teams, selectedTeams };
};
var toggleSelectNodes = (tree, nodeToSelectIds) => {
  return tree.map((node) => {
    return {
      ...node,
      selected: includes4(nodeToSelectIds, node.id),
      children: node.children ? toggleSelectNodes(node.children, nodeToSelectIds) : []
    };
  });
};
var toggleSelect = (tree, nodeToSelectIds, selected, inheritance) => {
  return tree.map((node) => {
    return includes4(nodeToSelectIds, node.id) ? {
      ...node,
      selected,
      children: inheritance ? node.children ? toggleSelectBranch(node.children, selected) : [] : node.children
    } : {
      ...node,
      children: node.children ? toggleSelect(node.children, nodeToSelectIds, selected, inheritance) : []
    };
  });
};
var toggleSelectBranch = (children2, selected) => {
  return map9(children2, (child) => {
    return { ...child, selected, children: child ? toggleSelectBranch(child.children, selected) : [] };
  });
};
var toggleDisplayNodes = (tree, parentNode, nodeToToggle, expanded) => tree.map((node) => {
  if (!parentNode && nodeToToggle === node.id) {
    return {
      ...node,
      expanded,
      children: node.children ? node.children.map(
        (child) => child.id === nodeToToggle ? { ...child, expanded } : { ...child, expanded: false }
      ) : []
    };
  }
  return node.id === parentNode ? {
    ...node,
    children: node.children ? node.children.map(
      (child) => child.id === nodeToToggle ? { ...child, expanded } : { ...child, expanded: false }
    ) : []
  } : {
    ...node,
    children: node.children ? toggleDisplayNodes(node.children, parentNode, nodeToToggle, expanded) : []
  };
});
var findSelected = (tree, selected) => {
  const selectedTemp = selected || [];
  tree.forEach((child) => {
    if (child.selected) {
      selectedTemp.push(child);
    }
    if (!isEmpty8(child.children)) {
      findSelected(child.children, selectedTemp);
    }
  });
  selected = selectedTemp;
  return selected;
};
var filterByName = (tree, term) => tree.map((node) => {
  const hidden = !isContainSubString(node.path, term);
  const newNode = {
    ...node,
    hidden,
    expanded: true,
    children: !isEmpty8(node.children) ? filterByName(node.children, term) : []
  };
  newNode.hidden = !isEmpty8(newNode.children) ? filter6(newNode.children, (c) => !c.hidden).length === 0 : hidden;
  return newNode;
});
var cancelFilter = (tree) => tree.map(
  (node) => ({
    ...node,
    hidden: false,
    expanded: node.parent === null,
    children: !isEmpty8(node.children) ? cancelFilter(node.children) : []
  })
);

// src/common/TeamsModal/TeamTree.tsx
import * as React82 from "react";
import { Checkbox as Checkbox2, Loader as Loader4, SearchInput as SearchInput2 } from "@sgbs-ui/core";
import { isEmpty as isEmpty10, map as map12, noop as noop14, size as size4 } from "lodash-es";
import { isStringEmpty as isStringEmpty4 } from "@ic-anywhere/ic-utils";

// src/common/TeamsModal/Tags.tsx
import * as React79 from "react";
import { map as map10, size as size2, slice } from "lodash-es";
import { Badge as Badge4 } from "@sgbs-ui/core";
var Tags2 = ({ teams, onDeselect }) => {
  const DISPLAY_LIMIT = 10;
  const currentSize = size2(teams);
  const limitReached = currentSize > DISPLAY_LIMIT;
  const updatedTeams = limitReached ? slice(teams, 0, DISPLAY_LIMIT) : teams;
  return /* @__PURE__ */ React79.createElement(React79.Fragment, null, map10(updatedTeams, (team) => /* @__PURE__ */ React79.createElement(
    Badge4,
    {
      key: team.id,
      text: team.path,
      badgeType: "default",
      className: "mr-2 mb-1",
      closable: true,
      onClose: onDeselect.bind(void 0, team)
    }
  )), limitReached ? size2(teams) - DISPLAY_LIMIT === 1 ? /* @__PURE__ */ React79.createElement(Badge4, { badgeType: "default", text: "and one other team" }) : /* @__PURE__ */ React79.createElement(Badge4, { badgeType: "default", text: `and ${size2(teams) - DISPLAY_LIMIT} others teams` }) : null);
};
var Tags_default = Tags2;

// src/common/TeamsModal/TeamTreeNode.tsx
import * as React81 from "react";
import { classNames as classNames6 } from "@ic-anywhere/ic-utils";
import { filter as filter7, isEmpty as isEmpty9, map as map11, size as size3 } from "lodash-es";
import { Checkbox } from "@sgbs-ui/core";

// src/common/TeamsModal/Chevron.tsx
import * as React80 from "react";
var Chevron = ({ expanded, expandable = true }) => expandable ? /* @__PURE__ */ React80.createElement("div", null, expanded ? /* @__PURE__ */ React80.createElement("i", { className: "icon" }, "expand_more") : /* @__PURE__ */ React80.createElement("i", { className: "icon" }, "chevron_right")) : /* @__PURE__ */ React80.createElement("div", { style: { paddingLeft: "14px" } });
var Chevron_default = Chevron;

// src/common/TeamsModal/TeamTreeNode.tsx
var TeamTreeNode = ({
  level,
  selectableParentsOnly,
  disableSelection,
  teamNode,
  onToggleExpand,
  onToggleSelection,
  onExpand
}) => {
  const { id: id2, name, children: children2, expanded, selected, hidden, path: path2 } = teamNode;
  const borderClass = level === 0 ? "border" : "border-left border-bottom border-right";
  const hasChildren2 = !isEmpty9(children2);
  const allChildrenHidden = hasChildren2 && size3(children2) === size3(filter7(children2, (child) => child.hidden));
  const handleDisplayChildren = () => {
    onToggleExpand(teamNode, !teamNode.expanded);
  };
  const handleToggleSelection = (selected2) => {
    onToggleSelection(teamNode, selected2);
  };
  return hidden ? null : /* @__PURE__ */ React81.createElement(React81.Fragment, null, /* @__PURE__ */ React81.createElement("div", { className: classNames6("tree d-flex flex-row", `level-${level}`, borderClass) }, /* @__PURE__ */ React81.createElement("div", { title: path2, className: "d-flex flex-row flex-grow-1 px-1 py-1 mr-3", onClick: handleDisplayChildren }, /* @__PURE__ */ React81.createElement(Chevron_default, { expandable: hasChildren2 && !allChildrenHidden, expanded }), /* @__PURE__ */ React81.createElement("strong", null, name)), /* @__PURE__ */ React81.createElement("div", null, /* @__PURE__ */ React81.createElement(
    Checkbox,
    {
      disabled: disableSelection && !selected,
      onChange: handleToggleSelection,
      id: id2,
      checked: selected,
      className: "d-flex align-items-center"
    }
  ))), expanded && hasChildren2 ? /* @__PURE__ */ React81.createElement("div", { className: "ml-3" }, map11(children2, (teamNode2) => /* @__PURE__ */ React81.createElement(
    TeamTreeNode,
    {
      isRoot: level === 0,
      level: level + 1,
      onToggleExpand,
      onToggleSelection,
      key: teamNode2.id,
      teamNode: teamNode2,
      onExpand,
      selectableParentsOnly,
      disableSelection
    }
  ))) : null);
};
var TeamTreeNode_default = TeamTreeNode;

// src/common/TeamsModal/TeamTree.tsx
var TeamTree = ({
  teams,
  selectedTeams,
  selectableParentsOnly,
  disableSelection,
  displayInheritance = true,
  teamInheritance = false,
  onTeamChanged,
  onIsInheritanceActiveChanged = noop14
}) => {
  const [inheritance, setInheritance] = React82.useState(teamInheritance);
  React82.useEffect(() => {
    setInheritance(teamInheritance);
  }, [teamInheritance]);
  const handleOnInheritanceChange = (inheritanceValue) => {
    setInheritance(inheritanceValue);
    onIsInheritanceActiveChanged(inheritanceValue);
    if (inheritanceValue) {
      const inheritanceTeams = toggleSelect(
        teams,
        map12(selectedTeams, ({ id: id2 }) => id2),
        true,
        inheritanceValue
      );
      onTeamChanged(inheritanceTeams);
    }
  };
  const handleSearch = (term) => {
    const filteredTeams = isStringEmpty4(term) || term.length < 3 ? cancelFilter(teams) : filterByName(teams, term);
    onTeamChanged(filteredTeams);
  };
  const handleTagDeselect = (teamNode) => {
    handleToggleSelection(teamNode, false);
  };
  const handleToggleSelection = (teamNode, selected) => {
    const result = toggleSelect(teams, [teamNode.id], selected, inheritance);
    onTeamChanged(result);
  };
  const handleOnExpand = (teamNode, expanded) => {
    var _a;
    if (size4(teamNode.children) === 0) {
      return;
    }
    const result = toggleDisplayNodes(teams, (_a = teamNode.parent) == null ? void 0 : _a.id, teamNode.id, expanded);
    onTeamChanged(result);
  };
  return /* @__PURE__ */ React82.createElement(React82.Fragment, null, /* @__PURE__ */ React82.createElement("div", { className: "row d-flex align-items-baseline mb-2" }, /* @__PURE__ */ React82.createElement("div", { className: "col" }, /* @__PURE__ */ React82.createElement(SearchInput2, { onChange: handleSearch, placeholder: "Search team" })), displayInheritance && /* @__PURE__ */ React82.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React82.createElement("div", { className: "input-group" }, /* @__PURE__ */ React82.createElement(
    Checkbox2,
    {
      onChange: handleOnInheritanceChange,
      id: "team-selector-inheritance",
      checked: inheritance,
      text: "inheritance"
    }
  )))), /* @__PURE__ */ React82.createElement("div", { className: "row" }, /* @__PURE__ */ React82.createElement("div", { className: "col" }, /* @__PURE__ */ React82.createElement(Tags_default, { teams: selectedTeams, onDeselect: handleTagDeselect }))), /* @__PURE__ */ React82.createElement("div", { className: "team-tree" }, !isEmpty10(teams) ? /* @__PURE__ */ React82.createElement(React82.Fragment, null, map12(teams, (teamNode) => /* @__PURE__ */ React82.createElement(
    TeamTreeNode_default,
    {
      disableSelection,
      selectableParentsOnly,
      level: 0,
      isRoot: true,
      onToggleExpand: handleOnExpand,
      onToggleSelection: handleToggleSelection,
      key: teamNode.id,
      teamNode
    }
  ))) : /* @__PURE__ */ React82.createElement(Loader4, null)));
};

// src/common/TeamsModal/TeamsModal.tsx
var TeamsModal = ({
  show,
  teams,
  selectedTeams,
  defaultUserTeamIds,
  capacity,
  onSelectedTeams,
  onClose,
  teamInheritance = false,
  displayInheritance = true,
  resetOnCancel = true
}) => {
  const [teamsState, setTeams] = React83.useState(teams);
  const [teamInheritanceState, setTeamInheritance] = React83.useState(teamInheritance);
  const [selectedTeamsState, setSelectedTeams] = React83.useState([]);
  React83.useEffect(() => {
    if (!show) {
      return;
    }
    const selectedTeamsOrDefaultTeam = isEmpty11(selectedTeams) ? defaultUserTeamIds != null ? defaultUserTeamIds : [] : selectedTeams;
    const { ...result } = updateSelectedTeams(teams, selectedTeamsOrDefaultTeam);
    setTeams(result.teams);
    setSelectedTeams(result.selectedTeams);
  }, [show, teams, selectedTeams, defaultUserTeamIds]);
  React83.useEffect(() => {
    setTeamInheritance(teamInheritance);
  }, [teamInheritance]);
  const handleTeamChange = (teamNodes) => {
    const updatedSelectedTeams = [];
    findSelected(teamNodes, updatedSelectedTeams);
    setTeams(teamNodes);
    setSelectedTeams(updatedSelectedTeams);
  };
  const handleConfirmSelectedTeams = () => {
    if (!isEmpty11(selectedTeamsState)) {
      const updatedTeams = cancelFilter(teamsState);
      setTeams(updatedTeams);
      onClose();
      onSelectedTeams(selectedTeamsState, teamInheritanceState);
    } else {
      selectDefaultTeam();
    }
  };
  const selectDefaultTeam = () => {
    const { teams: updatedTeams, selectedTeams: updatedSelectedTeams } = updateSelectedTeams(
      cancelFilter(teams),
      defaultUserTeamIds != null ? defaultUserTeamIds : []
    );
    setTeams(updatedTeams);
    setSelectedTeams(updatedSelectedTeams);
    onClose();
    onSelectedTeams(updatedSelectedTeams, teamInheritanceState);
  };
  const handleOnCancel = () => {
    if (resetOnCancel) {
      selectDefaultTeam();
    } else {
      onClose();
    }
  };
  const handleOnIsInheritanceActiveChanged = (isWithTeamInheritanceValue) => setTeamInheritance(!!isWithTeamInheritanceValue);
  const renderFooterActions = () => /* @__PURE__ */ React83.createElement(React83.Fragment, null, /* @__PURE__ */ React83.createElement(Button7, { text: "Cancel", btnType: "flat", color: "secondary", size: "lg", className: "ml-2", onClick: handleOnCancel }), /* @__PURE__ */ React83.createElement(Button7, { onClick: handleConfirmSelectedTeams, text: "Confirm", size: "lg" }));
  return show ? /* @__PURE__ */ React83.createElement(
    Modal,
    {
      show: true,
      title: !!capacity && capacity === 1 ? "Select a team" : "Select teams",
      type: "primary",
      onClose,
      renderFooterActions
    },
    /* @__PURE__ */ React83.createElement("div", { className: "row mt-3" }, /* @__PURE__ */ React83.createElement("div", { className: "col-12" }, /* @__PURE__ */ React83.createElement(
      TeamTree,
      {
        teams: teamsState,
        onTeamChanged: handleTeamChange,
        selectedTeams: selectedTeamsState,
        teamInheritance: teamInheritanceState,
        displayInheritance,
        disableSelection: !!capacity && size5(selectedTeamsState) >= capacity,
        onIsInheritanceActiveChanged: handleOnIsInheritanceActiveChanged
      }
    )))
  ) : null;
};
var TeamsModal_default = TeamsModal;

// src/common/AccessRights/common/Components/TeamsRow.tsx
var TeamsRow = ({
  teams,
  label,
  onClickTeam,
  onEditTeams,
  isEditable: isEditable2 = false,
  singleSelection = false,
  reason = TeamReason2.custom
}) => {
  const [show, openModal, closeModal] = useModal();
  const { data: allTeams, isFetching } = useGetAllTeamsQuery({ ...contactDbHeader });
  const allTeamsTree = React84.useMemo(() => {
    return mapToTeamTree(allTeams != null ? allTeams : []);
  }, [allTeams]);
  const selectedTeams = React84.useMemo(() => {
    return teams == null ? void 0 : teams.map((x) => x.id);
  }, [teams]);
  const onSelectedTeamsChange = (teams2) => {
    const selectedTeams2 = teams2.map(({ id: id2, name, path: path2 }) => ({ id: id2, name, fullName: path2, reason }));
    onEditTeams == null ? void 0 : onEditTeams(selectedTeams2);
  };
  return !!selectedTeams || isEditable2 ? /* @__PURE__ */ React84.createElement(React84.Fragment, null, /* @__PURE__ */ React84.createElement(Loader, { isVisible: isFetching }), !isFetching && /* @__PURE__ */ React84.createElement(React84.Fragment, null, /* @__PURE__ */ React84.createElement("div", null, /* @__PURE__ */ React84.createElement("label", { className: "text-secondary ml-3 mt-0 mb-1" }, label), /* @__PURE__ */ React84.createElement(TeamLinkList_default, { teams, onClickTeam, disabled: !isEditable2 }), isEditable2 && /* @__PURE__ */ React84.createElement("em", { className: "icon icon-sm text-secondary action pointer", onClick: openModal }, "edit"))), show && /* @__PURE__ */ React84.createElement(
    TeamsModal_default,
    {
      show: true,
      teams: allTeamsTree,
      selectedTeams,
      onClose: closeModal,
      onSelectedTeams: onSelectedTeamsChange,
      displayInheritance: false,
      capacity: singleSelection ? 1 : void 0,
      resetOnCancel: false
    }
  )) : null;
};
var TeamsRow_default = TeamsRow;

// src/common/AccessRights/common/AccessRightsForm/Ownership.tsx
import { capitalize } from "lodash-es";
var Ownership = ({
  owners,
  canEdit = false,
  canEditMain = false,
  onClickTeam,
  onOwnersChange,
  onMainTeamChange,
  formatMessage
}) => {
  const ownersTeams = React85.useMemo(() => {
    var _a, _b, _c, _d, _e, _f;
    return {
      currentMainTeams: (_b = (_a = owners == null ? void 0 : owners.teams) == null ? void 0 : _a.filter((x) => x.reason === TeamReason3.main)) != null ? _b : [],
      currentSharedOwners: (_d = (_c = owners == null ? void 0 : owners.teams) == null ? void 0 : _c.filter((x) => x.reason === TeamReason3.implicit)) != null ? _d : [],
      currentOtherOwners: (_f = (_e = owners == null ? void 0 : owners.teams) == null ? void 0 : _e.filter((x) => x.reason === TeamReason3.custom)) != null ? _f : []
    };
  }, [owners == null ? void 0 : owners.teams]);
  const handleOnMainTeamOwner = (teams) => {
    if (teams == null ? void 0 : teams[0]) {
      const { id: id2, fullName } = teams[0];
      onMainTeamChange({ id: id2, fullName, reason: TeamReason3.main });
    }
  };
  const handleOnOwnersChange = (teams) => {
    var _a;
    const payload = {
      teams: replaceTeamsByReason((_a = owners == null ? void 0 : owners.teams) != null ? _a : [], teams, TeamReason3.custom)
    };
    onOwnersChange(payload);
  };
  return /* @__PURE__ */ React85.createElement(React85.Fragment, null, /* @__PURE__ */ React85.createElement(
    FormGroup,
    {
      label: formatMessage({
        id: "accessRights.ownership",
        defaultMessage: "Ownership"
      })
    },
    /* @__PURE__ */ React85.createElement(
      TeamsRow_default,
      {
        label: formatMessage({
          id: "accessRights.mainTeam",
          defaultMessage: "Main owner team"
        }),
        onClickTeam,
        teams: ownersTeams.currentMainTeams,
        onEditTeams: handleOnMainTeamOwner,
        isEditable: canEditMain,
        reason: TeamReason3.main,
        singleSelection: true
      }
    ),
    /* @__PURE__ */ React85.createElement(
      TeamsRow_default,
      {
        label: formatMessage({
          id: "accessRights.coTeams",
          defaultMessage: "Implicit team(s) from main team"
        }),
        onClickTeam,
        teams: ownersTeams.currentSharedOwners,
        isEditable: false,
        reason: TeamReason3.implicit
      }
    ),
    /* @__PURE__ */ React85.createElement(
      TeamsRow_default,
      {
        label: capitalize(
          formatMessage({
            id: "accessRights.custom",
            defaultMessage: "Custom teams"
          })
        ),
        onClickTeam,
        teams: ownersTeams.currentOtherOwners,
        onEditTeams: handleOnOwnersChange,
        isEditable: canEdit,
        reason: TeamReason3.custom
      }
    )
  ));
};
var Ownership_default = Ownership;

// src/common/AccessRights/common/AccessRightsForm/Viewership.tsx
import * as React86 from "react";
import { TeamReason as TeamReason4 } from "@ic-anywhere/ic-dal";
import { capitalize as capitalize2 } from "lodash-es";
var Viewership = ({ viewers, canEdit = false, onClickTeam, onViewersChange, formatMessage }) => {
  const viewersTeams = React86.useMemo(() => {
    var _a, _b, _c, _d;
    return {
      currentSharedViewers: (_b = (_a = viewers == null ? void 0 : viewers.teams) == null ? void 0 : _a.filter((x) => x.reason === TeamReason4.implicit)) != null ? _b : [],
      currentOtherViewers: (_d = (_c = viewers == null ? void 0 : viewers.teams) == null ? void 0 : _c.filter((x) => x.reason === TeamReason4.custom)) != null ? _d : []
    };
  }, [viewers == null ? void 0 : viewers.teams]);
  const handleOnViewersChange = (teams) => {
    var _a;
    const payload = {
      teams: replaceTeamsByReason((_a = viewers == null ? void 0 : viewers.teams) != null ? _a : [], teams, TeamReason4.custom)
    };
    onViewersChange(payload);
  };
  return /* @__PURE__ */ React86.createElement(React86.Fragment, null, /* @__PURE__ */ React86.createElement(
    FormGroup,
    {
      label: formatMessage({
        id: "accessRights.viewership",
        defaultMessage: "Viewership"
      })
    },
    /* @__PURE__ */ React86.createElement(
      TeamsRow_default,
      {
        label: formatMessage({
          id: "accessRights.coTeams",
          defaultMessage: "Implicit team(s) from main team"
        }),
        onClickTeam,
        teams: viewersTeams.currentSharedViewers,
        isEditable: false,
        reason: TeamReason4.implicit
      }
    ),
    /* @__PURE__ */ React86.createElement(
      TeamsRow_default,
      {
        label: capitalize2(
          formatMessage({
            id: "accessRights.custom",
            defaultMessage: "Custom teams"
          })
        ),
        onClickTeam,
        teams: viewersTeams.currentOtherViewers,
        onEditTeams: handleOnViewersChange,
        isEditable: canEdit,
        reason: TeamReason4.custom
      }
    )
  ));
};
var Viewership_default = Viewership;

// src/common/AccessRights/common/Hooks/useAccessRights.tsx
import {
  TeamReason as TeamReason5,
  useGetTeamSettingsQuery,
  useRequestMeSgmcQuery
} from "@ic-anywhere/ic-dal";
import * as React87 from "react";
var useAccessRights = (accessRights, repo) => {
  var _a, _b, _c, _d;
  const [currentAccessRights, setCurrentAccessRights] = React87.useState(accessRights);
  const [newMainTeam, setMainTeam] = React87.useState(void 0);
  const mainTeamId = (_d = newMainTeam == null ? void 0 : newMainTeam.id) != null ? _d : (_c = (_b = (_a = accessRights == null ? void 0 : accessRights.owners) == null ? void 0 : _a.teams) == null ? void 0 : _b.find((x) => x.reason === TeamReason5.main)) == null ? void 0 : _c.id;
  const { data: me, isFetching: isFetchingMe, isError: errorFetchingMe } = useRequestMeSgmcQuery(repo, true);
  const {
    data: teamSettings,
    isFetching: isFetchingSettings,
    isError: errorFetchingSettings
  } = useGetTeamSettingsQuery(repo, mainTeamId);
  React87.useEffect(() => {
    if (me && !(accessRights == null ? void 0 : accessRights.visibility)) {
      setMainTeam({ id: me.organizationTeamId, fullName: me.organizationTeamName, reason: TeamReason5.main });
    }
  }, [me, accessRights]);
  React87.useEffect(() => {
    var _a2;
    if (!!newMainTeam && !!teamSettings) {
      const objectAccessRights = (_a2 = teamSettings == null ? void 0 : teamSettings.objectAccessRights) != null ? _a2 : {};
      setCurrentAccessRights((previous) => {
        return getDefaultAccessRight(previous, objectAccessRights, newMainTeam);
      });
    }
  }, [teamSettings, newMainTeam]);
  React87.useEffect(() => {
    if (errorFetchingMe || errorFetchingSettings) {
      setCurrentAccessRights(accessRights);
    }
  }, [errorFetchingMe, errorFetchingSettings, accessRights]);
  const handleOnChangeRestriction = (optionValue) => {
    var _a2, _b2;
    const objectAccessRights = (_a2 = teamSettings == null ? void 0 : teamSettings.objectAccessRights) != null ? _a2 : {};
    const payload = {
      ...optionValue === "confidential" && !!newMainTeam ? getDefaultAccessRight(currentAccessRights, objectAccessRights, newMainTeam) : { viewers: { teams: [] }, owners: { teams: [] } },
      visibility: optionValue
    };
    setCurrentAccessRights(payload);
    setMainTeam({
      id: (_b2 = me == null ? void 0 : me.organizationTeamId) != null ? _b2 : "",
      fullName: me == null ? void 0 : me.organizationTeamName,
      reason: TeamReason5.main
    });
  };
  const handleOnMainOwnerChange = (mainOnwer) => {
    const { id: id2, fullName } = mainOnwer;
    setMainTeam({ id: id2, fullName, reason: TeamReason5.main });
  };
  const handleOnOwnersChange = (owners) => {
    if (currentAccessRights) {
      setCurrentAccessRights({ ...currentAccessRights, owners });
    }
  };
  const handleOnViewersChange = (viewers) => {
    if (currentAccessRights) {
      setCurrentAccessRights({ ...currentAccessRights, viewers });
    }
  };
  const showAccessRights = !errorFetchingMe && !errorFetchingSettings;
  const isLoading = !!isFetchingMe || !!isFetchingSettings;
  return [
    currentAccessRights,
    showAccessRights,
    isLoading,
    handleOnChangeRestriction,
    handleOnMainOwnerChange,
    handleOnOwnersChange,
    handleOnViewersChange
  ];
};

// src/common/AccessRights/AccessRightsField.tsx
var AccessRightsField = ({
  repo,
  accessRights,
  isMandateAdmin = false,
  formatMessage,
  onChange,
  handleOnClickTeam
}) => {
  var _a, _b;
  const [
    currentAccessRights,
    showAccessRights,
    isLoading,
    handleOnChangeRestriction,
    handleOnMainOwnerChange,
    handleOnOwnersChange,
    handleOnViewersChange
  ] = useAccessRights(accessRights, repo);
  React88.useEffect(() => {
    onChange(mapToAccessRightsDTO(currentAccessRights));
  }, [currentAccessRights]);
  const canEdit = (accessRights == null ? void 0 : accessRights.grantedRights) ? isEditable(accessRights) : true;
  return /* @__PURE__ */ React88.createElement(React88.Fragment, null, /* @__PURE__ */ React88.createElement(Loader5, { isVisible: isLoading }), !isLoading && showAccessRights && /* @__PURE__ */ React88.createElement("div", null, /* @__PURE__ */ React88.createElement("div", null, /* @__PURE__ */ React88.createElement(
    Visibility_default,
    {
      selectedOption: (_a = currentAccessRights == null ? void 0 : currentAccessRights.visibility) == null ? void 0 : _a.toLocaleLowerCase(),
      onChangeRestriction: handleOnChangeRestriction,
      formatMessage,
      canEdit
    }
  )), ((_b = currentAccessRights == null ? void 0 : currentAccessRights.visibility) == null ? void 0 : _b.toLocaleLowerCase()) === "confidential" && /* @__PURE__ */ React88.createElement(React88.Fragment, null, /* @__PURE__ */ React88.createElement("div", null, /* @__PURE__ */ React88.createElement(
    Ownership_default,
    {
      canEdit,
      canEditMain: canEdit && isMandateAdmin,
      onClickTeam: handleOnClickTeam,
      owners: currentAccessRights == null ? void 0 : currentAccessRights.owners,
      onOwnersChange: handleOnOwnersChange,
      onMainTeamChange: handleOnMainOwnerChange,
      formatMessage
    }
  )), /* @__PURE__ */ React88.createElement("div", null, /* @__PURE__ */ React88.createElement(
    Viewership_default,
    {
      canEdit,
      onClickTeam: handleOnClickTeam,
      viewers: currentAccessRights == null ? void 0 : currentAccessRights.viewers,
      onViewersChange: handleOnViewersChange,
      formatMessage
    }
  )))));
};

// src/common/OriginPicker/OriginPicker.tsx
import * as React89 from "react";
import { find as find6 } from "lodash-es";
import { useGetActionPlanOrigins } from "@ic-anywhere/ic-dal";
import { Select as Select9 } from "@sgbs-ui/core";
var OriginPicker = ({
  repo,
  id: id2,
  size: size6 = "lg",
  placeholder = "Select origin",
  selectedOrigin,
  disabled,
  outline,
  inError,
  errorMessage,
  onChange,
  onReady
}) => {
  var _a;
  React89.useEffect(() => {
    onReady == null ? void 0 : onReady();
  }, []);
  const pickerId = useGenerateId(id2);
  const { data: origins = [], isError: isFetchError, error: fetchError } = useGetActionPlanOrigins(repo);
  const selectedItem = (_a = find6(origins, ({ name }) => name === selectedOrigin)) != null ? _a : null;
  return /* @__PURE__ */ React89.createElement(React89.Fragment, null, /* @__PURE__ */ React89.createElement(
    Select9.SingleSelect,
    {
      id: pickerId,
      items: [...origins].sort((a, b) => {
        var _a2;
        return (_a2 = a == null ? void 0 : a.name) == null ? void 0 : _a2.localeCompare(b == null ? void 0 : b.name);
      }),
      onChange,
      selectedItem,
      idField: "id",
      labelField: "name",
      size: size6,
      placeholder,
      noSearch: true,
      isOutline: outline,
      disabled
    }
  ), inError && /* @__PURE__ */ React89.createElement(InvalidFeedback, { errorMessage }), isFetchError && /* @__PURE__ */ React89.createElement(InvalidFeedback, { errorMessage: fetchError != null ? fetchError : void 0 }));
};

// src/account/ClientTypeBadge.tsx
import * as React90 from "react";
import { Badge as Badge5 } from "@sgbs-ui/core";
var ClientTypeBadge = ({ bdrId, type }) => {
  let label;
  if (type === "Prospect" && !bdrId) {
    label = "Prospect";
  } else if (type === "Fund") {
    label = "Fund";
  } else {
    label = "Client";
  }
  return /* @__PURE__ */ React90.createElement(Badge5, { text: label, badgeType: "discreet", pill: true, textSize: "small" });
};

// src/account/AccountName.tsx
import * as React91 from "react";
var AccountName = ({ name }) => {
  return /* @__PURE__ */ React91.createElement(React91.Fragment, null, /* @__PURE__ */ React91.createElement("h1", { className: "d-none d-lg-flex" }, name), /* @__PURE__ */ React91.createElement("h3", { className: "d-lg-none" }, name));
};

// src/account/trees/legacy-d3/useOrgChartPerEntityTree.ts
import { useEffect as useEffect28, useRef as useRef9, useState as useState21 } from "react";

// src/account/trees/legacy-d3/useOrgChartPerEntityTree.utils.ts
import { cloneDeep as cloneDeep3, isString as isString3, sortBy as sortBy2, truncate } from "lodash-es";

// src/utils/d3trees/commercial.tree.d3.ts
import { cloneDeep, forEach as forEach2, isEmpty as isEmpty12, some as some4 } from "lodash-es";

// src/utils/d3trees/commercial.tree.constants.d3.ts
var DEFAULT_COLUMN_SIZE = 100;
var ACCOUNT_COLUMN_SIZE = 370;
var TREE_BAR_WIDTH = 1376;
var TREE_BAR_HEIGHT = 20;
var TREE_WIDTH = 1520;
var TREE_MARGIN = { top: 30, right: 20, bottom: 30, left: 20 };
var TREE_NODE_TRANSITION_DURATION = 400;
var TREE_KPI_ICON_SIZE = 15;
var ACCOUNT_LEVEL_COLOR = {
  Grp: "#dc4941",
  SubGrp: "#5c56e8",
  SubGrpDiv: "#6488ff",
  "LE Grp": "#e88e5e",
  LE: "#38699f",
  "Sub-LE": "#408182",
  EC: "#41c49d"
};
var SOURCE_SANS_PRO_FONT = "Source Sans Pro";
var FONT_FAMILY = "font-family";

// src/utils/d3trees/tree.utils.d3.ts
var updateLinks = (svg, tree, nodes, diagonal, activeElement, applyNbi) => {
  if (!activeElement || !svg)
    return;
  const links = tree.links(nodes);
  const link = svg.selectAll("path.link").data(links, (d) => d.target.id);
  const { x, y, x0, y0 } = activeElement;
  link.enter().insert("path", "g").attr("class", "link").attr("d", () => diagonal({ source: { x: x0, y: y0 }, target: { x: x0, y: y0 } }));
  if (applyNbi) {
    link.style("stroke-dasharray", (_) => "3,3");
  }
  link.transition().duration(TREE_NODE_TRANSITION_DURATION).attr("d", ({ source, target: { x: x2, y: y2 } }) => {
    return diagonal({ source, target: { x: x2, y: y2 - 20 } });
  });
  link.exit().transition().duration(TREE_NODE_TRANSITION_DURATION).attr("d", () => diagonal({ source: { x, y }, target: { x, y } })).remove();
};

// src/utils/d3trees/commercial.tree.kpis.d3.ts
var updateKpis = (node) => {
  kpiValues.forEach(({ metricLabel, iconLabel, styleCondition, fetchMetric }) => {
    updateKpiValue(node, metricLabel, styleCondition, fetchMetric);
    updateKpiLabel(node, iconLabel, styleCondition);
  });
};
var appendKpis = (nodeEnter, selectedNode, delta, click) => {
  kpiValues.forEach(({ metricLabel, iconLabel, icon, styleCondition, fetchMetric, margin }) => {
    appendKpi({
      nodeEnter,
      selectedNode,
      delta,
      iconLabel,
      metricLabel,
      icon,
      margin,
      styleCondition,
      fetchMetric,
      click
    });
  });
};
var hasCoverage = (d) => getCoverage(d) > 0;
var hasContact = (d) => getContact(d) > 0;
var hasActivityCount = (d) => getActivityCount(d) > 0;
var getCoverage = (d) => d[getCoverageProperty(d)];
var getContact = (d) => d[getContactProperty(d)];
var getActivityCount = (d) => d[getActivityCountProperty(d)];
var getCoverageProperty = (d) => !d._children && d.children ? "coverage" : "aggregatedCoverage";
var getActivityCountProperty = (d) => !d._children && d.children ? "numberOfActivities" : "aggregatedActivityCount";
var getContactProperty = (d) => !d._children && d.children ? "numberOfContacts" : "aggregatedContactCount";
var kpiValues = [
  {
    iconLabel: "kpiCoverageLabel_",
    metricLabel: "kpiCoverage_",
    styleCondition: hasCoverage,
    fetchMetric: getCoverage,
    margin: 45,
    icon: "\uF2B5"
  },
  {
    iconLabel: "kpiContactLabel_",
    metricLabel: "kpiContact_",
    styleCondition: hasContact,
    fetchMetric: getContact,
    margin: 0,
    icon: "\uF0C0"
  },
  {
    iconLabel: "kpiActivityLabel_",
    metricLabel: "kpiActivity_",
    styleCondition: hasActivityCount,
    fetchMetric: getActivityCount,
    margin: 90,
    icon: "\uF0AE"
  }
];
var appendKpi = ({
  nodeEnter,
  selectedNode,
  delta,
  iconLabel,
  metricLabel,
  icon,
  margin,
  styleCondition,
  fetchMetric,
  click
}) => {
  nodeEnter.append("text").attr("id", (d) => iconLabel + d.id).style("font-family", "FontAwesome").style("font-size", "10px").attr("dy", 3.5).attr("dx", (d) => delta - d.y + margin).style("fill", (d) => d.id === selectedNode.id ? "red" : "black").style("fill-opacity", (d) => styleCondition(d) ? 0.9 : 0).attr("text-anchor", "start").text(`${icon}`).on("click", click);
  nodeEnter.append("text").attr("id", (d) => metricLabel + d.id).style("font-family", "Source Sans Pro").style("font-size", "14px").style("fill-opacity", (d) => styleCondition(d) ? 1 : 0).attr("dy", 3.5).attr("dx", (d) => delta - d.y + margin + TREE_KPI_ICON_SIZE).text((d) => fetchMetric(d)).on("click", click);
};
var updateKpiLabel = (node, label, styleCondition) => {
  const labelElement = document.getElementById(label + node.id);
  if (!labelElement)
    return;
  labelElement.setAttribute(
    "style",
    `font-family: FontAwesome; fill-opacity: ${styleCondition(node) ? "1" : "0"}; font-size: 10px`
  );
};
var updateKpiValue = (node, label, styleCondition, fetchMetric) => {
  const labelElement = document.getElementById(label + node.id);
  if (!labelElement)
    return;
  labelElement.textContent = fetchMetric(node);
  labelElement.setAttribute(
    "style",
    `font-family: Source Sans Pro; font-size: 14px; fill-opacity: ${styleCondition(node) ? "1" : "0"}`
  );
};

// src/utils/d3trees/tree.logic.ts
import { get as get8 } from "lodash-es";

// src/utils/d3trees/constants.ts
var KycStatusColor = {
  "sgcib RESTRICTED": "#f17100",
  // Orange
  "sgcib GREEN": "#35bd5b",
  // Green
  NOTP: "#e60028",
  // Red
  "sgcib NON AG": "#e60028",
  // Red
  "NOTP BASELII SGCIB": "#e60028",
  // Red
  "sgcib RED": "#e60028",
  // Red
  "NON sgcib": "#e60028",
  // Red
  "sgcib ARCHI": "#e60028",
  // Red
  "SGCIB DRAFT": "#e60028",
  // Red
  "sgcib LIMIT": "#e60028",
  // Red
  "sgcib DECLINED": "#e60028"
  // Red
};
var Duration = 400;
var ZIndex = 99999999999;

// src/utils/d3trees/tree.logic.ts
var swap = (d, a, b) => {
  ;
  [d[a], d[b]] = [d[b], d[a]];
};
var collapseAll = (d) => {
  if (d.children) {
    swap(d, "_children", "children");
  }
  if (d._children) {
    d._children.forEach(collapseAll);
  }
};
var center = (containerRef, nodeId, svg, zoom, selectedNode) => {
  const selector = document.querySelector(nodeId);
  if (!selector) {
    return;
  }
  const offsetX = window.innerWidth / 2 - selectedNode.x * zoom.scale();
  const maxOffset = 300;
  const offsetY = 100 - Math.max(0, selectedNode.y - maxOffset);
  svg.transition().duration(Duration).call(zoom.translate([offsetX, offsetY]).event).attr("transform", "translate(" + offsetX + "," + offsetY + ")").each("end", () => containerRef.current.style.visibility = "visible");
  return;
};
var getNodeEnter = (node, activeSubRootElement, vertical = true) => {
  return node.enter().append("g").attr("class", "node").attr("id", (d) => `node_${d.id}`).attr(
    "transform",
    () => vertical ? `translate(${activeSubRootElement.x0},${activeSubRootElement.y0})` : `translate(${activeSubRootElement.y0},${activeSubRootElement.x0})`
  );
};
var hasChildren = (node) => node.children && node.children.length > 0 || node._children && node._children.length > 0;
var hasCoverage2 = (d) => getCoverage2(d) > 0;
var hasContact2 = (d) => getContact2(d) > 0;
var hasActivityCount2 = (d) => getActivityCount2(d) > 0;
var getCoverage2 = (d) => d[getCoverageProperty2(d)];
var getContact2 = (d) => d[getContactProperty2(d)];
var getActivityCount2 = (d) => d[getActivityCountProperty2(d)];
var getContactText = (d) => `\uF0C0 ${d["numberOfContacts"]}/${d["aggregatedContactCount"]}`;
var isCollapsed = (d) => !!d._children && !d.children;
var getCoverageProperty2 = (d) => !d._children && d.children ? "coverage" : "aggregatedCoverage";
var getActivityCountProperty2 = (d) => !d._children && d.children ? "numberOfActivities" : "aggregatedActivityCount";
var getContactProperty2 = (d) => !d._children && d.children ? "numberOfContacts" : "aggregatedContactCount";
var sortTree = (node, sortKey) => {
  if (node && node.children && node.children.length) {
    node.children.sort(
      (a, b) => get8(a, sortKey, "").toLowerCase() > get8(b, sortKey, "").toLowerCase() ? 1 : get8(b, sortKey, "").toLowerCase() > get8(a, sortKey, "").toLowerCase() ? -1 : 0
    );
    node.children.forEach(function(child) {
      sortTree(child, sortKey);
    });
  }
};

// src/utils/d3trees/commercial.tree.fields.d3.ts
var appendHeader = (nodeEnter) => {
  const gNode = nodeEnter.append("g").attr("class", "contacts-sg-activities-container");
  appendHeaderText(nodeEnter, 3.5, "Name");
  appendHeaderText(nodeEnter, ACCOUNT_COLUMN_SIZE, "Level");
  appendHeaderText(nodeEnter, ACCOUNT_COLUMN_SIZE + DEFAULT_COLUMN_SIZE - 10, "Country");
  appendHeaderText(nodeEnter, ACCOUNT_COLUMN_SIZE + 2 * DEFAULT_COLUMN_SIZE - 50, "Segmentation");
  appendHeaderText(nodeEnter, ACCOUNT_COLUMN_SIZE + 3 * DEFAULT_COLUMN_SIZE - 10, "Steering country");
  appendHeaderText(nodeEnter, ACCOUNT_COLUMN_SIZE + 4 * DEFAULT_COLUMN_SIZE + 70, "Typology");
  appendHeaderText(gNode, ACCOUNT_COLUMN_SIZE + 5 * DEFAULT_COLUMN_SIZE + 120, "Contacts");
  appendHeaderText(gNode, ACCOUNT_COLUMN_SIZE + 6 * DEFAULT_COLUMN_SIZE + 80, "SG");
  appendHeaderText(gNode, ACCOUNT_COLUMN_SIZE + 6 * DEFAULT_COLUMN_SIZE + 110, "Activities");
  appendHeaderText(nodeEnter, ACCOUNT_COLUMN_SIZE + 7 * DEFAULT_COLUMN_SIZE + 90, "BDR Ccial ID");
  appendHeaderText(nodeEnter, ACCOUNT_COLUMN_SIZE + 8 * DEFAULT_COLUMN_SIZE + 70, "BDR Legal ID");
};
var appendText = (nodeEnter, selectedNode, click, onActionClick) => {
  appendClientName(nodeEnter, click);
  appendTextField(nodeEnter, ACCOUNT_COLUMN_SIZE, "level", click);
  appendTextField(nodeEnter, ACCOUNT_COLUMN_SIZE + DEFAULT_COLUMN_SIZE - 10, "countryIso", click);
  appendTextField(nodeEnter, ACCOUNT_COLUMN_SIZE + 2 * DEFAULT_COLUMN_SIZE - 50, "segmentation", click);
  appendTextField(nodeEnter, ACCOUNT_COLUMN_SIZE + 3 * DEFAULT_COLUMN_SIZE - 10, "steeringCountry", click);
  appendTextField(nodeEnter, ACCOUNT_COLUMN_SIZE + 4 * DEFAULT_COLUMN_SIZE + 80, "typologyLevel2Name", click);
  appendKpis(nodeEnter, selectedNode, ACCOUNT_COLUMN_SIZE + 5 * DEFAULT_COLUMN_SIZE + 140, click);
  appendTextField(nodeEnter, ACCOUNT_COLUMN_SIZE + 7 * DEFAULT_COLUMN_SIZE + 100, "bdrCommercialId", click);
  appendTextField(nodeEnter, ACCOUNT_COLUMN_SIZE + 8 * DEFAULT_COLUMN_SIZE + 80, "bdrLegalId", click);
  appendActions(nodeEnter, onActionClick);
};
var columnSize = 100;
var clientColumnSize = 370;
function appendActions(container, clickOnAction) {
  container.append("text").append("tspan").attr("dy", 3.5).attr("dx", (d) => clientColumnSize + 9 * columnSize + 50 - d.y).attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", "#777").style("cursor", "pointer").text("\uF141").on("click", (d) => clickOnAction(d.id));
}
var appendHeaderText = (node, delta, header) => {
  node.append("text").style(FONT_FAMILY, SOURCE_SANS_PRO_FONT).style("font-size", "14px").attr("dy", 3.5).attr("dx", delta).text(header);
};
var appendClientName = (nodeEnter, click) => {
  nodeEnter.attr("id", (d) => "account_" + d.id).style("cursor", (d) => hasChildren(d) ? "pointer" : "default").append("text").style(FONT_FAMILY, SOURCE_SANS_PRO_FONT).style("font-size", "14px").attr("dy", 3.5).attr("dx", 5.5).attr("width", (d) => 360 - d.y).text((d) => d.name).each(wrap).on("click", click);
};
var appendTextField = (nodeEnter, delta, keyField, click) => {
  nodeEnter.append("text").style(FONT_FAMILY, SOURCE_SANS_PRO_FONT).style("font-size", "14px").attr("dy", 3.5).attr("dx", (d) => delta - d.y).text((d) => d[keyField]).on("click", click);
};
function wrap() {
  const self2 = d3.select(this);
  let textLength = self2.node().getComputedTextLength();
  let text = self2.text();
  const dx = parseFloat(self2.attr("width"));
  while (textLength > dx && text.length > 0) {
    text = text.slice(0, -1);
    self2.text(text + "...");
    textLength = self2.node().getComputedTextLength();
  }
  return text;
}

// src/utils/d3trees/commercial.tree.d3.ts
function drawCommercialTree(accountId, ref, data2, isFullScreen, onAccountClick) {
  if (!isEmpty12(data2)) {
    const tree = d3.layout.tree().nodeSize([0, 20]);
    const diagonal = d3.svg.diagonal().projection((d) => [d.y || 0, d.x || 0]);
    const centeredValue = ((!isFullScreen ? TREE_WIDTH : window.screen.width) - TREE_BAR_WIDTH) / 2;
    const zoom = d3.behavior.zoom().scaleExtent([1, 1]);
    const root2 = cloneDeep(data2);
    const selectedNode = cloneDeep(root2);
    root2.x0 = 0;
    root2.y0 = 0;
    const $svg = d3.select(ref.current).append("svg");
    const $root = $svg.append("g");
    const setTransform = (translate, scale) => {
      zoom.translate(translate);
      zoom.scale(scale);
      $root.transition().duration(300).ease("quad-out").attr("transform", "translate(" + translate + ") scale(" + scale + ")");
    };
    $root.on("mousewheel.zoom", function() {
      const evt = d3.event, translate = zoom.translate(), scale = zoom.scale(), delta = evt.wheelDelta / 2;
      setTransform([translate[0], translate[1] + delta], scale);
    }).on("dblclick.zoom", null).attr("transform", `translate(${centeredValue}, ${TREE_MARGIN.top})`);
    zoom.on("zoom", () => {
      const translate = zoom.translate(), scale = zoom.scale(), evt = d3.event;
      if (typeof evt.sourceEvent.wheelDelta !== "number") {
        setTransform(translate, scale);
      }
    });
    $svg.call(zoom);
    const n = $root.append("g").attr("class", "header").attr("transform", "translate(0, -20)").style("opacity", 1);
    n.append("rect").attr("y", -TREE_BAR_HEIGHT / 2).attr("height", TREE_BAR_HEIGHT).attr("width", TREE_BAR_WIDTH).attr("fill", "white");
    openTreeAndFindSelected(accountId, root2, selectedNode);
    appendHeader(n);
    update(accountId, selectedNode, tree, $root, diagonal, root2, onAccountClick);
  }
}
function update(accountId, selectedNode, tree, svg, diagonal, root2, onAccountClick) {
  if (!selectedNode)
    return;
  const nodes = tree.nodes(root2);
  const height = Math.max(500, nodes.length * TREE_BAR_HEIGHT + TREE_MARGIN.top + TREE_MARGIN.bottom);
  d3.select("svg").transition().duration(TREE_NODE_TRANSITION_DURATION);
  d3.select(self.frameElement).transition().duration(TREE_NODE_TRANSITION_DURATION).style("height", height + "px");
  nodes.forEach((n, i) => n.x = i * TREE_BAR_HEIGHT);
  const node = svg.selectAll("g.node").data(nodes, (d) => d.id);
  const nodeEnter = node.enter().append("g").attr("class", "node").attr(
    "transform",
    () => selectedNode.y0 && selectedNode.x0 ? `translate(${selectedNode.y0}, ${selectedNode.x0})` : null
  ).style("opacity", 1e-6);
  nodeEnter.append("rect").attr("y", -TREE_BAR_HEIGHT / 2).attr("height", TREE_BAR_HEIGHT).attr("width", (d) => TREE_BAR_WIDTH - d.y).on("click", click);
  appendText(nodeEnter, selectedNode, click, onAccountClick);
  nodeEnter.transition().duration(TREE_NODE_TRANSITION_DURATION).attr("transform", (d) => applyTranslation(selectedNode, d)).style("opacity", 1);
  node.transition().duration(TREE_NODE_TRANSITION_DURATION).attr("transform", (d) => applyTranslation(selectedNode, d)).style("opacity", 1).select("rect").style("fill", (d) => ACCOUNT_LEVEL_COLOR[d.level]);
  node.filter((d) => d.id === accountId).attr("font-weight", "bold").style("fill", "red");
  node.exit().transition().duration(TREE_NODE_TRANSITION_DURATION).attr("transform", () => applyTranslation(selectedNode)).style("opacity", 1e-6).remove();
  updateLinks(svg, tree, nodes, diagonal, selectedNode, false);
  nodes.forEach((d) => {
    d.x0 = d.x;
    d.y0 = d.y;
  });
  function click(clickedNode) {
    swap(clickedNode, "_children", "children");
    selectedNode = clickedNode;
    updateKpis(clickedNode);
    update(accountId, selectedNode, tree, svg, diagonal, root2, onAccountClick);
  }
}
function openTreeAndFindSelected(selectedId, node, selectedNode) {
  forEach2(node.children, (child) => {
    if (child.id === selectedId) {
      child.isOpened = true;
      selectedNode = child;
    }
    openTreeAndFindSelected(selectedId, child, selectedNode);
  });
  if (some4(node.children, { isOpened: true })) {
    node.isOpened = true;
  } else {
    node._children = node.children;
    node.children = null;
  }
}
function applyTranslation(source, node = void 0) {
  return node ? node.y && node.x ? `translate(${node.y}, ${node.x})` : null : source.x && source.y ? `translate(${source.y}, ${source.x})` : null;
}

// src/utils/d3trees/crmActivitiesAndA2dTree.ts
import { cloneDeep as cloneDeep2, forEach as forEach3, isString as isString2, some as some5 } from "lodash-es";

// src/utils/d3trees/tree.typings.ts
var TreeTypes = [
  {
    type: 0 /* CrmActivities */,
    colorWith: "#35bd5b",
    colorWithout: "#777"
  },
  {
    type: 2 /* AuthorizationToDeal */,
    colorWith: "#23558c",
    colorWithout: "#777"
  },
  {
    type: 3 /* OrgChartPerEntity */,
    colorWith: "#bcf7cd",
    colorWithout: "#777"
  },
  {
    type: 4 /* KycDigital */,
    colorWith: "#f17100",
    colorWithout: ""
  },
  {
    type: 5 /* Department */,
    colorWith: "",
    colorWithout: ""
  },
  {
    type: 6 /* Commercial */,
    colorWith: "",
    colorWithout: ""
  },
  {
    type: 1 /* Business */,
    colorWith: "#f17100",
    colorWithout: "#777"
  }
];

// ../../node_modules/d3-collection/src/map.js
var prefix = "$";
function Map2() {
}
Map2.prototype = map13.prototype = {
  constructor: Map2,
  has: function(key) {
    return prefix + key in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this)
      if (property[0] === prefix)
        delete this[property];
  },
  keys: function() {
    var keys4 = [];
    for (var property in this)
      if (property[0] === prefix)
        keys4.push(property.slice(1));
    return keys4;
  },
  values: function() {
    var values = [];
    for (var property in this)
      if (property[0] === prefix)
        values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this)
      if (property[0] === prefix)
        entries.push({ key: property.slice(1), value: this[property] });
    return entries;
  },
  size: function() {
    var size6 = 0;
    for (var property in this)
      if (property[0] === prefix)
        ++size6;
    return size6;
  },
  empty: function() {
    for (var property in this)
      if (property[0] === prefix)
        return false;
    return true;
  },
  each: function(f2) {
    for (var property in this)
      if (property[0] === prefix)
        f2(this[property], property.slice(1), this);
  }
};
function map13(object, f2) {
  var map36 = new Map2();
  if (object instanceof Map2)
    object.each(function(value, key2) {
      map36.set(key2, value);
    });
  else if (Array.isArray(object)) {
    var i = -1, n = object.length, o;
    if (f2 == null)
      while (++i < n)
        map36.set(i, object[i]);
    else
      while (++i < n)
        map36.set(f2(o = object[i], i, object), o);
  } else if (object)
    for (var key in object)
      map36.set(key, object[key]);
  return map36;
}
var map_default = map13;

// ../../node_modules/d3-collection/src/set.js
function Set2() {
}
var proto = map_default.prototype;
Set2.prototype = set3.prototype = {
  constructor: Set2,
  has: proto.has,
  add: function(value) {
    value += "";
    this[prefix + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};
function set3(object, f2) {
  var set4 = new Set2();
  if (object instanceof Set2)
    object.each(function(value) {
      set4.add(value);
    });
  else if (object) {
    var i = -1, n = object.length;
    if (f2 == null)
      while (++i < n)
        set4.add(object[i]);
    else
      while (++i < n)
        set4.add(f2(object[i], i, object));
  }
  return set4;
}

// ../../node_modules/d3-selection/src/namespaces.js
var xhtml = "http://www.w3.org/1999/xhtml";
var namespaces_default = {
  svg: "http://www.w3.org/2000/svg",
  xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

// ../../node_modules/d3-selection/src/namespace.js
function namespace_default(name) {
  var prefix2 = name += "", i = prefix2.indexOf(":");
  if (i >= 0 && (prefix2 = name.slice(0, i)) !== "xmlns")
    name = name.slice(i + 1);
  return namespaces_default.hasOwnProperty(prefix2) ? { space: namespaces_default[prefix2], local: name } : name;
}

// ../../node_modules/d3-selection/src/creator.js
function creatorInherit(name) {
  return function() {
    var document2 = this.ownerDocument, uri = this.namespaceURI;
    return uri === xhtml && document2.documentElement.namespaceURI === xhtml ? document2.createElement(name) : document2.createElementNS(uri, name);
  };
}
function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}
function creator_default(name) {
  var fullname = namespace_default(name);
  return (fullname.local ? creatorFixed : creatorInherit)(fullname);
}

// ../../node_modules/d3-selection/src/selector.js
function none() {
}
function selector_default(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
}

// ../../node_modules/d3-selection/src/selection/select.js
function select_default(select) {
  if (typeof select !== "function")
    select = selector_default(select);
  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node)
          subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }
  return new Selection(subgroups, this._parents);
}

// ../../node_modules/d3-selection/src/array.js
function array_default(x) {
  return typeof x === "object" && "length" in x ? x : Array.from(x);
}

// ../../node_modules/d3-selection/src/selectorAll.js
function empty() {
  return [];
}
function selectorAll_default(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}

// ../../node_modules/d3-selection/src/selection/selectAll.js
function arrayAll(select) {
  return function() {
    var group = select.apply(this, arguments);
    return group == null ? [] : array_default(group);
  };
}
function selectAll_default(select) {
  if (typeof select === "function")
    select = arrayAll(select);
  else
    select = selectorAll_default(select);
  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }
  return new Selection(subgroups, parents);
}

// ../../node_modules/d3-selection/src/matcher.js
function matcher_default(selector) {
  return function() {
    return this.matches(selector);
  };
}
function childMatcher(selector) {
  return function(node) {
    return node.matches(selector);
  };
}

// ../../node_modules/d3-selection/src/selection/selectChild.js
var find7 = Array.prototype.find;
function childFind(match2) {
  return function() {
    return find7.call(this.children, match2);
  };
}
function childFirst() {
  return this.firstElementChild;
}
function selectChild_default(match2) {
  return this.select(match2 == null ? childFirst : childFind(typeof match2 === "function" ? match2 : childMatcher(match2)));
}

// ../../node_modules/d3-selection/src/selection/selectChildren.js
var filter8 = Array.prototype.filter;
function children() {
  return this.children;
}
function childrenFilter(match2) {
  return function() {
    return filter8.call(this.children, match2);
  };
}
function selectChildren_default(match2) {
  return this.selectAll(match2 == null ? children : childrenFilter(typeof match2 === "function" ? match2 : childMatcher(match2)));
}

// ../../node_modules/d3-selection/src/selection/filter.js
function filter_default(match2) {
  if (typeof match2 !== "function")
    match2 = matcher_default(match2);
  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match2.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }
  return new Selection(subgroups, this._parents);
}

// ../../node_modules/d3-selection/src/selection/sparse.js
function sparse_default(update2) {
  return new Array(update2.length);
}

// ../../node_modules/d3-selection/src/selection/enter.js
function enter_default() {
  return new Selection(this._enter || this._groups.map(sparse_default), this._parents);
}
function EnterNode(parent, datum2) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum2;
}
EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) {
    return this._parent.insertBefore(child, this._next);
  },
  insertBefore: function(child, next) {
    return this._parent.insertBefore(child, next);
  },
  querySelector: function(selector) {
    return this._parent.querySelector(selector);
  },
  querySelectorAll: function(selector) {
    return this._parent.querySelectorAll(selector);
  }
};

// ../../node_modules/d3-selection/src/constant.js
function constant_default(x) {
  return function() {
    return x;
  };
}

// ../../node_modules/d3-selection/src/selection/data.js
function bindIndex(parent, group, enter, update2, exit2, data2) {
  var i = 0, node, groupLength = group.length, dataLength = data2.length;
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data2[i];
      update2[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data2[i]);
    }
  }
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit2[i] = node;
    }
  }
}
function bindKey(parent, group, enter, update2, exit2, data2, key) {
  var i, node, nodeByKeyValue = /* @__PURE__ */ new Map(), groupLength = group.length, dataLength = data2.length, keyValues = new Array(groupLength), keyValue;
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit2[i] = node;
      } else {
        nodeByKeyValue.set(keyValue, node);
      }
    }
  }
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data2[i], i, data2) + "";
    if (node = nodeByKeyValue.get(keyValue)) {
      update2[i] = node;
      node.__data__ = data2[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data2[i]);
    }
  }
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) {
      exit2[i] = node;
    }
  }
}
function datum(node) {
  return node.__data__;
}
function data_default(value, key) {
  if (!arguments.length)
    return Array.from(this, datum);
  var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
  if (typeof value !== "function")
    value = constant_default(value);
  for (var m = groups.length, update2 = new Array(m), enter = new Array(m), exit2 = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j], group = groups[j], groupLength = group.length, data2 = array_default(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data2.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update2[j] = new Array(dataLength), exitGroup = exit2[j] = new Array(groupLength);
    bind(parent, group, enterGroup, updateGroup, exitGroup, data2, key);
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1)
          i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength)
          ;
        previous._next = next || null;
      }
    }
  }
  update2 = new Selection(update2, parents);
  update2._enter = enter;
  update2._exit = exit2;
  return update2;
}

// ../../node_modules/d3-selection/src/selection/exit.js
function exit_default() {
  return new Selection(this._exit || this._groups.map(sparse_default), this._parents);
}

// ../../node_modules/d3-selection/src/selection/join.js
function join_default(onenter, onupdate, onexit) {
  var enter = this.enter(), update2 = this, exit2 = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null)
    update2 = onupdate(update2);
  if (onexit == null)
    exit2.remove();
  else
    onexit(exit2);
  return enter && update2 ? enter.merge(update2).order() : update2;
}

// ../../node_modules/d3-selection/src/selection/merge.js
function merge_default(selection2) {
  if (!(selection2 instanceof Selection))
    throw new Error("invalid merge");
  for (var groups0 = this._groups, groups1 = selection2._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Selection(merges, this._parents);
}

// ../../node_modules/d3-selection/src/selection/order.js
function order_default() {
  for (var groups = this._groups, j = -1, m = groups.length; ++j < m; ) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
      if (node = group[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4)
          next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }
  return this;
}

// ../../node_modules/d3-selection/src/selection/sort.js
function sort_default(compare) {
  if (!compare)
    compare = ascending;
  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }
  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }
  return new Selection(sortgroups, this._parents).order();
}
function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

// ../../node_modules/d3-selection/src/selection/call.js
function call_default() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}

// ../../node_modules/d3-selection/src/selection/nodes.js
function nodes_default() {
  return Array.from(this);
}

// ../../node_modules/d3-selection/src/selection/node.js
function node_default() {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node)
        return node;
    }
  }
  return null;
}

// ../../node_modules/d3-selection/src/selection/size.js
function size_default() {
  let size6 = 0;
  for (const node of this)
    ++size6;
  return size6;
}

// ../../node_modules/d3-selection/src/selection/empty.js
function empty_default() {
  return !this.node();
}

// ../../node_modules/d3-selection/src/selection/each.js
function each_default(callback) {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i])
        callback.call(node, node.__data__, i, group);
    }
  }
  return this;
}

// ../../node_modules/d3-selection/src/selection/attr.js
function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}
function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}
function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null)
      this.removeAttribute(name);
    else
      this.setAttribute(name, v);
  };
}
function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null)
      this.removeAttributeNS(fullname.space, fullname.local);
    else
      this.setAttributeNS(fullname.space, fullname.local, v);
  };
}
function attr_default(name, value) {
  var fullname = namespace_default(name);
  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
  }
  return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
}

// ../../node_modules/d3-selection/src/window.js
function window_default(node) {
  return node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView;
}

// ../../node_modules/d3-selection/src/selection/style.js
function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}
function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null)
      this.style.removeProperty(name);
    else
      this.style.setProperty(name, v, priority);
  };
}
function style_default(name, value, priority) {
  return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
}
function styleValue(node, name) {
  return node.style.getPropertyValue(name) || window_default(node).getComputedStyle(node, null).getPropertyValue(name);
}

// ../../node_modules/d3-selection/src/selection/property.js
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}
function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}
function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null)
      delete this[name];
    else
      this[name] = v;
  };
}
function property_default(name, value) {
  return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
}

// ../../node_modules/d3-selection/src/selection/classed.js
function classArray(string) {
  return string.trim().split(/^|\s+/);
}
function classList(node) {
  return node.classList || new ClassList(node);
}
function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};
function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n)
    list.add(names[i]);
}
function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n)
    list.remove(names[i]);
}
function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}
function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}
function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}
function classed_default(name, value) {
  var names = classArray(name + "");
  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n)
      if (!list.contains(names[i]))
        return false;
    return true;
  }
  return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
}

// ../../node_modules/d3-selection/src/selection/text.js
function textRemove() {
  this.textContent = "";
}
function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}
function text_default(value) {
  return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
}

// ../../node_modules/d3-selection/src/selection/html.js
function htmlRemove() {
  this.innerHTML = "";
}
function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}
function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}
function html_default(value) {
  return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
}

// ../../node_modules/d3-selection/src/selection/raise.js
function raise() {
  if (this.nextSibling)
    this.parentNode.appendChild(this);
}
function raise_default() {
  return this.each(raise);
}

// ../../node_modules/d3-selection/src/selection/lower.js
function lower() {
  if (this.previousSibling)
    this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function lower_default() {
  return this.each(lower);
}

// ../../node_modules/d3-selection/src/selection/append.js
function append_default(name) {
  var create2 = typeof name === "function" ? name : creator_default(name);
  return this.select(function() {
    return this.appendChild(create2.apply(this, arguments));
  });
}

// ../../node_modules/d3-selection/src/selection/insert.js
function constantNull() {
  return null;
}
function insert_default(name, before) {
  var create2 = typeof name === "function" ? name : creator_default(name), select = before == null ? constantNull : typeof before === "function" ? before : selector_default(before);
  return this.select(function() {
    return this.insertBefore(create2.apply(this, arguments), select.apply(this, arguments) || null);
  });
}

// ../../node_modules/d3-selection/src/selection/remove.js
function remove() {
  var parent = this.parentNode;
  if (parent)
    parent.removeChild(this);
}
function remove_default() {
  return this.each(remove);
}

// ../../node_modules/d3-selection/src/selection/clone.js
function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function clone_default(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}

// ../../node_modules/d3-selection/src/selection/datum.js
function datum_default(value) {
  return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

// ../../node_modules/d3-selection/src/selection/on.js
function contextListener(listener) {
  return function(event2) {
    listener.call(this, event2, this.__data__);
  };
}
function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0)
      name = t.slice(i + 1), t = t.slice(0, i);
    return { type: t, name };
  });
}
function onRemove(typename) {
  return function() {
    var on2 = this.__on;
    if (!on2)
      return;
    for (var j = 0, i = -1, m = on2.length, o; j < m; ++j) {
      if (o = on2[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on2[++i] = o;
      }
    }
    if (++i)
      on2.length = i;
    else
      delete this.__on;
  };
}
function onAdd(typename, value, options2) {
  return function() {
    var on2 = this.__on, o, listener = contextListener(value);
    if (on2)
      for (var j = 0, m = on2.length; j < m; ++j) {
        if ((o = on2[j]).type === typename.type && o.name === typename.name) {
          this.removeEventListener(o.type, o.listener, o.options);
          this.addEventListener(o.type, o.listener = listener, o.options = options2);
          o.value = value;
          return;
        }
      }
    this.addEventListener(typename.type, listener, options2);
    o = { type: typename.type, name: typename.name, value, listener, options: options2 };
    if (!on2)
      this.__on = [o];
    else
      on2.push(o);
  };
}
function on_default(typename, value, options2) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
  if (arguments.length < 2) {
    var on2 = this.node().__on;
    if (on2)
      for (var j = 0, m = on2.length, o; j < m; ++j) {
        for (i = 0, o = on2[j]; i < n; ++i) {
          if ((t = typenames[i]).type === o.type && t.name === o.name) {
            return o.value;
          }
        }
      }
    return;
  }
  on2 = value ? onAdd : onRemove;
  for (i = 0; i < n; ++i)
    this.each(on2(typenames[i], value, options2));
  return this;
}

// ../../node_modules/d3-selection/src/selection/dispatch.js
function dispatchEvent(node, type, params) {
  var window2 = window_default(node), event2 = window2.CustomEvent;
  if (typeof event2 === "function") {
    event2 = new event2(type, params);
  } else {
    event2 = window2.document.createEvent("Event");
    if (params)
      event2.initEvent(type, params.bubbles, params.cancelable), event2.detail = params.detail;
    else
      event2.initEvent(type, false, false);
  }
  node.dispatchEvent(event2);
}
function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}
function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}
function dispatch_default(type, params) {
  return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
}

// ../../node_modules/d3-selection/src/selection/iterator.js
function* iterator_default() {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i])
        yield node;
    }
  }
}

// ../../node_modules/d3-selection/src/selection/index.js
var root = [null];
function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}
function selection() {
  return new Selection([[document.documentElement]], root);
}
function selection_selection() {
  return this;
}
Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: select_default,
  selectAll: selectAll_default,
  selectChild: selectChild_default,
  selectChildren: selectChildren_default,
  filter: filter_default,
  data: data_default,
  enter: enter_default,
  exit: exit_default,
  join: join_default,
  merge: merge_default,
  selection: selection_selection,
  order: order_default,
  sort: sort_default,
  call: call_default,
  nodes: nodes_default,
  node: node_default,
  size: size_default,
  empty: empty_default,
  each: each_default,
  attr: attr_default,
  style: style_default,
  property: property_default,
  classed: classed_default,
  text: text_default,
  html: html_default,
  raise: raise_default,
  lower: lower_default,
  append: append_default,
  insert: insert_default,
  remove: remove_default,
  clone: clone_default,
  datum: datum_default,
  on: on_default,
  dispatch: dispatch_default,
  [Symbol.iterator]: iterator_default
};
var selection_default = selection;

// ../../node_modules/d3-selection/src/select.js
function select_default2(selector) {
  return typeof selector === "string" ? new Selection([[document.querySelector(selector)]], [document.documentElement]) : new Selection([[selector]], root);
}

// src/utils/d3trees/tip.ts
function d3tip() {
  let direction = d3TipDirection, offset = d3TipOffset, html2 = d3TipHTML, rootElement = document.body, node = initNode(), svg = null, point = null, target = null;
  function tip(vis) {
    svg = getSVGNode(vis);
    if (!svg)
      return;
    point = svg.createSVGPoint();
    rootElement.appendChild(node);
  }
  tip.show = function() {
    const args = Array.prototype.slice.call(arguments);
    if (args[args.length - 1] instanceof SVGElement)
      target = args.pop();
    let content = html2.apply(this, args), poffset = offset.apply(this, args), dir = direction.apply(this, args), nodel = getNodeEl(), i = directions.length, coords, scrollTop = document.documentElement.scrollTop || rootElement.scrollTop, scrollLeft = document.documentElement.scrollLeft || rootElement.scrollLeft;
    nodel.html(content).style("opacity", 1).style("pointer-events", "all");
    while (i--)
      nodel.classed(directions[i], false);
    coords = directionCallbacks.get(dir).apply(this);
    nodel.classed(dir, true).style("top", coords.top + poffset[0] + scrollTop + "px").style("left", coords.left + poffset[1] + scrollLeft + "px");
    return tip;
  };
  tip.hide = function() {
    const nodel = getNodeEl();
    nodel.style("opacity", 0).style("pointer-events", "none");
    return tip;
  };
  tip.attr = function(n, v) {
    if (arguments.length < 2 && typeof n === "string") {
      return getNodeEl().attr(n);
    }
    const args = Array.prototype.slice.call(arguments);
    selection_default.prototype.attr.apply(getNodeEl(), args);
    return tip;
  };
  tip.style = function(n, v) {
    if (arguments.length < 2 && typeof n === "string") {
      return getNodeEl().style(n);
    }
    const args = Array.prototype.slice.call(arguments);
    selection_default.prototype.style.apply(getNodeEl(), args);
    return tip;
  };
  tip.direction = function(v) {
    if (!arguments.length)
      return direction;
    direction = v == null ? v : functor(v);
    return tip;
  };
  tip.offset = function(v) {
    if (!arguments.length)
      return offset;
    offset = v == null ? v : functor(v);
    return tip;
  };
  tip.html = function(v) {
    if (!arguments.length)
      return html2;
    html2 = v == null ? v : functor(v);
    return tip;
  };
  tip.rootElement = function(v) {
    if (!arguments.length)
      return rootElement;
    rootElement = v == null ? v : functor(v);
    return tip;
  };
  tip.destroy = function() {
    if (node) {
      getNodeEl().remove();
      node = null;
    }
    return tip;
  };
  function d3TipDirection() {
    return "n";
  }
  function d3TipOffset() {
    return [0, 0];
  }
  function d3TipHTML() {
    return " ";
  }
  const directionCallbacks = map_default({
    n: directionNorth,
    s: directionSouth,
    e: directionEast,
    w: directionWest,
    nw: directionNorthWest,
    ne: directionNorthEast,
    sw: directionSouthWest,
    se: directionSouthEast
  }), directions = directionCallbacks.keys();
  function directionNorth() {
    const bbox = getScreenBBox(this);
    return {
      top: bbox.n.y - node.offsetHeight,
      left: bbox.n.x - node.offsetWidth / 2
    };
  }
  function directionSouth() {
    const bbox = getScreenBBox(this);
    return {
      top: bbox.s.y,
      left: bbox.s.x - node.offsetWidth / 2
    };
  }
  function directionEast() {
    const bbox = getScreenBBox(this);
    return {
      top: bbox.e.y - node.offsetHeight / 2,
      left: bbox.e.x
    };
  }
  function directionWest() {
    const bbox = getScreenBBox(this);
    return {
      top: bbox.w.y - node.offsetHeight / 2,
      left: bbox.w.x - node.offsetWidth
    };
  }
  function directionNorthWest() {
    const bbox = getScreenBBox(this);
    return {
      top: bbox.nw.y - node.offsetHeight,
      left: bbox.nw.x - node.offsetWidth
    };
  }
  function directionNorthEast() {
    const bbox = getScreenBBox(this);
    return {
      top: bbox.ne.y - node.offsetHeight,
      left: bbox.ne.x
    };
  }
  function directionSouthWest() {
    const bbox = getScreenBBox(this);
    return {
      top: bbox.sw.y,
      left: bbox.sw.x - node.offsetWidth
    };
  }
  function directionSouthEast() {
    const bbox = getScreenBBox(this);
    return {
      top: bbox.se.y,
      left: bbox.se.x
    };
  }
  function initNode() {
    const div = select_default2(document.createElement("div"));
    div.style("position", "absolute").style("top", 0).style("opacity", 0).style("pointer-events", "none").style("box-sizing", "border-box");
    return div.node();
  }
  function getSVGNode(element) {
    const svgNode = element.node();
    if (!svgNode)
      return null;
    if (svgNode.tagName.toLowerCase() === "svg")
      return svgNode;
    return svgNode.ownerSVGElement;
  }
  function getNodeEl() {
    if (node == null) {
      node = initNode();
      rootElement.appendChild(node);
    }
    return select_default2(node);
  }
  function getScreenBBox(targetShape) {
    let targetel = target || targetShape;
    while (targetel.getScreenCTM == null && targetel.parentNode != null) {
      targetel = targetel.parentNode;
    }
    let bbox = {}, matrix = targetel.getScreenCTM(), tbbox = targetel.getBBox(), width = tbbox.width, height = tbbox.height, y = tbbox.y;
    point.x = tbbox.x;
    point.y = y;
    bbox.nw = point.matrixTransform(matrix);
    point.x += width;
    bbox.ne = point.matrixTransform(matrix);
    point.y += height;
    bbox.se = point.matrixTransform(matrix);
    point.x -= width;
    bbox.sw = point.matrixTransform(matrix);
    point.y -= height / 2;
    bbox.w = point.matrixTransform(matrix);
    point.x += width;
    bbox.e = point.matrixTransform(matrix);
    point.x -= width / 2;
    point.y -= height / 2;
    bbox.n = point.matrixTransform(matrix);
    point.y += height;
    bbox.s = point.matrixTransform(matrix);
    return bbox;
  }
  function functor(v) {
    return typeof v === "function" ? v : function() {
      return v;
    };
  }
  return tip;
}

// src/utils/d3trees/crmActivitiesAndA2dTree.ts
function drawCrmActivitiesAndA2dTree(accountId, ref, treeData, onAccountClick) {
  const treeName = "__crmActivitiesAndA2dTree";
  window.scrollTo(0, 320);
  const duration4 = 400;
  const depthOffset2 = 640;
  const nbiAmountOffset = 50;
  const treeType = TreeTypes[0];
  let offsetX = 0, offsetY = 0;
  const tree = d3.layout.cluster().nodeSize([35]);
  const diagonal = d3.svg.diagonal().projection((d) => [d.y, d.x]);
  const zoom = d3.behavior.zoom().on("zoom", () => {
    offsetX = d3.event.translate[0];
    offsetY = d3.event.translate[1];
    svg.attr("transform", "translate(" + d3.event.translate + ") scale(" + d3.event.scale + ")");
  });
  const tip = d3tip().direction("e").offset([10, 20]);
  const svg = d3.select(ref.current).append("svg").call(zoom).on("dblclick.zoom", null).call(tip).append("g");
  function openTreeAndFindSelected2(selectedId, node) {
    forEach3(node.children, (c) => {
      if (c.id === selectedId) {
        c.isOpened = true;
        selectedNode = c;
      }
      openTreeAndFindSelected2(selectedId, c);
    });
    if (some5(node.children, { isOpened: true })) {
      node.isOpened = true;
    } else {
      node._children = node.children;
      node.children = null;
    }
  }
  const root2 = cloneDeep2(treeData.root);
  let selectedNode = cloneDeep2(root2);
  treeData.x0 = 0;
  treeData.y0 = 0;
  const groupAccount = root2;
  sortTree(root2, "name");
  openTreeAndFindSelected2(accountId, root2);
  updateGraphic(root2);
  function swap2(d, a, b) {
    ;
    [d[a], d[b]] = [d[b], d[a]];
  }
  function updateGraphic(source) {
    if (!source) {
      return;
    }
    const nodes = tree.nodes(root2).reverse();
    nodes.forEach((d) => d.y = d.depth * depthOffset2);
    svg.selectAll("#node_" + source.id).remove();
    const node = svg.selectAll("g.node").data(nodes, (d) => d.id);
    const nodeEnter = getNodeEnter2(node, source);
    drawNode(nodeEnter);
    nodeTransition2(node);
    nodeExitTransition2(node);
    updateLinks(svg, tree, nodes, diagonal, source, true);
    nodes.forEach((d) => {
      d.x0 = d.x;
      d.y0 = d.y;
    });
  }
  function click(d) {
    swap2(d, "_children", "children");
    selectedNode = d;
    updateGraphic(d);
  }
  function center2(centerFromFirstNode = false) {
    const selector = centerFromFirstNode ? document.querySelector("#account_" + groupAccount.id) : document.querySelector("#account_" + selectedNode.id);
    if (selector) {
      const bounding = selector.getBoundingClientRect();
      const container = ref.current;
      if (container) {
        const isOpenedOffsetX = zoom.scale() * (!selectedNode._children && selectedNode.children ? depthOffset2 : 0);
        offsetX += window.innerWidth / 2 - bounding.left - bounding.width / 2 - isOpenedOffsetX;
        offsetY += container.offsetHeight / 2 - bounding.top + container.offsetTop - bounding.height / 2;
      }
    }
    svg.transition().duration(duration4).call(zoom.translate([offsetX, offsetY]).event).attr("transform", "translate(" + offsetX + "," + offsetY + ")");
  }
  function getNodeEnter2(node, source) {
    return node.enter().append("g").attr("class", "node").attr("id", (d) => "node_" + d.id).attr("transform", () => "translate(" + source.y0 + "," + source.x0 + ")");
  }
  function drawNode(nodeEnter) {
    appendAccount2(nodeEnter);
    if (treeType.type === 0 /* CrmActivities */)
      appendPill2(nodeEnter);
    appendRect2(nodeEnter);
    if (treeType.type === 0 /* CrmActivities */)
      appendRightPanel3(nodeEnter, onAccountClick);
  }
  function appendPill2(nodeEnter) {
    nodeEnter.append("rect").attr("x", -15).attr("y", -16).attr("height", 30).attr("width", 220 + nbiAmountOffset).attr("rx", 15).attr("ry", 15).style("fill", (d) => hasCoverage2(d) ? "#bcf7cd" : "#dddedf").style("stroke", (d) => hasCoverage2(d) ? "#bcf7cd" : "#dddedf");
  }
  function appendRect2(nodeEnter) {
    nodeEnter.append("rect").attr("id", (d) => "account_" + d.id).attr("x", -15).attr("y", -16).attr("height", 30).attr("width", 30).attr("rx", 20).attr("ry", 20).attr("class", (d) => {
      return groupAccount.id === d.id ? "global-rect-node" : "";
    }).style("fill", () => "#35bd5b").style("cursor", (d) => hasChildren(d) || d.level === "EC" && d.bdrLegalId ? "pointer" : "default").on("click", click);
    if (treeType.type !== 0 /* CrmActivities */) {
      nodeEnter.on("click", (d) => {
        if (d.level === "EC" && d.bdrLegalId)
          window[treeName].openA2D(event, d.id);
      });
    }
    nodeEnter.filter(hasChildren).append("text").style("font-family", "FontAwesome").style("font-size", "20px").style("fill", "white").style("cursor", "pointer").attr("text-anchor", "middle").attr("dy", "0.68ex").text((d) => isCollapsed(d) ? "\uF067" : "\uF068").on("click", click);
  }
  function appendAccount2(nodeEnter) {
    nodeEnter.append("text").attr("id", (d) => "text_" + d.id).attr("x", -20).style("font-size", "15px").attr("dy", "0.68ex").attr("text-anchor", "end").style("font-weight", (d) => d.id === accountId ? "bold" : "").style("fill", (d) => d.id === accountId ? "red" : "").text((d) => {
      const nameSize = 30;
      const level = isString2(d.level) ? " (" + d.level + ")" : "";
      const name = isString2(d.name) ? d.name.slice(0, nameSize) + (d.name.length > nameSize ? "..." : "") : "";
      const country = isString2(d.countryIso) ? " " + d.countryIso : "";
      return name + level + country;
    });
  }
  function appendRightPanel3(nodeEnter, onAccountClick2) {
    const container = nodeEnter.append("text").attr("x", 20).attr("y", 4);
    appendContacts2(container);
    appendCoverage3(container);
    appendActivities2(container);
    if (treeType.type === 0 /* CrmActivities */) {
      appendNodeActions(nodeEnter, onAccountClick2);
    }
  }
  function appendContacts2(container) {
    container.filter(hasContact2).append("tspan").attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", (d) => getColor(d)).attr("text-anchor", "start").text((d) => getContactText(d));
  }
  function appendCoverage3(container) {
    container.filter(hasCoverage2).append("tspan").attr("dx", 5).attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", (d) => getColor(d)).attr("text-anchor", "start").text((d) => "\uF2B5 " + getCoverage2(d));
  }
  function appendActivities2(container) {
    container.filter(hasActivityCount2).append("tspan").attr("dx", 5).attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", (d) => getColor(d)).attr("text-anchor", "start").text((d) => "\uF0AE " + getActivityCount2(d));
  }
  function appendNodeActions(container, onAccountClick2) {
    container.append("text").attr("y", 4).attr("x", 20).append("tspan").attr("dx", 190 + nbiAmountOffset).attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", "#777").style("cursor", "pointer").attr("text-anchor", "start").text("\uF141").on("click", (d) => onAccountClick2(d.id));
  }
  function nodeTransition2(node) {
    node.transition().duration(duration4).attr("transform", (d) => "translate(" + d.y + "," + d.x + ")").select("text").style("fill-opacity", 1).each("end", () => svg.transition().each("end", center2));
  }
  function nodeExitTransition2(node) {
    node.exit().transition().duration(duration4).attr("transform", (d) => {
      return d.parent ? "translate(" + d.parent.y + "," + d.parent.x + ")" : "translate(" + d.y + "," + d.x + ")";
    }).remove().select("text").style("fill-opacity", 0).each("end", () => svg.transition().each("end", center2));
  }
  function getColor(d) {
    const color = (hasProp) => hasProp(d) ? treeType.colorWith : treeType.colorWithout;
    switch (treeType.type) {
      case 0 /* CrmActivities */:
        return color(hasCoverage2);
      case 1 /* Business */:
        return color((d2) => d2.nbi > 0);
      case 2 /* AuthorizationToDeal */:
        return color((d2) => d2.level === "EC" && d2.bdrLegalId);
      default:
        return "";
    }
  }
}

// src/account/trees/legacy-d3/useOrgChartPerEntityTree.utils.ts
var MarginTopOnContactListContainer = 40;
var MarginLeftOnContactListContainer = 15;
var RowHeight = 17;
var ContactsDisplayedByDefault = 5;
var appendContactsListForOrgChart = (nodeEnter, filteredContactId, onContactClick) => appendContactList(nodeEnter, filteredContactId, "orgChartPerEntity", onContactClick);
var appendContactList = (nodeEnter, filteredContactId, fetchingType, onContactClick, coveredContacts = [], onShowMoreCallback = null) => {
  nodeEnter.filter((d) => d._children || !d.children).append("g").each(function(d) {
    const textGroup = d3.select(this);
    textGroup.attr("dy", MarginTopOnContactListContainer).attr("class", "hover").attr("text-anchor", "left").style("font-size", "10px").style("fill", "gray").style("cursor", "pointer");
    const text = textGroup.append("text");
    const contacts = fetchingType === "department" ? d.department.contacts : d.contacts;
    if (contacts) {
      let contactsCopy = cloneDeep3(contacts);
      if (filteredContactId) {
        const contacts2 = contactsCopy.map(function(contact) {
          if (filteredContactId === contact.id) {
            contact.isSearched = true;
          }
          return contact;
        });
        contactsCopy = sortBy2(contacts2, "isSearched");
      }
      const contactsToParse = filteredContactId ? contactsCopy : contacts;
      const contactsLength = contactsToParse.length;
      const showMoreContainer = contactsLength > ContactsDisplayedByDefault ? textGroup.append("text") : null;
      const x = fetchingType === "department" ? 0 : -MarginLeftOnContactListContainer;
      for (let i = 0; i < contactsLength; i++) {
        const container = !onShowMoreCallback || i < ContactsDisplayedByDefault ? text : showMoreContainer.filter((d2) => d2.showMore);
        appendContactAndMenu(container, x, i, fetchingType, contactsToParse, onContactClick);
      }
      handleShowMoreClick(textGroup, contactsLength, RowHeight, ContactsDisplayedByDefault, x, onShowMoreCallback);
    }
  });
};
var appendContactAndMenu = (container, xPosition, contactIndex, fetchingType, contactsToParse, onContactClick) => {
  const currentContact = contactsToParse[contactIndex];
  container.append("tspan").attr("x", xPosition).attr("y", 10).attr("dy", (d) => (!d.titleHeight ? 20 : d.titleHeight + d.coverageHeight) + RowHeight * contactIndex).style("font-family", "Source Sans Pro").style("font-size", "12px").style("fill", currentContact.isSearched ? "red" : "black").style("font-weight", currentContact.isSearched ? "bold" : "normal").text(truncate(currentContact.fullname, { length: 30 })).on("click", () => onContactClick(currentContact.id)).append("tspan").attr("class", "dropdown opened").style("z-index", ZIndex).attr("data-id", (d) => d.department ? d.department.id + currentContact.id : currentContact.id);
};
var handleShowMoreClick = (node, contactsLength, rowHeight, contactsDisplayedByDefault, xPosition, callbackAction) => {
  if (!callbackAction) {
    return;
  }
  if (contactsLength > contactsDisplayedByDefault) {
    const currentNode = node.append("text").append("tspan").attr("x", xPosition).attr("y", 10).attr(
      "dy",
      (d) => (!d.titleHeight ? 20 : d.titleHeight) + (!d.showMore ? rowHeight * contactsDisplayedByDefault : rowHeight * contactsLength) + d.coverageHeight
    ).style("font-family", "Source Sans Pro").style("font-size", "12px").style("font-weight", "normal").text((d) => !d.showMore ? "Show more" : "Show less");
    currentNode.on("click", callbackAction);
  }
};
var drawNodes = (nodeEnter, searchedNode, onPillClick, onActionClick, filters = void 0) => {
  appendTitle(nodeEnter, searchedNode, "black");
  appendPill(nodeEnter, onPillClick);
  appendRightPanel(nodeEnter, onActionClick("account_click"));
  appendContactsListForOrgChart(nodeEnter, (filters || {}).contactId, onActionClick("contact_click"));
};
var appendRightPanel = (nodeEnter, onAccountClick) => {
  const container = nodeEnter.append("text").attr("y", 4).attr("x", 20);
  appendContacts(container);
  appendActivities(container);
  appendCoverage(container);
  appendActions2(nodeEnter, onAccountClick);
};
var appendTitle = (nodeEnter, searchedNode, color) => {
  nodeEnter.append("text").attr("y", -30).attr("x", -15).attr("text-anchor", "start").text((d) => {
    const nameSize = 30, level = isString3(d.level) ? " (" + d.level + ")" : "", name = isString3(d.name) ? d.name.slice(0, nameSize) + (d.name.length > nameSize ? "..." : "") : "", country = isString3(d.countryIso) ? " " + d.countryIso : "";
    return name + level + country;
  }).style("fill", color);
};
var appendContacts = (nodeEnter) => {
  nodeEnter.filter(hasContact2).append("tspan").attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", (d) => hasCoverage2(d) ? "#35bd5b" : "gray").text((d) => getContactText(d));
};
var appendActivities = (container) => {
  container.filter(hasActivityCount2).append("tspan").attr("dx", 5).attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", (d) => hasCoverage2(d) ? "#35bd5b" : "gray").text((d) => "\uF0AE " + getActivityCount2(d));
};
var appendCoverage = (container) => {
  container.filter(hasCoverage2).append("tspan").attr("dx", 5).attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", (d) => hasCoverage2(d) ? "#35bd5b" : "gray").text((d) => "\uF2B5 " + getCoverage2(d));
};
var appendActions2 = (container, onAccountClick) => {
  container.append("text").attr("y", 4).attr("x", 20).append("tspan").attr("dx", 170).attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", "#777").style("cursor", "pointer").text("\uF141").on("click", (d) => onAccountClick(d.id));
};
var appendPill = (nodeEnter, onClick) => {
  nodeEnter.append("rect").attr("x", -15).attr("y", -16).attr("height", 30).attr("width", 200).attr("rx", 15).attr("ry", 15).style("fill", (d) => hasCoverage2(d) ? "#bcf7cd" : "#dddedf").style("stroke", (d) => hasCoverage2(d) ? "#bcf7cd" : "#dddedf");
  nodeEnter.append("rect").attr("id", (d) => "account_" + d.id).attr("x", -15).attr("y", -16).attr("height", 30).attr("width", 30).attr("rx", 20).attr("ry", 20).style("fill", (d) => hasCoverage2(d) ? "#35bd5b" : "gray").style("cursor", "pointer").style("stroke", (d) => hasCoverage2(d) ? "#35bd5b" : "gray");
  nodeEnter.filter(hasChildren).append("text").style("font-family", "FontAwesome").style("font-size", "20px").style("cursor", "pointer").style("fill", "white").attr("text-anchor", "middle").attr("dy", "0.68ex").text((d) => isCollapsed(d) ? "\uF067" : "\uF068").on("click", onClick);
};

// src/account/trees/legacy-d3/useOrgChartPerEntityTree.ts
var duration = 400;
var useOrgChartPerEntityTree = (onMenuClick) => {
  const containerRef = useRef9(null);
  let root2, selectedNode, searchedNode, filters;
  const [{ tree, zoom, svg, diagonal }, setTreeState] = useState21({});
  useEffect28(() => {
    const tree2 = d3.layout.cluster().nodeSize([350]);
    const diagonalProj = d3.svg.diagonal().projection((d) => [d.x, d.y]);
    const zoom2 = d3.behavior.zoom();
    const newSvg = d3.select(containerRef.current).append("svg").call(zoom2).on("dblclick.zoom", null).append("g");
    zoom2.on("zoom", () => {
      newSvg.attr("transform", `translate(${d3.event.translate}) scale(${d3.event.scale})`);
    });
    window.scrollTo(0, 320);
    setTreeState({ tree: tree2, zoom: zoom2, svg: newSvg, diagonal: diagonalProj });
  }, [containerRef]);
  const updateTree = (data2, filtersData = void 0) => {
    if (!svg)
      return;
    if (!data2 || root2 !== void 0) {
      svg.selectAll("*").remove();
      if (!data2)
        return;
    }
    root2 = data2.root;
    selectedNode = root2;
    searchedNode = void 0;
    filters = filtersData;
    sortTree(root2, "name");
    root2.x0 = 0;
    root2.y0 = 0;
    openTreeAndFindSelectedId(data2.accountId, root2);
    collapseAll(selectedNode);
    updateSubTreeDisplay(root2, filters);
  };
  if (searchedNode) {
    const selected = svg.selectAll("#node_" + searchedNode.id);
    appendTitle(selected, "red", toggleChildrenDisplay);
  }
  const updateSubTreeDisplay = (activeSubRootElement, filters2 = void 0) => {
    if (!activeSubRootElement || !svg) {
      return;
    }
    const nodes = tree.nodes(root2).reverse();
    nodes == null ? void 0 : nodes.forEach((d) => d.y = d.depth * 150);
    const updateRootNode = svg.selectAll("#node_" + activeSubRootElement.id);
    updateRootNode.remove().append("text").attr("y", 30).attr("dy", ".35em").attr("text-anchor", "middle").text(() => 10).style("fill-opacity", 1).style("stroke", "gray").style("fill", "none").style("stroke-width", 1);
    const nodesWithIds = svg.selectAll("g.node").data(nodes, (d) => d.id);
    const nodeEnter = getNodeEnter(nodesWithIds, activeSubRootElement);
    drawNodes(nodeEnter, filters2, toggleChildrenDisplay, onMenuClick);
    const nodeUpdate = nodesWithIds.transition().duration(duration).attr("transform", (d) => `translate(${d.x},${d.y})`).each(
      "end",
      () => svg.transition().each("end", center(containerRef, "#account_" + selectedNode.id, svg, zoom, selectedNode))
    );
    nodeUpdate.select("text").style("fill-opacity", 1);
    const nodeExit = nodesWithIds.exit().transition().duration(duration).attr("transform", () => `translate(${activeSubRootElement.x},${activeSubRootElement.y})`).remove().each(
      "end",
      () => svg.transition().each("end", center(containerRef, "#account_" + selectedNode.id, svg, zoom, selectedNode))
    );
    nodeExit.select("text").style("fill-opacity", 1e-6);
    updateLinks(svg, tree, nodes, diagonal, activeSubRootElement, false);
    nodes == null ? void 0 : nodes.forEach((d) => {
      d.x0 = d.x;
      d.y0 = d.y;
    });
    if (searchedNode) {
      const selected = svg.selectAll("#node_" + searchedNode.id);
      appendTitle(selected, searchedNode, "red");
    }
  };
  const toggleChildrenDisplay = (node) => {
    swap(node, "_children", "children");
    selectedNode = node;
    updateSubTreeDisplay(node, filters);
  };
  const openTreeAndFindSelected2 = (contactId, clientId, node) => {
    if (node._children) {
      swap(node, "_children", "children");
    }
    if (node.contacts && node.id === clientId && node.contacts.map(({ id: id2 }) => id2).some((id2) => id2 === contactId)) {
      node.isOpened = true;
      selectedNode = node;
      searchedNode = node;
      return;
    }
    if (node.children) {
      node.children.forEach(function(c) {
        if (c.contacts && node.id === clientId && c.contacts.map(({ id: id2 }) => id2).some((id2) => id2 === contactId)) {
          c.isOpened = true;
          selectedNode = c;
          searchedNode = c;
        } else {
          openTreeAndFindSelected2(contactId, clientId, c);
        }
      });
      if (node.children.some(({ isOpened }) => isOpened === true)) {
        node.isOpened = true;
      } else {
        node._children = node.children;
        node.children = null;
      }
    }
  };
  const openTreeAndFindSelectedId = (selectedId, node) => {
    var _a;
    if (node._children) {
      swap(node, "_children", "children");
    }
    if (node.id === selectedId) {
      node.isOpened = true;
      selectedNode = node;
      searchedNode = node;
      return;
    }
    (_a = node.children) == null ? void 0 : _a.forEach(function(c) {
      if (c.id === selectedId) {
        c.isOpened = true;
        selectedNode = c;
        searchedNode = c;
        return;
      } else {
        openTreeAndFindSelectedId(selectedId, c);
      }
    });
    if (node.children.some(({ isOpened }) => isOpened === true)) {
      node.isOpened = true;
    } else {
      node._children = node.children;
      node.children = null;
    }
  };
  return { containerRef, updateTree };
};

// src/account/trees/AccountCommercialTree.tsx
import * as React104 from "react";
import { isEmpty as isEmpty13 } from "lodash-es";

// src/hooks/useWidget.ts
import * as React92 from "react";
import { find as find8 } from "lodash-es";
import { getEnvironment } from "@ic-anywhere/ic-utils";

// src/document/createScriptElement.ts
var createScriptElement = (scriptUrl, asModule = false) => {
  const preloadLink = document.createElement("link");
  preloadLink.href = scriptUrl;
  preloadLink.rel = "prefetch";
  preloadLink.as = "script";
  document.head.appendChild(preloadLink);
  const script = document.createElement("script");
  script.src = scriptUrl;
  script.type = asModule ? "module" : "text/javascript";
  if (!asModule) {
    script.async = true;
  }
  return script;
};

// src/hooks/useWidget.ts
var getBaseUrl = (widgetType, isLocal) => {
  const env = getEnvironment();
  if ((widgetType === "ic-v1" || widgetType === "ic") && isLocal) {
    return widgetType === "ic-v1" ? "http://localhost:8090" : "http://localhost:8080";
  }
  const urls = find8(urlWidgetType, { widgetType });
  if (!urls) {
    return "";
  }
  return env === "production" ? urls.urlProd : urls.urlNotProd;
};
var useWidget = (widgetName, widgetType = "ic", isLocal = false, appendWidgetName = true, isModuleScript = false) => {
  React92.useEffect(() => {
    const baseUrl = `${getBaseUrl(widgetType, isLocal)}`;
    const widgetSrc = appendWidgetName ? `${baseUrl}/${widgetName}.js` : baseUrl;
    const script = find8(document.scripts, ({ src }) => src === widgetSrc);
    if (!script) {
      document.body.appendChild(createScriptElement(widgetSrc, isModuleScript));
    }
  }, [widgetName, widgetType, isLocal]);
};

// src/hooks/useRefListeners.ts
import * as React93 from "react";
var useRefListeners = (listeners) => {
  const ref = React93.useRef(null);
  const applyEffect = (listenerList, domEffect) => {
    listenerList.forEach(domEffect);
  };
  React93.useEffect(() => {
    applyEffect(listeners, ({ eventName, eventHandler }) => {
      var _a;
      return (_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.addEventListener(eventName, eventHandler);
    });
    return () => {
      applyEffect(
        listeners,
        ({ eventName, eventHandler }) => {
          var _a;
          return (
            // eslint-disable-next-line react-hooks/exhaustive-deps
            (_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.removeEventListener(eventName, eventHandler)
          );
        }
      );
    };
  }, [listeners, ref]);
  return ref;
};

// src/hooks/useRefListener.ts
import * as React94 from "react";
import { identity } from "lodash-es";
var useRefListener = (eventName, onChange, mapToEventValue = identity) => {
  const ref = React94.useRef();
  React94.useEffect(() => {
    var _a;
    const onSelectionChanged = (event2) => {
      onChange(mapToEventValue(event2));
    };
    (_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.addEventListener(eventName, onSelectionChanged);
    const curr = ref == null ? void 0 : ref.current;
    return () => curr == null ? void 0 : curr.removeEventListener(eventName, onSelectionChanged);
  }, [onChange, ref, eventName, mapToEventValue]);
  return ref;
};

// src/hooks/useFullscreen.tsx
var screenfull = __toESM(require_screenfull());
import * as React95 from "react";
import { noop as noop15 } from "lodash-es";
var useFullScreen = (targetRef, buttonRef, triggers = [], callback = noop15, clean = noop15) => {
  const [isFullScreen, setIsFullScreen] = React95.useState(false);
  const handleFullscreenChange = () => {
    setIsFullScreen(!!document.fullscreenElement);
  };
  const fullscreen = React95.useCallback(() => {
    var _a;
    if (screenfull.isEnabled) {
      const isFullscreen2 = screenfull.isFullscreen;
      const requestScreen = !isFullscreen2 ? screenfull.request((_a = targetRef == null ? void 0 : targetRef.current) != null ? _a : void 0) : screenfull.exit();
      requestScreen.then(() => {
        callback(!isFullscreen2);
      });
    } else {
      callback(false);
    }
  }, [callback, targetRef]);
  React95.useEffect(() => {
    const currentRef = buttonRef == null ? void 0 : buttonRef.current;
    currentRef == null ? void 0 : currentRef.addEventListener("click", fullscreen);
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      currentRef == null ? void 0 : currentRef.removeEventListener("click", fullscreen);
      clean();
    };
  }, [triggers, buttonRef, fullscreen, clean]);
  return [isFullScreen];
};

// src/hooks/useModal.ts
import * as React96 from "react";
var useModal = (initiallyOpened = false) => {
  const [isShown, setIsShown] = React96.useState(initiallyOpened);
  const closeModal = () => {
    setIsShown(false);
  };
  const openModal = () => {
    setIsShown(true);
  };
  return [isShown, openModal, closeModal];
};

// src/hooks/useQuickFilter.ts
import * as React97 from "react";
import { isContainSubString as isContainSubString2, isStringEmpty as isStringEmpty5 } from "@ic-anywhere/ic-utils";
import { filter as filter9 } from "lodash-es";
function useQuickFilter(elements, mapper) {
  const [term, setTerm] = React97.useState("");
  const result = React97.useMemo(() => {
    return isStringEmpty5(term) ? elements : filter9(elements, (element) => isContainSubString2(mapper(element), term));
  }, [elements, mapper, term]);
  return [result, setTerm, term];
}

// src/hooks/useSortableData.ts
import { orderBy } from "lodash-es";
import * as React98 from "react";
var useSortableData = (items, config = {}) => {
  const [sortConfig, setSortConfig] = React98.useState(config);
  const sortedItems = React98.useMemo(() => {
    const keys4 = Object.keys(sortConfig);
    const values = Object.values(sortConfig);
    return orderBy(items, keys4, values);
  }, [items, sortConfig]);
  const requestSort = (key) => {
    const keyConfig = sortConfig[key];
    const updatedConfig = { ...sortConfig };
    if (keyConfig === "asc") {
      updatedConfig[`${key}`] = "desc";
    } else if (keyConfig === "desc") {
      delete updatedConfig[`${key}`];
    } else {
      updatedConfig[`${key}`] = "asc";
    }
    setSortConfig(updatedConfig);
  };
  const getSortStatus = (key) => {
    var _a;
    return (_a = sortConfig[`${key}`]) != null ? _a : null;
  };
  return [sortedItems, requestSort, getSortStatus];
};

// src/hooks/useWindowSize.ts
import * as React99 from "react";
import { noop as noop16 } from "lodash-es";
var getBreakPoint = (windowWidth) => {
  if (windowWidth) {
    if (windowWidth < 480) {
      return "sm";
    } else if (windowWidth < 1024) {
      return "md";
    } else if (windowWidth < 1200) {
      return "lg";
    } else if (windowWidth < 1600) {
      return "xlg";
    } else {
      return "xxlg";
    }
  } else {
    return void 0;
  }
};
var useWindowSize = () => {
  const isWindowClient = typeof window === "object";
  const [windowSize, setWindowSize] = React99.useState(isWindowClient ? getBreakPoint(window.innerWidth) : void 0);
  React99.useEffect(() => {
    function setSize() {
      setWindowSize(getBreakPoint(window.innerWidth));
    }
    if (isWindowClient) {
      window.addEventListener("resize", setSize);
      return () => window.removeEventListener("resize", setSize);
    }
    return noop16;
  }, [isWindowClient, setWindowSize]);
  return windowSize;
};

// src/hooks/useIntersectionObserver.ts
import { useEffect as useEffect34, useRef as useRef12, useState as useState27 } from "react";
function useIntersectionObserver(callbackFn, hasNextPage) {
  const [entry, setEntry] = useState27();
  const ref = useRef12(null);
  const updateEntry = ([entry2]) => {
    setEntry(entry2);
  };
  useEffect34(() => {
    const node = ref == null ? void 0 : ref.current;
    const observer = new IntersectionObserver(updateEntry);
    if (node) {
      observer.observe(node);
    }
    return () => observer.disconnect();
  }, [ref]);
  useEffect34(() => {
    const isVisible = entry == null ? void 0 : entry.isIntersecting;
    if (isVisible && hasNextPage) {
      callbackFn();
    }
  }, [entry, callbackFn, hasNextPage]);
  return ref;
}

// src/hooks/useLoadJsScript.ts
import * as React100 from "react";
import { find as find9 } from "lodash-es";
var useLoadJsScript = (path2) => {
  React100.useEffect(() => {
    const script = find9(document.scripts, ({ src }) => src === path2);
    if (!script) {
      document.body.appendChild(createScriptElement(path2));
    }
  }, [path2]);
};

// src/hooks/usePrevious.ts
import { useEffect as useEffect36, useRef as useRef13 } from "react";
var usePrevious = (value) => {
  const ref = useRef13();
  useEffect36(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

// src/account/trees/CommercialTree.tsx
import * as React103 from "react";
import { noop as noop17 } from "lodash-es";

// src/account/trees/CommercialTreeViewChooser.tsx
import * as React101 from "react";
var btnValues = [
  { value: "Table", label: "Table" },
  { value: "Tree", label: "Tree" }
];
var CommercialTreeViewChooser = ({ onChange }) => {
  const handleOnChange = (value) => {
    onChange(value);
  };
  return /* @__PURE__ */ React101.createElement("div", { className: "d-flex" }, /* @__PURE__ */ React101.createElement(ToggleButtons, { buttons: btnValues, size: "lg", initialValue: "Table", onChange: handleOnChange }));
};
var CommercialTreeViewChooser_default = CommercialTreeViewChooser;

// src/account/trees/CommercialTreeSettingModal.tsx
import * as React102 from "react";
import { Button as Button8, Modal as Modal2, Switch } from "@sgbs-ui/core";
import { DateFilterEnum as DateFilterEnum3 } from "@ic-anywhere/ic-dal";
var CommercialTreeSettingModal = ({ onChange, settings }) => {
  const [isShown, setIsShown] = React102.useState(false);
  const [includeEmptyNodes, setIncludeEmptyNodes] = React102.useState(settings.includeEmptyNodes);
  const [period, setPeriod] = React102.useState(settings.dateFilter);
  const handleOnChangePeriod = (dateFilter) => {
    setPeriod(dateFilter);
  };
  const handleOnIncludeEmptyNodeChange = (value) => {
    setIncludeEmptyNodes(value);
  };
  const handleOnClose = () => {
    setIsShown(false);
  };
  const handleOnConfirm = () => {
    setIsShown(false);
    onChange({ dateFilter: period, includeEmptyNodes, withStrategic: settings.withStrategic });
  };
  const renderFooterActions = () => /* @__PURE__ */ React102.createElement("div", { className: "modal-footer" }, /* @__PURE__ */ React102.createElement(Button8, { text: "Cancel", btnType: "flat", color: "secondary", size: "lg", className: "ml-2", onClick: handleOnClose }), /* @__PURE__ */ React102.createElement(Button8, { onClick: handleOnConfirm, text: "Confirm", size: "lg" }));
  return /* @__PURE__ */ React102.createElement("div", null, /* @__PURE__ */ React102.createElement("span", { onClick: () => setIsShown(true) }, /* @__PURE__ */ React102.createElement("i", { className: "icon icon-md text-secondary pointer" }, "settings")), isShown && /* @__PURE__ */ React102.createElement(
    Modal2,
    {
      show: true,
      isCenter: false,
      renderFooterActions,
      onClose: handleOnClose,
      title: "Settings",
      isScrollable: false
    },
    /* @__PURE__ */ React102.createElement(FormGroup, { label: "Empty node" }, /* @__PURE__ */ React102.createElement(
      Switch,
      {
        id: "includeEmptyNodesCheckbox",
        checked: includeEmptyNodes,
        onChange: handleOnIncludeEmptyNodeChange
      }
    )),
    /* @__PURE__ */ React102.createElement(FormGroup, { label: "Period" }, /* @__PURE__ */ React102.createElement(
      MultiSelectDateFilter,
      {
        filterLabels: COMMERCIAL_TREE_DATE_FILTERS,
        size: "lg",
        dateRangeFilter: period || { type: DateFilterEnum3.All },
        onSelectionChange: handleOnChangePeriod
      }
    ))
  ));
};

// src/account/trees/CommercialTree.tsx
var FullscreenIcon = () => /* @__PURE__ */ React103.createElement("em", { className: "icon icon-md text-secondary pointer" }, "fullscreen");
var ExitFullscreenIcon = () => /* @__PURE__ */ React103.createElement("em", { className: "icon icon-md text-secondary pointer" }, "fullscreen_exit");
var TREE_CARD_WIDTH = 1e3;
var TREE_CARD_HEIGHT = 1200;
var CommercialTree = ({
  title,
  isFullScreen,
  cardRef,
  buttonRef,
  children: children2,
  onDownload,
  isDownloading,
  settings,
  onTypeTreeChange,
  onChangeSettings
}) => {
  return /* @__PURE__ */ React103.createElement("div", { ref: cardRef, className: !isFullScreen ? "pt-5 mt-n3" : "row" }, /* @__PURE__ */ React103.createElement(
    "div",
    {
      className: "card card-bordered",
      style: {
        overflowX: "scroll",
        minWidth: !isFullScreen ? TREE_CARD_WIDTH : window.screen.width,
        height: !isFullScreen ? TREE_CARD_HEIGHT : window.screen.height
      }
    },
    /* @__PURE__ */ React103.createElement("div", { className: "card-body card-xl d-flex flex-column" }, /* @__PURE__ */ React103.createElement("div", { className: "card-title d-flex justify-content-between" }, /* @__PURE__ */ React103.createElement("h2", null, title), /* @__PURE__ */ React103.createElement(CommercialTreeViewChooser_default, { onChange: onTypeTreeChange }), /* @__PURE__ */ React103.createElement("div", { className: "d-flex justify-content-between", style: { width: 100 } }, isDownloading && /* @__PURE__ */ React103.createElement(IconSpinner, { size: "md" }), !isDownloading && /* @__PURE__ */ React103.createElement(React103.Fragment, null, /* @__PURE__ */ React103.createElement("span", { onClick: onDownload }, /* @__PURE__ */ React103.createElement("i", { className: "icon icon-md text-secondary pointer" }, "save_alt")), /* @__PURE__ */ React103.createElement(CommercialTreeSettingModal, { settings, onChange: onChangeSettings })), /* @__PURE__ */ React103.createElement("span", { className: "pointer", ref: buttonRef, onClick: noop17 }, isFullScreen ? /* @__PURE__ */ React103.createElement(ExitFullscreenIcon, null) : /* @__PURE__ */ React103.createElement(FullscreenIcon, null)))), children2)
  ));
};

// src/account/trees/AccountCommercialTree.tsx
import { classNames as classNames7 } from "@ic-anywhere/ic-utils";
var AccountCommercialTree = ({
  accountId,
  onAccountClick,
  isDownloadingExcelFile,
  commercialTree,
  onDownloadClick,
  isCommercialTreeFetching,
  settings,
  onChangeSettings
}) => {
  const [nodeName, setNodeName] = React104.useState("commercial-tree-node");
  const [viewMode, setViewMode] = React104.useState("Table");
  const cardRef = React104.useRef(null);
  const treeRef = React104.useRef(null);
  const buttonRef = React104.useRef(null);
  const redrawTree = React104.useCallback(
    (fullscreen, viewMode2) => {
      if (!commercialTree) {
        return;
      }
      removeExistingTree();
      viewMode2 === "Tree" ? drawCrmActivitiesAndA2dTree(accountId, treeRef, { root: commercialTree }, onAccountClick) : drawCommercialTree(accountId, treeRef, commercialTree, fullscreen, onAccountClick);
    },
    [commercialTree, accountId, onAccountClick]
  );
  const removeExistingTree = () => {
    var _a;
    const tree = (_a = treeRef == null ? void 0 : treeRef.current) == null ? void 0 : _a.children[0];
    if (tree) {
      tree.remove();
    }
  };
  const handleOnTypeTreeChange = (viewMode2) => {
    setNodeName(viewMode2 === "Table" ? "commercial-tree-node" : "bubble-tree");
    setViewMode(viewMode2);
    redrawTree(isFullScreen, viewMode2);
  };
  const [isFullScreen] = useFullScreen(cardRef, buttonRef, [commercialTree], redrawTree, removeExistingTree);
  React104.useEffect(() => {
    if (!isEmpty13(commercialTree)) {
      redrawTree(isFullScreen, viewMode);
    }
  }, [commercialTree, isFullScreen, redrawTree, viewMode]);
  return /* @__PURE__ */ React104.createElement(
    CommercialTree,
    {
      ...{ isFullScreen, cardRef, buttonRef, settings, onChangeSettings },
      title: "Commercial Tree",
      isDownloading: isDownloadingExcelFile,
      onDownload: onDownloadClick,
      onTypeTreeChange: handleOnTypeTreeChange
    },
    /* @__PURE__ */ React104.createElement(Loader, { isVisible: isCommercialTreeFetching }),
    /* @__PURE__ */ React104.createElement(
      "div",
      {
        id: "commercial-tree",
        ref: treeRef,
        className: classNames7(`${nodeName}`, isCommercialTreeFetching ? "d-none" : "h-100")
      }
    )
  );
};

// src/account/trees/AccountKycTree.tsx
import * as React105 from "react";
import { classNames as classNames8 } from "@ic-anywhere/ic-utils";

// src/account/trees/legacy-d3/useKycTree.ts
import { useEffect as useEffect38, useRef as useRef15, useState as useState30 } from "react";

// src/account/trees/legacy-d3/useKycTree.utils.ts
import { isEmpty as isEmpty14 } from "lodash-es";
import { toDisplayedDate as toDisplayedDate2 } from "@ic-anywhere/ic-utils";
var duration2 = 400;
var kycInfo = (d) => [
  { label: "KYC EL Last Global Validation Date", value: toDisplayedDate2(d.kycLastDate) },
  { label: "KYC EL Last Global Validation Username", value: toDisplayedDate2(d.kycLastUsername) },
  { label: "KYC EL Next Global Review Date", value: toDisplayedDate2(d.kycNextReviewDate) },
  { label: "Countries KYC Authorized", value: FormatKycRestriction(d.kycAuthorizationToDealAuthorized) },
  { label: "Countries KYC Restricted", value: FormatKycRestriction(d.kycAuthorizationToDealRestricted) },
  { label: "Countries KYC Not Authorized", value: FormatKycRestriction(d.kycAuthorizationToDealNonauthorized) }
].map(({ label, value }) => `<li class="list-group-item">${label}: <b>${value}</b></li>`).join("");
var buildHtmlKyc = (d) => {
  if (!d) {
    return void 0;
  }
  return `<div class="popover fade bs-popover-right show" style="z-index:${ZIndex};top:-78px;left:25px;">
<div class="arrow" style="top: 58px;"></div>
<div class="popover-body" style="width:400px">
<ul class="list-group">${kycInfo(d)}</ul>
 </div></div>`;
};
var appendAccount = (nodeEnter, accountId) => {
  nodeEnter.append("text").attr("id", (d) => "text_" + d.id).attr("x", -20).style("font-size", "15px").style("font-family", "Source Sans Pro").style("fill", (d) => getColorInfos(d, accountId, true)).attr("dy", "0.68ex").attr("text-anchor", "end").style("font-weight", (d) => d.id === accountId ? "bold" : "").text((d) => {
    const nameSize = 30, level = !isEmpty14(d.level) ? ` (${d.level})` : "", name = !isEmpty14(d.name) ? d.name.slice(0, nameSize) + (d.name.length > nameSize ? "..." : "") : "", country = !isEmpty14(d.countryIso) ? " " + d.countryIso : "";
    return name + level + country;
  });
};
var appendRightPanel2 = (nodeEnter, accountId, onCoverageClick, onActionClick) => {
  const container = nodeEnter.append("text").attr("x", 20).attr("dy", "0.68ex");
  appendCoverage2(container, accountId, onCoverageClick);
  appendEc(container, accountId);
  appendFund(container, accountId);
  appendActions3(container, onActionClick);
};
var appendRect = (nodeEnter, onClick, onDblClick, onMouseOver, onMouseOut) => {
  nodeEnter.append("rect").attr("id", (d) => "account_" + d.id).attr("x", -15).attr("y", -16).attr("height", 30).attr("width", 30).attr("rx", 20).attr("ry", 20).style("fill", getKycColor).on("click", onClick);
  nodeEnter.filter(hasChildren).append("text").style("font-family", "FontAwesome").style("font-size", "20px").style("fill", "white").style("cursor", "pointer").attr("text-anchor", "middle").attr("dy", "0.68ex").text((d) => isCollapsed(d) ? "\uF067" : "\uF068").on("click", onClick);
  nodeEnter.filter((d) => d.bdrCommercialId !== null).on("dblclick", (d) => {
    onDblClick("kycUrl" + d.bdrCommercialId);
  });
  nodeEnter.filter((d) => d.bdrPrimaryRole !== null).on("mouseover", onMouseOver).on("mouseout", onMouseOut);
};
var appendCoverage2 = (container, accountId, onCoverageClick) => {
  container.filter(hasCoverage2).append("tspan").attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", (d) => getColorInfos(d, accountId)).attr("text-anchor", "start").text((d) => "\uF2B5 " + getCoverage2(d)).on("click", (d) => {
    if (!hasCoverage2(d)) {
      return;
    }
    const coverageViewMode = !d._children && d.children ? "expanded" : "collapsed";
    onCoverageClick(coverageViewMode);
  });
};
var appendEc = (container, accountId) => {
  container.filter((d) => d.aggregatedEcCount > 0).append("tspan").attr("dx", 5).attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", (d) => getColorInfos(d, accountId)).attr("text-anchor", "start").text((d) => `\uF1AD ${getEcCount(d)}`);
};
var appendFund = (container, accountId) => {
  container.filter((d) => d.aggregatedFundCount > 0).append("tspan").attr("dx", 5).attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", (d) => getColorInfos(d, accountId)).attr("text-anchor", "start").text((d) => `\uF0F2 ${getFundCount(d)}`);
};
var appendActions3 = (container, onActionClick) => {
  container.filter((d) => d.level === "EC").append("tspan").attr("dx", 5).attr("class", "info").style("font-family", "FontAwesome").style("font-size", "15px").style("fill", "#777").text(() => "\uF141").style("cursor", "pointer").on("click", onActionClick);
};
var nodeTransition = (node) => {
  return node.transition().duration(duration2).attr("transform", (d) => `translate(${d.y},${d.x})`).select("text").style("fill-opacity", () => 1);
};
var nodeExitTransition = (node) => {
  return node.exit().transition().duration(duration2).attr("transform", (d) => `translate(${d.parent ? d.parent.y : d.y},${d.parent ? d.parent.x : d.x})`).remove().select("text").style("fill-opacity", 0);
};
var getKycColor = (d) => {
  const color = KycStatusColor[d.bdrPrimaryRole];
  if (d.level === "EC") {
    return color ? KycStatusColor[d.bdrPrimaryRole] : "#ccc";
  }
  return "#777";
};
var getColorInfos = (d, accountId, isAccount = false) => {
  if (isAccount && d.id === accountId) {
    return "red";
  } else if (d.level === "EC") {
    return "#777";
  }
  return "#777";
};
var getEcCount = (d) => {
  return !d._children && d.children ? d.ecCount : d.aggregatedEcCount;
};
var getFundCount = (d) => {
  return !d._children && d.children ? d.fundCount : d.aggregatedFundCount;
};
var FormatKycRestriction = (countries) => {
  return countries ? countries : "?";
};
var computeSpace = (d) => {
  return [(d2) => hasCoverage2(d2), (d2) => d2.aggregatedEcCount > 0, (d2) => d2.aggregatedFundCount > 0].filter((f2) => f2(d)).length * 30;
};
var addKycInfoOnNode = (d) => {
  const node = d3.select(`g#node_${d.id}`);
  const infoAlreadyThere = node.selectAll("text.hover") && node.selectAll("text.hover").some((t) => t.length > 0);
  if (infoAlreadyThere)
    return;
  node.append("text").attr("x", 50).attr("class", "hover").append("tspan").attr("dx", computeSpace).style("font-family", "Source Sans Pro").style("font-size", "10px").style("fill", "#777").attr("text-anchor", "start").text((d2) => d2.name);
  node.append("text").attr("x", 50).attr("class", "hover").append("tspan").attr("dx", computeSpace).attr("dy", 12).style("font-family", "Source Sans Pro").style("font-size", "10px").style("font-weight", "bold").style("fill", (d2) => getKycColor(d2)).attr("text-anchor", "start").text((d2) => d2.bdrPrimaryRole);
};
var removeKycInfoFromNode = (d) => {
  d3.selectAll(`g#node_${d.id}>text.hover`).remove();
};

// src/account/trees/legacy-d3/useKycTree.ts
import { noop as noop18 } from "lodash-es";
var duration3 = 400;
var depthOffset = 640;
var useKycTree = () => {
  const containerRef = useRef15(null);
  const onCoverageClick = noop18;
  const onNodeDblClick = noop18;
  let root2, selectedNode, oldKycTipId;
  const [{ tree, zoom, svg, diagonal, kycTip }, setTreeState] = useState30({});
  useEffect38(() => {
    const tree2 = d3.layout.tree().nodeSize([35]);
    const diagonalProj = d3.svg.diagonal().projection((d) => [d.y, d.x]);
    const zoom2 = d3.behavior.zoom();
    const kycTip2 = d3tip().direction("e").offset([10, -20]).html(buildHtmlKyc);
    const newSvg = d3.select(containerRef.current).append("svg").call(zoom2).on("dblclick.zoom", null).call(kycTip2).append("g");
    zoom2.on("zoom", () => {
      newSvg.attr("transform", `translate(${d3.event.translate}) scale(${d3.event.scale})`);
      kycTip2.hide();
    });
    window.scrollTo(0, 320);
    setTreeState({ tree: tree2, zoom: zoom2, svg: newSvg, diagonal: diagonalProj, kycTip: kycTip2 });
    return () => {
      document.removeEventListener("click", kycTip2.hide);
      kycTip2.hide();
    };
  }, [containerRef]);
  const updateTree = (data2) => {
    if (!svg) {
      return;
    }
    if (!data2 || root2 !== void 0) {
      svg.selectAll("*").remove();
      if (!data2)
        return;
    }
    root2 = data2.root;
    selectedNode = root2;
    sortTree(root2, "name");
    root2.x0 = 0;
    root2.y0 = 0;
    openTreeAndFindSelectedId(data2.accountId, root2);
    collapseAll(selectedNode);
    updateSubTreeDisplay(data2, root2);
  };
  const updateSubTreeDisplay = (data2, activeSubRootElement) => {
    if (!activeSubRootElement || !svg) {
      return;
    }
    const nodes = tree.nodes(root2).reverse();
    nodes.forEach((d) => d.y = d.depth * depthOffset);
    svg.selectAll("#node_" + activeSubRootElement.id).remove();
    const updateRootNode = svg.selectAll("g.node").data(nodes, (d) => d.id);
    const nodeEnter = getNodeEnter(updateRootNode, activeSubRootElement, false);
    appendAccount(nodeEnter, data2.accountId);
    appendRect(nodeEnter, toggleChildrenDisplay(data2), onNodeDblClick, addKycInfoOnNode, removeKycInfoFromNode);
    appendRightPanel2(nodeEnter, data2.accountId, onCoverageClick, toggleKycTip);
    nodeTransition(updateRootNode).each("end", () => svg.transition().each("end", centerOnSelectedNode));
    nodeExitTransition(updateRootNode).each("end", () => svg.transition().each("end", centerOnSelectedNode));
    updateLinks(svg, tree, nodes, diagonal, activeSubRootElement, false);
    nodes.forEach((d) => {
      d.x0 = d.x;
      d.y0 = d.y;
    });
  };
  const toggleChildrenDisplay = (data2) => (node) => {
    swap(node, "_children", "children");
    selectedNode = node;
    updateSubTreeDisplay(data2, node);
  };
  const openTreeAndFindSelected2 = (contactId, clientId, node) => {
    if (node._children) {
      swap(node, "_children", "children");
    }
    if (node.contacts && node.id === clientId && node.contacts.map(({ id: id2 }) => id2).some((id2) => id2 === contactId)) {
      node.isOpened = true;
      selectedNode = node;
      return;
    }
    if (node.children) {
      node.children.forEach(function(c) {
        if (c.contacts && node.id === clientId && c.contacts.map(({ id: id2 }) => id2).some((id2) => id2 === contactId)) {
          c.isOpened = true;
          selectedNode = c;
        } else {
          openTreeAndFindSelected2(contactId, clientId, c);
        }
      });
      if (node.children.some(({ isOpened }) => isOpened === true)) {
        node.isOpened = true;
      } else {
        node._children = node.children;
        node.children = null;
      }
    }
  };
  const openTreeAndFindSelectedId = (selectedId, node) => {
    if (node._children) {
      swap(node, "_children", "children");
    }
    if (node.id === selectedId) {
      node.isOpened = true;
      selectedNode = node;
      return;
    }
    node.children.forEach(function(c) {
      if (c.id === selectedId) {
        c.isOpened = true;
        selectedNode = c;
        return;
      } else {
        openTreeAndFindSelectedId(selectedId, c);
      }
    });
    if (node.children.some(({ isOpened }) => isOpened === true)) {
      node.isOpened = true;
    } else {
      node._children = node.children;
      node.children = null;
    }
  };
  const centerOnSelectedNode = () => {
    const container = containerRef.current;
    if (!container)
      return;
    const isOpenedOffsetX = zoom.scale() * (!selectedNode._children && selectedNode.children ? depthOffset : 0);
    const offsetX = window.innerWidth / 2 - selectedNode.y * zoom.scale() - isOpenedOffsetX;
    const offsetY = window.innerHeight / 2 - selectedNode.x * zoom.scale() - 160;
    svg.transition().duration(duration3).call(zoom.translate([offsetX, offsetY]).event).attr("transform", "translate(" + offsetX + "," + offsetY + ")").each("end", () => container.style.visibility = "visible");
  };
  const toggleKycTip = (d) => {
    if (!kycTip)
      return;
    if (!d || oldKycTipId === d.id) {
      kycTip.hide();
      oldKycTipId = null;
    } else {
      kycTip.show(d, d3.event.target.parentNode);
      oldKycTipId = d.id.toString();
    }
  };
  return { containerRef, updateTree };
};

// src/account/trees/AccountKycTree.tsx
var AccountKycTree = ({ kycTreeData, isKycTreeFetching }) => {
  const { updateTree, containerRef: treeDivRef } = useKycTree();
  React105.useEffect(() => {
    if (kycTreeData) {
      updateTree(kycTreeData);
    }
  }, [kycTreeData, updateTree]);
  return /* @__PURE__ */ React105.createElement("div", { className: "pt-5 mt-n3" }, /* @__PURE__ */ React105.createElement("div", { className: "card card-bordered bubble-tree-card" }, /* @__PURE__ */ React105.createElement("div", { className: "card-header" }, /* @__PURE__ */ React105.createElement("h2", { className: "card-title" }, "KYC")), /* @__PURE__ */ React105.createElement("div", { className: "card-body card-xl d-flex flex-column" }, /* @__PURE__ */ React105.createElement(Loader, { isVisible: isKycTreeFetching }), /* @__PURE__ */ React105.createElement("div", { ref: treeDivRef, className: classNames8(isKycTreeFetching ? "d-none" : "bubble-tree") }))));
};

// src/account/trees/AccountOrgChartTree.tsx
import * as React106 from "react";
import { classNames as classNames9 } from "@ic-anywhere/ic-utils";
var AccountOrgChartTree = ({
  orgChartTreeData,
  isOrgChartTreeFetching,
  onContactClick,
  onAccountClick
}) => {
  const onMenuClick = (actionType) => (id2) => {
    if (!id2)
      return;
    if (actionType === "account_click") {
      onAccountClick(id2);
    }
    if (actionType === "contact_click") {
      onContactClick(id2);
    }
  };
  const { updateTree, containerRef: treeDivRef } = useOrgChartPerEntityTree(onMenuClick);
  React106.useEffect(() => {
    updateTree(orgChartTreeData);
  }, [orgChartTreeData, updateTree]);
  return /* @__PURE__ */ React106.createElement("div", { className: "pt-5 mt-n3" }, /* @__PURE__ */ React106.createElement("div", { className: "card card-bordered bubble-tree-card" }, /* @__PURE__ */ React106.createElement("div", { className: "card-header" }, /* @__PURE__ */ React106.createElement("h2", { className: "card-title" }, "Org chart per entity")), /* @__PURE__ */ React106.createElement("div", { className: "card-body card-xl d-flex flex-column" }, isOrgChartTreeFetching && /* @__PURE__ */ React106.createElement(Loader, null), /* @__PURE__ */ React106.createElement("div", { ref: treeDivRef, className: classNames9(isOrgChartTreeFetching ? "d-none" : "bubble-tree") }))));
};

// src/account/trees/account.trees.constants.ts
import { DateFilterEnum as DateFilterEnum4 } from "@ic-anywhere/ic-dal";
import { lastYear as lastYear2, today as today2 } from "@ic-anywhere/ic-utils";
var settingsInitialState = {
  dateFilter: {
    type: DateFilterEnum4.FromLastYear,
    dateRange: { start: lastYear2().stringFormat, end: today2().stringFormat }
  },
  includeEmptyNodes: true,
  withStrategic: true
};

// src/account/AccountCoverageSortButton.tsx
import * as React107 from "react";
import { AccountCoverageSortField } from "@ic-anywhere/ic-dal";
var SORT_BY_FIELDS_LIGHT = ["Role", "Contact name", "Entities name"];
var SORT_BY_FIELDS = [...SORT_BY_FIELDS_LIGHT, "Number of activities"];
var AccountCoverageSortButton = ({ onChange, isLight = false }) => {
  const handleOnLinkClick = (item) => {
    if (item === "Role") {
      onChange([AccountCoverageSortField.Role]);
    } else if (item === "Contact name") {
      onChange([AccountCoverageSortField.LastName, AccountCoverageSortField.FirstName]);
    } else if (item === "Entities name") {
      onChange([AccountCoverageSortField.AccountName]);
    } else if (item === "Number of activities") {
      onChange([AccountCoverageSortField.ActivityCount]);
    }
  };
  return /* @__PURE__ */ React107.createElement("div", { className: "d-flex flex-row ml-3" }, /* @__PURE__ */ React107.createElement("div", { className: "d-flex align-items-center" }, "Sort by"), /* @__PURE__ */ React107.createElement(ButtonLinkDropDown, { items: isLight ? SORT_BY_FIELDS_LIGHT : SORT_BY_FIELDS, onClick: handleOnLinkClick }));
};

// src/account/AccountCoverageFilterRow.tsx
import * as React108 from "react";
import { Select as Select10 } from "@sgbs-ui/core";
import { compact, isEmpty as isEmpty15, map as map14, orderBy as orderBy2, uniq } from "lodash-es";
import { getShortPathTeam } from "@ic-anywhere/ic-dal";
var AccountCoverageFilterRow = ({ roles, teams, onChange }) => {
  const [selectedRolesState, setSelectedRolesState] = React108.useState([]);
  const [selectedTeamsState, setSelectedTeamsState] = React108.useState([]);
  React108.useEffect(() => {
    onChange({ roles: map14(selectedRolesState, ({ id: id2 }) => id2), teams: map14(selectedTeamsState, ({ id: id2 }) => id2) });
  }, [selectedRolesState, selectedTeamsState]);
  const filters = React108.useMemo(() => {
    if (isEmpty15(roles) && isEmpty15(teams)) {
      return { teams: [], roles: [] };
    }
    return {
      teams: orderBy2(
        map14(uniq(compact(teams)), (team) => ({ id: team, name: getShortPathTeam(team) })),
        ["name"]
      ),
      roles: orderBy2(map14(uniq(compact(roles)), (role) => ({ id: role, name: role })))
    };
  }, [roles, teams]);
  return /* @__PURE__ */ React108.createElement("div", { className: "row" }, !isEmpty15(filters.roles) && /* @__PURE__ */ React108.createElement(FormGroup, { label: "Role", containerClass: "col-4", "data-testid": "rolesFormGroup" }, /* @__PURE__ */ React108.createElement(
    Select10,
    {
      items: filters.roles,
      idField: "id",
      labelField: "name",
      placeholder: "Filter roles",
      selectedItems: selectedRolesState,
      onChange: setSelectedRolesState,
      color: "primary",
      size: "lg",
      isOutline: true,
      noSearch: true
    }
  )), !isEmpty15(filters.teams) && /* @__PURE__ */ React108.createElement(FormGroup, { label: "Team", containerClass: "col-6", "data-testid": "teamsFormGroup" }, /* @__PURE__ */ React108.createElement(
    Select10,
    {
      items: filters.teams,
      idField: "id",
      labelField: "name",
      placeholder: "Filter teams",
      selectedItems: selectedTeamsState,
      onChange: setSelectedTeamsState,
      color: "primary",
      size: "lg",
      isOutline: true,
      noSearch: true
    }
  )));
};

// src/account/bulkSelector/AccountBulkSelector.tsx
import * as React109 from "react";
import { isEmpty as isEmpty17, isEqual as isEqual4 } from "lodash-es";

// src/account/bulkSelector/accountBulkSelector.utils.ts
import { compact as compact2, isEmpty as isEmpty16, trim } from "lodash-es";
var extractIds = (rawText) => {
  if (isEmpty16(rawText)) {
    return { ids: [] };
  }
  const ids = compact2(rawText.split(/[,;\r\n]/).map((id2) => trim(id2)));
  if (isEmpty16(ids)) {
    return { ids: [], error: "Unable to find any id in input" };
  }
  return { ids };
};

// src/account/bulkSelector/AccountBulkSelector.tsx
import { useBulkSearchByBrdLegalId } from "@ic-anywhere/ic-dal";
import { classNames as classNames10 } from "@ic-anywhere/ic-utils";
var AccountBulkSelector = ({
  repository,
  queryParams = {},
  onChange,
  initialBdrIds = [],
  placeholder = "Search by BDR ID",
  showPasteIcon = false,
  batchSize,
  size: size6 = "lg",
  className = "mt-2",
  inError = false,
  errorMessage
}) => {
  const [parsed, setParsed] = React109.useState({ ids: [] });
  const showClearIcon = !isEmpty17(parsed.ids) || !isEmpty17(parsed.error);
  const { data: data2, isFetching, isSuccess, setBdrIds } = useBulkSearchByBrdLegalId(repository, queryParams, batchSize);
  const parsedCountText = `${parsed.ids.length} parsed IDs`;
  const fetchedCountText = data2 && data2.length ? `, ${data2.length} selected accounts` : "";
  const selectedCountText = `${parsedCountText}${fetchedCountText}`;
  React109.useEffect(() => {
    if (!isFetching && !isEmpty17(data2) && isSuccess) {
      onChange(data2);
    }
  }, [isSuccess, isFetching]);
  React109.useEffect(() => {
    if (initialBdrIds == null ? void 0 : initialBdrIds.length) {
      const newParsed = { ids: initialBdrIds };
      if (!isEqual4(newParsed, parsed)) {
        setParsed(newParsed);
        setBdrIds(newParsed.ids);
      }
    }
  }, [initialBdrIds]);
  const handlePaste = (rawData) => {
    setParsed(extractIds(rawData));
    setBdrIds(extractIds(rawData).ids);
  };
  const manualPaste = async () => {
    const rawData = await navigator.clipboard.readText();
    handlePaste(rawData);
  };
  const keyboardPaste = (event2) => {
    event2.preventDefault();
    handlePaste(event2.clipboardData.getData("text"));
  };
  const clear = () => {
    setParsed({ ids: [] });
    setBdrIds([]);
    onChange([]);
  };
  return /* @__PURE__ */ React109.createElement("div", { className: classNames10("form-group", className) }, /* @__PURE__ */ React109.createElement("div", { className: `input-group input-group-${size6}` }, /* @__PURE__ */ React109.createElement("div", { className: "input-group-prepend input-group-merged" }, /* @__PURE__ */ React109.createElement("em", { className: "icon" }, "search")), /* @__PURE__ */ React109.createElement("div", { className: "input-group-append input-group-merged" }, !isFetching && showPasteIcon && !showClearIcon && /* @__PURE__ */ React109.createElement("button", { type: "button", className: "btn", style: { width: "50px", cursor: "pointer" }, onClick: manualPaste }, /* @__PURE__ */ React109.createElement("em", { className: "icon icon-md" }, "content_paste_go")), !isFetching && showClearIcon && /* @__PURE__ */ React109.createElement(
    "button",
    {
      type: "button",
      className: "btn",
      style: { zIndex: "10", width: "50px", cursor: "pointer" },
      onClick: clear
    },
    /* @__PURE__ */ React109.createElement("em", { className: "icon icon-md" }, "cancel")
  ), isFetching && /* @__PURE__ */ React109.createElement("button", { type: "button", className: "btn", style: { zIndex: "10", width: "50px" } }, /* @__PURE__ */ React109.createElement("em", { className: "icon icon-md fa-spin mr-1" }, "autorenew"))), /* @__PURE__ */ React109.createElement("div", { className: "d-flex form-control align-items-center pr-0" }, !isEmpty17(parsed.ids) && /* @__PURE__ */ React109.createElement("div", { className: "text-info text-truncate mx-2", title: selectedCountText }, selectedCountText), /* @__PURE__ */ React109.createElement(
    "input",
    {
      type: "text",
      readOnly: true,
      className: `form-control-plaintext pl-2 form-control-${size6}`,
      placeholder,
      style: { flex: "1 1 120px" },
      onPaste: keyboardPaste
    }
  ))), inError || parsed.error && /* @__PURE__ */ React109.createElement(InvalidFeedback, { errorMessage: errorMessage != null ? errorMessage : parsed.error }));
};

// src/account/clientTeam/ClientTeamViewer.tsx
import React112, { useEffect as useEffect43 } from "react";
import { useGetClient as useGetClient2, useGetClientPrivate } from "@ic-anywhere/ic-dal";

// src/account/clientTeam/clientTeamViewer.typings.ts
var teamSkeleton = [
  {
    label: "PCRU Banker",
    role: "PCRU Banker",
    type: "pcru_banker"
  },
  {
    label: "PCRU Lead coverage",
    role: "PCRU Lead Coverage",
    type: "pcru"
  },
  {
    label: "PCRU Lead coverage (Public)",
    role: "PCRU Lead Coverage (Public)",
    type: "pcru"
  },
  {
    label: "PCRU Relationship Manager",
    role: "PCRU Relationship Manager",
    type: "standard"
  },
  {
    label: "Local Relationship Manager",
    role: "Local Relationship Manager",
    type: "standard"
  },
  {
    label: "MARK CCR Owner",
    role: "MARK CCR Owner",
    type: "standard"
  },
  {
    label: "Delegated MARK CCR Owner",
    role: "Delegated MARK CCR Owner",
    type: "standard"
  },
  {
    label: "MARK Sponsor",
    role: "MARK Sponsor",
    type: "standard"
  },
  {
    label: "BSG Sales Captain",
    role: "Sales Captain",
    type: "bsg"
  },
  {
    label: "BSG Trading Captain",
    role: "Trading Captain",
    type: "bsg"
  },
  {
    label: "Sponsor",
    role: "Sponsor",
    type: "executiveSponsorship"
  },
  {
    label: "GBIS Senior Contact",
    role: "GBIS Senior Contact",
    type: "executiveSponsorship"
  },
  {
    label: "Ambassador",
    role: "Ambassador",
    type: "executiveSponsorship"
  }
];

// src/account/clientTeam/clientTeamViewer.mapper.ts
import { includes as includes5, map as map15, some as some6, uniq as uniq2 } from "lodash-es";
var getPersonsForRole = ({ coverage, id: accountId }, role) => {
  var _a;
  if (coverage) {
    return (_a = coverage.filter((c) => c.role === role)) == null ? void 0 : _a.map(({ person, clientId }) => ({
      person: `${person.firstname} ${person.lastname}`,
      differentClientId: clientId !== accountId ? clientId : void 0
    }));
  }
  return [];
};
var PCRUSegmentationLevelIds = [
  "d53cd8bf-eec5-4c91-bc95-ce5f1fd3a142",
  "c148749f-3922-41cf-bae7-5182266cc6d3",
  "118e7efe-73fe-4f0b-a5a1-f1576104ef05"
];
var PCRUSegmentationListId = "8b98e67e-8c53-4e61-8248-855767ab6a56";
var mapToAccountTeamModel = (privateClient, client) => {
  const roleItems = teamSkeleton.map(({ role, type, label }) => {
    const personsForRole = getPersonsForRole(client, role);
    return {
      role,
      type,
      label,
      persons: uniq2(map15(personsForRole, (p) => ({ name: p.person, differentClientId: p.differentClientId })))
    };
  }).filter((item) => some6(item.persons));
  const isPCRUSegmentation = some6(
    map15(client.tieringLists, ({ list, level }) => ({ listId: list.id, levelId: level.id })),
    ({ listId, levelId }) => listId === PCRUSegmentationListId && includes5(PCRUSegmentationLevelIds, levelId)
  );
  return {
    pcru: privateClient.pcru,
    roleItems,
    isPCRUSegmentation
  };
};

// src/account/clientTeam/ClientTeamViewer.tsx
import { map as map18 } from "lodash-es";

// src/account/clientTeam/ClientTeamPCRUItems.tsx
import React110 from "react";
import { useGetClient } from "@ic-anywhere/ic-dal";
import { flatten, groupBy, isEmpty as isEmpty18, map as map16, partition, toPairs } from "lodash-es";
var ClientTeamPCRUItems = ({
  repo,
  roleLabel,
  persons,
  labelTdClass,
  valueTdClass
}) => {
  const [withSameClientId, withDifferentClientId] = partition(persons, (p) => !p.differentClientId);
  const grpByClientId = toPairs(groupBy(withDifferentClientId, (p) => p.differentClientId));
  return /* @__PURE__ */ React110.createElement(React110.Fragment, null, map16(grpByClientId, ([clientId, personsGrp]) => /* @__PURE__ */ React110.createElement(
    ClientTeamPCRUItem,
    {
      key: `${roleLabel}-${clientId}`,
      repo,
      labelTdClass,
      valueTdClass,
      roleLabel,
      differentClientId: clientId,
      persons: personsGrp
    }
  )), !isEmpty18(withSameClientId) && /* @__PURE__ */ React110.createElement(
    ClientTeamPCRUItem,
    {
      key: `${roleLabel}-same_client_id`,
      repo,
      labelTdClass,
      valueTdClass,
      roleLabel,
      differentClientId: void 0,
      persons: withSameClientId
    }
  ));
};
var ClientTeamPCRUItem = ({
  repo,
  roleLabel,
  persons,
  differentClientId,
  labelTdClass,
  valueTdClass
}) => {
  var _a, _b, _c;
  const { data: client } = useGetClient(repo, differentClientId, !!differentClientId, ["clientIds", "country"]);
  const level = (_b = (_a = client == null ? void 0 : client.clientIds) == null ? void 0 : _a.internalId) == null ? void 0 : _b.level;
  const levelParenthesis = level ? `(${level})` : "";
  const label = differentClientId && !!client ? `${roleLabel} of ${client.name} ${levelParenthesis} - ${(_c = client.country) == null ? void 0 : _c.iso3}` : roleLabel;
  return /* @__PURE__ */ React110.createElement("tr", null, /* @__PURE__ */ React110.createElement("td", { className: labelTdClass }, label), /* @__PURE__ */ React110.createElement("td", { className: valueTdClass }, flatten(persons.map((p) => p.name)).join(", ")));
};

// src/account/clientTeam/ClientTeamRoleItems.tsx
import React111 from "react";
import { flatten as flatten2, map as map17 } from "lodash-es";
var ClientTeamRoleItems = ({ otherRoleItems, bsgRoleItems, labelTdClass, valueTdClass }) => {
  const displayRoleItems = (roleItems) => map17(roleItems, ({ label, role, persons }, idx) => /* @__PURE__ */ React111.createElement("tr", { key: `${role}-${idx}` }, /* @__PURE__ */ React111.createElement("td", { className: labelTdClass }, label), /* @__PURE__ */ React111.createElement("td", { className: `${valueTdClass} pl-1` }, flatten2(persons.map((p) => p.name)).join(", "))));
  const displayBsgRoleItems = displayRoleItems(bsgRoleItems);
  const displayOtherRoleItems = displayRoleItems(otherRoleItems);
  return displayBsgRoleItems.length > 0 || displayOtherRoleItems.length > 0 ? /* @__PURE__ */ React111.createElement("div", { className: "pt-4" }, /* @__PURE__ */ React111.createElement("h4", { className: "mb-3" }, "Other coverage roles"), /* @__PURE__ */ React111.createElement("div", { className: "ml-2" }, displayOtherRoleItems.length > 0 && displayOtherRoleItems, displayBsgRoleItems.length > 0 && displayBsgRoleItems)) : null;
};

// src/account/clientTeam/ClientTeamViewer.tsx
var ClientTeamViewer = ({ repo, accountId, onReady, onError, isTypeFund }) => {
  const {
    data: privateClient,
    isFetching: isFetchingPrivate,
    error: errorPrivate,
    refetch: refetchPrivate
  } = useGetClientPrivate(repo, accountId);
  const { data: client, isFetching: isFetchingClient, error, refetch } = useGetClient2(repo, accountId);
  const isFetching = isFetchingPrivate || isFetchingClient;
  const teamModel = privateClient && client ? mapToAccountTeamModel(privateClient, client) : void 0;
  const pcruBankerRoleItems = teamModel == null ? void 0 : teamModel.roleItems.filter(({ type }) => type === "pcru_banker");
  const pcruRoleItems = teamModel == null ? void 0 : teamModel.roleItems.filter(({ type }) => type === "pcru");
  const otherRoleItems = teamModel ? teamModel.roleItems.filter(({ type }) => type === "standard") : [];
  const bsgRoleItems = teamModel ? teamModel.roleItems.filter(({ type }) => type === "bsg") : [];
  const executiveSponsorshipItems = teamModel ? teamModel.roleItems.filter(({ type }) => type === "executiveSponsorship") : [];
  useEffect43(() => {
    if (teamModel) {
      onReady == null ? void 0 : onReady(teamModel);
    }
  }, [teamModel, onReady]);
  useEffect43(() => {
    var _a, _b;
    if (errorPrivate || error) {
      onError == null ? void 0 : onError({ errorMessage: (_b = (_a = errorPrivate == null ? void 0 : errorPrivate.message) != null ? _a : error == null ? void 0 : error.message) != null ? _b : "Error while fetching client team." });
    }
  }, [errorPrivate, error, onError]);
  if (errorPrivate || error) {
    return /* @__PURE__ */ React112.createElement("div", { className: "p-2" }, /* @__PURE__ */ React112.createElement(
      PageErrorContainer,
      {
        isRetryShow: true,
        onRetry: () => {
          refetchPrivate();
          refetch();
        }
      }
    ));
  }
  if (isFetching) {
    return /* @__PURE__ */ React112.createElement("div", { className: "p-2" }, /* @__PURE__ */ React112.createElement("div", null, "Loading..."));
  }
  if (!teamModel) {
    return /* @__PURE__ */ React112.createElement("div", { className: "p-2" }, /* @__PURE__ */ React112.createElement("span", null, "There are no main coverage team to be displayed for this account."));
  }
  const labelTdClass = "text-secondary p-1";
  const valueTdClass = "p-1";
  return /* @__PURE__ */ React112.createElement("table", { className: "table table-borderless" }, /* @__PURE__ */ React112.createElement("tbody", null, /* @__PURE__ */ React112.createElement("h4", { className: "mb-3" }, "PCRU Team ", isTypeFund && "of DME"), /* @__PURE__ */ React112.createElement("div", { className: "ml-2" }, map18(pcruBankerRoleItems, ({ label, role, persons }, idx) => /* @__PURE__ */ React112.createElement(
    ClientTeamPCRUItems,
    {
      key: `${role}-${idx}`,
      repo,
      labelTdClass,
      valueTdClass,
      roleLabel: label,
      persons
    }
  )), map18(pcruRoleItems, ({ label, role, persons }, idx) => /* @__PURE__ */ React112.createElement(
    ClientTeamPCRUItems,
    {
      key: `${role}-${idx}`,
      repo,
      labelTdClass,
      valueTdClass,
      roleLabel: label,
      persons
    }
  )), /* @__PURE__ */ React112.createElement("tr", { key: "PCRU_LABEL" }, /* @__PURE__ */ React112.createElement("td", { className: labelTdClass }, "PCRU label"), /* @__PURE__ */ React112.createElement("td", { className: valueTdClass }, teamModel.pcru))), executiveSponsorshipItems.length > 0 && /* @__PURE__ */ React112.createElement("div", { className: "pt-4" }, /* @__PURE__ */ React112.createElement("h4", { className: "mb-3" }, "Executive sponsorship"), /* @__PURE__ */ React112.createElement("div", { className: "ml-2" }, map18(executiveSponsorshipItems, ({ label, role, persons }, idx) => /* @__PURE__ */ React112.createElement(
    ClientTeamPCRUItems,
    {
      key: `${role}-${idx}`,
      repo,
      labelTdClass,
      valueTdClass,
      roleLabel: label,
      persons
    }
  )))), /* @__PURE__ */ React112.createElement(
    ClientTeamRoleItems,
    {
      labelTdClass,
      valueTdClass,
      otherRoleItems,
      bsgRoleItems
    }
  )));
};

// src/account/mifid/AccountMifid.tsx
import React119 from "react";

// src/account/mifid/compos/ProductKnowledgeSection.tsx
import React115 from "react";
import { isEmpty as isEmpty20, map as map19 } from "lodash-es";

// src/account/mifid/compos/LabelFieldReadonly.tsx
import React114 from "react";
import { capitalize as capitalize3, isEmpty as isEmpty19 } from "lodash-es";

// src/account/mifid/compos/FieldColored.tsx
import React113 from "react";
import { isStringEqual as isStringEqual5 } from "@ic-anywhere/ic-utils";
var FieldColored = ({ value }) => {
  if (isStringEqual5(value, "YES")) {
    return /* @__PURE__ */ React113.createElement("span", { className: "text-success" }, value);
  } else if (isStringEqual5(value, "NO")) {
    return /* @__PURE__ */ React113.createElement("span", { className: "text-danger" }, value);
  } else {
    return /* @__PURE__ */ React113.createElement("span", { className: "text-black" }, value);
  }
};

// src/account/mifid/compos/LabelFieldReadonly.tsx
var LabelFieldReadonly = ({ label, value = "", withCapitalizeCase = true }) => {
  if (isEmpty19(value)) {
    return null;
  }
  return /* @__PURE__ */ React114.createElement("div", { className: "d-flex flex-wrap" }, /* @__PURE__ */ React114.createElement("div", { className: "col-auto pr-0" }, /* @__PURE__ */ React114.createElement("label", { className: "text-left text-secondary m-0" }, label)), /* @__PURE__ */ React114.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React114.createElement(FieldColored, { value: withCapitalizeCase ? capitalize3(value) : value })));
};

// src/account/mifid/compos/ProductKnowledgeSection.tsx
var ProductKnowledgeSection = ({ productKnowledge }) => !isEmpty20(productKnowledge) ? /* @__PURE__ */ React115.createElement("div", null, /* @__PURE__ */ React115.createElement("div", { className: "col pt-3" }, /* @__PURE__ */ React115.createElement("h5", { className: "mb-0" }, "Knowledge & Experience / Assessment")), map19(productKnowledge, ({ productLabel, productExperienceLevel, assessmentFlagList }, idx) => /* @__PURE__ */ React115.createElement("div", { key: idx }, /* @__PURE__ */ React115.createElement(LabelFieldReadonly, { label: `${productLabel}:`, value: productExperienceLevel }), map19(assessmentFlagList, ({ flagType, date }, index) => /* @__PURE__ */ React115.createElement(LabelFieldReadonly, { key: index, label: `${flagType}:`, value: date }))))) : null;

// src/account/mifid/compos/AuthorisationMediaSection.tsx
import React116 from "react";
var AuthorisationMediaSection = ({ authorizationMediaList }) => authorizationMediaList ? /* @__PURE__ */ React116.createElement("div", { className: "col-12 p-0" }, /* @__PURE__ */ React116.createElement("div", { className: "col pt-3" }, /* @__PURE__ */ React116.createElement("h5", { className: "mb-0" }, "Authorization")), /* @__PURE__ */ React116.createElement(
  LabelFieldReadonly,
  {
    label: "Authorization to trade OTC financial products usually traded on regulated venues:",
    value: authorizationMediaList.authorizationToTrade
  }
), /* @__PURE__ */ React116.createElement(
  LabelFieldReadonly,
  {
    label: "Authorization to publish on a regulated venue an equity order unfulfilled:",
    value: authorizationMediaList.authorizationToPublish
  }
), /* @__PURE__ */ React116.createElement(
  LabelFieldReadonly,
  {
    label: "Authorized media where durable media required:",
    value: authorizationMediaList.authorizedMedia
  }
)) : null;

// src/account/mifid/compos/CAndcExAnteDisclosure.tsx
import React117 from "react";
import { isEmpty as isEmpty21, join as join2 } from "lodash-es";
var CAndcExAnteDisclosure = ({ cAndcExAnteDisclosure }) => {
  if (!cAndcExAnteDisclosure) {
    return null;
  }
  const { allAssets, disclosureList } = cAndcExAnteDisclosure;
  return /* @__PURE__ */ React117.createElement("div", { className: "col-12 p-0" }, /* @__PURE__ */ React117.createElement("div", { className: "col pt-3" }, /* @__PURE__ */ React117.createElement("h5", { className: "mb-0" }, "C&C Ex Ante Disclosure")), allAssets && /* @__PURE__ */ React117.createElement(LabelFieldReadonly, { label: "Disclosure:", value: "All assets" }), !allAssets && isEmpty21(disclosureList) && /* @__PURE__ */ React117.createElement(LabelFieldReadonly, { label: "Disclosure:", value: "No disclosure" }), !allAssets && !isEmpty21(disclosureList) && /* @__PURE__ */ React117.createElement(LabelFieldReadonly, { label: "Disclosure:", value: join2(disclosureList, ", ") }));
};

// src/account/mifid/AccountMifid.tsx
import { map as map21 } from "lodash-es";
import { useGetClient as useGetClient3, useGetMifidQuery } from "@ic-anywhere/ic-dal";

// src/account/mifid/compos/AuthorizationToTradeOTC.tsx
import React118 from "react";
import { isEmpty as isEmpty22, map as map20 } from "lodash-es";
var AuthorizationToTradeOTCLabel = "Authorization to trade OTC financial products usually traded on regulated venues";
var AuthorizationToTradeOTC = ({ productList }) => !isEmpty22(productList) ? /* @__PURE__ */ React118.createElement("div", { className: "col-12 p-0" }, /* @__PURE__ */ React118.createElement("div", { className: "col pt-3" }, /* @__PURE__ */ React118.createElement("h5", { className: "mb-0" }, AuthorizationToTradeOTCLabel)), map20(productList, ({ authorization, assetClass }, index) => /* @__PURE__ */ React118.createElement(LabelFieldReadonly, { key: index, label: `${assetClass}:`, value: authorization }))) : null;

// src/account/mifid/AccountMifid.tsx
import { Loader as Loader6 } from "@sgbs-ui/core";
var displayedMessage = "There are no information to be displayed for this account.";
var AccountMifid = ({ repo, accountId, bdrId }) => {
  var _a, _b;
  const { data: accountData, isFetching: isFetchingAccount } = useGetClient3(repo, accountId, !bdrId && !!accountId);
  const targetBdrId = bdrId != null ? bdrId : (_b = (_a = accountData == null ? void 0 : accountData.bdrId) == null ? void 0 : _a.bdrLegalId) == null ? void 0 : _b.id;
  const { data: mifidData, isFetching: isFetchingMifid } = useGetMifidQuery(repo, targetBdrId, !!targetBdrId);
  if (isFetchingMifid || isFetchingAccount) {
    return /* @__PURE__ */ React119.createElement(Loader6, null);
  }
  if (!mifidData) {
    return /* @__PURE__ */ React119.createElement(NoRecord, { icon: "info_outline", reason: displayedMessage, message: "" });
  }
  return /* @__PURE__ */ React119.createElement("div", null, /* @__PURE__ */ React119.createElement("div", null, /* @__PURE__ */ React119.createElement("div", null, /* @__PURE__ */ React119.createElement(LabelFieldReadonly, { label: "MiFID Eligibility:", value: mifidData.isEligible || "" }), /* @__PURE__ */ React119.createElement(LabelFieldReadonly, { label: "MiFID Category:", value: mifidData.category || "" }), /* @__PURE__ */ React119.createElement(LabelFieldReadonly, { label: "Category Support:", value: mifidData.categorySupport || "" }), /* @__PURE__ */ React119.createElement(LabelFieldReadonly, { label: "Theoretical Category:", value: mifidData.theoreticalCategory || "" })), mifidData.productExceptionList && /* @__PURE__ */ React119.createElement("div", { className: "col-12 p-0" }, /* @__PURE__ */ React119.createElement("div", { className: "col pt-3" }, /* @__PURE__ */ React119.createElement("h5", { className: "mb-0" }, "Exception per Product/Activity")), map21(mifidData.productExceptionList, ({ productOrActivity, category }, index) => /* @__PURE__ */ React119.createElement(LabelFieldReadonly, { key: index, label: `${productOrActivity}:`, value: category }))), /* @__PURE__ */ React119.createElement(ProductKnowledgeSection, { productKnowledge: mifidData.productKnowledge }), /* @__PURE__ */ React119.createElement(AuthorisationMediaSection, { authorizationMediaList: mifidData.authorizationMediaList }), /* @__PURE__ */ React119.createElement(CAndcExAnteDisclosure, { cAndcExAnteDisclosure: mifidData.cAndcExAnteDisclosure }), /* @__PURE__ */ React119.createElement(AuthorizationToTradeOTC, { productList: mifidData.mifidOtc })));
};

// src/account/picker/AccountMultiPickerV2.tsx
import { Select as Select11 } from "@sgbs-ui/core";
import * as React121 from "react";
import { useState as useState34 } from "react";
import {
  mapQueryResults,
  mapToAccountWidget,
  useGetClientsByIds,
  useSearchAccountsQuery
} from "@ic-anywhere/ic-dal";
import { concat as concat2, differenceWith, size as _size2, some as some7, unionBy, isEmpty as isEmpty23 } from "lodash-es";

// ../../node_modules/use-deep-compare-effect/dist/use-deep-compare-effect.esm.js
import * as React120 from "react";

// ../../node_modules/dequal/dist/index.mjs
var has2 = Object.prototype.hasOwnProperty;
function find10(iter, tar, key) {
  for (key of iter.keys()) {
    if (dequal(key, tar))
      return key;
  }
}
function dequal(foo, bar) {
  var ctor, len, tmp;
  if (foo === bar)
    return true;
  if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
    if (ctor === Date)
      return foo.getTime() === bar.getTime();
    if (ctor === RegExp)
      return foo.toString() === bar.toString();
    if (ctor === Array) {
      if ((len = foo.length) === bar.length) {
        while (len-- && dequal(foo[len], bar[len]))
          ;
      }
      return len === -1;
    }
    if (ctor === Set) {
      if (foo.size !== bar.size) {
        return false;
      }
      for (len of foo) {
        tmp = len;
        if (tmp && typeof tmp === "object") {
          tmp = find10(bar, tmp);
          if (!tmp)
            return false;
        }
        if (!bar.has(tmp))
          return false;
      }
      return true;
    }
    if (ctor === Map) {
      if (foo.size !== bar.size) {
        return false;
      }
      for (len of foo) {
        tmp = len[0];
        if (tmp && typeof tmp === "object") {
          tmp = find10(bar, tmp);
          if (!tmp)
            return false;
        }
        if (!dequal(len[1], bar.get(tmp))) {
          return false;
        }
      }
      return true;
    }
    if (ctor === ArrayBuffer) {
      foo = new Uint8Array(foo);
      bar = new Uint8Array(bar);
    } else if (ctor === DataView) {
      if ((len = foo.byteLength) === bar.byteLength) {
        while (len-- && foo.getInt8(len) === bar.getInt8(len))
          ;
      }
      return len === -1;
    }
    if (ArrayBuffer.isView(foo)) {
      if ((len = foo.byteLength) === bar.byteLength) {
        while (len-- && foo[len] === bar[len])
          ;
      }
      return len === -1;
    }
    if (!ctor || typeof foo === "object") {
      len = 0;
      for (ctor in foo) {
        if (has2.call(foo, ctor) && ++len && !has2.call(bar, ctor))
          return false;
        if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor]))
          return false;
      }
      return Object.keys(bar).length === len;
    }
  }
  return foo !== foo && bar !== bar;
}

// ../../node_modules/use-deep-compare-effect/dist/use-deep-compare-effect.esm.js
function checkDeps(deps) {
  if (!deps || !deps.length) {
    throw new Error("useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.");
  }
  if (deps.every(isPrimitive)) {
    throw new Error("useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.");
  }
}
function isPrimitive(val) {
  return val == null || /^[sbn]/.test(typeof val);
}
function useDeepCompareMemoize(value) {
  var ref = React120.useRef(value);
  var signalRef = React120.useRef(0);
  if (!dequal(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  }
  return React120.useMemo(function() {
    return ref.current;
  }, [signalRef.current]);
}
function useDeepCompareEffect(callback, dependencies) {
  if (true) {
    checkDeps(dependencies);
  }
  return React120.useEffect(callback, useDeepCompareMemoize(dependencies));
}

// src/account/picker/AccountMultiPickerV2.tsx
var renderAccount = ({ fullCommercialName, isInMyPortfolio }) => {
  return /* @__PURE__ */ React121.createElement("div", null, fullCommercialName, isInMyPortfolio && /* @__PURE__ */ React121.createElement("i", { className: "icon text-info h-100 ml-2" }, "account_balance_wallet"));
};
var AccountMultiPickerV2 = ({
  repository,
  selectedIds = [],
  readonlyIds = [],
  onChange,
  placeholder,
  size: size6
}) => {
  const [term, setTerm] = React121.useState("");
  const [selectedByUser, setSelectedByUser] = useState34([]);
  const { data: data2, isError } = useSearchAccountsQuery(
    repository,
    term,
    {
      pageSize: 500,
      withFunds: true,
      levels: [],
      displayOption: "bdr-commercial-id",
      legalOnly: false
    },
    _size2(term) >= 2
  );
  const { data: accountsFromProps } = mapQueryResults(useGetClientsByIds(repository, selectedIds), mapToAccountWidget);
  const { data: readOnlyAccounts = [] } = mapQueryResults(
    useGetClientsByIds(repository, readonlyIds),
    mapToAccountWidget
  );
  useDeepCompareEffect(() => {
    if (some7(accountsFromProps)) {
      setSelectedByUser(unionBy(selectedByUser, accountsFromProps, "id"));
    }
  }, [accountsFromProps]);
  const selectionState = unionBy(selectedByUser, accountsFromProps, readOnlyAccounts, "id");
  useDeepCompareEffect(() => {
    if (!isEmpty23(selectionState)) {
      onChange(selectionState);
    }
  }, [selectionState]);
  const handleChange = (selectedInPicker) => {
    const byUser = differenceWith(selectedInPicker, concat2(readonlyIds), (account, id2) => account.id === id2);
    setSelectedByUser(byUser);
    onChange(selectedInPicker);
    setTerm("");
  };
  return /* @__PURE__ */ React121.createElement(React121.Fragment, null, /* @__PURE__ */ React121.createElement(
    Select11.AsyncSelect,
    {
      idField: "id",
      labelField: "fullCommercialName",
      size: size6 != null ? size6 : "lg",
      iconName: "business",
      selectedItems: selectedByUser,
      readOnlyItems: readOnlyAccounts,
      items: data2 != null ? data2 : [],
      onTermChange: (val) => setTerm(val),
      onChange: handleChange,
      placeholder: placeholder != null ? placeholder : "Start typing account name",
      inError: isError,
      eraseSearchTermOnClick: true
    },
    renderAccount
  ));
};

// src/kyc/KycCountries.ts
import { orderBy as orderBy3 } from "lodash-es";
var kycCountries = [
  { key: "SPAIN", value: "ESP" },
  { key: "FRANCE", value: "FRA" },
  { key: "UNITED KINGDOM", value: "GBR" },
  { key: "HONG KONG", value: "HKG" },
  { key: "INDIA", value: "IND" },
  { key: "IRELAND", value: "IRL" },
  { key: "ITALY", value: "ITA" },
  { key: "JAPAN", value: "JPN" },
  { key: "KOREA, REPUBLIC OF", value: "KOR" },
  { key: "LUXEMBOURG", value: "LUX" },
  { key: "NETHERLANDS", value: "NLD" },
  { key: "POLAND", value: "POL" },
  { key: "SAUDI ARABIA", value: "SAU" },
  { key: "SINGAPORE", value: "SGP" },
  { key: "THAILAND", value: "THA" },
  { key: "TURKEY", value: "TUR" },
  { key: "TAIWAN", value: "TWN" },
  { key: "UNITED STATES OF AMERICA", value: "USA" },
  { key: "SOUTH AFRICA", value: "ZAF" },
  { key: "UNITED ARAB EMIRATES", value: "ARE" },
  { key: "AUSTRALIA", value: "AUS" },
  { key: "AUSTRIA", value: "AUT" },
  { key: "BELGIUM", value: "BEL" },
  { key: "BRAZIL", value: "BRA" },
  { key: "CANADA", value: "CAN" },
  { key: "SWITZERLAND", value: "CHE" },
  { key: "CHINA", value: "CHN" },
  { key: "CAYMAN ISLANDS", value: "CYM" },
  { key: "GERMANY", value: "DEU" },
  { key: "ALGERIA", value: "DZA" },
  { key: "BENIN", value: "BEN" },
  { key: "BURKINA FASO", value: "BFA" },
  { key: "CAMEROON", value: "CMR" },
  { key: "CONGO", value: "COG" },
  { key: "IVORY COAST", value: "CIV" },
  { key: "GHANA", value: "GHA" },
  { key: "GUIN\xC9E CONAKRY", value: "GIN" },
  { key: "EQUATORIAL GUINEA", value: "GNQ" },
  { key: "MADAGASCAR", value: "MDG" },
  { key: "MOROCCO", value: "MAR" },
  { key: "MAURITANIA", value: "MRT" },
  { key: "MONACO", value: "MCO" },
  { key: "MOZAMBIQUE", value: "MOZ" },
  { key: "CZECH REPUBLIC", value: "CZE" },
  { key: "ROMANIA", value: "ROU" },
  { key: "SENEGAL", value: "SEN" },
  { key: "CHAD", value: "TCD" },
  { key: "TOGO", value: "TGO" },
  { key: "TUNISIA", value: "TUN" }
];
var listCountries = orderBy3(kycCountries, ["key", "value"], ["asc", "asc"]);

// src/kyc/KycGlobalInfoSidePanel.tsx
import { map as map22 } from "lodash-es";
import * as React122 from "react";
import { isStringEmpty as isStringEmpty6 } from "@ic-anywhere/ic-utils";
var KycGlobalInfoSidePanel = ({
  isFetching,
  globalInfo,
  a2dStatus,
  title
}) => {
  const infoContent = [
    {
      label: "BDR ID",
      value: "bdrId"
    },
    {
      label: "Authorization to deal",
      value: "a2dStatus"
    },
    {
      label: "Last global validation date",
      value: "validationDate"
    },
    {
      label: "Next global review date",
      value: "reviewDate"
    },
    {
      label: "Countries KYC authorized",
      value: "authorizedCountries"
    },
    {
      label: "Countries KYC restricted",
      value: "restrictedCountries"
    },
    {
      label: "Countries KYC not authorized",
      value: "notAuthorizedCountries"
    }
  ];
  return /* @__PURE__ */ React122.createElement(React122.Fragment, null, /* @__PURE__ */ React122.createElement(Loader, { isVisible: isFetching }), !isFetching && /* @__PURE__ */ React122.createElement("div", { className: "p-4" }, /* @__PURE__ */ React122.createElement("div", { className: "card-title d-flex flex-shrink-0 justify-content-between" }, /* @__PURE__ */ React122.createElement("h2", { className: "mb-2" }, title)), map22(infoContent, ({ label, value }, index) => /* @__PURE__ */ React122.createElement("div", { key: index, className: "row pb-1" }, /* @__PURE__ */ React122.createElement("div", { className: "col-6" }, /* @__PURE__ */ React122.createElement("span", { className: "text-secondary" }, label)), /* @__PURE__ */ React122.createElement("div", { className: "col-6" }, value !== "a2dStatus" ? /* @__PURE__ */ React122.createElement("span", { className: "text-primary" }, !isStringEmpty6(globalInfo == null ? void 0 : globalInfo[value]) ? globalInfo == null ? void 0 : globalInfo[value] : "-") : /* @__PURE__ */ React122.createElement(A2DStatusBadge, { a2dStatus }))))));
};

// src/kyc/KycGlobalInfoCard.tsx
import { useGetA2dStatus, useGetKycInfo } from "@ic-anywhere/ic-dal";
import * as React123 from "react";
var KycGlobalInfoCard = ({ accountBdrId, repo, countryIso3 }) => {
  const { data: kycInfo2, isFetching: isFetchingKyc } = useGetKycInfo(repo, accountBdrId);
  const { data: a2dStatus, isFetching: isFetchingA2d } = useGetA2dStatus(repo, accountBdrId, countryIso3);
  return kycInfo2 && a2dStatus && a2dStatus.score ? /* @__PURE__ */ React123.createElement("div", { className: "card card-bordered" }, /* @__PURE__ */ React123.createElement(
    KycGlobalInfoSidePanel,
    {
      title: "KYC",
      isFetching: isFetchingKyc || isFetchingA2d,
      globalInfo: kycInfo2,
      a2dStatus: a2dStatus == null ? void 0 : a2dStatus.score
    }
  )) : null;
};

// src/navigation/SgBsErrorBody.tsx
import * as React124 from "react";
var SgBsErrorBody = ({
  num,
  messageTitle,
  message,
  errorImgSrc,
  logoMutedSrc,
  logoFullSrc,
  onLinkButtonClick,
  linkButtonName
}) => {
  const background = `#fff url(${errorImgSrc}) center no-repeat`;
  return /* @__PURE__ */ React124.createElement(React124.Fragment, null, /* @__PURE__ */ React124.createElement("section", { className: "section-1" }, /* @__PURE__ */ React124.createElement("div", { className: "container-fluid d-block d-lg-none px-4" }, /* @__PURE__ */ React124.createElement("div", { className: "row" }, /* @__PURE__ */ React124.createElement("div", { className: "col-7 bg-white" }, /* @__PURE__ */ React124.createElement("a", { href: "#", className: "d-inline-block" }, /* @__PURE__ */ React124.createElement("img", { className: "my-4", src: logoMutedSrc, height: "32", alt: "logo muted" }))), /* @__PURE__ */ React124.createElement("div", { className: "col-4 bg-white" }))), /* @__PURE__ */ React124.createElement("div", { className: "container d-none d-lg-block" }, /* @__PURE__ */ React124.createElement("div", { className: "row" }, /* @__PURE__ */ React124.createElement("div", { className: "col-7 bg-white" }, /* @__PURE__ */ React124.createElement("a", { href: "#", className: "d-inline-block" }, /* @__PURE__ */ React124.createElement("img", { className: "spacing-mt-3 spacing-mb-5", src: logoFullSrc, height: "32", alt: "logo full" }))), /* @__PURE__ */ React124.createElement("div", { className: "col-4 bg-white" })))), /* @__PURE__ */ React124.createElement("section", { className: "section-2" }, /* @__PURE__ */ React124.createElement("div", { className: "container-fluid" }, /* @__PURE__ */ React124.createElement("div", { className: "container main-wrapper" }, /* @__PURE__ */ React124.createElement("div", { className: "row" }, /* @__PURE__ */ React124.createElement("div", { className: "col-lg-2 bg-white pt-5 pb-4 py-lg-0" }, /* @__PURE__ */ React124.createElement(
    "span",
    {
      className: "d-block d-md-none text-outline-socgen text-primary-alt font-weight-medium",
      style: { fontSize: 56, fontFamily: "Neue Haas Grotesk W04 Disp" }
    },
    num
  ), /* @__PURE__ */ React124.createElement(
    "span",
    {
      className: "d-none d-md-block d-lg-none text-outline-socgen text-primary-alt font-weight-medium",
      style: { lineHeight: 1.2, fontSize: 56, fontFamily: "Neue Haas Grotesk W04 Disp" }
    },
    num
  ), /* @__PURE__ */ React124.createElement("span", { className: "mt-n2 d-none d-lg-inline-block d-xl-none display-2 text-outline-socgen text-primary-alt font-weight-medium" }, num), /* @__PURE__ */ React124.createElement(
    "span",
    {
      className: "mt-n3 d-none d-xl-block display-1 text-outline-socgen text-primary-alt font-weight-medium",
      style: { fontSize: 96, overflow: "hidden" }
    },
    "404"
  )), /* @__PURE__ */ React124.createElement("div", { className: "col-lg-5  bg-white d-flex flex-column justify-content-between" }, /* @__PURE__ */ React124.createElement("div", null, /* @__PURE__ */ React124.createElement("h1", { className: "d-none d-lg-block display-2 font-weight-medium line-height-1 pt-0 pb-3" }, messageTitle), /* @__PURE__ */ React124.createElement("h1", { className: "d-lg-none display-3 font-weight-medium line-height-1 py-2" }, messageTitle), /* @__PURE__ */ React124.createElement("p", { className: "d-lg-none mb-5 h3 font-weight-medium text-secondary line-height-1" }, message), /* @__PURE__ */ React124.createElement("p", { className: "d-none d-lg-block d-xxl-none display-3 font-weight-medium text-secondary w-75 line-height-1" }, message), /* @__PURE__ */ React124.createElement("p", { className: "d-none d-xxl-block display-3 font-weight-medium text-secondary w-75 line-height-1" }, message)), /* @__PURE__ */ React124.createElement("div", { className: "mb-5 d-none d-md-flex" }, /* @__PURE__ */ React124.createElement("button", { className: "btn btn-xl btn-primary", onClick: onLinkButtonClick }, linkButtonName)), /* @__PURE__ */ React124.createElement("div", { className: "d-block d-md-none" }, /* @__PURE__ */ React124.createElement("button", { className: "btn btn-xl btn-primary btn-block mb-1", onClick: onLinkButtonClick }, "linkButtonName"))), /* @__PURE__ */ React124.createElement("div", { className: "col-4 px-0 position-relative" }, /* @__PURE__ */ React124.createElement("div", { className: "d-none d-lg-block", style: { paddingTop: "100%", background, backgroundSize: "130%" } })))))), /* @__PURE__ */ React124.createElement("section", { className: "section-3 flex-grow-1 d-flex" }, /* @__PURE__ */ React124.createElement("div", { className: "container-fluid" }, /* @__PURE__ */ React124.createElement("div", { className: "container h-100 d-none d-lg-block" }, /* @__PURE__ */ React124.createElement("div", { className: "row h-100" }, /* @__PURE__ */ React124.createElement("div", { className: "offset-2 col-5 pt-5 text-muted", style: { backgroundColor: "#fafafa" } }, "\xA9 Societe Generale Group 2021"))), /* @__PURE__ */ React124.createElement(
    "footer",
    {
      className: "container-fluid d-lg-none position-absolute text-muted",
      style: { bottom: 0, left: 0, right: 0, backgroundColor: "#fafafa" }
    },
    /* @__PURE__ */ React124.createElement("div", { className: "container py-4" }, "\xA9 Societe Generale Group 2021")
  ))));
};

// src/search/SearchBar.tsx
import * as React127 from "react";
import { formatAccountName } from "@ic-anywhere/ic-dal";

// src/search/MultiTabSelect.tsx
import * as React126 from "react";
import { isEmpty as isEmpty24, keys as keys3, map as map23, noop as noop19 } from "lodash-es";
import { Select as Select12 } from "@sgbs-ui/core";

// src/search/MultiTabOption.tsx
import * as React125 from "react";
function MultiTabOption({
  item,
  labelField,
  onSelect,
  iconName,
  render: render2
}) {
  const handleOnChange = () => {
    onSelect(item);
  };
  const classNames11 = `d-flex list-group-item border-0 mt-0 list-group-item-action list-group-item-primary align-items-center`;
  return /* @__PURE__ */ React125.createElement("div", { onClick: handleOnChange, style: { cursor: "pointer" }, title: `${item[labelField]}`, className: classNames11 }, render2 ? render2(item) : /* @__PURE__ */ React125.createElement(React125.Fragment, null, /* @__PURE__ */ React125.createElement("i", { className: "icon icon-sm text-secondary mr-2", style: { cursor: "pointer" } }, iconName), /* @__PURE__ */ React125.createElement("div", { className: "w-100" }, item[labelField])));
}

// src/search/MultiTabSelect.tsx
function MultiTabSelect({
  tabsDescriptor,
  onTermChange,
  items,
  lastSearches,
  itemsLoading,
  onSelect,
  onTabChange,
  placeholder,
  size: size6,
  defaultValue
}) {
  const [currentTab, setCurrentTab] = React126.useState("all");
  const [currentTerm, setCurrentTerm] = React126.useState(void 0);
  React126.useEffect(() => {
    if (defaultValue) {
      setCurrentTab(defaultValue);
    }
  }, [defaultValue]);
  const handleTabChanged = (selectedTab) => {
    setCurrentTab(selectedTab);
    onTabChange(selectedTab);
  };
  const handleTermChanged = (inputTerm) => {
    setCurrentTerm(inputTerm);
    onTermChange(inputTerm);
  };
  return /* @__PURE__ */ React126.createElement(
    Select12.AsyncSingleSelect,
    {
      items,
      isLoading: itemsLoading,
      onTermChange: handleTermChanged,
      iconName: "search",
      placeholder,
      size: size6,
      idField: "id",
      labelField: "name",
      itemsRenderer: (items2, _, onChangeCallback) => renderTabsAndItems(
        items2,
        tabsDescriptor,
        currentTab,
        handleTabChanged,
        currentTerm,
        lastSearches,
        onChangeCallback
      ),
      onChange: onSelect,
      selectedItem: null,
      inputSearchMode: true
    },
    void 0
  );
}
function renderTabsAndItems(items, tabsDescriptor, currentTab, onTabChange, currentTerm, lastSearches, onChangeCallback) {
  const { labelField, icon, render: render2 } = tabsDescriptor[currentTab];
  return !isEmpty24(currentTerm) ? /* @__PURE__ */ React126.createElement(React126.Fragment, null, /* @__PURE__ */ React126.createElement("ul", { className: "nav nav-pills flex-nowrap justify-content-between justify-content-sm-start px-3 my-2" }, map23(keys3(tabsDescriptor), (tabKey) => {
    const tab = tabsDescriptor[tabKey];
    return /* @__PURE__ */ React126.createElement(
      "li",
      {
        key: tab.label,
        className: "nav-item text-center",
        onClick: () => onTabChange(tabKey),
        style: { cursor: "pointer" }
      },
      /* @__PURE__ */ React126.createElement("i", { className: "icon icon-md text-secondary pointer", style: { cursor: "pointer" } }, tab.icon),
      /* @__PURE__ */ React126.createElement("a", { className: `nav-link text-small pt-0 px-2 px-sm-3 ${tabKey === currentTab ? "active" : ""}` }, tab.label)
    );
  })), /* @__PURE__ */ React126.createElement("ul", { className: "list-group" }, items.map((item, index) => /* @__PURE__ */ React126.createElement(
    MultiTabOption,
    {
      key: index,
      item,
      labelField,
      iconName: icon,
      onSelect: onChangeCallback != null ? onChangeCallback : noop19,
      render: render2
    }
  )))) : /* @__PURE__ */ React126.createElement(React126.Fragment, null, !isEmpty24(lastSearches) && /* @__PURE__ */ React126.createElement(React126.Fragment, null, /* @__PURE__ */ React126.createElement("div", { className: "text-secondary font-weight-medium p-3" }, "Last searches"), /* @__PURE__ */ React126.createElement("ul", { className: "list-group" }, map23(lastSearches, (item, index) => /* @__PURE__ */ React126.createElement(
    MultiTabOption,
    {
      key: index,
      item,
      labelField,
      iconName: icon,
      onSelect: onChangeCallback != null ? onChangeCallback : noop19,
      render: render2
    }
  )))));
}
var MultiTabSelect_default = MultiTabSelect;

// src/search/SearchBar.tsx
var renderContact = ({
  title,
  firstname,
  lastname,
  accountName,
  level,
  countryIso
}) => {
  const accountCompleteName = formatAccountName({ name: accountName, accountLevel: level, country: countryIso });
  return /* @__PURE__ */ React127.createElement(React127.Fragment, null, /* @__PURE__ */ React127.createElement("em", { className: "icon icon-sm text-secondary mr-3" }, "person"), /* @__PURE__ */ React127.createElement("div", { className: "font-weight-500 text-black mr-1" }, `${firstname} ${lastname}`), /* @__PURE__ */ React127.createElement("div", { className: "text-secondary mr-1" }, accountCompleteName), title && /* @__PURE__ */ React127.createElement("div", { className: "text-secondary" }, `${bulletCode} ${title}`));
};
var renderAccount2 = ({
  name = "",
  level = "",
  countryIso3 = "",
  city,
  isFund
}) => {
  const accountCompleteName = formatAccountName({ name, accountLevel: level, country: countryIso3 });
  return /* @__PURE__ */ React127.createElement(React127.Fragment, null, /* @__PURE__ */ React127.createElement("i", { className: "icon icon-sm text-secondary mr-3" }, "business"), /* @__PURE__ */ React127.createElement("div", { className: "font-weight-500 text-black mr-1" }, accountCompleteName), city && /* @__PURE__ */ React127.createElement("div", { className: "text-secondary" }, `${bulletCode} ${city}`), isFund && /* @__PURE__ */ React127.createElement("div", { className: "ml-1" }, /* @__PURE__ */ React127.createElement(ClientTypeBadge, { type: "Fund" })));
};
var renderMixed = (item) => item.type === "contact" ? renderContact(item) : renderAccount2(item);
var descriptor = {
  all: {
    label: "All",
    icon: "list",
    labelField: "id",
    render: (result) => renderMixed(result)
  },
  accounts: {
    label: "Accounts",
    icon: "business",
    labelField: "id",
    render: (result) => renderAccount2(result)
  },
  contacts: {
    label: "Contacts",
    icon: "person",
    labelField: "id",
    render: (result) => renderContact(result)
  }
};
var SearchBar = ({
  searchItems,
  lastSearches,
  isLoading,
  onTermChange,
  onSearchTypeChanged,
  onSelectItem,
  size: size6
}) => {
  const handleSelect = (selectedItem) => {
    onSelectItem(selectedItem);
  };
  return /* @__PURE__ */ React127.createElement(
    MultiTabSelect_default,
    {
      tabsDescriptor: descriptor,
      onTabChange: onSearchTypeChanged,
      onTermChange,
      items: searchItems || [],
      lastSearches,
      itemsLoading: isLoading,
      onSelect: handleSelect,
      placeholder: "Search for a contact or an account",
      size: size6
    }
  );
};

// src/widgets/SegmentationSinglePickerWidget.tsx
import * as React128 from "react";
var SegmentationEvents = {
  SegmentationChanged: "ic-segmentation-single-picker--changed",
  SegmentationReady: "ic-segmentation-single-picker--ready"
};
var SegmentationSinglePickerWidget = ({
  id: id2,
  selectedId,
  placeholder,
  errorMessage,
  inError,
  onlyForMyPerimeter,
  size: size6,
  outline,
  emitMode,
  disabled,
  onlySharedWithMe,
  onChange,
  onReady
}) => {
  useWidget("ic-segmentation-single-picker", "ic-v1");
  const listeners = [
    {
      eventName: SegmentationEvents.SegmentationChanged,
      eventHandler: (event2) => {
        var _a;
        return onChange == null ? void 0 : onChange((_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.segmentation);
      }
    },
    { eventName: SegmentationEvents.SegmentationReady, eventHandler: () => onReady == null ? void 0 : onReady() }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React128.createElement(
    "ic-segmentation-single-picker",
    {
      ref,
      id: id2,
      "selected-id": selectedId,
      placeholder,
      "in-error": inError,
      "error-message": errorMessage,
      "only-for-my-perimeter": onlyForMyPerimeter,
      "only-open": true,
      "only-shared-with-me": onlySharedWithMe,
      size: size6,
      outline,
      "emit-mode": emitMode,
      disabled
    }
  );
};

// src/widgets/LastActivitiesWidget.tsx
import * as React129 from "react";
var LastActivitiesEvents = {
  LastActivitiesReady: "ic-last-activities--ready",
  LastActivitiesError: "ic-last-activities--exception",
  LastActivitiesClick: "ic-last-activities--click",
  LastActivitiesAuthorClick: "ic-last-activities--click-on-author-name",
  LastActivitiesAccountClick: "ic-last-activities--click-on-account-name"
};
var LastActivitiesWidget = ({
  startDate,
  endDate,
  accountId,
  contactId,
  activitiesCount,
  activitiesTypes,
  impersonatingAs,
  onClick,
  onError,
  onAccountClick,
  onContactClick,
  onReady
}) => {
  useWidget("ic-last-activities", "ic-v1");
  const listeners = [
    { eventName: LastActivitiesEvents.LastActivitiesClick, eventHandler: (event2) => onClick == null ? void 0 : onClick(event2 == null ? void 0 : event2.detail) },
    {
      eventName: LastActivitiesEvents.LastActivitiesAuthorClick,
      eventHandler: (event2) => {
        var _a;
        return onContactClick == null ? void 0 : onContactClick((_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.contactId);
      }
    },
    {
      eventName: LastActivitiesEvents.LastActivitiesAccountClick,
      eventHandler: (event2) => {
        var _a;
        return onAccountClick == null ? void 0 : onAccountClick((_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.accountId);
      }
    },
    {
      eventName: LastActivitiesEvents.LastActivitiesError,
      eventHandler: (event2) => {
        var _a;
        return onError == null ? void 0 : onError((_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.errorMessage);
      }
    },
    { eventName: LastActivitiesEvents.LastActivitiesReady, eventHandler: () => onReady == null ? void 0 : onReady() }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React129.createElement(
    "ic-last-activities",
    {
      ref,
      "start-date": startDate,
      "end-date": endDate,
      "account-id": accountId,
      "contact-id": contactId,
      "activities-count": activitiesCount,
      "activities-types": activitiesTypes == null ? void 0 : activitiesTypes.toString(),
      "impersonating-as": impersonatingAs
    }
  );
};

// src/widgets/SgwtSplashScreen.tsx
import * as React130 from "react";
import { find as find11 } from "lodash-es";
var scriptSrc = "https://sgwt-cdn-widgets.sgmarkets.com/widgets/sgwt-splash-screen/v4/sgwt-splash-screen.js";
var SgwtSplashScreen = ({ applicationName = "ic-anywhere", debug = false }) => {
  React130.useEffect(() => {
    const existing = find11(document.scripts, ({ src }) => src === scriptSrc);
    if (!existing) {
      document.body.appendChild(createScriptElement(scriptSrc));
    }
  }, []);
  return /* @__PURE__ */ React130.createElement("sgwt-splash-screen", { "application-id": applicationName, debug });
};

// src/widgets/SgwtWebAnalytics.tsx
import * as React131 from "react";
var SgwtWebAnalytics = ({ siteId, disableUserTracking = false }) => {
  useWidget("sgwt-web-analytics", "sgwt-analytics");
  return /* @__PURE__ */ React131.createElement("sgwt-web-analytics", { "site-id": siteId, "disable-user-tracking": disableUserTracking });
};

// src/widgets/PdfIcTagHelperWidget.tsx
import * as React132 from "react";
var PdfIcTagHelperWidget = ({
  size: size6,
  inError,
  placeholder,
  selectedHashtags = [],
  outline,
  onChange
}) => {
  useWidget("pdf-ic-tag-helper", "mark-eng-dat", false, false, true);
  const listeners = [
    {
      eventName: "pdf-ic-tag-helper--changed",
      eventHandler: (event2) => {
        var _a;
        return onChange == null ? void 0 : onChange(
          (_a = event2 == null ? void 0 : event2.detail) != null ? _a : {
            content: null,
            hashtags: []
          }
        );
      }
    }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React132.createElement(
    "pdf-ic-tag-helper",
    {
      ref,
      size: size6,
      placeholder,
      "in-error": inError === void 0 ? void 0 : inError,
      "selected-ids": JSON.stringify(selectedHashtags),
      outline
    }
  );
};

// src/widgets/SgmRequestAccess.tsx
import * as React133 from "react";
var SgmRequestAccess = ({ className, size: size6 = "md", icId, resourceId, url, onClick }) => {
  useWidget("sgmarkets-request-access", "sgr-request-access");
  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return /* @__PURE__ */ React133.createElement("div", { onClick: handleOnClick }, /* @__PURE__ */ React133.createElement(
    "sgmarkets-request-access",
    {
      classBtn: `btn btn-${size6} btn-discreet-socgen ${className}`,
      "ressource-id": resourceId,
      url,
      icid: icId
    }
  ));
};

// src/widgets/SgmDocsDocumentViewer.tsx
import * as React134 from "react";
import { getServiceUrl } from "@ic-anywhere/ic-dal";
import { getEnvironment as getEnvironment2 } from "@ic-anywhere/ic-utils";
var SgmDocsDocumentViewer = ({
  hideDownloadButton = false,
  token = null,
  permalinkId,
  workspaceId,
  documentId,
  versionId,
  mimeType,
  sgmDocsBaseUrl = getServiceUrl("SgmDocs", getEnvironment2())
}) => {
  useWidget("sgm-docs-document-viewer", "sgmdocs");
  return /* @__PURE__ */ React134.createElement("div", { style: { width: "100%" } }, /* @__PURE__ */ React134.createElement(
    "sgm-docs-document-viewer",
    {
      "permalink-id": permalinkId,
      "hide-download-button": stringifyBoolean(hideDownloadButton),
      "document-id": documentId,
      "mime-type": mimeType,
      "sgm-docs-base-url": sgmDocsBaseUrl,
      token,
      "version-id": versionId,
      "workspace-id": workspaceId
    }
  ));
};

// src/widgets/Accounts/AccountSinglePicker.tsx
import * as React135 from "react";
var AccountSinglePicker = ({
  selectedId,
  readonlyId,
  onChange,
  isInError,
  size: size6,
  levels = [],
  emitMode,
  displayOption = "none",
  createLinkMode,
  onCreateLinkClicked,
  errorMessage,
  placeholder,
  suggestionsIds,
  autofocus
}) => {
  useWidget("ic-account-single-picker", "ic-v1");
  const listeners = [
    {
      eventName: "ic-account-single-picker--changed",
      eventHandler: (event2) => {
        var _a, _b;
        return onChange == null ? void 0 : onChange((_b = (_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.account) != null ? _b : null);
      }
    },
    {
      eventName: "ic-account-single-picker--create-link-clicked",
      eventHandler: (event2) => onCreateLinkClicked == null ? void 0 : onCreateLinkClicked(event2 == null ? void 0 : event2.detail)
    }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React135.createElement(
    "ic-account-single-picker",
    {
      ref,
      placeholder,
      "in-error": isInError,
      "error-message": errorMessage,
      "selected-id": selectedId,
      "readonly-id": readonlyId,
      size: size6,
      levels: JSON.stringify(levels),
      "emit-mode": emitMode,
      "display-option": displayOption,
      "create-link-mode": createLinkMode,
      "suggestion-ids": JSON.stringify(suggestionsIds),
      autofocus
    }
  );
};

// src/widgets/Accounts/AccountsPicker.tsx
import * as React136 from "react";
var AccountsPicker = ({
  id: id2,
  selectedIds = [],
  readonlyIds = [],
  onChange,
  inError,
  placeholder,
  size: size6,
  emitMode
}) => {
  useWidget("ic-account-multi-picker", "ic-v1");
  const ref = useRefListener(
    "ic-account-multi-picker--changed",
    onChange,
    (event2) => {
      var _a, _b;
      return (_b = (_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.accounts) != null ? _b : [];
    }
  );
  return /* @__PURE__ */ React136.createElement(
    "ic-account-multi-picker",
    {
      ref,
      id: id2,
      placeholder,
      "selected-ids": JSON.stringify(selectedIds),
      "readonly-ids": JSON.stringify(readonlyIds),
      "in-error": inError,
      size: size6,
      "emit-mode": emitMode
    }
  );
};

// src/widgets/MaestroAccountsPicker/MaestroAccountPicker.tsx
import * as React137 from "react";
import { noop as noop20 } from "lodash-es";
var MaestroAccountPicker = ({
  level,
  size: size6,
  selectedId,
  onChange,
  createLinkMode = "none",
  placeholder,
  emitMode = "user",
  inError = false,
  searchBy,
  searchByOptions
}) => {
  useWidget("ic-maestro-single-picker", "ic-v1");
  const ref = useRefListener("ic-maestro-single-picker--changed", onChange != null ? onChange : noop20, (event2) => event2.detail);
  return /* @__PURE__ */ React137.createElement(
    "ic-maestro-single-picker",
    {
      ref,
      "sso-v2": true,
      "selected-id": JSON.stringify(selectedId),
      "create-link-mode": createLinkMode,
      level,
      size: size6,
      "emit-mode": emitMode,
      placeholder,
      "in-error": inError,
      "search-by": searchBy,
      "search-by-options": JSON.stringify(searchByOptions)
    }
  );
};

// src/widgets/MaestroAccountsPicker/MaestroAccountsPicker.tsx
import * as React138 from "react";
import { map as map24, noop as noop21 } from "lodash-es";
var MaestroAccountsPicker = ({
  level,
  size: size6,
  selectedIds = [],
  readonlyIds = [],
  onChange,
  createLinkMode = "none"
}) => {
  useWidget("ic-maestro-multi-picker", "ic-v1");
  const ref = useRefListener("ic-maestro-multi-picker--changed", onChange != null ? onChange : noop21, (event2) => map24(event2.detail));
  return /* @__PURE__ */ React138.createElement(
    "ic-maestro-multi-picker",
    {
      ref,
      "sso-v2": true,
      "selected-ids": JSON.stringify(selectedIds),
      "readonly-ids": JSON.stringify(readonlyIds),
      "create-link-mode": createLinkMode,
      level,
      size: size6
    }
  );
};

// src/widgets/Contacts/PersonContactMultiPicker.tsx
import * as React139 from "react";
var PersonContactMultiPicker = ({
  placeholder,
  selectedIds,
  size: size6,
  inError,
  dropdownZIndex,
  onChange,
  onCreateClick,
  onMandateClick,
  ignoreClickOutside
}) => {
  useWidget("ic-person-contact-multi-picker", "ic-v1");
  const listeners = [
    {
      eventName: "ic-person-contact-multi-picker--changed",
      eventHandler: (event2) => {
        var _a;
        return onChange == null ? void 0 : onChange((_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.contacts);
      }
    },
    {
      eventName: "ic-person-contact-multi-picker--mandate-clicked",
      eventHandler: (event2) => onMandateClick == null ? void 0 : onMandateClick(event2 == null ? void 0 : event2.detail)
    },
    {
      eventName: "ic-person-contact-multi-picker--create-clicked",
      eventHandler: (event2) => onCreateClick == null ? void 0 : onCreateClick(event2 == null ? void 0 : event2.detail)
    }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React139.createElement(
    "ic-person-contact-multi-picker",
    {
      ref,
      placeholder,
      size: size6,
      "in-error": inError,
      "dropdown-z-index": dropdownZIndex,
      "ignore-click-outside": ignoreClickOutside,
      "selected-ids": selectedIds ? JSON.stringify(selectedIds) : void 0
    }
  );
};

// src/widgets/Contacts/PersonContactPicker.tsx
import * as React140 from "react";
var PersonContactPicker = ({
  placeholder,
  selectedId,
  size: size6,
  inError,
  dropdownZIndex,
  onChange,
  onCreateClick,
  onMandateClick,
  ignoreClickOutside,
  emitMode = "user"
}) => {
  useWidget("ic-person-contact-single-picker", "ic-v1");
  const listeners = [
    {
      eventName: "ic-person-contact-single-picker--changed",
      eventHandler: (event2) => {
        var _a;
        return onChange == null ? void 0 : onChange((_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.contact);
      }
    },
    {
      eventName: "ic-person-contact-single-picker--mandate-clicked",
      eventHandler: (event2) => onMandateClick == null ? void 0 : onMandateClick(event2 == null ? void 0 : event2.detail)
    },
    {
      eventName: "ic-person-contact-single-picker--create-clicked",
      eventHandler: (event2) => onCreateClick == null ? void 0 : onCreateClick(event2 == null ? void 0 : event2.detail)
    }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React140.createElement(
    "ic-person-contact-single-picker",
    {
      ref,
      placeholder,
      "selected-id": selectedId,
      size: size6,
      "emit-mode": emitMode,
      "in-error": inError,
      "dropdown-z-index": dropdownZIndex,
      "ignore-click-outside": ignoreClickOutside
    }
  );
};

// src/widgets/Contacts/PersonContactCreatorWidget.tsx
import * as React141 from "react";
var PersonContactCreatorWidget = ({
  isShowCancel = false,
  isHideStepper = false,
  onCreate,
  onCancel,
  onError
}) => {
  useWidget("ic-person-contact-creator", "ic-v1");
  const listeners = [
    { eventName: "ic-person-contact-creator--created", eventHandler: (event2) => onCreate == null ? void 0 : onCreate(event2 == null ? void 0 : event2.detail) },
    { eventName: "ic-person-contact-creator--error", eventHandler: (event2) => onError == null ? void 0 : onError(event2 == null ? void 0 : event2.detail) },
    { eventName: "ic-person-contact-creator--cancel", eventHandler: () => onCancel == null ? void 0 : onCancel() }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React141.createElement("ic-person-contact-creator", { "is-show-cancel": isShowCancel, "is-hide-stepper": isHideStepper, ref });
};

// src/widgets/Contacts/PersonContactCreatorModalWidget.tsx
import * as React142 from "react";
var PersonContactCreatorModalWidget = ({
  isShown = false,
  onCreate,
  onCancel,
  onError
}) => {
  useWidget("ic-person-contact-creator-modal", "ic-v1");
  const listeners = [
    { eventName: "ic-person-contact-creator-modal--created", eventHandler: (event2) => onCreate == null ? void 0 : onCreate(event2 == null ? void 0 : event2.detail) },
    { eventName: "ic-person-contact-creator-modal--error", eventHandler: (event2) => onError == null ? void 0 : onError(event2 == null ? void 0 : event2.detail) },
    { eventName: "ic-person-contact-creator-modal--cancel", eventHandler: () => onCancel == null ? void 0 : onCancel() }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React142.createElement("ic-person-contact-creator-modal", { "is-shown": isShown, ref });
};

// src/widgets/Contacts/ContactCreatorWidget.tsx
import * as React143 from "react";
var ContactEvents = {
  ContactCreatorCreated: "ic-contact-creator--created",
  ContactCreatorCancel: "ic-contact-creator--cancel",
  ContactCreatorError: "ic-contact-creator--error",
  ContactCreateAccount: "ic-contact-creator--create-account",
  ContactEditorEdited: "ic-contact-editor--edited",
  ContactEditorCancel: "ic-contact-editor--cancel",
  ContactEditorError: "ic-contact-editor--error"
};
var ContactCreatorWidget = ({
  isShowCancel,
  personId,
  accountId,
  onCreate,
  onCancel,
  onError,
  onCreateAccount,
  createLinkMode
}) => {
  useWidget("ic-contact-creator", "ic-v1");
  const listeners = [
    { eventName: ContactEvents.ContactCreatorCreated, eventHandler: (event2) => onCreate == null ? void 0 : onCreate(event2 == null ? void 0 : event2.detail) },
    { eventName: ContactEvents.ContactCreatorError, eventHandler: (event2) => onError == null ? void 0 : onError(event2 == null ? void 0 : event2.detail) },
    { eventName: ContactEvents.ContactCreatorCancel, eventHandler: () => onCancel == null ? void 0 : onCancel() },
    { eventName: ContactEvents.ContactCreateAccount, eventHandler: (event2) => onCreateAccount == null ? void 0 : onCreateAccount(event2 == null ? void 0 : event2.detail) }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React143.createElement(
    "ic-contact-creator",
    {
      "show-cancel": isShowCancel,
      "person-id": personId,
      "account-id": accountId,
      ref,
      "create-link-mode": createLinkMode
    }
  );
};

// src/widgets/Contacts/ContactPickerWidget.tsx
import * as React144 from "react";
var ContactPickerEvents = {
  changed: "ic-contact-single-picker--changed",
  createLinkClicked: "ic-contact-single-picker--create-link-clicked"
};
var ContactPickerWidget = ({
  selectedId = null,
  readonlyId = null,
  isInternalOnly,
  isOnlyActive,
  size: size6,
  displayOption,
  inError,
  emitMode,
  createActionText,
  createLinkMode,
  withQualityIndicators,
  onCreateLinkClicked,
  onChange,
  ...props
}) => {
  useWidget("ic-contact-single-picker", "ic-v1");
  const listeners = [
    {
      eventName: ContactPickerEvents.changed,
      eventHandler: (event2) => {
        var _a;
        return onChange == null ? void 0 : onChange((_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.contact);
      }
    },
    {
      eventName: ContactPickerEvents.createLinkClicked,
      eventHandler: (event2) => onCreateLinkClicked == null ? void 0 : onCreateLinkClicked(event2.detail)
    }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React144.createElement(
    "ic-contact-single-picker",
    {
      ref,
      "display-option": displayOption,
      placeholder: props.placeholder,
      "selected-id": selectedId,
      "readonly-id": readonlyId,
      "internal-only": stringifyBoolean(isInternalOnly),
      "active-only": stringifyBoolean(isOnlyActive),
      size: size6,
      "in-error": stringifyBoolean(inError),
      "emit-mode": emitMode,
      "create-link-mode": createLinkMode,
      "create-action-text": createActionText,
      "with-quality-indicators": withQualityIndicators
    }
  );
};

// src/widgets/Contacts/ContactMultiPickerWidget.tsx
import * as React145 from "react";
var ContactMultiPickerEvents = {
  changed: "ic-contact-multi-picker--changed",
  createLinkClicked: "ic-contact-multi-picker--create-link-clicked"
};
var ContactMultiPickerWidget = ({
  selectedIds = [],
  readonlyIds = [],
  isInternalOnly,
  size: size6,
  emitMode,
  scope,
  displayOption,
  createLinkMode,
  createActionText,
  withQualityIndicators,
  onChange,
  onCreateLinkClicked,
  ...props
}) => {
  useWidget("ic-contact-multi-picker", "ic-v1");
  const listeners = [
    {
      eventName: ContactMultiPickerEvents.changed,
      eventHandler: (event2) => {
        var _a;
        return onChange == null ? void 0 : onChange((_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.contacts);
      }
    },
    {
      eventName: ContactMultiPickerEvents.createLinkClicked,
      eventHandler: (event2) => onCreateLinkClicked == null ? void 0 : onCreateLinkClicked(event2.detail)
    }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React145.createElement(
    "ic-contact-multi-picker",
    {
      ref,
      placeholder: props.placeholder,
      "selected-ids": JSON.stringify(selectedIds),
      "readonly-ids": JSON.stringify(readonlyIds),
      "internal-only": JSON.stringify(isInternalOnly),
      "in-error": stringifyBoolean(props.inError),
      "error-message": props.errorMessage,
      size: size6,
      "emit-mode": emitMode,
      scope,
      "display-option": displayOption,
      "create-link-mode": createLinkMode,
      "create-action-text": createActionText,
      "with-quality-indicators": withQualityIndicators
    }
  );
};

// src/widgets/Contacts/ContactEditorWidget.tsx
import * as React146 from "react";
var ContactEditorWidget = ({ contactId, onEdited, onCancel, onError }) => {
  const listeners = [
    { eventName: ContactEvents.ContactEditorCancel, eventHandler: () => onCancel == null ? void 0 : onCancel() },
    { eventName: ContactEvents.ContactEditorEdited, eventHandler: (event2) => onEdited == null ? void 0 : onEdited(event2 == null ? void 0 : event2.detail) },
    { eventName: ContactEvents.ContactEditorError, eventHandler: (event2) => onError == null ? void 0 : onError(event2 == null ? void 0 : event2.detail) }
  ];
  useWidget("ic-contact-editor", "ic-v1");
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React146.createElement("ic-contact-editor", { "contact-id": contactId, ref });
};

// src/widgets/Contacts/WorkPositionsWidget.tsx
import * as React147 from "react";
var WorkPositionsWidget = ({ contactId }) => {
  useWidget("ic-work-positions", "ic-v1");
  return /* @__PURE__ */ React147.createElement("div", { style: { width: "100%" } }, /* @__PURE__ */ React147.createElement("ic-work-positions", { "contact-id": contactId }));
};

// src/widgets/SgDatePicker.tsx
import { generateUID as generateUID2 } from "@sgbs-ui/core";
import * as React148 from "react";
var SgDatePicker = ({
  onChange,
  onReset,
  className,
  fieldId,
  label,
  isOptional,
  error,
  value,
  disabled,
  top,
  yearControllers
}) => {
  const ref = React148.useRef(null);
  const pickerId = generateUID2();
  React148.useEffect(() => {
    var _a, _b, _c, _d;
    if (error) {
      (_b = (_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.setState) == null ? void 0 : _b.call(_a, "invalid", error);
    } else {
      (_d = (_c = ref == null ? void 0 : ref.current) == null ? void 0 : _c.setState) == null ? void 0 : _d.call(_c, void 0);
    }
  }, [error]);
  React148.useEffect(() => {
    var _a, _b;
    if ((ref == null ? void 0 : ref.current) && value) {
      (_b = (_a = ref == null ? void 0 : ref.current).selectDate) == null ? void 0 : _b.call(_a, value ? [new Date(value).getTime()] : null);
    }
  }, [value, ref]);
  React148.useEffect(() => {
    var _a, _b, _c;
    const dateSelected = "dateSelected";
    const dateUnSelected = "dateUnSelected";
    const inputCleared = "inputCleared";
    (_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.addEventListener(dateSelected, (value2) => {
      var _a2;
      return onChange((_a2 = value2 == null ? void 0 : value2.detail) == null ? void 0 : _a2.formatted);
    });
    (_b = ref == null ? void 0 : ref.current) == null ? void 0 : _b.addEventListener(dateUnSelected, onReset);
    (_c = ref == null ? void 0 : ref.current) == null ? void 0 : _c.addEventListener(inputCleared, onReset);
    return () => {
      var _a2, _b2, _c2;
      (_a2 = ref == null ? void 0 : ref.current) == null ? void 0 : _a2.removeEventListener(dateSelected, (value2) => {
        var _a3;
        return onChange((_a3 = value2 == null ? void 0 : value2.detail) == null ? void 0 : _a3.formatted);
      });
      (_b2 = ref == null ? void 0 : ref.current) == null ? void 0 : _b2.removeEventListener(dateUnSelected, onReset);
      (_c2 = ref == null ? void 0 : ref.current) == null ? void 0 : _c2.removeEventListener(inputCleared, onReset);
    };
  }, [ref]);
  return /* @__PURE__ */ React148.createElement("div", { className: `form-group ${className}`, style: { width: "310px" } }, /* @__PURE__ */ React148.createElement("label", { htmlFor: fieldId }, label, isOptional ? " (optional)" : ""), /* @__PURE__ */ React148.createElement(
    "sg-datepicker",
    {
      disabled: stringifyBoolean(disabled),
      ref,
      "input-id": pickerId,
      size: "lg",
      format: "yyyy-MM-dd",
      "display-format": "dd MMM yyyy",
      "year-controllers": yearControllers,
      top
    }
  ));
};

// src/widgets/MandateList/MandateListWidget.tsx
import * as React149 from "react";
var widgetTag = "ic-mandate-list";
var MandateListWidget = ({
  contactId,
  thirdId,
  delegationId,
  functionId,
  roleId,
  hiddenColumns = ["jobtitle", "contact", "delegation"],
  accountId,
  contactPerimeter,
  onContactClick,
  onThirdClick
}) => {
  useWidget(widgetTag, "ic-v1");
  const listeners = [
    {
      eventName: `${widgetTag}--contact-clicked`,
      eventHandler: (event2) => onContactClick == null ? void 0 : onContactClick(event2 == null ? void 0 : event2.detail)
    },
    {
      eventName: `${widgetTag}--third-clicked`,
      eventHandler: (event2) => onThirdClick == null ? void 0 : onThirdClick(event2 == null ? void 0 : event2.detail)
    }
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React149.createElement(
    "ic-mandate-list",
    {
      ref,
      "contact-id": JSON.stringify(contactId),
      "third-id": JSON.stringify(thirdId),
      "role-id": roleId,
      "function-id": functionId,
      "delegation-id": delegationId,
      "hidden-columns": JSON.stringify(hiddenColumns),
      "account-id": accountId,
      "contact-perimeter": contactPerimeter
    }
  );
};

// src/widgets/Countries/CountryPicker.tsx
import * as React150 from "react";
import { noop as noop22 } from "lodash-es";
var CountryPicker = ({
  placeholder,
  selectedId,
  isInError = false,
  onChange = noop22,
  size: size6,
  top
}) => {
  useWidget("ic-country-single-picker", "ic-v1");
  const ref = useRefListener("ic-country-single-picker--changed", onChange, (event2) => {
    var _a;
    return (_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.country;
  });
  return /* @__PURE__ */ React150.createElement(
    "ic-country-single-picker",
    {
      ref,
      placeholder,
      "in-error": isInError || void 0,
      size: size6,
      "selected-id": selectedId,
      top
    }
  );
};

// src/widgets/Countries/CountriesPicker.tsx
import * as React151 from "react";
import { noop as noop23 } from "lodash-es";
var CountriesPicker = ({
  placeholder,
  selectedIds,
  onChange = noop23,
  size: size6,
  inError = false,
  top
}) => {
  useWidget("ic-country-multi-picker", "ic-v1");
  const ref = useRefListener("ic-country-multi-picker--changed", onChange, (event2) => {
    var _a;
    return (_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.countries;
  });
  return /* @__PURE__ */ React151.createElement(
    "ic-country-multi-picker",
    {
      ref,
      placeholder,
      size: size6,
      "in-error": inError,
      "selected-ids": JSON.stringify(selectedIds),
      top
    }
  );
};

// src/widgets/SgmIdyRequestAccess.tsx
import * as React152 from "react";
var SgmIdyRequestAccess = ({
  className,
  size: size6 = "md",
  icId,
  resourceId,
  preSelectedProfileId,
  onRequestDone
}) => {
  useWidget("idy-request-access", "sgidentity");
  const listeners = [
    { eventName: "idy-request-access--access-requested", eventHandler: (event2) => onRequestDone == null ? void 0 : onRequestDone(event2 == null ? void 0 : event2.detail) }
    // Add others events here
  ];
  const ref = useRefListeners(listeners);
  return /* @__PURE__ */ React152.createElement("div", null, /* @__PURE__ */ React152.createElement(
    "idy-request-access",
    {
      ref,
      "class-btn": `btn btn-${size6} btn-discreet-socgen ${className != null ? className : ""}`,
      targetUserId: icId,
      selectedResourceId: resourceId,
      preSelectedProfileId
    }
  ));
};

// src/widgets/ClientTeamViewer/ClientTeamViewerWidget.tsx
import * as React153 from "react";
var ClientTeamViewerWidget = ({ accountId }) => {
  useWidget("ic-client-team-viewer", "ic-v1");
  return /* @__PURE__ */ React153.createElement(NavigationCard, { title: "PCRU team", cardSize: "sm" }, /* @__PURE__ */ React153.createElement("ic-client-team-viewer", { "account-id": accountId }));
};

// src/widgets/SgwtAccountCenter.tsx
import * as React154 from "react";
import { getEnvironment as getEnvironment3 } from "@ic-anywhere/ic-utils";
import { noop as noop24 } from "lodash-es";
var SgwtAccountCenter = ({
  applicationId,
  impersonateAs,
  cancelImpersonate,
  availableLanguages = ["en"],
  currentLanguage = "en",
  onLanguageChanged = noop24
}) => {
  const isAccountCenterReadyEvent = "sgwt-account-center--ready";
  const currentEnv = getEnvironment3();
  const env = currentEnv === "production" ? void 0 : currentEnv;
  const [isReady, setIsReady] = React154.useState(false);
  const listeners = [
    { eventName: isAccountCenterReadyEvent, eventHandler: () => setIsReady(true) },
    {
      eventName: "sgwt-account-center--stop-navigation-as",
      eventHandler: cancelImpersonate != null ? cancelImpersonate : noop24
    },
    {
      eventName: "sgwt-account-center--language-changed",
      eventHandler: (event2) => {
        var _a;
        if ((_a = event2 == null ? void 0 : event2.detail) == null ? void 0 : _a.language) {
          onLanguageChanged(event2.detail.language);
        }
      }
    }
  ];
  const ref = useRefListeners(listeners);
  React154.useEffect(() => {
    handleIsReady();
  }, []);
  const handleIsReady = () => {
    const widget = document.querySelector("sgwt-account-center");
    if (widget) {
      if (typeof widget.setNavigateAsUser === "undefined" || typeof widget.stopNavigationAs === "undefined") {
        const handleWidgetReady = () => {
          setTimeout(() => setIsReady(true));
          widget.removeEventListener(isAccountCenterReadyEvent, handleWidgetReady);
        };
        widget.addEventListener(isAccountCenterReadyEvent, handleWidgetReady);
      } else {
        setTimeout(() => setIsReady(true));
      }
    }
  };
  React154.useEffect(() => {
    if (isReady && (ref == null ? void 0 : ref.current)) {
      const accountCenterInstance = ref.current;
      if (impersonateAs) {
        accountCenterInstance.setNavigateAsUser({
          mail: impersonateAs.email,
          name: impersonateAs.fullName
        });
      } else {
        accountCenterInstance.setNavigateAsUser(void 0);
      }
    }
  }, [impersonateAs, ref, isReady]);
  return /* @__PURE__ */ React154.createElement(
    "sgwt-account-center",
    {
      ref,
      id: applicationId,
      environment: env,
      mode: "sg-markets",
      debug: false,
      language: currentLanguage,
      authentication: "sg-connect-v2",
      "available-languages": availableLanguages.join(",")
    }
  );
};

// src/widgets/Tiering/TieringsSelect.tsx
import React155, { useEffect as useEffect49 } from "react";
import { find as find12 } from "lodash-es";
import { Select as Select13 } from "@sgbs-ui/core";
var tierings = [
  { name: "", id: "" },
  { name: "Tier-One", id: "true" },
  { name: "Standard", id: "false" }
];
var TieringsSelect = ({ selected, onChange, emitOnMount }) => {
  var _a;
  useEffect49(() => {
    if (emitOnMount) {
      onChange(selected);
    }
  }, [emitOnMount]);
  return /* @__PURE__ */ React155.createElement(
    Select13.SingleSelect,
    {
      items: tierings,
      idField: "id",
      labelField: "name",
      size: "md",
      selectedItem: (_a = find12(tierings, ({ id: id2 }) => id2 === selected)) != null ? _a : tierings[0],
      onChange: (item) => {
        var _a2;
        onChange((_a2 = item == null ? void 0 : item.id) != null ? _a2 : "");
      },
      noSearch: true,
      showClearButton: false
    }
  );
};

// src/contact/ContactEmails.tsx
import * as React158 from "react";
import { filter as filter10, isEmpty as isEmpty25, map as map25, noop as noop25 } from "lodash-es";

// src/contact/EmailLink.tsx
import * as React156 from "react";
var EmailLink = ({ email, className = "", onClick, type, children: children2 }) => /* @__PURE__ */ React156.createElement("a", { className: `${className} text-break`, onClick, href: `mailto:${email}` }, type === "button" ? children2 : email);

// src/contact/ContactEmails.tsx
import { useGetContactEmailsStatusQuery, useGetValidatorInfoQuery } from "@ic-anywhere/ic-dal";
import { toDisplayedDate as toDisplayedDate3 } from "@ic-anywhere/ic-utils";

// src/contact/CertifyEmailButton.tsx
import * as React157 from "react";
import { Button as Button9 } from "@sgbs-ui/core";
var CertifyEmailButton = ({ onclick }) => {
  return /* @__PURE__ */ React157.createElement(Button9, { className: "btn-outline-warning mt-2", btnType: "default", size: "lg", onClick: onclick }, /* @__PURE__ */ React157.createElement(Icon, { className: "text-warning", size: "lg", iconName: "verified_user" }), /* @__PURE__ */ React157.createElement("span", { className: "ml-3 text-warning" }, "Certify the email(s)"));
};

// src/contact/ContactEmails.tsx
import { Loader as Loader7 } from "@sgbs-ui/core";
var ContactEmails = ({
  contactId,
  onEmailClick,
  onCertifyEmailClick = noop25,
  contactRepo
}) => {
  const {
    data: emails,
    isLoading: isLoadingEmails,
    isError: isErrorEmails,
    error: errorEmails
  } = useGetContactEmailsStatusQuery(contactRepo, contactId);
  const {
    data: emailsWithValidators,
    isLoading: isLoadingValidator,
    isError: isErrorValidators,
    error: errorValidators
  } = useGetValidatorInfoQuery(contactRepo, emails);
  const isLoading = isLoadingEmails || isLoadingValidator;
  useQueryErrorHandler(isErrorEmails, errorEmails);
  useQueryErrorHandler(isErrorValidators, errorValidators);
  if (isLoading) {
    return /* @__PURE__ */ React158.createElement(Loader7, { isVisible: isLoading });
  }
  return /* @__PURE__ */ React158.createElement(React158.Fragment, null, map25(emailsWithValidators, ({ email: { personalEmailJustification, value }, validator }, index) => {
    return /* @__PURE__ */ React158.createElement(LabelValueComponent, { key: index, label: `Email` }, /* @__PURE__ */ React158.createElement("span", { className: "d-flew flex-row font-weight-500" }, /* @__PURE__ */ React158.createElement(
      EmailLink,
      {
        className: (personalEmailJustification == null ? void 0 : personalEmailJustification.expirationDate) ? "text-warning" : "",
        email: value != null ? value : "",
        onClick: onEmailClick
      }
    ), personalEmailJustification && validator && /* @__PURE__ */ React158.createElement("div", { className: "alert alert-outline-warning pr-3 mb-2" }, /* @__PURE__ */ React158.createElement(LabelValueComponent, { label: "Review date", childrenClassName: "text-primary" }, toDisplayedDate3(personalEmailJustification.date)), /* @__PURE__ */ React158.createElement(LabelValueComponent, { label: "Last reviewed by", childrenClassName: "text-primary" }, `${validator.fullName} - ${validator.internalHrTeam}`), /* @__PURE__ */ React158.createElement(LabelValueComponent, { label: "Business justification", childrenClassName: "text-primary" }, personalEmailJustification.name), /* @__PURE__ */ React158.createElement(LabelValueComponent, { label: "Valid until", childrenClassName: "text-primary" }, toDisplayedDate3(personalEmailJustification == null ? void 0 : personalEmailJustification.expirationDate)))));
  }), !isEmpty25(
    filter10(
      emails,
      (email) => {
        var _a;
        return (_a = email == null ? void 0 : email.allowedActions) == null ? void 0 : _a.includes("Certify");
      }
    )
  ) && /* @__PURE__ */ React158.createElement("div", { className: `d-flex mb-2` }, /* @__PURE__ */ React158.createElement("div", { className: "text-secondary", style: { minWidth: "150px" } }), /* @__PURE__ */ React158.createElement(CertifyEmailButton, { onclick: onCertifyEmailClick })));
};

// src/contact/ContactLinkedin.tsx
import * as React159 from "react";
var ContactLinkedin = ({ linkedin }) => linkedin ? /* @__PURE__ */ React159.createElement("div", { className: "row" }, /* @__PURE__ */ React159.createElement("span", { className: "text-secondary font-weight-500 col-auto" }, /* @__PURE__ */ React159.createElement("a", { href: linkedin, className: "mr-1", rel: "noreferrer", target: "_blank" }, "Linkedin profile"), /* @__PURE__ */ React159.createElement("em", { className: "icon" }, "launch"))) : null;

// src/contact/ContactPepSpo.tsx
import * as React160 from "react";
var ContactPepSpo = ({ isPepOrSpo }) => {
  return /* @__PURE__ */ React160.createElement(LabelValueComponent, { label: "PEP/SPO" }, /* @__PURE__ */ React160.createElement("span", null, isPepOrSpo === null || isPepOrSpo === void 0 ? "Unknown" : isPepOrSpo ? "Yes" : "No"));
};

// src/contact/ContactPhones.tsx
import { map as map26 } from "lodash-es";
import * as React162 from "react";

// src/contact/PhoneLink.tsx
import * as React161 from "react";
var PhoneLink = ({
  className = "",
  phone,
  phoneProtocol,
  type = "anchor",
  onClick,
  children: children2
}) => {
  const getUrl = (phone2) => phoneProtocol === "cisco" ? `dialto:${phone2}` : `tel:${phone2}`;
  return phone ? /* @__PURE__ */ React161.createElement("a", { className, onClick, href: getUrl(phone) }, type === "button" ? children2 : phone) : null;
};

// src/contact/ContactPhones.tsx
var ContactPhones = ({ phones, phoneProtocol, onPhoneClick }) => {
  return /* @__PURE__ */ React162.createElement(React162.Fragment, null, map26(phones, ({ phone, type }, index) => /* @__PURE__ */ React162.createElement(LabelValueComponent, { key: index, label: type }, /* @__PURE__ */ React162.createElement("span", { className: "font-weight-500" }, /* @__PURE__ */ React162.createElement(PhoneLink, { phone, phoneProtocol, onClick: onPhoneClick })))));
};

// src/contact/ContactNameRow.tsx
import * as React163 from "react";
import { Badge as Badge6 } from "@sgbs-ui/core";
var ContactNameRow = ({
  firstname = "",
  lastname = "",
  jobTitle = "",
  isRestricted,
  isInternal,
  onEdit
}) => {
  return /* @__PURE__ */ React163.createElement(React163.Fragment, null, /* @__PURE__ */ React163.createElement("div", { className: "d-flex align-items-center mb-2" }, /* @__PURE__ */ React163.createElement("span", { className: "display-3 mr-2 d-inline font-weight-bold" }, `${firstname} ${lastname}`, isInternal === false && /* @__PURE__ */ React163.createElement("i", { onClick: onEdit, className: "icon pl-2 icon-md", style: { cursor: "pointer" } }, "edit")), isRestricted && /* @__PURE__ */ React163.createElement(Badge6, { size: "lg", pill: true, badgeType: "discreet", text: "Restricted", closeIcon: "lock", closable: true })), /* @__PURE__ */ React163.createElement("span", { className: "font-weight-500 text-xxlarge" }, jobTitle));
};

// src/contact/ContactCoverage.tsx
import { Badge as Badge7, Highlight, SearchInput as SearchInput3 } from "@sgbs-ui/core";
import { isEmpty as isEmpty27, map as map28 } from "lodash-es";
import * as React165 from "react";
import { formatContactFullName, getShortPathTeam as getShortPathTeam3 } from "@ic-anywhere/ic-dal";

// src/contact/useDisplayCoverageLogic.ts
import {
  getShortPathTeam as getShortPathTeam2
} from "@ic-anywhere/ic-dal";
import * as React164 from "react";
import { filter as filter11, find as find13, isEmpty as isEmpty26, map as map27 } from "lodash-es";
import { isContainSubString as isContainSubString3, isStringEmpty as isStringEmpty7 } from "@ic-anywhere/ic-utils";
var filterCoverage = (coverageItems, term) => filter11(
  coverageItems,
  ({ coverage, interactions }) => isStringEmpty7(term) || isContainSubString3(coverage.lastname, term) || isContainSubString3(coverage.firstname, term) || isContainSubString3(getShortPathTeam2(coverage.team), term) || isContainSubString3(mapToCoverageInteractions(interactions), term)
);
var useDisplayCoverageLogic = (coverage, contactQualityView) => {
  const [searchTerm, setSearchTerm] = React164.useState("");
  const changeQuickSearchTerm = (term) => {
    setSearchTerm(term);
  };
  const coverageWithInteractions = mapCoverageToContactCoverageWithInteractions(coverage, contactQualityView);
  const displayedItems = filterCoverage(coverageWithInteractions, searchTerm);
  return { searchTerm, changeQuickSearchTerm, displayedItems };
};
var mapToCoverageInteractions = (interactions) => map27(interactions, (interaction) => interaction.name).join(", ");
var mapCoverageToContactCoverageWithInteractions = (coverages, contactQualityView) => map27(coverages, (c) => {
  var _a;
  return {
    coverage: c,
    interactions: !isEmpty26(contactQualityView) ? (_a = find13(contactQualityView == null ? void 0 : contactQualityView.dqOwners, (d) => d.contact.id === c.contactId)) == null ? void 0 : _a.interactions : []
  };
});

// src/contact/ContactCoverage.tsx
import { isStringEmpty as isStringEmpty8 } from "@ic-anywhere/ic-utils";
var ContactCoverage = ({
  coverage,
  errorMessage,
  isFetching,
  isInternal,
  contactQualityView,
  title,
  isDisplayActivities = true
}) => {
  const hasError = !isFetching && !isStringEmpty8(errorMessage);
  const noResult = !isFetching && isEmpty27(coverage);
  const hasResults = !isFetching && !isEmpty27(coverage);
  const displayRole = !isInternal && (contactQualityView == null ? void 0 : contactQualityView.dqOwners);
  const { searchTerm, changeQuickSearchTerm, displayedItems } = useDisplayCoverageLogic(coverage, contactQualityView);
  return /* @__PURE__ */ React165.createElement(NavigationCard, { title, height: 470 }, noResult && /* @__PURE__ */ React165.createElement(NoRecord, { reason: "There are no coverage for this contact.", icon: "info_outline" }), hasError && /* @__PURE__ */ React165.createElement("b", null, errorMessage), /* @__PURE__ */ React165.createElement(Loader, { isVisible: isFetching }), hasResults && /* @__PURE__ */ React165.createElement(React165.Fragment, null, /* @__PURE__ */ React165.createElement("div", { className: "col-12 col-lg-6 mb-2" }, /* @__PURE__ */ React165.createElement("div", { className: "row" }, /* @__PURE__ */ React165.createElement(SearchInput3, { placeholder: "Search by keyword", size: "lg", onChange: changeQuickSearchTerm }))), /* @__PURE__ */ React165.createElement("table", { className: "table table-fixed" }, /* @__PURE__ */ React165.createElement("thead", null, /* @__PURE__ */ React165.createElement("tr", null, /* @__PURE__ */ React165.createElement("th", null, "SG contact name"), /* @__PURE__ */ React165.createElement("th", null, "Business line"), displayRole && /* @__PURE__ */ React165.createElement("th", null, "Role"), isDisplayActivities && /* @__PURE__ */ React165.createElement("th", { className: "text-right" }, "Activities"))), /* @__PURE__ */ React165.createElement("tbody", null, map28(displayedItems, ({ coverage: coverage2, interactions }, index) => {
    var _a;
    return /* @__PURE__ */ React165.createElement("tr", { key: index }, /* @__PURE__ */ React165.createElement("td", null, /* @__PURE__ */ React165.createElement(
      Highlight,
      {
        term: [searchTerm],
        text: formatContactFullName(coverage2.firstname, coverage2.lastname),
        color: "info"
      }
    )), /* @__PURE__ */ React165.createElement("td", null, /* @__PURE__ */ React165.createElement(Highlight, { term: [searchTerm], text: getShortPathTeam3(coverage2.team), color: "info" })), displayRole && /* @__PURE__ */ React165.createElement("td", null, " ", mapToCoverageInteractions(interactions)), isDisplayActivities && /* @__PURE__ */ React165.createElement("td", { className: "text-right" }, /* @__PURE__ */ React165.createElement(Badge7, { text: (_a = coverage2.activities) == null ? void 0 : _a.toString(), pill: true, className: "badge-pill" })));
  })))));
};

// src/contact/ContactMultiWithCreate.tsx
import * as React166 from "react";
import { Modal as Modal3 } from "@sgbs-ui/core";
import { isEqual as isEqual5, map as map29 } from "lodash-es";
var ContactMultiWithCreate = ({
  accountId,
  selectedIds,
  onChange,
  onCreationError,
  onCreateLinkClicked,
  ...props
}) => {
  const [isShown, openModal, closeModal] = useModal();
  const [contactIds, setContactIds] = React166.useState([]);
  const handleOnCreate = (contact) => {
    if (contact && contact.id) {
      setContactIds([...contactIds, contact.id]);
      closeModal();
    }
  };
  const handleOnChange = (contacts) => {
    const ids = map29(contacts, ({ id: id2 }) => id2);
    setContactIds(ids);
    onChange == null ? void 0 : onChange(contacts);
  };
  React166.useEffect(() => {
    if (selectedIds && selectedIds.length && !isEqual5(selectedIds, contactIds)) {
      setContactIds(selectedIds);
    }
  }, [selectedIds]);
  return /* @__PURE__ */ React166.createElement("div", null, /* @__PURE__ */ React166.createElement(
    ContactMultiPickerWidget,
    {
      ...props,
      selectedIds: contactIds,
      createLinkMode: "emit",
      createActionText: "New Contact",
      onCreateLinkClicked: () => {
        openModal();
        onCreateLinkClicked == null ? void 0 : onCreateLinkClicked("");
      },
      onChange: handleOnChange
    }
  ), /* @__PURE__ */ React166.createElement(
    Modal3,
    {
      show: isShown,
      size: "xl",
      title: `Create contact`,
      onClose: closeModal,
      withActions: false,
      isScrollable: false,
      footerClassName: "p-0"
    },
    /* @__PURE__ */ React166.createElement(
      ContactCreatorWidget,
      {
        accountId,
        isShowCancel: true,
        onCreate: handleOnCreate,
        onCancel: closeModal,
        onError: onCreationError
      }
    )
  ));
};

// src/contact/ContactWithCreate.tsx
import * as React167 from "react";
import { Modal as Modal4 } from "@sgbs-ui/core";
var ContactWithCreate = ({
  accountId,
  selectedId,
  onChange,
  onCreationError,
  ...props
}) => {
  const [isShown, openModal, closeModal] = useModal();
  const [contactId, setContactId] = React167.useState();
  const handleOnCreate = (contact) => {
    if (contact && contact.id) {
      setContactId(contact.id);
      closeModal();
    }
  };
  const handleOnChange = (contact) => {
    if (contact) {
      setContactId(contact.id);
      onChange == null ? void 0 : onChange(contact);
    }
  };
  React167.useEffect(() => {
    if (selectedId) {
      setContactId(selectedId);
    }
  }, [selectedId]);
  return /* @__PURE__ */ React167.createElement("div", null, /* @__PURE__ */ React167.createElement(
    ContactPickerWidget,
    {
      ...props,
      selectedId: contactId,
      createLinkMode: "emit",
      createActionText: "New Contact",
      onCreateLinkClicked: openModal,
      onChange: handleOnChange,
      emitMode: "always"
    }
  ), /* @__PURE__ */ React167.createElement(
    Modal4,
    {
      show: isShown,
      size: "xl",
      title: `Create contact`,
      onClose: closeModal,
      withActions: false,
      isScrollable: false,
      footerClassName: "p-0"
    },
    /* @__PURE__ */ React167.createElement(
      ContactCreatorWidget,
      {
        accountId,
        isShowCancel: true,
        onCreate: handleOnCreate,
        onCancel: closeModal,
        onError: onCreationError
      }
    )
  ));
};

// src/contact/contactMifid/ContactMifid.tsx
import * as React172 from "react";
import { capitalize as capitalize4 } from "lodash-es";
import { isStringEmpty as isStringEmpty9 } from "@ic-anywhere/ic-utils";

// src/contact/contactMifid/compos/ContactMifidTooltip.tsx
import * as React168 from "react";
var ContactMifidTooltip = ({ content, placement = "top", id: id2 }) => {
  const tooltipId = useGenerateId(id2);
  if (!content) {
    return null;
  }
  return /* @__PURE__ */ React168.createElement(Tooltip, { id: `contact-mifid-info-${tooltipId}`, content, placement }, /* @__PURE__ */ React168.createElement("em", { className: "icon icon-sm text-secondary", style: { cursor: "pointer" } }, "info_outline"));
};

// src/contact/contactMifid/compos/ScopeModal.tsx
import * as React171 from "react";
import { Modal as Modal5 } from "@sgbs-ui/core";

// src/contact/contactMifid/compos/JustificationsPicker.tsx
import * as React169 from "react";
import { Select as Select14 } from "@sgbs-ui/core";
import { useMifidJustificationsQuery } from "@ic-anywhere/ic-dal";
import { find as find14 } from "lodash-es";
var MifidJustificationsPicker = ({
  id: id2,
  repo,
  size: size6 = "lg",
  disabled = false,
  selectedId,
  language = "en",
  placeholder = "Search justification",
  errorMessage,
  inError,
  top,
  onChange,
  onReady
}) => {
  var _a;
  React169.useEffect(() => {
    onReady == null ? void 0 : onReady();
  }, []);
  const pickerId = useGenerateId(id2);
  const {
    data: justifications,
    error: fetchError,
    isError: isFetchError
  } = useMifidJustificationsQuery(repo, language, true);
  const selectedItem = find14(justifications, ({ id: id3 }) => id3 === selectedId);
  return /* @__PURE__ */ React169.createElement(React169.Fragment, null, /* @__PURE__ */ React169.createElement(
    Select14.SingleSelect,
    {
      id: pickerId,
      items: justifications != null ? justifications : [],
      selectedItem: selectedItem != null ? selectedItem : null,
      idField: "id",
      labelField: "name",
      onChange,
      placeholder,
      size: size6,
      keepOrder: false,
      disabled,
      top
    }
  ), inError && /* @__PURE__ */ React169.createElement(InvalidFeedback, { errorMessage }), isFetchError && /* @__PURE__ */ React169.createElement(InvalidFeedback, { errorMessage: (_a = fetchError == null ? void 0 : fetchError.message) != null ? _a : void 0 }));
};

// src/contact/contactMifid/compos/ScopeStatus.tsx
import * as React170 from "react";
import { Radio as Radio2 } from "@sgbs-ui/core";
import { noop as noop26 } from "lodash-es";
import { Mifid2ResearchScopeEnum } from "@ic-anywhere/ic-dal";
var options = Mifid2ResearchScopeEnum.options;
var ScopeStatus = ({ selectedOption, onChange, className = "ml-2" }) => {
  return /* @__PURE__ */ React170.createElement("div", { className }, options.map((option) => /* @__PURE__ */ React170.createElement(
    Radio2,
    {
      key: option,
      text: option,
      value: option,
      onChange: (checked) => checked ? onChange(option) : noop26,
      checked: selectedOption === option
    }
  )));
};
var ScopeStatus_default = ScopeStatus;

// src/contact/contactMifid/utils.ts
var formatMessageCallBack2 = (message) => {
  var _a;
  return (_a = message.defaultMessage) != null ? _a : "";
};

// src/contact/contactMifid/compos/ScopeModal.tsx
var ScopeModal = ({
  show,
  sgmcRepo,
  language,
  mifid2Research,
  isLoading,
  formatMessage = formatMessageCallBack2,
  onClose,
  onConfirm
}) => {
  const [selectedStatus, setSelectedStatus] = React171.useState(mifid2Research == null ? void 0 : mifid2Research.scope);
  const [selectedJustificationId, setSelectedJustification] = React171.useState();
  const handleOnChangeJustification = (justification) => {
    setSelectedJustification(justification == null ? void 0 : justification.id);
  };
  const handleOnConfirm = () => {
    if (selectedStatus && selectedJustificationId !== void 0) {
      const payload = {
        mifid2Research: { scope: selectedStatus, justification: { id: selectedJustificationId } }
      };
      onConfirm == null ? void 0 : onConfirm(payload);
    }
  };
  const hasChanged = selectedStatus !== (mifid2Research == null ? void 0 : mifid2Research.scope);
  return show ? /* @__PURE__ */ React171.createElement(
    Modal5,
    {
      show: true,
      title: formatMessage({
        id: "mifid.contact.modal.title",
        defaultMessage: "MIFID 2 research status exemption"
      }),
      type: "warning",
      onClose,
      onConfirm: handleOnConfirm,
      isScrollable: true,
      isConfirmValid: hasChanged && selectedJustificationId !== void 0,
      footerClassName: "modal-footer px-4 py-2",
      cancelLabel: formatMessage({
        id: "global.cancel",
        defaultMessage: "Cancel"
      }),
      confirmLabel: formatMessage({
        id: "global.confirm",
        defaultMessage: "Confirm"
      }),
      size: "md",
      isLoading
    },
    /* @__PURE__ */ React171.createElement("div", null, /* @__PURE__ */ React171.createElement(
      AlertCustom,
      {
        color: "warning",
        content: /* @__PURE__ */ React171.createElement("div", { className: "d-flex justify-content-between align-items-center" }, /* @__PURE__ */ React171.createElement("em", { className: "ml-1 mr-2 icon icon-sm text-color-warning" }, "info_outline"), formatMessage({
          id: "mifid.contact.modal.alert",
          defaultMessage: "MIFID 2 research status are calculated based on regulatory criterias. You are about to override this status"
        })),
        outline: true
      }
    ), /* @__PURE__ */ React171.createElement(
      FormGroup,
      {
        label: formatMessage({
          id: "mifid.contact.modal.status",
          defaultMessage: "Status"
        })
      },
      /* @__PURE__ */ React171.createElement(ScopeStatus_default, { onChange: setSelectedStatus, selectedOption: selectedStatus, className: "ml-2" })
    ), hasChanged && /* @__PURE__ */ React171.createElement(
      FormGroup,
      {
        label: formatMessage({
          id: "mifid.contact.modal.justification",
          defaultMessage: "Please provide the proper justification to override this status"
        })
      },
      /* @__PURE__ */ React171.createElement(
        MifidJustificationsPicker,
        {
          onChange: handleOnChangeJustification,
          selectedId: selectedJustificationId,
          repo: sgmcRepo,
          language,
          placeholder: selectedJustificationId === void 0 ? formatMessage({
            id: "mifid.contact.modal.justification.placeholder",
            defaultMessage: "Search a justification"
          }) : "",
          top: true
        }
      )
    ))
  ) : null;
};
var ScopeModal_default = ScopeModal;

// src/contact/contactMifid/hooks/useContactMifid.ts
import {
  Mifid2ResearchScopeEnum as Mifid2ResearchScopeEnum2,
  useGetContactSgmcByIdQuery,
  useGetMifidContractUrlQuery,
  usePutContactSgmcMifidMutation
} from "@ic-anywhere/ic-dal";
import { lowerCase } from "lodash-es";
var MIFID_FIELDS = ["mifid2Research"];
var useContactMifid = (sgmcRepo, crmRepo, contactId, mifid2Research, onSuccess, onError) => {
  var _a;
  const [scopeModal, openScopeModal, closeScopeModal] = useModal();
  const { data: contact, isFetching: isFetchingMifid } = useGetContactSgmcByIdQuery(
    sgmcRepo,
    contactId,
    !mifid2Research && !!contactId,
    MIFID_FIELDS
  );
  const mifid2ResearchState = mifid2Research != null ? mifid2Research : contact == null ? void 0 : contact.mifid2Research;
  const { data: url, isFetching: isFetchingUrl } = useGetMifidContractUrlQuery(
    crmRepo,
    contactId,
    lowerCase(mifid2ResearchState == null ? void 0 : mifid2ResearchState.scope) === lowerCase(Mifid2ResearchScopeEnum2.enum["In scope"])
  );
  const { mutate: updateMifid, isLoading } = usePutContactSgmcMifidMutation(sgmcRepo, contactId, {
    onSuccess: () => handleOnUpdateMifid(),
    onError: (err) => handleOnErrorMifid(err)
  });
  const handleOnUpdateMifid = () => {
    closeScopeModal();
    onSuccess == null ? void 0 : onSuccess();
  };
  const handleOnErrorMifid = (err) => {
    closeScopeModal();
    onError == null ? void 0 : onError(err);
  };
  return {
    scopeModalShown: scopeModal,
    tooltipContent: !!((_a = mifid2ResearchState == null ? void 0 : mifid2ResearchState.justification) == null ? void 0 : _a.name) && !!(mifid2ResearchState == null ? void 0 : mifid2ResearchState.scope) ? mifid2ResearchState.justification.name : void 0,
    isFetching: isFetchingUrl || isFetchingMifid,
    isUpdating: isLoading,
    mifid2ResearchState,
    url: url && lowerCase(mifid2ResearchState == null ? void 0 : mifid2ResearchState.scope) === lowerCase(Mifid2ResearchScopeEnum2.enum["In scope"]) ? url : void 0,
    onEditScope: openScopeModal,
    onCancelEditScope: closeScopeModal,
    onConfirmEditScope: updateMifid
  };
};

// src/contact/contactMifid/ContactMifid.tsx
var ContactMifid = ({
  sgmcRepo,
  crmRepo,
  contactId,
  mifid2Research,
  language,
  fullbackStatus,
  canEdit,
  className = "d-flex align-items-center",
  formatMessage = formatMessageCallBack2,
  onSuccess,
  onError,
  openMifidContract,
  onConfirmUpdateMifidScore
}) => {
  var _a;
  const {
    isFetching,
    isUpdating,
    mifid2ResearchState,
    scopeModalShown,
    url,
    tooltipContent,
    onEditScope,
    onCancelEditScope,
    onConfirmEditScope
  } = useContactMifid(sgmcRepo, crmRepo, contactId, mifid2Research, onSuccess, onError);
  if (isFetching) {
    return /* @__PURE__ */ React172.createElement(Loader, null);
  }
  return mifid2ResearchState || !isStringEmpty9(fullbackStatus) ? /* @__PURE__ */ React172.createElement(React172.Fragment, null, /* @__PURE__ */ React172.createElement("div", { className }, /* @__PURE__ */ React172.createElement("span", { "data-testid": "mifid-status", className: `${url ? "font-weight-500" : ""}` }, capitalize4((_a = mifid2ResearchState == null ? void 0 : mifid2ResearchState.scope) != null ? _a : fullbackStatus)), tooltipContent && /* @__PURE__ */ React172.createElement(ContactMifidTooltip, { content: tooltipContent }), url && /* @__PURE__ */ React172.createElement(
    "a",
    {
      "data-testid": "mifid-link",
      href: url,
      className: "ml-2",
      rel: "noreferrer",
      target: "_blank",
      onClick: () => openMifidContract()
    },
    formatMessage({
      id: "mifid.contact.contract",
      defaultMessage: "Consult MIFID2 contract"
    }),
    /* @__PURE__ */ React172.createElement("em", { className: "icon" }, "launch")
  ), canEdit && /* @__PURE__ */ React172.createElement("i", { onClick: onEditScope, className: "icon px-1 icon-sm", style: { cursor: "pointer" } }, "edit")), scopeModalShown && mifid2ResearchState && /* @__PURE__ */ React172.createElement(
    ScopeModal_default,
    {
      sgmcRepo,
      show: true,
      language,
      mifid2Research: mifid2ResearchState,
      onClose: onCancelEditScope,
      onConfirm: (payload) => {
        onConfirmEditScope(payload);
        onConfirmUpdateMifidScore();
      },
      isLoading: isUpdating
    }
  )) : null;
};

// src/contact/contactIndicators/ContactIndicators.tsx
import * as React177 from "react";
import {
  useGetContactQualityIndicatorsQuery,
  useGetContactUsageIndicatorsQuery
} from "@ic-anywhere/ic-dal";

// src/contact/contactIndicators/ContactIndicatorsTooltip.tsx
import * as React176 from "react";

// src/contact/contactIndicators/ContactIndicatorsHeader.tsx
import * as React173 from "react";

// src/contact/contactIndicators/contactIndicators.mapper.ts
import { displayDate } from "@ic-anywhere/ic-utils";
import { compact as compact3, map as map30 } from "lodash-es";
var mapToIndicatorValidityType = (isValid) => isValid ? "Good" : "Bad";
var mapQualityIndicators = (contactQuality) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const emailIndicators = ((_a = contactQuality.inconsistencyReasons) == null ? void 0 : _a.length) > 0 && contactQuality.quality === "Bad" ? map30(contactQuality.inconsistencyReasons, (reason) => ({ name: `- ${reason}` })) : [];
  return compact3([
    {
      name: "SG contacts",
      value: (_d = (_c = (_b = contactQuality.dqOwners) == null ? void 0 : _b.length) == null ? void 0 : _c.toString()) != null ? _d : "0"
    },
    ((_f = (_e = contactQuality.indicators) == null ? void 0 : _e.lastEmailCheck) == null ? void 0 : _f.date) ? {
      name: "Email checked",
      value: displayDate((_h = (_g = contactQuality.indicators) == null ? void 0 : _g.lastEmailCheck) == null ? void 0 : _h.date)
    } : void 0,
    contactQuality.quality === "Bad" || contactQuality.quality === "Unknown" ? {
      name: contactQuality.quality === "Unknown" ? "Email quality unknown" : "Email in error"
    } : void 0,
    ...emailIndicators
  ]);
};
var mapUsageIndicators = (contactUsageIndicators) => compact3([
  contactUsageIndicators.mandatesCount !== void 0 ? { name: "Mandates", value: contactUsageIndicators.mandatesCount.toString() } : void 0,
  {
    name: contactUsageIndicators.lastConnectionDate ? "Last connection to SG Markets" : "No connection to SG Markets < 1 year",
    value: contactUsageIndicators.lastConnectionDate && displayDate(contactUsageIndicators.lastConnectionDate)
  },
  {
    name: contactUsageIndicators.lastActivityDate ? "Last commercial activities" : "No commercial activities < 2 years",
    value: contactUsageIndicators.lastActivityDate && displayDate(contactUsageIndicators.lastActivityDate)
  }
]);
var getGlobalValidity = (qualityValidity, hasUsage) => {
  if (qualityValidity === "Good" && hasUsage) {
    return "Good";
  } else if (qualityValidity === "Good" || qualityValidity === "Unknown") {
    return "Unknown";
  }
  return "Bad";
};
var getQualityIndicators = (contactQuality, contactUsageIndicators) => {
  const globalValidity = contactUsageIndicators ? getGlobalValidity(contactQuality.quality, contactUsageIndicators == null ? void 0 : contactUsageIndicators.usage) : contactQuality.quality;
  return {
    globalValidity,
    qualityValidity: contactQuality.quality,
    usageValidity: contactUsageIndicators && mapToIndicatorValidityType(contactUsageIndicators == null ? void 0 : contactUsageIndicators.usage),
    qualityIndicators: mapQualityIndicators(contactQuality),
    usageIndicators: contactUsageIndicators && mapUsageIndicators(contactUsageIndicators)
  };
};
var mapToQualityIndicatorIconColor = (qualityIndicatorValidity, validLabel, invalidLabel, unknownLabel) => {
  switch (qualityIndicatorValidity) {
    case "Good":
      return { color: "text-success", icon: "expand_circle_down", label: validLabel };
    case "Unknown":
      return { color: "text-warning", icon: "error", label: unknownLabel };
    case "Bad":
      return { color: "text-danger", icon: "cancel", label: invalidLabel };
    default:
      return { label: validLabel };
  }
};

// src/contact/contactIndicators/ContactIndicatorsHeader.tsx
var ContactIndicatorsHeader = ({ validity, label }) => {
  const { color, icon } = mapToQualityIndicatorIconColor(validity);
  return /* @__PURE__ */ React173.createElement("span", { className: `ml-1 ${color}` }, /* @__PURE__ */ React173.createElement("em", { className: "icon icon-md mx-1" }, icon), label);
};

// src/contact/contactIndicators/ContactIndicatorsBody.tsx
import * as React175 from "react";

// src/contact/contactIndicators/ContactIndicatorsRow.tsx
import * as React174 from "react";
var ContactIndicatorsRow = ({
  qualityIndicatorValidity,
  qualityIndicatorName,
  qualityIndicatorValue
}) => {
  const qualityIndicator = qualityIndicatorValue ? `- ${qualityIndicatorValue}` : "";
  const { color } = mapToQualityIndicatorIconColor(qualityIndicatorValidity);
  return /* @__PURE__ */ React174.createElement("div", { className: "d-flex align-items-center" }, color && /* @__PURE__ */ React174.createElement("em", { className: `icon icon-sm mr-2 ${color}` }, "brightness_1"), /* @__PURE__ */ React174.createElement("span", { className: "text-wrap" }, `${qualityIndicatorName} ${qualityIndicator}`));
};

// src/contact/contactIndicators/ContactIndicatorsBody.tsx
var ContactIndicatorsBody = ({ indicators }) => /* @__PURE__ */ React175.createElement(React175.Fragment, null, indicators.map((indicator) => /* @__PURE__ */ React175.createElement(
  ContactIndicatorsRow,
  {
    key: indicator.name,
    qualityIndicatorValidity: indicator.validity,
    qualityIndicatorName: indicator.name,
    qualityIndicatorValue: indicator.value
  }
)));

// src/contact/contactIndicators/ContactIndicatorsTooltip.tsx
import { displayDate as displayDate2 } from "@ic-anywhere/ic-utils";
var ContactIndicatorsTooltip = ({
  contactQualityIndicators,
  contactUsageIndicators,
  id: id2,
  displayMode = "both",
  placement = "right",
  className = "",
  onAfterShow,
  onHover,
  validityType
}) => {
  var _a;
  const tooltipId = useGenerateId(id2);
  const allQualityIndicators = contactQualityIndicators ? getQualityIndicators(contactQualityIndicators, contactUsageIndicators) : null;
  const { color, label } = mapToQualityIndicatorIconColor(
    (_a = allQualityIndicators == null ? void 0 : allQualityIndicators.globalValidity) != null ? _a : validityType,
    "Good",
    "Bad",
    "Medium"
  );
  const renderContactQuality = () => {
    var _a2, _b, _c, _d;
    if (!allQualityIndicators) {
      return /* @__PURE__ */ React176.createElement("div", null);
    }
    const { qualityValidity, usageValidity, qualityIndicators, usageIndicators } = allQualityIndicators;
    return /* @__PURE__ */ React176.createElement(React176.Fragment, null, /* @__PURE__ */ React176.createElement("div", null, "Quality indicator refreshed daily"), /* @__PURE__ */ React176.createElement("div", { className: "mt-1" }, `Contact last updated on ${((_b = (_a2 = contactQualityIndicators == null ? void 0 : contactQualityIndicators.indicators) == null ? void 0 : _a2.edition) == null ? void 0 : _b.date) ? displayDate2((_d = (_c = contactQualityIndicators.indicators) == null ? void 0 : _c.edition) == null ? void 0 : _d.date) : "unknown"}`), /* @__PURE__ */ React176.createElement("div", { className: `${usageIndicators ? "row" : ""} mt-3` }, /* @__PURE__ */ React176.createElement("div", { className: "pl-2" }, /* @__PURE__ */ React176.createElement("h6", { className: "font-weight-normal d-flex justify-content-around" }, /* @__PURE__ */ React176.createElement(ContactIndicatorsHeader, { validity: qualityValidity, label: "Quality" })), /* @__PURE__ */ React176.createElement("ul", { className: "d-block list-unstyled" }, /* @__PURE__ */ React176.createElement(ContactIndicatorsBody, { indicators: qualityIndicators }))), usageIndicators && usageValidity && /* @__PURE__ */ React176.createElement("div", { className: "border-left border-white mx-3 pl-3" }, /* @__PURE__ */ React176.createElement("h6", { className: "font-weight-normal d-flex justify-content-around" }, /* @__PURE__ */ React176.createElement(ContactIndicatorsHeader, { validity: usageValidity, label: "Usage" })), /* @__PURE__ */ React176.createElement("ul", { className: "d-block list-unstyled" }, /* @__PURE__ */ React176.createElement(ContactIndicatorsBody, { indicators: usageIndicators })))));
  };
  return /* @__PURE__ */ React176.createElement(
    Tooltip,
    {
      id: tooltipId,
      effect: "float",
      placement: "right",
      content: renderContactQuality(),
      onAfterShow,
      delayShow: 200
    },
    /* @__PURE__ */ React176.createElement("div", { className }, /* @__PURE__ */ React176.createElement(
      "span",
      {
        onMouseEnter: onHover,
        "data-place": placement,
        className: "d-inline-flex align-items-center",
        "data-tip": "",
        "data-for": tooltipId
      },
      displayMode !== "text" && /* @__PURE__ */ React176.createElement("em", { className: `mr-1 display-3 pointer icon icon-sm ${color}` }, "brightness_1"),
      displayMode !== "image" && /* @__PURE__ */ React176.createElement("span", { className: "pointer" }, label)
    ))
  );
};

// src/contact/contactIndicators/ContactIndicators.tsx
import Skeleton from "react-loading-skeleton";
var ContactIndicators = ({
  crmRepo,
  sgmcRepo,
  id: id2,
  contactId,
  displayMode = "both",
  placement = "right",
  className = "",
  contactOnly = false,
  onAfterShow,
  validityType,
  fetchOnHover = false
}) => {
  const [isHoverDone, setIsHoverDone] = React177.useState(false);
  const enabled = fetchOnHover && isHoverDone || !fetchOnHover;
  const { data: contactQualityIndicators, isFetching: isLoadingQualityIndicators } = useGetContactQualityIndicatorsQuery(sgmcRepo, contactId, enabled);
  const { data: contactUsageIndicators, isFetching: isLoadingUsageIndicators } = useGetContactUsageIndicatorsQuery(
    crmRepo,
    contactId,
    !contactOnly && enabled
  );
  const isLoading = isLoadingQualityIndicators || isLoadingUsageIndicators;
  return /* @__PURE__ */ React177.createElement(React177.Fragment, null, isLoading && !fetchOnHover && /* @__PURE__ */ React177.createElement("div", { className }, /* @__PURE__ */ React177.createElement(Skeleton, { className: "mr-1", height: 18, width: 18, circle: true })), (fetchOnHover && validityType || contactQualityIndicators && (contactUsageIndicators || contactOnly)) && /* @__PURE__ */ React177.createElement(
    ContactIndicatorsTooltip,
    {
      validityType,
      contactQualityIndicators,
      contactUsageIndicators,
      displayMode,
      placement,
      className,
      id: id2,
      onHover: () => setIsHoverDone(true),
      onAfterShow
    }
  ));
};

// src/mifid/MifidClientStatus.tsx
import * as React178 from "react";
var MifidClientStatus = ({ url }) => {
  return /* @__PURE__ */ React178.createElement(React178.Fragment, null, /* @__PURE__ */ React178.createElement(LabelValueComponent, { label: "MIFID2 research" }, /* @__PURE__ */ React178.createElement("a", { "data-testid": "mifid-link", href: url, rel: "noreferrer", target: "_blank" }, "Consult MIFID2 contract ", /* @__PURE__ */ React178.createElement("em", { className: "icon" }, "launch"))));
};

// src/segmentation/SegmentationList.tsx
import { isEmpty as isEmpty28 } from "lodash-es";
import * as React179 from "react";
var SegmentationList = ({ segmentationList, size: size6 = "md", height }) => {
  return /* @__PURE__ */ React179.createElement(NavigationCard, { cardSize: size6, title: "Segmentations", height }, /* @__PURE__ */ React179.createElement("div", { className: "container" }, isEmpty28(segmentationList) ? /* @__PURE__ */ React179.createElement(NoRecord, { reason: "No segmentation list for this account", icon: "info_outline", isSmall: size6 === "sm" }) : segmentationList.map((segmentation, index) => /* @__PURE__ */ React179.createElement("div", { key: index, className: "row flex-wrap mb-1" }, /* @__PURE__ */ React179.createElement("div", { className: "text-secondary col-6" }, segmentation.listName), /* @__PURE__ */ React179.createElement("div", { className: "col-6" }, segmentation.levelName)))));
};

// src/events/EventPicker.tsx
import { Select as Select15 } from "@sgbs-ui/core";
import * as React180 from "react";
import { useSearchEvents } from "@ic-anywhere/ic-dal";
var EventPicker = ({ repository, selectedItem, onChange, placeholder, size: size6 }) => {
  const [searchTerm, setSearchTerm] = React180.useState("");
  const { data: data2 = [], isLoading, isError } = useSearchEvents(repository, searchTerm);
  return /* @__PURE__ */ React180.createElement(
    Select15.AsyncSingleSelect,
    {
      size: size6 != null ? size6 : "lg",
      selectedItem,
      items: data2,
      idField: "id",
      labelField: "name",
      onChange,
      placeholder: placeholder != null ? placeholder : "Start typing event's name...",
      onTermChange: setSearchTerm,
      showToggleButton: true,
      inError: isError,
      isLoading,
      showClearButton: true
    }
  );
};

// src/events/FeedbackView.tsx
import { formatTitleDate, jsDateFromIso } from "@ic-anywhere/ic-utils";
import { Button as Button10 } from "@sgbs-ui/core";
import { map as map31 } from "lodash-es";
import * as React181 from "react";
var FeedbackView = ({ feedbacks, period, eventName, onClickPrint }) => {
  const logoSg = "https://ic-statics.sgmarkets.com/images/socgen_logo_full.svg";
  return /* @__PURE__ */ React181.createElement("div", { className: "container" }, /* @__PURE__ */ React181.createElement("div", { className: "col-auto align-self-center d-print-none" }, /* @__PURE__ */ React181.createElement(
    Button10,
    {
      text: "Print",
      size: "lg",
      btnType: "default",
      onClick: onClickPrint,
      className: "float-right mt-2 d-md-inline d-none"
    }
  ), /* @__PURE__ */ React181.createElement("div", { className: "d-flex flex-row-reverse d-md-none" }, /* @__PURE__ */ React181.createElement(Button10, { icon: "print", size: "lg", btnType: "default", onClick: onClickPrint, className: "mt-2" }))), /* @__PURE__ */ React181.createElement("div", { className: "mb-5 print-only" }, /* @__PURE__ */ React181.createElement("img", { src: logoSg, alt: "logo_full_sg", height: "40" })), /* @__PURE__ */ React181.createElement("div", { className: "row mt-2" }, /* @__PURE__ */ React181.createElement("div", { className: "col-lg-10 col-xl-8" }, /* @__PURE__ */ React181.createElement("h1", { className: "feedbackTitle mb-4 mt-4 font-weight-medium d-none d-md-block" }, "Feedback Report"), /* @__PURE__ */ React181.createElement("h2", { className: "feedbackTitle mb-3 font-weight-medium print-only" }, eventName), /* @__PURE__ */ React181.createElement("div", null, /* @__PURE__ */ React181.createElement("h5", { className: "pb-4 mb-4 pt-2 d-none d-md-block" }, formatTitleDate(jsDateFromIso(period.startDate), jsDateFromIso(period.endDate))), map31(
    feedbacks.filter((f2) => f2.feedback),
    ({ feedback, slotType }, index) => /* @__PURE__ */ React181.createElement("div", { key: index, className: "mb-4 border-top feedback" }, /* @__PURE__ */ React181.createElement("h5", { className: "card-title font-weight-medium mb-4 title pt-4" }, `Investor ${index + 1} - ${slotType}`), feedback && /* @__PURE__ */ React181.createElement(HtmlSanitizer, { content: feedback.description }))
  )))));
};

// src/actionPlans/ActionPlanPicker.tsx
import { Select as Select16 } from "@sgbs-ui/core";
import * as React182 from "react";
import { mapToRelatedAccountsName, useSearchActionPlans } from "@ic-anywhere/ic-dal";
import { find as find15, flatten as flatten3, map as map32, noop as noop27, size as _size3 } from "lodash-es";
var itemRenderer = (item) => {
  return /* @__PURE__ */ React182.createElement("div", null, item == null ? void 0 : item.subject, /* @__PURE__ */ React182.createElement("span", { className: "font-weight-normal text-secondary" }, " \u2022 ", mapToRelatedAccountsName(item == null ? void 0 : item.relatedToAccounts)));
};
var ActionPlanPicker = ({
  repository,
  selectedId,
  accountId,
  onChange,
  placeholder,
  size: size6,
  creationAction,
  readOnly
}) => {
  var _a;
  const [initialized, setInitialized] = React182.useState(false);
  const { data: data2, isError, hasNextPage, fetchNextPage } = useSearchActionPlans(repository, { accountId });
  const nbPages = _size3(data2 == null ? void 0 : data2.pages);
  React182.useEffect(() => {
    if (nbPages > 0 && hasNextPage) {
      fetchNextPage();
    }
  }, [nbPages, hasNextPage]);
  const actionPlans = flatten3(map32(data2 == null ? void 0 : data2.pages, (page) => page.actionPlans));
  const selectedActionPlan = (_a = find15(actionPlans, (ap) => ap.id === selectedId)) != null ? _a : null;
  React182.useEffect(() => {
    if (!initialized && selectedActionPlan) {
      setInitialized(true);
      onChange(selectedActionPlan);
    }
  }, [onChange, selectedActionPlan]);
  const canCreate = !!creationAction;
  return /* @__PURE__ */ React182.createElement(React182.Fragment, null, /* @__PURE__ */ React182.createElement(
    Select16.SingleSelect,
    {
      size: size6 != null ? size6 : "md",
      selectedItem: selectedActionPlan != null ? selectedActionPlan : null,
      items: actionPlans,
      idField: "id",
      labelField: "subject",
      onChange,
      placeholder: placeholder != null ? placeholder : "Start typing action plan's name...",
      inError: isError,
      showToggleButton: true,
      showClearButton: true,
      showCreateAction: true,
      onCreatClick: canCreate ? creationAction.onCreateClick : noop27,
      createActionText: canCreate ? "Create new" : void 0,
      readOnlyItems: readOnly && selectedActionPlan ? [selectedActionPlan] : []
    },
    itemRenderer
  ), canCreate && /* @__PURE__ */ React182.createElement(React182.Fragment, null, creationAction.creationComponent));
};

// src/rum/useRum.ts
import { init as initApm } from "@elastic/apm-rum";
import { SERVICE_URLS, getServiceUrlsByEnv, iCUrlMappingConfig } from "@ic-anywhere/ic-dal";
import { getEnvironment as getEnvironment4 } from "@ic-anywhere/ic-utils";
import * as React183 from "react";
function configureUserContext(apm, user) {
  if (user) {
    const { id: id2, userEmail } = user;
    apm.setUserContext({ id: id2, email: userEmail });
  }
}
function configureHttpRequestGrouping(apm, env, isInLan = false, serviceUrls = SERVICE_URLS) {
  apm.getCurrentTransaction();
  apm.observe("transaction:end", function(transaction) {
    if (transaction.type === "http-request") {
      const urlsByEnv = getServiceUrlsByEnv(env, false, isInLan, serviceUrls);
      const transactionUrl = urlsByEnv.find((url) => transaction.name.includes(url));
      transaction.name = formatUrl(transaction.name, transactionUrl);
    }
  });
}
function formatUrl(transactionName, transactionUrl) {
  var _a, _b;
  if (!transactionUrl) {
    return transactionName;
  }
  const httpMethod = transactionName.split(" ")[0];
  const apiPrefix = (_b = (_a = iCUrlMappingConfig.urlGatewayRules.find((rule) => transactionName.includes(rule.path))) == null ? void 0 : _a.path.replace(/\/$/, "")) != null ? _b : "";
  const apiUrl = transactionName.replace(transactionUrl, "").replace(apiPrefix, "").split("/")[1];
  return `${httpMethod} ${apiPrefix}/${apiUrl}`;
}
function useRum(configurator, user, enable = true, isInLan = false, serviceUrls = SERVICE_URLS) {
  const env = getEnvironment4();
  React183.useEffect(() => {
    if (enable && !!user) {
      const apm = initApm(configurator(env, isInLan));
      configureUserContext(apm, user);
      configureHttpRequestGrouping(apm, env, isInLan, serviceUrls);
    }
  }, [configurator, user, enable, env, isInLan, serviceUrls]);
}

// src/rum/rumService.ts
var getApmEnvUrlForRum = (env) => {
  switch (env) {
    case "production":
      return {
        serverUrl: "https://t-monitoring-rum.sgmarkets.com/rum/3d90e1e516e94cffbc053629b4ca2ddc",
        environment: "PROD"
      };
    case "iso":
      return {
        serverUrl: "https://t-monitoring-rum-uat.sgmarkets.com/rum/8b599b00c3de465688ea9d171942f4d6",
        environment: "ISO"
      };
    case "homologation":
      return {
        serverUrl: "https://t-monitoring-rum-uat.sgmarkets.com/rum/8b599b00c3de465688ea9d171942f4d6",
        environment: "HOM"
      };
    default:
      return {
        serverUrl: "https://t-monitoring-rum-uat.sgmarkets.com/rum/8b599b00c3de465688ea9d171942f4d6",
        environment: "DEV"
      };
  }
};

// src/activities/activities.constants.ts
var typeToLabelValueActivityDictionary = {
  event: { value: "Event", type: "faded-jade" },
  note: { value: "Note", type: "cornflower-blue" },
  meeting: { value: "Meeting", type: "apricot" },
  email: { value: "Email", type: "spicy-mix" },
  deal: { value: "Deal", type: "royal-blue" },
  actionPlan: { value: "Action plan", type: "victoria" },
  feedback: { value: "Feedback", type: "manatee" }
};

// src/activities/LastActivities.tsx
import React186 from "react";

// src/activities/ActivityTimeline.tsx
import { camelCase } from "lodash-es";
import React184 from "react";
var getTypeColor = (type) => {
  var _a;
  const key = camelCase(type);
  return (_a = typeToLabelValueActivityDictionary[key]) == null ? void 0 : _a.type;
};
var ActivityTimeline = ({
  activities,
  onClick,
  onAuthorNameClick,
  onAccountNameClick
}) => /* @__PURE__ */ React184.createElement("ul", { className: "sgbs-timeline sgbs-timeline-vertical align-items-start" }, activities.map((item) => {
  var _a, _b, _c, _d, _e, _f;
  return /* @__PURE__ */ React184.createElement("li", { className: "sgbs-timeline-item", key: item.activity.activityId }, /* @__PURE__ */ React184.createElement("span", { className: "sgbs-timeline-day" }, " ", (_a = item.date) == null ? void 0 : _a.year, " "), /* @__PURE__ */ React184.createElement(
    "div",
    {
      className: "d-flex flex-row flex-wrap align-items-center mb-2 action",
      onClick: () => onClick == null ? void 0 : onClick(item.activity)
    },
    /* @__PURE__ */ React184.createElement("span", { className: "sgbs-timeline-date display-4 mr-2 action" }, (_b = item.date) == null ? void 0 : _b.day, " ", (_c = item.date) == null ? void 0 : _c.month),
    /* @__PURE__ */ React184.createElement(
      "span",
      {
        className: `badge badge-prepend-square badge-discreet-${getTypeColor(
          item.activity.type
        )} text-small mr-2 action`
      },
      item.activity.type,
      !!item.activity.subType && /* @__PURE__ */ React184.createElement("span", { className: "mx-1 text-small" }, "\u2022"),
      item.activity.subType
    )
  ), /* @__PURE__ */ React184.createElement("div", { className: "d-flex flex-row flex-wrap align-items-center mb-2" }, /* @__PURE__ */ React184.createElement("h6", { className: "m-0" }, /* @__PURE__ */ React184.createElement(
    "a",
    {
      href: "",
      className: "text-primary",
      onClick: (event2) => {
        event2.preventDefault();
        onAccountNameClick == null ? void 0 : onAccountNameClick({ accountId: item.account.id });
      }
    },
    item.account.name,
    " (",
    item.account.level,
    ") ",
    item.account.countryIso3
  ), /* @__PURE__ */ React184.createElement("span", { className: "mx-1 font-weight-bold" }, "\u2022"), /* @__PURE__ */ React184.createElement(
    "a",
    {
      href: "#",
      className: "text-primary",
      onClick: (event2) => {
        event2.preventDefault();
        onClick == null ? void 0 : onClick(item.activity);
      }
    },
    item.activity.isRestricted ? /* @__PURE__ */ React184.createElement("span", { className: "" }, "Private content ", /* @__PURE__ */ React184.createElement("em", { className: "icon icon-md mr-3 mb-1" }, "lock")) : item.title
  ))), /* @__PURE__ */ React184.createElement("div", { className: "mb-2" }, /* @__PURE__ */ React184.createElement("span", { className: "text-secondary text-small" }, "By", " ", /* @__PURE__ */ React184.createElement(
    "a",
    {
      href: "#",
      className: "font-weight-medium",
      onClick: (event2) => {
        event2.preventDefault();
        onAuthorNameClick == null ? void 0 : onAuthorNameClick({ contactId: item.author.id });
      }
    },
    (_d = item.author) == null ? void 0 : _d.firstName,
    " ",
    (_e = item.author) == null ? void 0 : _e.lastName
  ), " ", /* @__PURE__ */ React184.createElement("span", null, "(", (_f = item.author) == null ? void 0 : _f.team, ")"))), /* @__PURE__ */ React184.createElement("div", { className: "mb-5" }, /* @__PURE__ */ React184.createElement("p", { className: "text-small" }, item.description)));
}));
var ActivityTimeline_default = ActivityTimeline;

// src/activities/LastActivities.tsx
import { isEmpty as isEmpty29 } from "lodash-es";
import {
  DEFAULT_ACTIVITIES_PARAMS,
  useGetContactSgmcByIdQuery as useGetContactSgmcByIdQuery2,
  useGetLastActivitiesQuery
} from "@ic-anywhere/ic-dal";

// src/activities/activities.mapper.ts
import { find as find16, head as head2, map as map33 } from "lodash-es";
var mapToActivities = (activities, accountId) => {
  return map33(activities, (activity) => {
    var _a, _b, _c, _d;
    const activityDate = new Date(activity.activityDate);
    const account = find16(activity.accounts, ({ id: id2 }) => id2 === accountId);
    const accountActivity = account != null ? account : head2(activity.accounts);
    return {
      account: {
        id: (_a = accountActivity == null ? void 0 : accountActivity.id) != null ? _a : "",
        name: (_b = accountActivity == null ? void 0 : accountActivity.name) != null ? _b : "",
        level: (_c = accountActivity == null ? void 0 : accountActivity.level) != null ? _c : "",
        countryIso3: (_d = accountActivity == null ? void 0 : accountActivity.countryId) != null ? _d : ""
      },
      author: activity.author,
      title: activity.title,
      description: activity.contentSummary,
      activity: {
        activityId: activity.id,
        type: activity.type,
        subType: activity.subType,
        isRestricted: activity.isRestricted,
        parentActivityId: activity.parentId
      },
      date: {
        year: activityDate.getFullYear(),
        month: activityDate.toLocaleDateString("en-En", { month: "short" }).toString(),
        day: activityDate.toLocaleDateString("en-En", { day: "2-digit" }).toString()
      }
    };
  });
};

// src/activities/LastActivities.tsx
import { Loader as Loader8 } from "@sgbs-ui/core";

// src/activities/ActivityEmpty.tsx
import * as React185 from "react";
var ActivityEmpty = ({ isContact }) => /* @__PURE__ */ React185.createElement("div", { className: "container text-center text-secondary my-5" }, /* @__PURE__ */ React185.createElement("div", { className: "mb-2" }, /* @__PURE__ */ React185.createElement("i", { className: "icon  icon-xl", "data-e2e": "" }, "info_outline")), /* @__PURE__ */ React185.createElement("div", null, /* @__PURE__ */ React185.createElement("p", { className: "m-0" }, `There is no activity for this ${isContact ? "contact" : "account"} yet.`), /* @__PURE__ */ React185.createElement("p", { className: "m-0" }, "Create a new one and it will show up here.")));
var ActivityEmpty_default = ActivityEmpty;

// src/activities/LastActivities.tsx
var LastActivities = ({
  sgmcRepo,
  crmRepo,
  accountId,
  startDate,
  endDate,
  mainEmail,
  contactId,
  activitiesCount,
  activitiesTypes,
  onClick,
  onAuthorNameClick,
  onAccountNameClick,
  onError,
  onReady,
  hashtags
}) => {
  const { data: contact, isFetching: isFetchingContact } = useGetContactSgmcByIdQuery2(sgmcRepo, contactId, true, [
    "account"
  ]);
  const pageSize = activitiesCount != null ? activitiesCount : DEFAULT_ACTIVITIES_PARAMS.pageSize;
  const params = {
    ...DEFAULT_ACTIVITIES_PARAMS,
    accountIds: accountId,
    inheritOnAccount: !contactId,
    participantIds: contactId,
    types: activitiesTypes != null ? activitiesTypes : DEFAULT_ACTIVITIES_PARAMS.types,
    startDate,
    endDate,
    mainEmail,
    pageSize,
    hashtags
  };
  const {
    data: activitiesDTO,
    error,
    isFetching: isFetchingActivities
  } = useGetLastActivitiesQuery(
    crmRepo,
    {
      enabled: !!contact || !contactId,
      onSuccess: onReady,
      onError: (err) => onError == null ? void 0 : onError({ errorMessage: err.message })
    },
    params
  );
  const data2 = mapToActivities(activitiesDTO != null ? activitiesDTO : []);
  if (error) {
    const msg = error ? `(${error.message})` : "";
    return /* @__PURE__ */ React186.createElement("div", { className: "p-2" }, `Error while fetching activities ${msg}`);
  }
  if (isFetchingContact || isFetchingActivities) {
    return /* @__PURE__ */ React186.createElement("div", { className: "p-2" }, /* @__PURE__ */ React186.createElement(Loader8, { isVisible: true }));
  }
  if (!data2.length) {
    return /* @__PURE__ */ React186.createElement(ActivityEmpty_default, { isContact: !isEmpty29(contactId) });
  }
  return /* @__PURE__ */ React186.createElement(
    ActivityTimeline_default,
    {
      activities: data2,
      onClick,
      onAuthorNameClick,
      onAccountNameClick
    }
  );
};

// src/topSales/TopSales.tsx
import { useGetTopSales } from "@ic-anywhere/ic-dal";
import { Loader as Loader9 } from "@sgbs-ui/core";
import { isEmpty as isEmpty30, map as map34 } from "lodash-es";
import * as React187 from "react";
var TopSales = ({ repo, accountId }) => {
  const { data: topSales, isFetching, error } = useGetTopSales(repo, accountId);
  if (error) {
    return /* @__PURE__ */ React187.createElement(NavigationCard, { title: "Top iC contributors last 12 months", cardSize: "sm" }, /* @__PURE__ */ React187.createElement(
      NoRecord,
      {
        icon: "info_outline",
        message: "We are sorry, but we couldn't find the requested data. Please try again later."
      }
    ));
  }
  return /* @__PURE__ */ React187.createElement(React187.Fragment, null, isFetching ? /* @__PURE__ */ React187.createElement(Loader9, { isVisible: isFetching }) : /* @__PURE__ */ React187.createElement(NavigationCard, { title: "Top iC contributors last 12 months", cardSize: "sm" }, /* @__PURE__ */ React187.createElement("div", { className: "col" }, isEmpty30(topSales) ? /* @__PURE__ */ React187.createElement(NoRecord, { icon: "info_outline", message: "There are no top sales to be displayed for this account." }) : /* @__PURE__ */ React187.createElement(React187.Fragment, null, map34(topSales, ({ id: id2, firstname, lastname, organizationTeam }) => {
    var _a;
    return /* @__PURE__ */ React187.createElement("div", { className: "col-sm-12 pl-1", key: id2 }, /* @__PURE__ */ React187.createElement(
      "input",
      {
        type: "text",
        readOnly: true,
        className: "form-control-plaintext text-dark p-0",
        value: `${firstname} ${lastname} (${(_a = organizationTeam == null ? void 0 : organizationTeam.path) != null ? _a : ""})`
      }
    ));
  })))));
};

// src/ribbonBar/RibbonBar.tsx
import * as React188 from "react";
import { isEmpty as isEmpty31, map as map35 } from "lodash-es";
import { Button as Button11, Checkbox as Checkbox3, Dropdown as Dropdown2 } from "@sgbs-ui/core";
var RibbonBar = ({
  isOnSelection,
  isAllSelected,
  title,
  config,
  configOption,
  onSelectAll
}) => {
  return /* @__PURE__ */ React188.createElement("div", { className: "fixed-bottom ribbon-bar" }, /* @__PURE__ */ React188.createElement("div", { className: "card-body p-3 bg-info" }, /* @__PURE__ */ React188.createElement("div", { className: "d-flex align-items-start align-items-center" }, onSelectAll && /* @__PURE__ */ React188.createElement("div", { className: "mr-2" }, /* @__PURE__ */ React188.createElement(
    Checkbox3,
    {
      color: "white",
      checked: isOnSelection && isAllSelected,
      indeterminate: !isAllSelected && isOnSelection,
      onChange: onSelectAll,
      id: title
    }
  )), /* @__PURE__ */ React188.createElement("span", { className: `font-weight-500 ${isOnSelection ? "text-white" : ""}` }, title), /* @__PURE__ */ React188.createElement("div", { className: "ml-auto" }, map35(
    config,
    ({ visible, icon, label, onClick }, index) => visible && /* @__PURE__ */ React188.createElement(
      Button11,
      {
        className: `text-white ${icon ? "btn-icon-text" : ""}`,
        onClick,
        key: index,
        color: "info"
      },
      icon && /* @__PURE__ */ React188.createElement(Icon, { iconName: icon, size: "sm", className: "mb-1 mr-1" }),
      /* @__PURE__ */ React188.createElement("span", null, label)
    )
  ), !isEmpty31(configOption) && /* @__PURE__ */ React188.createElement(
    Dropdown2,
    {
      className: "d-inline-block",
      type: "info",
      label: /* @__PURE__ */ React188.createElement(Icon, { iconName: "more_vert", size: "md" }),
      direction: "up",
      items: configOption,
      disableDefaultIcon: true,
      menuAlignOnRight: true
    }
  )))));
};
export {
  A2DStatusBadge,
  ACTION_PLAN_FILTERS,
  ALL_DATE_RANGE,
  AccessRightsField,
  AccountBulkSelector,
  AccountCommercialTree,
  AccountCoverageFilterRow,
  AccountCoverageSortButton,
  AccountKycTree,
  AccountMifid,
  AccountMultiPickerV2,
  AccountName,
  AccountOrgChartTree,
  AccountSinglePicker,
  AccountsPicker,
  ActionPlanPicker,
  AlertCustom,
  AppliedFilters,
  AutoCompleteTextPicker,
  Avatar,
  BackButton,
  BankAccountMutliPicker,
  BulletSeparator,
  BusinessFunctionMultiPicker,
  ButtonGroup,
  ButtonGroupAccount,
  ButtonLinkDropDown,
  COMMERCIAL_TREE_DATE_FILTERS,
  Card,
  CardLabelItem,
  CertifyEmailButton,
  CheckboxCard,
  ClientTeamViewer,
  ClientTeamViewerWidget,
  ClientTypeBadge,
  CollapseButton,
  CommercialTreeSettingModal,
  ContactCoverage,
  ContactCreatorWidget,
  ContactEditorWidget,
  ContactEmails,
  ContactEvents,
  ContactIndicators,
  ContactIndicatorsTooltip,
  ContactLinkedin,
  ContactListMultiPicker,
  ContactMifid,
  ContactMultiPickerWidget,
  ContactMultiWithCreate,
  ContactNameRow,
  ContactPepSpo,
  ContactPhones,
  ContactPickerWidget,
  ContactWithCreate,
  CountriesPicker,
  CountryPicker,
  CountrySinglePicker,
  CurrencyPicker,
  DATE_FILTERS,
  DEFAULT_DATE_FILTERS,
  DatePicker,
  DateRangePickerForm,
  DateRangePickerValidationForm,
  DropZone,
  EmailLink,
  EventPicker,
  FROM_LAST_3_MONTHS_RANGE,
  FROM_LAST_6_MONTHS_RANGE,
  FROM_LAST_MONTH_DATE_RANGE,
  FROM_LAST_MONTH_DATE_RANGE_FIXED,
  FROM_LAST_WEEK_DATE_RANGE,
  FROM_LAST_WEEK_DATE_RANGE_FIXED,
  FROM_LAST_YEAR_DATE_RANGE,
  FROM_LAST_YEAR_DATE_RANGE_FIXED,
  FeedbackView,
  FilesUpload,
  Footer,
  FormGroup,
  GoogleStaticMap,
  HtmlSanitizer,
  Icon,
  IconSpinner,
  IconStarFilled,
  IconStarUnfilled,
  IconUploadedFile,
  InfiniteList,
  InvalidFeedback,
  JOB_TYPES,
  JobTypePicker,
  KycGlobalInfoCard,
  KycGlobalInfoSidePanel,
  LabelValueComponent,
  LastActivities,
  LastActivitiesEvents,
  LastActivitiesWidget,
  Loader,
  MY_FEED_DATE_FILTERS,
  MaestroAccountPicker,
  MaestroAccountsPicker,
  MandateListWidget,
  MaxSizeReached,
  MifidClientStatus,
  MultiSelectDateFilter,
  NavPills,
  NavigationCard,
  NoRecord,
  OriginPicker,
  OutlookHtmlSanitizer,
  PAST_DATE_RANGE,
  PageErrorContainer,
  PageHeader,
  ParseUrlOptions,
  PdfIcTagHelperWidget,
  PersonContactCreatorModalWidget,
  PersonContactCreatorWidget,
  PersonContactMultiPicker,
  PersonContactPicker,
  PhoneLink,
  ReadOnlyInputLabelField,
  ResponsiveTitle,
  RibbonBar,
  SearchBar,
  SearchNoResult,
  SegmentationList,
  SegmentationSinglePickerWidget,
  SelectDropDown,
  SgBsErrorBody,
  SgDatePicker,
  SgTimePicker,
  SgmDocsDocumentViewer,
  SgmIdyRequestAccess,
  SgmRequestAccess,
  SgwtAccountCenter,
  SgwtDatePicker,
  SgwtSplashScreen,
  SgwtWebAnalytics,
  SortableTableColumn,
  StarRating,
  StringifyUrlOptions,
  ThWithSort,
  TieringsSelect,
  TimeLine,
  TimeLineItem,
  TimePicker,
  TimeZoneInfo,
  TimeZonePicker,
  ToastContainer,
  ToastContent,
  ToggleButtons,
  TooLargeFile,
  Tooltip,
  TopSales,
  TypologySinglePicker,
  UPCOMING_DATE_RANGE,
  UPCOMING_DATE_RANGE_FIXED,
  USER_MONITORING_FILTERS,
  UploadSquares,
  UploadedFiles,
  WidgetList,
  WorkPositionsWidget,
  _1MB,
  _5MB,
  buildUrlWithQueryParams,
  bulletCode,
  createScriptElement,
  defaultDisplayHour,
  filterIanaCodes,
  formatAddress,
  formatterAddress,
  getAgGridKey,
  getApmEnvUrlForRum,
  getErrorClass,
  getGoogleMapsKey,
  getOffsetForDate,
  getQualityIndicators,
  getRangeByDateFilterType,
  getTimeZonesItemsForDate,
  listCountries,
  mapIanaToLabel,
  mapIanaToShortLabel,
  mapQualityIndicators,
  mapToIndicatorValidityType,
  mapToQualityIndicatorIconColor,
  parseUrlQueryString,
  renderAccount,
  settingsInitialState,
  stringifyBoolean,
  timezoneModels,
  toastify,
  toastifyErrorMessage,
  toastifyInfo,
  toastifySuccess,
  toastifyWarningMessage,
  typeToLabelValueActivityDictionary,
  urlWidgetType,
  useDropdownState,
  useFullScreen,
  useGetGoogleUrls,
  useHideNavBarBorder,
  useIntersectionObserver,
  useLoadJsScript,
  useModal,
  useOrgChartPerEntityTree,
  usePrevious,
  useQueryErrorHandler,
  useQuickFilter,
  useRefListener,
  useRefListeners,
  useRum,
  useSortableData,
  useWidget,
  useWindowSize,
  validTime,
  validateDateRange,
  validateInput,
  validateUploadedFile
};
/*! Bundled license information:

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)

is-plain-object/dist/is-plain-object.js:
  (*!
   * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   *)

screenfull/dist/screenfull.js:
  (*!
  * screenfull
  * v5.2.0 - 2021-11-03
  * (c) Sindre Sorhus; MIT License
  *)
*/
